(function () {
  const l = document.createElement("link").relList;
  if (l && l.supports && l.supports("modulepreload")) return;
  for (const c of document.querySelectorAll('link[rel="modulepreload"]')) r(c);
  new MutationObserver((c) => {
    for (const h of c)
      if (h.type === "childList")
        for (const f of h.addedNodes)
          f.tagName === "LINK" && f.rel === "modulepreload" && r(f);
  }).observe(document, { childList: !0, subtree: !0 });
  
  function o(c) {
    const h = {};
    return (
      c.integrity && (h.integrity = c.integrity),
      c.referrerPolicy && (h.referrerPolicy = c.referrerPolicy),
      c.crossOrigin === "use-credentials"
        ? (h.credentials = "include")
        : c.crossOrigin === "anonymous"
        ? (h.credentials = "omit")
        : (h.credentials = "same-origin"),
      h
    );
  }

  function r(c) {
    if (c.ep) return;
    c.ep = !0;
    const h = o(c);
    fetch(c.href, h);
  }
})();
var Ou = { exports: {} },
  yl = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var Zm;
function _b() {
  if (Zm) return yl;
  Zm = 1;
  var a = Symbol.for("react.transitional.element"),
    l = Symbol.for("react.fragment");
  function o(r, c, h) {
    var f = null;
    if (
      (h !== void 0 && (f = "" + h),
      c.key !== void 0 && (f = "" + c.key),
      "key" in c)
    ) {
      h = {};
      for (var m in c) m !== "key" && (h[m] = c[m]);
    } else h = c;
    return (
      (c = h.ref),
      { $$typeof: a, type: r, key: f, ref: c !== void 0 ? c : null, props: h }
    );
  }
  return (yl.Fragment = l), (yl.jsx = o), (yl.jsxs = o), yl;
}
var Qm;
function Ub() {
  return Qm || ((Qm = 1), (Ou.exports = _b())), Ou.exports;
}
var j = Ub(),
  Cu = { exports: {} },
  ot = {};
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var Km;
function jb() {
  if (Km) return ot;
  Km = 1;
  var a = Symbol.for("react.transitional.element"),
    l = Symbol.for("react.portal"),
    o = Symbol.for("react.fragment"),
    r = Symbol.for("react.strict_mode"),
    c = Symbol.for("react.profiler"),
    h = Symbol.for("react.consumer"),
    f = Symbol.for("react.context"),
    m = Symbol.for("react.forward_ref"),
    p = Symbol.for("react.suspense"),
    g = Symbol.for("react.memo"),
    v = Symbol.for("react.lazy"),
    b = Symbol.iterator;
  function A(S) {
    return S === null || typeof S != "object"
      ? null
      : ((S = (b && S[b]) || S["@@iterator"]),
        typeof S == "function" ? S : null);
  }
  var O = {
      isMounted: function () {
        return !1;
      },
      enqueueForceUpdate: function () {},
      enqueueReplaceState: function () {},
      enqueueSetState: function () {},
    },
    B = Object.assign,
    L = {};
  function Y(S, U, Q) {
    (this.props = S),
      (this.context = U),
      (this.refs = L),
      (this.updater = Q || O);
  }
  (Y.prototype.isReactComponent = {}),
    (Y.prototype.setState = function (S, U) {
      if (typeof S != "object" && typeof S != "function" && S != null)
        throw Error(
          "takes an object of state variables to update or a function which returns an object of state variables."
        );
      this.updater.enqueueSetState(this, S, U, "setState");
    }),
    (Y.prototype.forceUpdate = function (S) {
      this.updater.enqueueForceUpdate(this, S, "forceUpdate");
    });
  function Z() {}
  Z.prototype = Y.prototype;
  function $(S, U, Q) {
    (this.props = S),
      (this.context = U),
      (this.refs = L),
      (this.updater = Q || O);
  }
  var X = ($.prototype = new Z());
  (X.constructor = $), B(X, Y.prototype), (X.isPureReactComponent = !0);
  var lt = Array.isArray,
    k = { H: null, A: null, T: null, S: null, V: null },
    nt = Object.prototype.hasOwnProperty;
  function rt(S, U, Q, q, K, dt) {
    return (
      (Q = dt.ref),
      { $$typeof: a, type: S, key: U, ref: Q !== void 0 ? Q : null, props: dt }
    );
  }
  function G(S, U) {
    return rt(S.type, U, void 0, void 0, void 0, S.props);
  }
  function pt(S) {
    return typeof S == "object" && S !== null && S.$$typeof === a;
  }
  function Ut(S) {
    var U = { "=": "=0", ":": "=2" };
    return (
      "$" +
      S.replace(/[=:]/g, function (Q) {
        return U[Q];
      })
    );
  }
  var Xt = /\/+/g;
  function Ot(S, U) {
    return typeof S == "object" && S !== null && S.key != null
      ? Ut("" + S.key)
      : U.toString(36);
  }
  function we() {}
  function ce(S) {
    switch (S.status) {
      case "fulfilled":
        return S.value;
      case "rejected":
        throw S.reason;
      default:
        switch (
          (typeof S.status == "string"
            ? S.then(we, we)
            : ((S.status = "pending"),
              S.then(
                function (U) {
                  S.status === "pending" &&
                    ((S.status = "fulfilled"), (S.value = U));
                },
                function (U) {
                  S.status === "pending" &&
                    ((S.status = "rejected"), (S.reason = U));
                }
              )),
          S.status)
        ) {
          case "fulfilled":
            return S.value;
          case "rejected":
            throw S.reason;
        }
    }
    throw S;
  }
  function Ct(S, U, Q, q, K) {
    var dt = typeof S;
    (dt === "undefined" || dt === "boolean") && (S = null);
    var st = !1;
    if (S === null) st = !0;
    else
      switch (dt) {
        case "bigint":
        case "string":
        case "number":
          st = !0;
          break;
        case "object":
          switch (S.$$typeof) {
            case a:
            case l:
              st = !0;
              break;
            case v:
              return (st = S._init), Ct(st(S._payload), U, Q, q, K);
          }
      }
    if (st)
      return (
        (K = K(S)),
        (st = q === "" ? "." + Ot(S, 0) : q),
        lt(K)
          ? ((Q = ""),
            st != null && (Q = st.replace(Xt, "$&/") + "/"),
            Ct(K, U, Q, "", function (ye) {
              return ye;
            }))
          : K != null &&
            (pt(K) &&
              (K = G(
                K,
                Q +
                  (K.key == null || (S && S.key === K.key)
                    ? ""
                    : ("" + K.key).replace(Xt, "$&/") + "/") +
                  st
              )),
            U.push(K)),
        1
      );
    st = 0;
    var vt = q === "" ? "." : q + ":";
    if (lt(S))
      for (var Dt = 0; Dt < S.length; Dt++)
        (q = S[Dt]), (dt = vt + Ot(q, Dt)), (st += Ct(q, U, Q, dt, K));
    else if (((Dt = A(S)), typeof Dt == "function"))
      for (S = Dt.call(S), Dt = 0; !(q = S.next()).done; )
        (q = q.value), (dt = vt + Ot(q, Dt++)), (st += Ct(q, U, Q, dt, K));
    else if (dt === "object") {
      if (typeof S.then == "function") return Ct(ce(S), U, Q, q, K);
      throw (
        ((U = String(S)),
        Error(
          "Objects are not valid as a React child (found: " +
            (U === "[object Object]"
              ? "object with keys {" + Object.keys(S).join(", ") + "}"
              : U) +
            "). If you meant to render a collection of children, use an array instead."
        ))
      );
    }
    return st;
  }
  function C(S, U, Q) {
    if (S == null) return S;
    var q = [],
      K = 0;
    return (
      Ct(S, q, "", "", function (dt) {
        return U.call(Q, dt, K++);
      }),
      q
    );
  }
  function H(S) {
    if (S._status === -1) {
      var U = S._result;
      (U = U()),
        U.then(
          function (Q) {
            (S._status === 0 || S._status === -1) &&
              ((S._status = 1), (S._result = Q));
          },
          function (Q) {
            (S._status === 0 || S._status === -1) &&
              ((S._status = 2), (S._result = Q));
          }
        ),
        S._status === -1 && ((S._status = 0), (S._result = U));
    }
    if (S._status === 1) return S._result.default;
    throw S._result;
  }
  var _ =
    typeof reportError == "function"
      ? reportError
      : function (S) {
          if (
            typeof window == "object" &&
            typeof window.ErrorEvent == "function"
          ) {
            var U = new window.ErrorEvent("error", {
              bubbles: !0,
              cancelable: !0,
              message:
                typeof S == "object" &&
                S !== null &&
                typeof S.message == "string"
                  ? String(S.message)
                  : String(S),
              error: S,
            });
            if (!window.dispatchEvent(U)) return;
          } else if (
            typeof process == "object" &&
            typeof process.emit == "function"
          ) {
            process.emit("uncaughtException", S);
            return;
          }
          console.error(S);
        };
  function gt() {}
  return (
    (ot.Children = {
      map: C,
      forEach: function (S, U, Q) {
        C(
          S,
          function () {
            U.apply(this, arguments);
          },
          Q
        );
      },
      count: function (S) {
        var U = 0;
        return (
          C(S, function () {
            U++;
          }),
          U
        );
      },
      toArray: function (S) {
        return (
          C(S, function (U) {
            return U;
          }) || []
        );
      },
      only: function (S) {
        if (!pt(S))
          throw Error(
            "React.Children.only expected to receive a single React element child."
          );
        return S;
      },
    }),
    (ot.Component = Y),
    (ot.Fragment = o),
    (ot.Profiler = c),
    (ot.PureComponent = $),
    (ot.StrictMode = r),
    (ot.Suspense = p),
    (ot.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = k),
    (ot.__COMPILER_RUNTIME = {
      __proto__: null,
      c: function (S) {
        return k.H.useMemoCache(S);
      },
    }),
    (ot.cache = function (S) {
      return function () {
        return S.apply(null, arguments);
      };
    }),
    (ot.cloneElement = function (S, U, Q) {
      if (S == null)
        throw Error(
          "The argument must be a React element, but you passed " + S + "."
        );
      var q = B({}, S.props),
        K = S.key,
        dt = void 0;
      if (U != null)
        for (st in (U.ref !== void 0 && (dt = void 0),
        U.key !== void 0 && (K = "" + U.key),
        U))
          !nt.call(U, st) ||
            st === "key" ||
            st === "__self" ||
            st === "__source" ||
            (st === "ref" && U.ref === void 0) ||
            (q[st] = U[st]);
      var st = arguments.length - 2;
      if (st === 1) q.children = Q;
      else if (1 < st) {
        for (var vt = Array(st), Dt = 0; Dt < st; Dt++)
          vt[Dt] = arguments[Dt + 2];
        q.children = vt;
      }
      return rt(S.type, K, void 0, void 0, dt, q);
    }),
    (ot.createContext = function (S) {
      return (
        (S = {
          $$typeof: f,
          _currentValue: S,
          _currentValue2: S,
          _threadCount: 0,
          Provider: null,
          Consumer: null,
        }),
        (S.Provider = S),
        (S.Consumer = { $$typeof: h, _context: S }),
        S
      );
    }),
    (ot.createElement = function (S, U, Q) {
      var q,
        K = {},
        dt = null;
      if (U != null)
        for (q in (U.key !== void 0 && (dt = "" + U.key), U))
          nt.call(U, q) &&
            q !== "key" &&
            q !== "__self" &&
            q !== "__source" &&
            (K[q] = U[q]);
      var st = arguments.length - 2;
      if (st === 1) K.children = Q;
      else if (1 < st) {
        for (var vt = Array(st), Dt = 0; Dt < st; Dt++)
          vt[Dt] = arguments[Dt + 2];
        K.children = vt;
      }
      if (S && S.defaultProps)
        for (q in ((st = S.defaultProps), st))
          K[q] === void 0 && (K[q] = st[q]);
      return rt(S, dt, void 0, void 0, null, K);
    }),
    (ot.createRef = function () {
      return { current: null };
    }),
    (ot.forwardRef = function (S) {
      return { $$typeof: m, render: S };
    }),
    (ot.isValidElement = pt),
    (ot.lazy = function (S) {
      return { $$typeof: v, _payload: { _status: -1, _result: S }, _init: H };
    }),
    (ot.memo = function (S, U) {
      return { $$typeof: g, type: S, compare: U === void 0 ? null : U };
    }),
    (ot.startTransition = function (S) {
      var U = k.T,
        Q = {};
      k.T = Q;
      try {
        var q = S(),
          K = k.S;
        K !== null && K(Q, q),
          typeof q == "object" &&
            q !== null &&
            typeof q.then == "function" &&
            q.then(gt, _);
      } catch (dt) {
        _(dt);
      } finally {
        k.T = U;
      }
    }),
    (ot.unstable_useCacheRefresh = function () {
      return k.H.useCacheRefresh();
    }),
    (ot.use = function (S) {
      return k.H.use(S);
    }),
    (ot.useActionState = function (S, U, Q) {
      return k.H.useActionState(S, U, Q);
    }),
    (ot.useCallback = function (S, U) {
      return k.H.useCallback(S, U);
    }),
    (ot.useContext = function (S) {
      return k.H.useContext(S);
    }),
    (ot.useDebugValue = function () {}),
    (ot.useDeferredValue = function (S, U) {
      return k.H.useDeferredValue(S, U);
    }),
    (ot.useEffect = function (S, U, Q) {
      var q = k.H;
      if (typeof Q == "function")
        throw Error(
          "useEffect CRUD overload is not enabled in this build of React."
        );
      return q.useEffect(S, U);
    }),
    (ot.useId = function () {
      return k.H.useId();
    }),
    (ot.useImperativeHandle = function (S, U, Q) {
      return k.H.useImperativeHandle(S, U, Q);
    }),
    (ot.useInsertionEffect = function (S, U) {
      return k.H.useInsertionEffect(S, U);
    }),
    (ot.useLayoutEffect = function (S, U) {
      return k.H.useLayoutEffect(S, U);
    }),
    (ot.useMemo = function (S, U) {
      return k.H.useMemo(S, U);
    }),
    (ot.useOptimistic = function (S, U) {
      return k.H.useOptimistic(S, U);
    }),
    (ot.useReducer = function (S, U, Q) {
      return k.H.useReducer(S, U, Q);
    }),
    (ot.useRef = function (S) {
      return k.H.useRef(S);
    }),
    (ot.useState = function (S) {
      return k.H.useState(S);
    }),
    (ot.useSyncExternalStore = function (S, U, Q) {
      return k.H.useSyncExternalStore(S, U, Q);
    }),
    (ot.useTransition = function () {
      return k.H.useTransition();
    }),
    (ot.version = "19.1.0"),
    ot
  );
}
var Jm;
function vc() {
  return Jm || ((Jm = 1), (Cu.exports = jb())), Cu.exports;
}
var W = vc(),
  Vu = { exports: {} },
  vl = {},
  zu = { exports: {} },
  Nu = {};
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var Pm;
function Bb() {
  return (
    Pm ||
      ((Pm = 1),
      (function (a) {
        function l(C, H) {
          var _ = C.length;
          C.push(H);
          t: for (; 0 < _; ) {
            var gt = (_ - 1) >>> 1,
              S = C[gt];
            if (0 < c(S, H)) (C[gt] = H), (C[_] = S), (_ = gt);
            else break t;
          }
        }
        function o(C) {
          return C.length === 0 ? null : C[0];
        }
        function r(C) {
          if (C.length === 0) return null;
          var H = C[0],
            _ = C.pop();
          if (_ !== H) {
            C[0] = _;
            t: for (var gt = 0, S = C.length, U = S >>> 1; gt < U; ) {
              var Q = 2 * (gt + 1) - 1,
                q = C[Q],
                K = Q + 1,
                dt = C[K];
              if (0 > c(q, _))
                K < S && 0 > c(dt, q)
                  ? ((C[gt] = dt), (C[K] = _), (gt = K))
                  : ((C[gt] = q), (C[Q] = _), (gt = Q));
              else if (K < S && 0 > c(dt, _))
                (C[gt] = dt), (C[K] = _), (gt = K);
              else break t;
            }
          }
          return H;
        }
        function c(C, H) {
          var _ = C.sortIndex - H.sortIndex;
          return _ !== 0 ? _ : C.id - H.id;
        }
        if (
          ((a.unstable_now = void 0),
          typeof performance == "object" &&
            typeof performance.now == "function")
        ) {
          var h = performance;
          a.unstable_now = function () {
            return h.now();
          };
        } else {
          var f = Date,
            m = f.now();
          a.unstable_now = function () {
            return f.now() - m;
          };
        }
        var p = [],
          g = [],
          v = 1,
          b = null,
          A = 3,
          O = !1,
          B = !1,
          L = !1,
          Y = !1,
          Z = typeof setTimeout == "function" ? setTimeout : null,
          $ = typeof clearTimeout == "function" ? clearTimeout : null,
          X = typeof setImmediate < "u" ? setImmediate : null;
        function lt(C) {
          for (var H = o(g); H !== null; ) {
            if (H.callback === null) r(g);
            else if (H.startTime <= C)
              r(g), (H.sortIndex = H.expirationTime), l(p, H);
            else break;
            H = o(g);
          }
        }
        function k(C) {
          if (((L = !1), lt(C), !B))
            if (o(p) !== null) (B = !0), nt || ((nt = !0), Ot());
            else {
              var H = o(g);
              H !== null && Ct(k, H.startTime - C);
            }
        }
        var nt = !1,
          rt = -1,
          G = 5,
          pt = -1;
        function Ut() {
          return Y ? !0 : !(a.unstable_now() - pt < G);
        }
        function Xt() {
          if (((Y = !1), nt)) {
            var C = a.unstable_now();
            pt = C;
            var H = !0;
            try {
              t: {
                (B = !1), L && ((L = !1), $(rt), (rt = -1)), (O = !0);
                var _ = A;
                try {
                  e: {
                    for (
                      lt(C), b = o(p);
                      b !== null && !(b.expirationTime > C && Ut());

                    ) {
                      var gt = b.callback;
                      if (typeof gt == "function") {
                        (b.callback = null), (A = b.priorityLevel);
                        var S = gt(b.expirationTime <= C);
                        if (((C = a.unstable_now()), typeof S == "function")) {
                          (b.callback = S), lt(C), (H = !0);
                          break e;
                        }
                        b === o(p) && r(p), lt(C);
                      } else r(p);
                      b = o(p);
                    }
                    if (b !== null) H = !0;
                    else {
                      var U = o(g);
                      U !== null && Ct(k, U.startTime - C), (H = !1);
                    }
                  }
                  break t;
                } finally {
                  (b = null), (A = _), (O = !1);
                }
                H = void 0;
              }
            } finally {
              H ? Ot() : (nt = !1);
            }
          }
        }
        var Ot;
        if (typeof X == "function")
          Ot = function () {
            X(Xt);
          };
        else if (typeof MessageChannel < "u") {
          var we = new MessageChannel(),
            ce = we.port2;
          (we.port1.onmessage = Xt),
            (Ot = function () {
              ce.postMessage(null);
            });
        } else
          Ot = function () {
            Z(Xt, 0);
          };
        function Ct(C, H) {
          rt = Z(function () {
            C(a.unstable_now());
          }, H);
        }
        (a.unstable_IdlePriority = 5),
          (a.unstable_ImmediatePriority = 1),
          (a.unstable_LowPriority = 4),
          (a.unstable_NormalPriority = 3),
          (a.unstable_Profiling = null),
          (a.unstable_UserBlockingPriority = 2),
          (a.unstable_cancelCallback = function (C) {
            C.callback = null;
          }),
          (a.unstable_forceFrameRate = function (C) {
            0 > C || 125 < C
              ? console.error(
                  "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
                )
              : (G = 0 < C ? Math.floor(1e3 / C) : 5);
          }),
          (a.unstable_getCurrentPriorityLevel = function () {
            return A;
          }),
          (a.unstable_next = function (C) {
            switch (A) {
              case 1:
              case 2:
              case 3:
                var H = 3;
                break;
              default:
                H = A;
            }
            var _ = A;
            A = H;
            try {
              return C();
            } finally {
              A = _;
            }
          }),
          (a.unstable_requestPaint = function () {
            Y = !0;
          }),
          (a.unstable_runWithPriority = function (C, H) {
            switch (C) {
              case 1:
              case 2:
              case 3:
              case 4:
              case 5:
                break;
              default:
                C = 3;
            }
            var _ = A;
            A = C;
            try {
              return H();
            } finally {
              A = _;
            }
          }),
          (a.unstable_scheduleCallback = function (C, H, _) {
            var gt = a.unstable_now();
            switch (
              (typeof _ == "object" && _ !== null
                ? ((_ = _.delay),
                  (_ = typeof _ == "number" && 0 < _ ? gt + _ : gt))
                : (_ = gt),
              C)
            ) {
              case 1:
                var S = -1;
                break;
              case 2:
                S = 250;
                break;
              case 5:
                S = 1073741823;
                break;
              case 4:
                S = 1e4;
                break;
              default:
                S = 5e3;
            }
            return (
              (S = _ + S),
              (C = {
                id: v++,
                callback: H,
                priorityLevel: C,
                startTime: _,
                expirationTime: S,
                sortIndex: -1,
              }),
              _ > gt
                ? ((C.sortIndex = _),
                  l(g, C),
                  o(p) === null &&
                    C === o(g) &&
                    (L ? ($(rt), (rt = -1)) : (L = !0), Ct(k, _ - gt)))
                : ((C.sortIndex = S),
                  l(p, C),
                  B || O || ((B = !0), nt || ((nt = !0), Ot()))),
              C
            );
          }),
          (a.unstable_shouldYield = Ut),
          (a.unstable_wrapCallback = function (C) {
            var H = A;
            return function () {
              var _ = A;
              A = H;
              try {
                return C.apply(this, arguments);
              } finally {
                A = _;
              }
            };
          });
      })(Nu)),
    Nu
  );
}
var Fm;
function Lb() {
  return Fm || ((Fm = 1), (zu.exports = Bb())), zu.exports;
}
var _u = { exports: {} },
  ie = {};
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var Wm;
function Hb() {
  if (Wm) return ie;
  Wm = 1;
  var a = vc();
  function l(p) {
    var g = "https://react.dev/errors/" + p;
    if (1 < arguments.length) {
      g += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var v = 2; v < arguments.length; v++)
        g += "&args[]=" + encodeURIComponent(arguments[v]);
    }
    return (
      "Minified React error #" +
      p +
      "; visit " +
      g +
      " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
    );
  }
  function o() {}
  var r = {
      d: {
        f: o,
        r: function () {
          throw Error(l(522));
        },
        D: o,
        C: o,
        L: o,
        m: o,
        X: o,
        S: o,
        M: o,
      },
      p: 0,
      findDOMNode: null,
    },
    c = Symbol.for("react.portal");
  function h(p, g, v) {
    var b =
      3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return {
      $$typeof: c,
      key: b == null ? null : "" + b,
      children: p,
      containerInfo: g,
      implementation: v,
    };
  }
  var f = a.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  function m(p, g) {
    if (p === "font") return "";
    if (typeof g == "string") return g === "use-credentials" ? g : "";
  }
  return (
    (ie.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = r),
    (ie.createPortal = function (p, g) {
      var v =
        2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
      if (!g || (g.nodeType !== 1 && g.nodeType !== 9 && g.nodeType !== 11))
        throw Error(l(299));
      return h(p, g, null, v);
    }),
    (ie.flushSync = function (p) {
      var g = f.T,
        v = r.p;
      try {
        if (((f.T = null), (r.p = 2), p)) return p();
      } finally {
        (f.T = g), (r.p = v), r.d.f();
      }
    }),
    (ie.preconnect = function (p, g) {
      typeof p == "string" &&
        (g
          ? ((g = g.crossOrigin),
            (g =
              typeof g == "string"
                ? g === "use-credentials"
                  ? g
                  : ""
                : void 0))
          : (g = null),
        r.d.C(p, g));
    }),
    (ie.prefetchDNS = function (p) {
      typeof p == "string" && r.d.D(p);
    }),
    (ie.preinit = function (p, g) {
      if (typeof p == "string" && g && typeof g.as == "string") {
        var v = g.as,
          b = m(v, g.crossOrigin),
          A = typeof g.integrity == "string" ? g.integrity : void 0,
          O = typeof g.fetchPriority == "string" ? g.fetchPriority : void 0;
        v === "style"
          ? r.d.S(p, typeof g.precedence == "string" ? g.precedence : void 0, {
              crossOrigin: b,
              integrity: A,
              fetchPriority: O,
            })
          : v === "script" &&
            r.d.X(p, {
              crossOrigin: b,
              integrity: A,
              fetchPriority: O,
              nonce: typeof g.nonce == "string" ? g.nonce : void 0,
            });
      }
    }),
    (ie.preinitModule = function (p, g) {
      if (typeof p == "string")
        if (typeof g == "object" && g !== null) {
          if (g.as == null || g.as === "script") {
            var v = m(g.as, g.crossOrigin);
            r.d.M(p, {
              crossOrigin: v,
              integrity: typeof g.integrity == "string" ? g.integrity : void 0,
              nonce: typeof g.nonce == "string" ? g.nonce : void 0,
            });
          }
        } else g == null && r.d.M(p);
    }),
    (ie.preload = function (p, g) {
      if (
        typeof p == "string" &&
        typeof g == "object" &&
        g !== null &&
        typeof g.as == "string"
      ) {
        var v = g.as,
          b = m(v, g.crossOrigin);
        r.d.L(p, v, {
          crossOrigin: b,
          integrity: typeof g.integrity == "string" ? g.integrity : void 0,
          nonce: typeof g.nonce == "string" ? g.nonce : void 0,
          type: typeof g.type == "string" ? g.type : void 0,
          fetchPriority:
            typeof g.fetchPriority == "string" ? g.fetchPriority : void 0,
          referrerPolicy:
            typeof g.referrerPolicy == "string" ? g.referrerPolicy : void 0,
          imageSrcSet:
            typeof g.imageSrcSet == "string" ? g.imageSrcSet : void 0,
          imageSizes: typeof g.imageSizes == "string" ? g.imageSizes : void 0,
          media: typeof g.media == "string" ? g.media : void 0,
        });
      }
    }),
    (ie.preloadModule = function (p, g) {
      if (typeof p == "string")
        if (g) {
          var v = m(g.as, g.crossOrigin);
          r.d.m(p, {
            as: typeof g.as == "string" && g.as !== "script" ? g.as : void 0,
            crossOrigin: v,
            integrity: typeof g.integrity == "string" ? g.integrity : void 0,
          });
        } else r.d.m(p);
    }),
    (ie.requestFormReset = function (p) {
      r.d.r(p);
    }),
    (ie.unstable_batchedUpdates = function (p, g) {
      return p(g);
    }),
    (ie.useFormState = function (p, g, v) {
      return f.H.useFormState(p, g, v);
    }),
    (ie.useFormStatus = function () {
      return f.H.useHostTransitionStatus();
    }),
    (ie.version = "19.1.0"),
    ie
  );
}
var $m;
function Gb() {
  if ($m) return _u.exports;
  $m = 1;
  function a() {
    if (
      !(
        typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" ||
        typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"
      )
    )
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(a);
      } catch (l) {
        console.error(l);
      }
  }
  return a(), (_u.exports = Hb()), _u.exports;
}
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var Im;
function qb() {
  if (Im) return vl;
  Im = 1;
  var a = Lb(),
    l = vc(),
    o = Gb();
  function r(t) {
    var e = "https://react.dev/errors/" + t;
    if (1 < arguments.length) {
      e += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var n = 2; n < arguments.length; n++)
        e += "&args[]=" + encodeURIComponent(arguments[n]);
    }
    return (
      "Minified React error #" +
      t +
      "; visit " +
      e +
      " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
    );
  }
  function c(t) {
    return !(!t || (t.nodeType !== 1 && t.nodeType !== 9 && t.nodeType !== 11));
  }
  function h(t) {
    var e = t,
      n = t;
    if (t.alternate) for (; e.return; ) e = e.return;
    else {
      t = e;
      do (e = t), (e.flags & 4098) !== 0 && (n = e.return), (t = e.return);
      while (t);
    }
    return e.tag === 3 ? n : null;
  }
  function f(t) {
    if (t.tag === 13) {
      var e = t.memoizedState;
      if (
        (e === null && ((t = t.alternate), t !== null && (e = t.memoizedState)),
        e !== null)
      )
        return e.dehydrated;
    }
    return null;
  }
  function m(t) {
    if (h(t) !== t) throw Error(r(188));
  }
  function p(t) {
    var e = t.alternate;
    if (!e) {
      if (((e = h(t)), e === null)) throw Error(r(188));
      return e !== t ? null : t;
    }
    for (var n = t, i = e; ; ) {
      var s = n.return;
      if (s === null) break;
      var u = s.alternate;
      if (u === null) {
        if (((i = s.return), i !== null)) {
          n = i;
          continue;
        }
        break;
      }
      if (s.child === u.child) {
        for (u = s.child; u; ) {
          if (u === n) return m(s), t;
          if (u === i) return m(s), e;
          u = u.sibling;
        }
        throw Error(r(188));
      }
      if (n.return !== i.return) (n = s), (i = u);
      else {
        for (var d = !1, y = s.child; y; ) {
          if (y === n) {
            (d = !0), (n = s), (i = u);
            break;
          }
          if (y === i) {
            (d = !0), (i = s), (n = u);
            break;
          }
          y = y.sibling;
        }
        if (!d) {
          for (y = u.child; y; ) {
            if (y === n) {
              (d = !0), (n = u), (i = s);
              break;
            }
            if (y === i) {
              (d = !0), (i = u), (n = s);
              break;
            }
            y = y.sibling;
          }
          if (!d) throw Error(r(189));
        }
      }
      if (n.alternate !== i) throw Error(r(190));
    }
    if (n.tag !== 3) throw Error(r(188));
    return n.stateNode.current === n ? t : e;
  }
  function g(t) {
    var e = t.tag;
    if (e === 5 || e === 26 || e === 27 || e === 6) return t;
    for (t = t.child; t !== null; ) {
      if (((e = g(t)), e !== null)) return e;
      t = t.sibling;
    }
    return null;
  }
  var v = Object.assign,
    b = Symbol.for("react.element"),
    A = Symbol.for("react.transitional.element"),
    O = Symbol.for("react.portal"),
    B = Symbol.for("react.fragment"),
    L = Symbol.for("react.strict_mode"),
    Y = Symbol.for("react.profiler"),
    Z = Symbol.for("react.provider"),
    $ = Symbol.for("react.consumer"),
    X = Symbol.for("react.context"),
    lt = Symbol.for("react.forward_ref"),
    k = Symbol.for("react.suspense"),
    nt = Symbol.for("react.suspense_list"),
    rt = Symbol.for("react.memo"),
    G = Symbol.for("react.lazy"),
    pt = Symbol.for("react.activity"),
    Ut = Symbol.for("react.memo_cache_sentinel"),
    Xt = Symbol.iterator;
  function Ot(t) {
    return t === null || typeof t != "object"
      ? null
      : ((t = (Xt && t[Xt]) || t["@@iterator"]),
        typeof t == "function" ? t : null);
  }
  var we = Symbol.for("react.client.reference");
  function ce(t) {
    if (t == null) return null;
    if (typeof t == "function")
      return t.$$typeof === we ? null : t.displayName || t.name || null;
    if (typeof t == "string") return t;
    switch (t) {
      case B:
        return "Fragment";
      case Y:
        return "Profiler";
      case L:
        return "StrictMode";
      case k:
        return "Suspense";
      case nt:
        return "SuspenseList";
      case pt:
        return "Activity";
    }
    if (typeof t == "object")
      switch (t.$$typeof) {
        case O:
          return "Portal";
        case X:
          return (t.displayName || "Context") + ".Provider";
        case $:
          return (t._context.displayName || "Context") + ".Consumer";
        case lt:
          var e = t.render;
          return (
            (t = t.displayName),
            t ||
              ((t = e.displayName || e.name || ""),
              (t = t !== "" ? "ForwardRef(" + t + ")" : "ForwardRef")),
            t
          );
        case rt:
          return (
            (e = t.displayName || null), e !== null ? e : ce(t.type) || "Memo"
          );
        case G:
          (e = t._payload), (t = t._init);
          try {
            return ce(t(e));
          } catch {}
      }
    return null;
  }
  var Ct = Array.isArray,
    C = l.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
    H = o.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
    _ = { pending: !1, data: null, method: null, action: null },
    gt = [],
    S = -1;
  function U(t) {
    return { current: t };
  }
  function Q(t) {
    0 > S || ((t.current = gt[S]), (gt[S] = null), S--);
  }
  function q(t, e) {
    S++, (gt[S] = t.current), (t.current = e);
  }
  var K = U(null),
    dt = U(null),
    st = U(null),
    vt = U(null);
  function Dt(t, e) {
    switch ((q(st, e), q(dt, t), q(K, null), e.nodeType)) {
      case 9:
      case 11:
        t = (t = e.documentElement) && (t = t.namespaceURI) ? bm(t) : 0;
        break;
      default:
        if (((t = e.tagName), (e = e.namespaceURI)))
          (e = bm(e)), (t = xm(e, t));
        else
          switch (t) {
            case "svg":
              t = 1;
              break;
            case "math":
              t = 2;
              break;
            default:
              t = 0;
          }
    }
    Q(K), q(K, t);
  }
  function ye() {
    Q(K), Q(dt), Q(st);
  }
  function vn(t) {
    t.memoizedState !== null && q(vt, t);
    var e = K.current,
      n = xm(e, t.type);
    e !== n && (q(dt, t), q(K, n));
  }
  function bn(t) {
    dt.current === t && (Q(K), Q(dt)),
      vt.current === t && (Q(vt), (dl._currentValue = _));
  }
  var xn = Object.prototype.hasOwnProperty,
    go = a.unstable_scheduleCallback,
    yo = a.unstable_cancelCallback,
    dv = a.unstable_shouldYield,
    hv = a.unstable_requestPaint,
    Xe = a.unstable_now,
    mv = a.unstable_getCurrentPriorityLevel,
    $c = a.unstable_ImmediatePriority,
    Ic = a.unstable_UserBlockingPriority,
    Ll = a.unstable_NormalPriority,
    pv = a.unstable_LowPriority,
    tf = a.unstable_IdlePriority,
    gv = a.log,
    yv = a.unstable_setDisableYieldValue,
    xi = null,
    ve = null;
  function Sn(t) {
    if (
      (typeof gv == "function" && yv(t),
      ve && typeof ve.setStrictMode == "function")
    )
      try {
        ve.setStrictMode(xi, t);
      } catch {}
  }
  var be = Math.clz32 ? Math.clz32 : xv,
    vv = Math.log,
    bv = Math.LN2;
  function xv(t) {
    return (t >>>= 0), t === 0 ? 32 : (31 - ((vv(t) / bv) | 0)) | 0;
  }
  var Hl = 256,
    Gl = 4194304;
  function Fn(t) {
    var e = t & 42;
    if (e !== 0) return e;
    switch (t & -t) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return t & 4194048;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return t & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return t;
    }
  }
  function ql(t, e, n) {
    var i = t.pendingLanes;
    if (i === 0) return 0;
    var s = 0,
      u = t.suspendedLanes,
      d = t.pingedLanes;
    t = t.warmLanes;
    var y = i & 134217727;
    return (
      y !== 0
        ? ((i = y & ~u),
          i !== 0
            ? (s = Fn(i))
            : ((d &= y),
              d !== 0
                ? (s = Fn(d))
                : n || ((n = y & ~t), n !== 0 && (s = Fn(n)))))
        : ((y = i & ~u),
          y !== 0
            ? (s = Fn(y))
            : d !== 0
            ? (s = Fn(d))
            : n || ((n = i & ~t), n !== 0 && (s = Fn(n)))),
      s === 0
        ? 0
        : e !== 0 &&
          e !== s &&
          (e & u) === 0 &&
          ((u = s & -s),
          (n = e & -e),
          u >= n || (u === 32 && (n & 4194048) !== 0))
        ? e
        : s
    );
  }
  function Si(t, e) {
    return (t.pendingLanes & ~(t.suspendedLanes & ~t.pingedLanes) & e) === 0;
  }
  function Sv(t, e) {
    switch (t) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return e + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return e + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function ef() {
    var t = Hl;
    return (Hl <<= 1), (Hl & 4194048) === 0 && (Hl = 256), t;
  }
  function nf() {
    var t = Gl;
    return (Gl <<= 1), (Gl & 62914560) === 0 && (Gl = 4194304), t;
  }
  function vo(t) {
    for (var e = [], n = 0; 31 > n; n++) e.push(t);
    return e;
  }
  function Ti(t, e) {
    (t.pendingLanes |= e),
      e !== 268435456 &&
        ((t.suspendedLanes = 0), (t.pingedLanes = 0), (t.warmLanes = 0));
  }
  function Tv(t, e, n, i, s, u) {
    var d = t.pendingLanes;
    (t.pendingLanes = n),
      (t.suspendedLanes = 0),
      (t.pingedLanes = 0),
      (t.warmLanes = 0),
      (t.expiredLanes &= n),
      (t.entangledLanes &= n),
      (t.errorRecoveryDisabledLanes &= n),
      (t.shellSuspendCounter = 0);
    var y = t.entanglements,
      x = t.expirationTimes,
      D = t.hiddenUpdates;
    for (n = d & ~n; 0 < n; ) {
      var V = 31 - be(n),
        N = 1 << V;
      (y[V] = 0), (x[V] = -1);
      var w = D[V];
      if (w !== null)
        for (D[V] = null, V = 0; V < w.length; V++) {
          var R = w[V];
          R !== null && (R.lane &= -536870913);
        }
      n &= ~N;
    }
    i !== 0 && af(t, i, 0),
      u !== 0 && s === 0 && t.tag !== 0 && (t.suspendedLanes |= u & ~(d & ~e));
  }
  function af(t, e, n) {
    (t.pendingLanes |= e), (t.suspendedLanes &= ~e);
    var i = 31 - be(e);
    (t.entangledLanes |= e),
      (t.entanglements[i] = t.entanglements[i] | 1073741824 | (n & 4194090));
  }
  function lf(t, e) {
    var n = (t.entangledLanes |= e);
    for (t = t.entanglements; n; ) {
      var i = 31 - be(n),
        s = 1 << i;
      (s & e) | (t[i] & e) && (t[i] |= e), (n &= ~s);
    }
  }
  function bo(t) {
    switch (t) {
      case 2:
        t = 1;
        break;
      case 8:
        t = 4;
        break;
      case 32:
        t = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        t = 128;
        break;
      case 268435456:
        t = 134217728;
        break;
      default:
        t = 0;
    }
    return t;
  }
  function xo(t) {
    return (
      (t &= -t),
      2 < t ? (8 < t ? ((t & 134217727) !== 0 ? 32 : 268435456) : 8) : 2
    );
  }
  function sf() {
    var t = H.p;
    return t !== 0 ? t : ((t = window.event), t === void 0 ? 32 : Hm(t.type));
  }
  function Av(t, e) {
    var n = H.p;
    try {
      return (H.p = t), e();
    } finally {
      H.p = n;
    }
  }
  var Tn = Math.random().toString(36).slice(2),
    ne = "__reactFiber$" + Tn,
    fe = "__reactProps$" + Tn,
    Sa = "__reactContainer$" + Tn,
    So = "__reactEvents$" + Tn,
    Ev = "__reactListeners$" + Tn,
    Mv = "__reactHandles$" + Tn,
    of = "__reactResources$" + Tn,
    Ai = "__reactMarker$" + Tn;
  function To(t) {
    delete t[ne], delete t[fe], delete t[So], delete t[Ev], delete t[Mv];
  }
  function Ta(t) {
    var e = t[ne];
    if (e) return e;
    for (var n = t.parentNode; n; ) {
      if ((e = n[Sa] || n[ne])) {
        if (
          ((n = e.alternate),
          e.child !== null || (n !== null && n.child !== null))
        )
          for (t = Em(t); t !== null; ) {
            if ((n = t[ne])) return n;
            t = Em(t);
          }
        return e;
      }
      (t = n), (n = t.parentNode);
    }
    return null;
  }
  function Aa(t) {
    if ((t = t[ne] || t[Sa])) {
      var e = t.tag;
      if (e === 5 || e === 6 || e === 13 || e === 26 || e === 27 || e === 3)
        return t;
    }
    return null;
  }
  function Ei(t) {
    var e = t.tag;
    if (e === 5 || e === 26 || e === 27 || e === 6) return t.stateNode;
    throw Error(r(33));
  }
  function Ea(t) {
    var e = t[of];
    return (
      e ||
        (e = t[of] =
          { hoistableStyles: new Map(), hoistableScripts: new Map() }),
      e
    );
  }
  function Jt(t) {
    t[Ai] = !0;
  }
  var rf = new Set(),
    uf = {};
  function Wn(t, e) {
    Ma(t, e), Ma(t + "Capture", e);
  }
  function Ma(t, e) {
    for (uf[t] = e, t = 0; t < e.length; t++) rf.add(e[t]);
  }
  var Dv = RegExp(
      "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ),
    cf = {},
    ff = {};
  function wv(t) {
    return xn.call(ff, t)
      ? !0
      : xn.call(cf, t)
      ? !1
      : Dv.test(t)
      ? (ff[t] = !0)
      : ((cf[t] = !0), !1);
  }
  function Yl(t, e, n) {
    if (wv(e))
      if (n === null) t.removeAttribute(e);
      else {
        switch (typeof n) {
          case "undefined":
          case "function":
          case "symbol":
            t.removeAttribute(e);
            return;
          case "boolean":
            var i = e.toLowerCase().slice(0, 5);
            if (i !== "data-" && i !== "aria-") {
              t.removeAttribute(e);
              return;
            }
        }
        t.setAttribute(e, "" + n);
      }
  }
  function kl(t, e, n) {
    if (n === null) t.removeAttribute(e);
    else {
      switch (typeof n) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          t.removeAttribute(e);
          return;
      }
      t.setAttribute(e, "" + n);
    }
  }
  function Ie(t, e, n, i) {
    if (i === null) t.removeAttribute(n);
    else {
      switch (typeof i) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          t.removeAttribute(n);
          return;
      }
      t.setAttributeNS(e, n, "" + i);
    }
  }
  var Ao, df;
  function Da(t) {
    if (Ao === void 0)
      try {
        throw Error();
      } catch (n) {
        var e = n.stack.trim().match(/\n( *(at )?)/);
        (Ao = (e && e[1]) || ""),
          (df =
            -1 <
            n.stack.indexOf(`
    at`)
              ? " (<anonymous>)"
              : -1 < n.stack.indexOf("@")
              ? "@unknown:0:0"
              : "");
      }
    return (
      `
` +
      Ao +
      t +
      df
    );
  }
  var Eo = !1;
  function Mo(t, e) {
    if (!t || Eo) return "";
    Eo = !0;
    var n = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var i = {
        DetermineComponentFrameRoot: function () {
          try {
            if (e) {
              var N = function () {
                throw Error();
              };
              if (
                (Object.defineProperty(N.prototype, "props", {
                  set: function () {
                    throw Error();
                  },
                }),
                typeof Reflect == "object" && Reflect.construct)
              ) {
                try {
                  Reflect.construct(N, []);
                } catch (R) {
                  var w = R;
                }
                Reflect.construct(t, [], N);
              } else {
                try {
                  N.call();
                } catch (R) {
                  w = R;
                }
                t.call(N.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (R) {
                w = R;
              }
              (N = t()) &&
                typeof N.catch == "function" &&
                N.catch(function () {});
            }
          } catch (R) {
            if (R && w && typeof R.stack == "string") return [R.stack, w.stack];
          }
          return [null, null];
        },
      };
      i.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var s = Object.getOwnPropertyDescriptor(
        i.DetermineComponentFrameRoot,
        "name"
      );
      s &&
        s.configurable &&
        Object.defineProperty(i.DetermineComponentFrameRoot, "name", {
          value: "DetermineComponentFrameRoot",
        });
      var u = i.DetermineComponentFrameRoot(),
        d = u[0],
        y = u[1];
      if (d && y) {
        var x = d.split(`
`),
          D = y.split(`
`);
        for (
          s = i = 0;
          i < x.length && !x[i].includes("DetermineComponentFrameRoot");

        )
          i++;
        for (; s < D.length && !D[s].includes("DetermineComponentFrameRoot"); )
          s++;
        if (i === x.length || s === D.length)
          for (
            i = x.length - 1, s = D.length - 1;
            1 <= i && 0 <= s && x[i] !== D[s];

          )
            s--;
        for (; 1 <= i && 0 <= s; i--, s--)
          if (x[i] !== D[s]) {
            if (i !== 1 || s !== 1)
              do
                if ((i--, s--, 0 > s || x[i] !== D[s])) {
                  var V =
                    `
` + x[i].replace(" at new ", " at ");
                  return (
                    t.displayName &&
                      V.includes("<anonymous>") &&
                      (V = V.replace("<anonymous>", t.displayName)),
                    V
                  );
                }
              while (1 <= i && 0 <= s);
            break;
          }
      }
    } finally {
      (Eo = !1), (Error.prepareStackTrace = n);
    }
    return (n = t ? t.displayName || t.name : "") ? Da(n) : "";
  }
  function Rv(t) {
    switch (t.tag) {
      case 26:
      case 27:
      case 5:
        return Da(t.type);
      case 16:
        return Da("Lazy");
      case 13:
        return Da("Suspense");
      case 19:
        return Da("SuspenseList");
      case 0:
      case 15:
        return Mo(t.type, !1);
      case 11:
        return Mo(t.type.render, !1);
      case 1:
        return Mo(t.type, !0);
      case 31:
        return Da("Activity");
      default:
        return "";
    }
  }
  function hf(t) {
    try {
      var e = "";
      do (e += Rv(t)), (t = t.return);
      while (t);
      return e;
    } catch (n) {
      return (
        `
Error generating stack: ` +
        n.message +
        `
` +
        n.stack
      );
    }
  }
  function Re(t) {
    switch (typeof t) {
      case "bigint":
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return t;
      case "object":
        return t;
      default:
        return "";
    }
  }
  function mf(t) {
    var e = t.type;
    return (
      (t = t.nodeName) &&
      t.toLowerCase() === "input" &&
      (e === "checkbox" || e === "radio")
    );
  }
  function Ov(t) {
    var e = mf(t) ? "checked" : "value",
      n = Object.getOwnPropertyDescriptor(t.constructor.prototype, e),
      i = "" + t[e];
    if (
      !t.hasOwnProperty(e) &&
      typeof n < "u" &&
      typeof n.get == "function" &&
      typeof n.set == "function"
    ) {
      var s = n.get,
        u = n.set;
      return (
        Object.defineProperty(t, e, {
          configurable: !0,
          get: function () {
            return s.call(this);
          },
          set: function (d) {
            (i = "" + d), u.call(this, d);
          },
        }),
        Object.defineProperty(t, e, { enumerable: n.enumerable }),
        {
          getValue: function () {
            return i;
          },
          setValue: function (d) {
            i = "" + d;
          },
          stopTracking: function () {
            (t._valueTracker = null), delete t[e];
          },
        }
      );
    }
  }
  function Xl(t) {
    t._valueTracker || (t._valueTracker = Ov(t));
  }
  function pf(t) {
    if (!t) return !1;
    var e = t._valueTracker;
    if (!e) return !0;
    var n = e.getValue(),
      i = "";
    return (
      t && (i = mf(t) ? (t.checked ? "true" : "false") : t.value),
      (t = i),
      t !== n ? (e.setValue(t), !0) : !1
    );
  }
  function Zl(t) {
    if (
      ((t = t || (typeof document < "u" ? document : void 0)), typeof t > "u")
    )
      return null;
    try {
      return t.activeElement || t.body;
    } catch {
      return t.body;
    }
  }
  var Cv = /[\n"\\]/g;
  function Oe(t) {
    return t.replace(Cv, function (e) {
      return "\\" + e.charCodeAt(0).toString(16) + " ";
    });
  }
  function Do(t, e, n, i, s, u, d, y) {
    (t.name = ""),
      d != null &&
      typeof d != "function" &&
      typeof d != "symbol" &&
      typeof d != "boolean"
        ? (t.type = d)
        : t.removeAttribute("type"),
      e != null
        ? d === "number"
          ? ((e === 0 && t.value === "") || t.value != e) &&
            (t.value = "" + Re(e))
          : t.value !== "" + Re(e) && (t.value = "" + Re(e))
        : (d !== "submit" && d !== "reset") || t.removeAttribute("value"),
      e != null
        ? wo(t, d, Re(e))
        : n != null
        ? wo(t, d, Re(n))
        : i != null && t.removeAttribute("value"),
      s == null && u != null && (t.defaultChecked = !!u),
      s != null &&
        (t.checked = s && typeof s != "function" && typeof s != "symbol"),
      y != null &&
      typeof y != "function" &&
      typeof y != "symbol" &&
      typeof y != "boolean"
        ? (t.name = "" + Re(y))
        : t.removeAttribute("name");
  }
  function gf(t, e, n, i, s, u, d, y) {
    if (
      (u != null &&
        typeof u != "function" &&
        typeof u != "symbol" &&
        typeof u != "boolean" &&
        (t.type = u),
      e != null || n != null)
    ) {
      if (!((u !== "submit" && u !== "reset") || e != null)) return;
      (n = n != null ? "" + Re(n) : ""),
        (e = e != null ? "" + Re(e) : n),
        y || e === t.value || (t.value = e),
        (t.defaultValue = e);
    }
    (i = i ?? s),
      (i = typeof i != "function" && typeof i != "symbol" && !!i),
      (t.checked = y ? t.checked : !!i),
      (t.defaultChecked = !!i),
      d != null &&
        typeof d != "function" &&
        typeof d != "symbol" &&
        typeof d != "boolean" &&
        (t.name = d);
  }
  function wo(t, e, n) {
    (e === "number" && Zl(t.ownerDocument) === t) ||
      t.defaultValue === "" + n ||
      (t.defaultValue = "" + n);
  }
  function wa(t, e, n, i) {
    if (((t = t.options), e)) {
      e = {};
      for (var s = 0; s < n.length; s++) e["$" + n[s]] = !0;
      for (n = 0; n < t.length; n++)
        (s = e.hasOwnProperty("$" + t[n].value)),
          t[n].selected !== s && (t[n].selected = s),
          s && i && (t[n].defaultSelected = !0);
    } else {
      for (n = "" + Re(n), e = null, s = 0; s < t.length; s++) {
        if (t[s].value === n) {
          (t[s].selected = !0), i && (t[s].defaultSelected = !0);
          return;
        }
        e !== null || t[s].disabled || (e = t[s]);
      }
      e !== null && (e.selected = !0);
    }
  }
  function yf(t, e, n) {
    if (
      e != null &&
      ((e = "" + Re(e)), e !== t.value && (t.value = e), n == null)
    ) {
      t.defaultValue !== e && (t.defaultValue = e);
      return;
    }
    t.defaultValue = n != null ? "" + Re(n) : "";
  }
  function vf(t, e, n, i) {
    if (e == null) {
      if (i != null) {
        if (n != null) throw Error(r(92));
        if (Ct(i)) {
          if (1 < i.length) throw Error(r(93));
          i = i[0];
        }
        n = i;
      }
      n == null && (n = ""), (e = n);
    }
    (n = Re(e)),
      (t.defaultValue = n),
      (i = t.textContent),
      i === n && i !== "" && i !== null && (t.value = i);
  }
  function Ra(t, e) {
    if (e) {
      var n = t.firstChild;
      if (n && n === t.lastChild && n.nodeType === 3) {
        n.nodeValue = e;
        return;
      }
    }
    t.textContent = e;
  }
  var Vv = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  );
  function bf(t, e, n) {
    var i = e.indexOf("--") === 0;
    n == null || typeof n == "boolean" || n === ""
      ? i
        ? t.setProperty(e, "")
        : e === "float"
        ? (t.cssFloat = "")
        : (t[e] = "")
      : i
      ? t.setProperty(e, n)
      : typeof n != "number" || n === 0 || Vv.has(e)
      ? e === "float"
        ? (t.cssFloat = n)
        : (t[e] = ("" + n).trim())
      : (t[e] = n + "px");
  }
  function xf(t, e, n) {
    if (e != null && typeof e != "object") throw Error(r(62));
    if (((t = t.style), n != null)) {
      for (var i in n)
        !n.hasOwnProperty(i) ||
          (e != null && e.hasOwnProperty(i)) ||
          (i.indexOf("--") === 0
            ? t.setProperty(i, "")
            : i === "float"
            ? (t.cssFloat = "")
            : (t[i] = ""));
      for (var s in e)
        (i = e[s]), e.hasOwnProperty(s) && n[s] !== i && bf(t, s, i);
    } else for (var u in e) e.hasOwnProperty(u) && bf(t, u, e[u]);
  }
  function Ro(t) {
    if (t.indexOf("-") === -1) return !1;
    switch (t) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var zv = new Map([
      ["acceptCharset", "accept-charset"],
      ["htmlFor", "for"],
      ["httpEquiv", "http-equiv"],
      ["crossOrigin", "crossorigin"],
      ["accentHeight", "accent-height"],
      ["alignmentBaseline", "alignment-baseline"],
      ["arabicForm", "arabic-form"],
      ["baselineShift", "baseline-shift"],
      ["capHeight", "cap-height"],
      ["clipPath", "clip-path"],
      ["clipRule", "clip-rule"],
      ["colorInterpolation", "color-interpolation"],
      ["colorInterpolationFilters", "color-interpolation-filters"],
      ["colorProfile", "color-profile"],
      ["colorRendering", "color-rendering"],
      ["dominantBaseline", "dominant-baseline"],
      ["enableBackground", "enable-background"],
      ["fillOpacity", "fill-opacity"],
      ["fillRule", "fill-rule"],
      ["floodColor", "flood-color"],
      ["floodOpacity", "flood-opacity"],
      ["fontFamily", "font-family"],
      ["fontSize", "font-size"],
      ["fontSizeAdjust", "font-size-adjust"],
      ["fontStretch", "font-stretch"],
      ["fontStyle", "font-style"],
      ["fontVariant", "font-variant"],
      ["fontWeight", "font-weight"],
      ["glyphName", "glyph-name"],
      ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
      ["glyphOrientationVertical", "glyph-orientation-vertical"],
      ["horizAdvX", "horiz-adv-x"],
      ["horizOriginX", "horiz-origin-x"],
      ["imageRendering", "image-rendering"],
      ["letterSpacing", "letter-spacing"],
      ["lightingColor", "lighting-color"],
      ["markerEnd", "marker-end"],
      ["markerMid", "marker-mid"],
      ["markerStart", "marker-start"],
      ["overlinePosition", "overline-position"],
      ["overlineThickness", "overline-thickness"],
      ["paintOrder", "paint-order"],
      ["panose-1", "panose-1"],
      ["pointerEvents", "pointer-events"],
      ["renderingIntent", "rendering-intent"],
      ["shapeRendering", "shape-rendering"],
      ["stopColor", "stop-color"],
      ["stopOpacity", "stop-opacity"],
      ["strikethroughPosition", "strikethrough-position"],
      ["strikethroughThickness", "strikethrough-thickness"],
      ["strokeDasharray", "stroke-dasharray"],
      ["strokeDashoffset", "stroke-dashoffset"],
      ["strokeLinecap", "stroke-linecap"],
      ["strokeLinejoin", "stroke-linejoin"],
      ["strokeMiterlimit", "stroke-miterlimit"],
      ["strokeOpacity", "stroke-opacity"],
      ["strokeWidth", "stroke-width"],
      ["textAnchor", "text-anchor"],
      ["textDecoration", "text-decoration"],
      ["textRendering", "text-rendering"],
      ["transformOrigin", "transform-origin"],
      ["underlinePosition", "underline-position"],
      ["underlineThickness", "underline-thickness"],
      ["unicodeBidi", "unicode-bidi"],
      ["unicodeRange", "unicode-range"],
      ["unitsPerEm", "units-per-em"],
      ["vAlphabetic", "v-alphabetic"],
      ["vHanging", "v-hanging"],
      ["vIdeographic", "v-ideographic"],
      ["vMathematical", "v-mathematical"],
      ["vectorEffect", "vector-effect"],
      ["vertAdvY", "vert-adv-y"],
      ["vertOriginX", "vert-origin-x"],
      ["vertOriginY", "vert-origin-y"],
      ["wordSpacing", "word-spacing"],
      ["writingMode", "writing-mode"],
      ["xmlnsXlink", "xmlns:xlink"],
      ["xHeight", "x-height"],
    ]),
    Nv =
      /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function Ql(t) {
    return Nv.test("" + t)
      ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')"
      : t;
  }
  var Oo = null;
  function Co(t) {
    return (
      (t = t.target || t.srcElement || window),
      t.correspondingUseElement && (t = t.correspondingUseElement),
      t.nodeType === 3 ? t.parentNode : t
    );
  }
  var Oa = null,
    Ca = null;
  function Sf(t) {
    var e = Aa(t);
    if (e && (t = e.stateNode)) {
      var n = t[fe] || null;
      t: switch (((t = e.stateNode), e.type)) {
        case "input":
          if (
            (Do(
              t,
              n.value,
              n.defaultValue,
              n.defaultValue,
              n.checked,
              n.defaultChecked,
              n.type,
              n.name
            ),
            (e = n.name),
            n.type === "radio" && e != null)
          ) {
            for (n = t; n.parentNode; ) n = n.parentNode;
            for (
              n = n.querySelectorAll(
                'input[name="' + Oe("" + e) + '"][type="radio"]'
              ),
                e = 0;
              e < n.length;
              e++
            ) {
              var i = n[e];
              if (i !== t && i.form === t.form) {
                var s = i[fe] || null;
                if (!s) throw Error(r(90));
                Do(
                  i,
                  s.value,
                  s.defaultValue,
                  s.defaultValue,
                  s.checked,
                  s.defaultChecked,
                  s.type,
                  s.name
                );
              }
            }
            for (e = 0; e < n.length; e++)
              (i = n[e]), i.form === t.form && pf(i);
          }
          break t;
        case "textarea":
          yf(t, n.value, n.defaultValue);
          break t;
        case "select":
          (e = n.value), e != null && wa(t, !!n.multiple, e, !1);
      }
    }
  }
  var Vo = !1;
  function Tf(t, e, n) {
    if (Vo) return t(e, n);
    Vo = !0;
    try {
      var i = t(e);
      return i;
    } finally {
      if (
        ((Vo = !1),
        (Oa !== null || Ca !== null) &&
          (Vs(), Oa && ((e = Oa), (t = Ca), (Ca = Oa = null), Sf(e), t)))
      )
        for (e = 0; e < t.length; e++) Sf(t[e]);
    }
  }
  function Mi(t, e) {
    var n = t.stateNode;
    if (n === null) return null;
    var i = n[fe] || null;
    if (i === null) return null;
    n = i[e];
    t: switch (e) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (i = !i.disabled) ||
          ((t = t.type),
          (i = !(
            t === "button" ||
            t === "input" ||
            t === "select" ||
            t === "textarea"
          ))),
          (t = !i);
        break t;
      default:
        t = !1;
    }
    if (t) return null;
    if (n && typeof n != "function") throw Error(r(231, e, typeof n));
    return n;
  }
  var tn = !(
      typeof window > "u" ||
      typeof window.document > "u" ||
      typeof window.document.createElement > "u"
    ),
    zo = !1;
  if (tn)
    try {
      var Di = {};
      Object.defineProperty(Di, "passive", {
        get: function () {
          zo = !0;
        },
      }),
        window.addEventListener("test", Di, Di),
        window.removeEventListener("test", Di, Di);
    } catch {
      zo = !1;
    }
  var An = null,
    No = null,
    Kl = null;
  function Af() {
    if (Kl) return Kl;
    var t,
      e = No,
      n = e.length,
      i,
      s = "value" in An ? An.value : An.textContent,
      u = s.length;
    for (t = 0; t < n && e[t] === s[t]; t++);
    var d = n - t;
    for (i = 1; i <= d && e[n - i] === s[u - i]; i++);
    return (Kl = s.slice(t, 1 < i ? 1 - i : void 0));
  }
  function Jl(t) {
    var e = t.keyCode;
    return (
      "charCode" in t
        ? ((t = t.charCode), t === 0 && e === 13 && (t = 13))
        : (t = e),
      t === 10 && (t = 13),
      32 <= t || t === 13 ? t : 0
    );
  }
  function Pl() {
    return !0;
  }
  function Ef() {
    return !1;
  }
  function de(t) {
    function e(n, i, s, u, d) {
      (this._reactName = n),
        (this._targetInst = s),
        (this.type = i),
        (this.nativeEvent = u),
        (this.target = d),
        (this.currentTarget = null);
      for (var y in t)
        t.hasOwnProperty(y) && ((n = t[y]), (this[y] = n ? n(u) : u[y]));
      return (
        (this.isDefaultPrevented = (
          u.defaultPrevented != null ? u.defaultPrevented : u.returnValue === !1
        )
          ? Pl
          : Ef),
        (this.isPropagationStopped = Ef),
        this
      );
    }
    return (
      v(e.prototype, {
        preventDefault: function () {
          this.defaultPrevented = !0;
          var n = this.nativeEvent;
          n &&
            (n.preventDefault
              ? n.preventDefault()
              : typeof n.returnValue != "unknown" && (n.returnValue = !1),
            (this.isDefaultPrevented = Pl));
        },
        stopPropagation: function () {
          var n = this.nativeEvent;
          n &&
            (n.stopPropagation
              ? n.stopPropagation()
              : typeof n.cancelBubble != "unknown" && (n.cancelBubble = !0),
            (this.isPropagationStopped = Pl));
        },
        persist: function () {},
        isPersistent: Pl,
      }),
      e
    );
  }
  var $n = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function (t) {
        return t.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0,
    },
    Fl = de($n),
    wi = v({}, $n, { view: 0, detail: 0 }),
    _v = de(wi),
    _o,
    Uo,
    Ri,
    Wl = v({}, wi, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: Bo,
      button: 0,
      buttons: 0,
      relatedTarget: function (t) {
        return t.relatedTarget === void 0
          ? t.fromElement === t.srcElement
            ? t.toElement
            : t.fromElement
          : t.relatedTarget;
      },
      movementX: function (t) {
        return "movementX" in t
          ? t.movementX
          : (t !== Ri &&
              (Ri && t.type === "mousemove"
                ? ((_o = t.screenX - Ri.screenX), (Uo = t.screenY - Ri.screenY))
                : (Uo = _o = 0),
              (Ri = t)),
            _o);
      },
      movementY: function (t) {
        return "movementY" in t ? t.movementY : Uo;
      },
    }),
    Mf = de(Wl),
    Uv = v({}, Wl, { dataTransfer: 0 }),
    jv = de(Uv),
    Bv = v({}, wi, { relatedTarget: 0 }),
    jo = de(Bv),
    Lv = v({}, $n, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }),
    Hv = de(Lv),
    Gv = v({}, $n, {
      clipboardData: function (t) {
        return "clipboardData" in t ? t.clipboardData : window.clipboardData;
      },
    }),
    qv = de(Gv),
    Yv = v({}, $n, { data: 0 }),
    Df = de(Yv),
    kv = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified",
    },
    Xv = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta",
    },
    Zv = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey",
    };
  function Qv(t) {
    var e = this.nativeEvent;
    return e.getModifierState
      ? e.getModifierState(t)
      : (t = Zv[t])
      ? !!e[t]
      : !1;
  }
  function Bo() {
    return Qv;
  }
  var Kv = v({}, wi, {
      key: function (t) {
        if (t.key) {
          var e = kv[t.key] || t.key;
          if (e !== "Unidentified") return e;
        }
        return t.type === "keypress"
          ? ((t = Jl(t)), t === 13 ? "Enter" : String.fromCharCode(t))
          : t.type === "keydown" || t.type === "keyup"
          ? Xv[t.keyCode] || "Unidentified"
          : "";
      },
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: Bo,
      charCode: function (t) {
        return t.type === "keypress" ? Jl(t) : 0;
      },
      keyCode: function (t) {
        return t.type === "keydown" || t.type === "keyup" ? t.keyCode : 0;
      },
      which: function (t) {
        return t.type === "keypress"
          ? Jl(t)
          : t.type === "keydown" || t.type === "keyup"
          ? t.keyCode
          : 0;
      },
    }),
    Jv = de(Kv),
    Pv = v({}, Wl, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0,
    }),
    wf = de(Pv),
    Fv = v({}, wi, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: Bo,
    }),
    Wv = de(Fv),
    $v = v({}, $n, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }),
    Iv = de($v),
    t0 = v({}, Wl, {
      deltaX: function (t) {
        return "deltaX" in t
          ? t.deltaX
          : "wheelDeltaX" in t
          ? -t.wheelDeltaX
          : 0;
      },
      deltaY: function (t) {
        return "deltaY" in t
          ? t.deltaY
          : "wheelDeltaY" in t
          ? -t.wheelDeltaY
          : "wheelDelta" in t
          ? -t.wheelDelta
          : 0;
      },
      deltaZ: 0,
      deltaMode: 0,
    }),
    e0 = de(t0),
    n0 = v({}, $n, { newState: 0, oldState: 0 }),
    a0 = de(n0),
    i0 = [9, 13, 27, 32],
    Lo = tn && "CompositionEvent" in window,
    Oi = null;
  tn && "documentMode" in document && (Oi = document.documentMode);
  var l0 = tn && "TextEvent" in window && !Oi,
    Rf = tn && (!Lo || (Oi && 8 < Oi && 11 >= Oi)),
    Of = " ",
    Cf = !1;
  function Vf(t, e) {
    switch (t) {
      case "keyup":
        return i0.indexOf(e.keyCode) !== -1;
      case "keydown":
        return e.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function zf(t) {
    return (t = t.detail), typeof t == "object" && "data" in t ? t.data : null;
  }
  var Va = !1;
  function s0(t, e) {
    switch (t) {
      case "compositionend":
        return zf(e);
      case "keypress":
        return e.which !== 32 ? null : ((Cf = !0), Of);
      case "textInput":
        return (t = e.data), t === Of && Cf ? null : t;
      default:
        return null;
    }
  }
  function o0(t, e) {
    if (Va)
      return t === "compositionend" || (!Lo && Vf(t, e))
        ? ((t = Af()), (Kl = No = An = null), (Va = !1), t)
        : null;
    switch (t) {
      case "paste":
        return null;
      case "keypress":
        if (!(e.ctrlKey || e.altKey || e.metaKey) || (e.ctrlKey && e.altKey)) {
          if (e.char && 1 < e.char.length) return e.char;
          if (e.which) return String.fromCharCode(e.which);
        }
        return null;
      case "compositionend":
        return Rf && e.locale !== "ko" ? null : e.data;
      default:
        return null;
    }
  }
  var r0 = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0,
  };
  function Nf(t) {
    var e = t && t.nodeName && t.nodeName.toLowerCase();
    return e === "input" ? !!r0[t.type] : e === "textarea";
  }
  function _f(t, e, n, i) {
    Oa ? (Ca ? Ca.push(i) : (Ca = [i])) : (Oa = i),
      (e = Bs(e, "onChange")),
      0 < e.length &&
        ((n = new Fl("onChange", "change", null, n, i)),
        t.push({ event: n, listeners: e }));
  }
  var Ci = null,
    Vi = null;
  function u0(t) {
    mm(t, 0);
  }
  function $l(t) {
    var e = Ei(t);
    if (pf(e)) return t;
  }
  function Uf(t, e) {
    if (t === "change") return e;
  }
  var jf = !1;
  if (tn) {
    var Ho;
    if (tn) {
      var Go = "oninput" in document;
      if (!Go) {
        var Bf = document.createElement("div");
        Bf.setAttribute("oninput", "return;"),
          (Go = typeof Bf.oninput == "function");
      }
      Ho = Go;
    } else Ho = !1;
    jf = Ho && (!document.documentMode || 9 < document.documentMode);
  }
  function Lf() {
    Ci && (Ci.detachEvent("onpropertychange", Hf), (Vi = Ci = null));
  }
  function Hf(t) {
    if (t.propertyName === "value" && $l(Vi)) {
      var e = [];
      _f(e, Vi, t, Co(t)), Tf(u0, e);
    }
  }
  function c0(t, e, n) {
    t === "focusin"
      ? (Lf(), (Ci = e), (Vi = n), Ci.attachEvent("onpropertychange", Hf))
      : t === "focusout" && Lf();
  }
  function f0(t) {
    if (t === "selectionchange" || t === "keyup" || t === "keydown")
      return $l(Vi);
  }
  function d0(t, e) {
    if (t === "click") return $l(e);
  }
  function h0(t, e) {
    if (t === "input" || t === "change") return $l(e);
  }
  function m0(t, e) {
    return (t === e && (t !== 0 || 1 / t === 1 / e)) || (t !== t && e !== e);
  }
  var xe = typeof Object.is == "function" ? Object.is : m0;
  function zi(t, e) {
    if (xe(t, e)) return !0;
    if (
      typeof t != "object" ||
      t === null ||
      typeof e != "object" ||
      e === null
    )
      return !1;
    var n = Object.keys(t),
      i = Object.keys(e);
    if (n.length !== i.length) return !1;
    for (i = 0; i < n.length; i++) {
      var s = n[i];
      if (!xn.call(e, s) || !xe(t[s], e[s])) return !1;
    }
    return !0;
  }
  function Gf(t) {
    for (; t && t.firstChild; ) t = t.firstChild;
    return t;
  }
  function qf(t, e) {
    var n = Gf(t);
    t = 0;
    for (var i; n; ) {
      if (n.nodeType === 3) {
        if (((i = t + n.textContent.length), t <= e && i >= e))
          return { node: n, offset: e - t };
        t = i;
      }
      t: {
        for (; n; ) {
          if (n.nextSibling) {
            n = n.nextSibling;
            break t;
          }
          n = n.parentNode;
        }
        n = void 0;
      }
      n = Gf(n);
    }
  }
  function Yf(t, e) {
    return t && e
      ? t === e
        ? !0
        : t && t.nodeType === 3
        ? !1
        : e && e.nodeType === 3
        ? Yf(t, e.parentNode)
        : "contains" in t
        ? t.contains(e)
        : t.compareDocumentPosition
        ? !!(t.compareDocumentPosition(e) & 16)
        : !1
      : !1;
  }
  function kf(t) {
    t =
      t != null &&
      t.ownerDocument != null &&
      t.ownerDocument.defaultView != null
        ? t.ownerDocument.defaultView
        : window;
    for (var e = Zl(t.document); e instanceof t.HTMLIFrameElement; ) {
      try {
        var n = typeof e.contentWindow.location.href == "string";
      } catch {
        n = !1;
      }
      if (n) t = e.contentWindow;
      else break;
      e = Zl(t.document);
    }
    return e;
  }
  function qo(t) {
    var e = t && t.nodeName && t.nodeName.toLowerCase();
    return (
      e &&
      ((e === "input" &&
        (t.type === "text" ||
          t.type === "search" ||
          t.type === "tel" ||
          t.type === "url" ||
          t.type === "password")) ||
        e === "textarea" ||
        t.contentEditable === "true")
    );
  }
  var p0 = tn && "documentMode" in document && 11 >= document.documentMode,
    za = null,
    Yo = null,
    Ni = null,
    ko = !1;
  function Xf(t, e, n) {
    var i =
      n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
    ko ||
      za == null ||
      za !== Zl(i) ||
      ((i = za),
      "selectionStart" in i && qo(i)
        ? (i = { start: i.selectionStart, end: i.selectionEnd })
        : ((i = (
            (i.ownerDocument && i.ownerDocument.defaultView) ||
            window
          ).getSelection()),
          (i = {
            anchorNode: i.anchorNode,
            anchorOffset: i.anchorOffset,
            focusNode: i.focusNode,
            focusOffset: i.focusOffset,
          })),
      (Ni && zi(Ni, i)) ||
        ((Ni = i),
        (i = Bs(Yo, "onSelect")),
        0 < i.length &&
          ((e = new Fl("onSelect", "select", null, e, n)),
          t.push({ event: e, listeners: i }),
          (e.target = za))));
  }
  function In(t, e) {
    var n = {};
    return (
      (n[t.toLowerCase()] = e.toLowerCase()),
      (n["Webkit" + t] = "webkit" + e),
      (n["Moz" + t] = "moz" + e),
      n
    );
  }
  var Na = {
      animationend: In("Animation", "AnimationEnd"),
      animationiteration: In("Animation", "AnimationIteration"),
      animationstart: In("Animation", "AnimationStart"),
      transitionrun: In("Transition", "TransitionRun"),
      transitionstart: In("Transition", "TransitionStart"),
      transitioncancel: In("Transition", "TransitionCancel"),
      transitionend: In("Transition", "TransitionEnd"),
    },
    Xo = {},
    Zf = {};
  tn &&
    ((Zf = document.createElement("div").style),
    "AnimationEvent" in window ||
      (delete Na.animationend.animation,
      delete Na.animationiteration.animation,
      delete Na.animationstart.animation),
    "TransitionEvent" in window || delete Na.transitionend.transition);
  function ta(t) {
    if (Xo[t]) return Xo[t];
    if (!Na[t]) return t;
    var e = Na[t],
      n;
    for (n in e) if (e.hasOwnProperty(n) && n in Zf) return (Xo[t] = e[n]);
    return t;
  }
  var Qf = ta("animationend"),
    Kf = ta("animationiteration"),
    Jf = ta("animationstart"),
    g0 = ta("transitionrun"),
    y0 = ta("transitionstart"),
    v0 = ta("transitioncancel"),
    Pf = ta("transitionend"),
    Ff = new Map(),
    Zo =
      "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
        " "
      );
  Zo.push("scrollEnd");
  function Ge(t, e) {
    Ff.set(t, e), Wn(e, [t]);
  }
  var Wf = new WeakMap();
  function Ce(t, e) {
    if (typeof t == "object" && t !== null) {
      var n = Wf.get(t);
      return n !== void 0
        ? n
        : ((e = { value: t, source: e, stack: hf(e) }), Wf.set(t, e), e);
    }
    return { value: t, source: e, stack: hf(e) };
  }
  var Ve = [],
    _a = 0,
    Qo = 0;
  function Il() {
    for (var t = _a, e = (Qo = _a = 0); e < t; ) {
      var n = Ve[e];
      Ve[e++] = null;
      var i = Ve[e];
      Ve[e++] = null;
      var s = Ve[e];
      Ve[e++] = null;
      var u = Ve[e];
      if (((Ve[e++] = null), i !== null && s !== null)) {
        var d = i.pending;
        d === null ? (s.next = s) : ((s.next = d.next), (d.next = s)),
          (i.pending = s);
      }
      u !== 0 && $f(n, s, u);
    }
  }
  function ts(t, e, n, i) {
    (Ve[_a++] = t),
      (Ve[_a++] = e),
      (Ve[_a++] = n),
      (Ve[_a++] = i),
      (Qo |= i),
      (t.lanes |= i),
      (t = t.alternate),
      t !== null && (t.lanes |= i);
  }
  function Ko(t, e, n, i) {
    return ts(t, e, n, i), es(t);
  }
  function Ua(t, e) {
    return ts(t, null, null, e), es(t);
  }
  function $f(t, e, n) {
    t.lanes |= n;
    var i = t.alternate;
    i !== null && (i.lanes |= n);
    for (var s = !1, u = t.return; u !== null; )
      (u.childLanes |= n),
        (i = u.alternate),
        i !== null && (i.childLanes |= n),
        u.tag === 22 &&
          ((t = u.stateNode), t === null || t._visibility & 1 || (s = !0)),
        (t = u),
        (u = u.return);
    return t.tag === 3
      ? ((u = t.stateNode),
        s &&
          e !== null &&
          ((s = 31 - be(n)),
          (t = u.hiddenUpdates),
          (i = t[s]),
          i === null ? (t[s] = [e]) : i.push(e),
          (e.lane = n | 536870912)),
        u)
      : null;
  }
  function es(t) {
    if (50 < il) throw ((il = 0), (Ir = null), Error(r(185)));
    for (var e = t.return; e !== null; ) (t = e), (e = t.return);
    return t.tag === 3 ? t.stateNode : null;
  }
  var ja = {};
  function b0(t, e, n, i) {
    (this.tag = t),
      (this.key = n),
      (this.sibling =
        this.child =
        this.return =
        this.stateNode =
        this.type =
        this.elementType =
          null),
      (this.index = 0),
      (this.refCleanup = this.ref = null),
      (this.pendingProps = e),
      (this.dependencies =
        this.memoizedState =
        this.updateQueue =
        this.memoizedProps =
          null),
      (this.mode = i),
      (this.subtreeFlags = this.flags = 0),
      (this.deletions = null),
      (this.childLanes = this.lanes = 0),
      (this.alternate = null);
  }
  function Se(t, e, n, i) {
    return new b0(t, e, n, i);
  }
  function Jo(t) {
    return (t = t.prototype), !(!t || !t.isReactComponent);
  }
  function en(t, e) {
    var n = t.alternate;
    return (
      n === null
        ? ((n = Se(t.tag, e, t.key, t.mode)),
          (n.elementType = t.elementType),
          (n.type = t.type),
          (n.stateNode = t.stateNode),
          (n.alternate = t),
          (t.alternate = n))
        : ((n.pendingProps = e),
          (n.type = t.type),
          (n.flags = 0),
          (n.subtreeFlags = 0),
          (n.deletions = null)),
      (n.flags = t.flags & 65011712),
      (n.childLanes = t.childLanes),
      (n.lanes = t.lanes),
      (n.child = t.child),
      (n.memoizedProps = t.memoizedProps),
      (n.memoizedState = t.memoizedState),
      (n.updateQueue = t.updateQueue),
      (e = t.dependencies),
      (n.dependencies =
        e === null ? null : { lanes: e.lanes, firstContext: e.firstContext }),
      (n.sibling = t.sibling),
      (n.index = t.index),
      (n.ref = t.ref),
      (n.refCleanup = t.refCleanup),
      n
    );
  }
  function If(t, e) {
    t.flags &= 65011714;
    var n = t.alternate;
    return (
      n === null
        ? ((t.childLanes = 0),
          (t.lanes = e),
          (t.child = null),
          (t.subtreeFlags = 0),
          (t.memoizedProps = null),
          (t.memoizedState = null),
          (t.updateQueue = null),
          (t.dependencies = null),
          (t.stateNode = null))
        : ((t.childLanes = n.childLanes),
          (t.lanes = n.lanes),
          (t.child = n.child),
          (t.subtreeFlags = 0),
          (t.deletions = null),
          (t.memoizedProps = n.memoizedProps),
          (t.memoizedState = n.memoizedState),
          (t.updateQueue = n.updateQueue),
          (t.type = n.type),
          (e = n.dependencies),
          (t.dependencies =
            e === null
              ? null
              : { lanes: e.lanes, firstContext: e.firstContext })),
      t
    );
  }
  function ns(t, e, n, i, s, u) {
    var d = 0;
    if (((i = t), typeof t == "function")) Jo(t) && (d = 1);
    else if (typeof t == "string")
      d = Sb(t, n, K.current)
        ? 26
        : t === "html" || t === "head" || t === "body"
        ? 27
        : 5;
    else
      t: switch (t) {
        case pt:
          return (t = Se(31, n, e, s)), (t.elementType = pt), (t.lanes = u), t;
        case B:
          return ea(n.children, s, u, e);
        case L:
          (d = 8), (s |= 24);
          break;
        case Y:
          return (
            (t = Se(12, n, e, s | 2)), (t.elementType = Y), (t.lanes = u), t
          );
        case k:
          return (t = Se(13, n, e, s)), (t.elementType = k), (t.lanes = u), t;
        case nt:
          return (t = Se(19, n, e, s)), (t.elementType = nt), (t.lanes = u), t;
        default:
          if (typeof t == "object" && t !== null)
            switch (t.$$typeof) {
              case Z:
              case X:
                d = 10;
                break t;
              case $:
                d = 9;
                break t;
              case lt:
                d = 11;
                break t;
              case rt:
                d = 14;
                break t;
              case G:
                (d = 16), (i = null);
                break t;
            }
          (d = 29),
            (n = Error(r(130, t === null ? "null" : typeof t, ""))),
            (i = null);
      }
    return (
      (e = Se(d, n, e, s)), (e.elementType = t), (e.type = i), (e.lanes = u), e
    );
  }
  function ea(t, e, n, i) {
    return (t = Se(7, t, i, e)), (t.lanes = n), t;
  }
  function Po(t, e, n) {
    return (t = Se(6, t, null, e)), (t.lanes = n), t;
  }
  function Fo(t, e, n) {
    return (
      (e = Se(4, t.children !== null ? t.children : [], t.key, e)),
      (e.lanes = n),
      (e.stateNode = {
        containerInfo: t.containerInfo,
        pendingChildren: null,
        implementation: t.implementation,
      }),
      e
    );
  }
  var Ba = [],
    La = 0,
    as = null,
    is = 0,
    ze = [],
    Ne = 0,
    na = null,
    nn = 1,
    an = "";
  function aa(t, e) {
    (Ba[La++] = is), (Ba[La++] = as), (as = t), (is = e);
  }
  function td(t, e, n) {
    (ze[Ne++] = nn), (ze[Ne++] = an), (ze[Ne++] = na), (na = t);
    var i = nn;
    t = an;
    var s = 32 - be(i) - 1;
    (i &= ~(1 << s)), (n += 1);
    var u = 32 - be(e) + s;
    if (30 < u) {
      var d = s - (s % 5);
      (u = (i & ((1 << d) - 1)).toString(32)),
        (i >>= d),
        (s -= d),
        (nn = (1 << (32 - be(e) + s)) | (n << s) | i),
        (an = u + t);
    } else (nn = (1 << u) | (n << s) | i), (an = t);
  }
  function Wo(t) {
    t.return !== null && (aa(t, 1), td(t, 1, 0));
  }
  function $o(t) {
    for (; t === as; )
      (as = Ba[--La]), (Ba[La] = null), (is = Ba[--La]), (Ba[La] = null);
    for (; t === na; )
      (na = ze[--Ne]),
        (ze[Ne] = null),
        (an = ze[--Ne]),
        (ze[Ne] = null),
        (nn = ze[--Ne]),
        (ze[Ne] = null);
  }
  var oe = null,
    jt = null,
    xt = !1,
    ia = null,
    Ze = !1,
    Io = Error(r(519));
  function la(t) {
    var e = Error(r(418, ""));
    throw (ji(Ce(e, t)), Io);
  }
  function ed(t) {
    var e = t.stateNode,
      n = t.type,
      i = t.memoizedProps;
    switch (((e[ne] = t), (e[fe] = i), n)) {
      case "dialog":
        mt("cancel", e), mt("close", e);
        break;
      case "iframe":
      case "object":
      case "embed":
        mt("load", e);
        break;
      case "video":
      case "audio":
        for (n = 0; n < sl.length; n++) mt(sl[n], e);
        break;
      case "source":
        mt("error", e);
        break;
      case "img":
      case "image":
      case "link":
        mt("error", e), mt("load", e);
        break;
      case "details":
        mt("toggle", e);
        break;
      case "input":
        mt("invalid", e),
          gf(
            e,
            i.value,
            i.defaultValue,
            i.checked,
            i.defaultChecked,
            i.type,
            i.name,
            !0
          ),
          Xl(e);
        break;
      case "select":
        mt("invalid", e);
        break;
      case "textarea":
        mt("invalid", e), vf(e, i.value, i.defaultValue, i.children), Xl(e);
    }
    (n = i.children),
      (typeof n != "string" && typeof n != "number" && typeof n != "bigint") ||
      e.textContent === "" + n ||
      i.suppressHydrationWarning === !0 ||
      vm(e.textContent, n)
        ? (i.popover != null && (mt("beforetoggle", e), mt("toggle", e)),
          i.onScroll != null && mt("scroll", e),
          i.onScrollEnd != null && mt("scrollend", e),
          i.onClick != null && (e.onclick = Ls),
          (e = !0))
        : (e = !1),
      e || la(t);
  }
  function nd(t) {
    for (oe = t.return; oe; )
      switch (oe.tag) {
        case 5:
        case 13:
          Ze = !1;
          return;
        case 27:
        case 3:
          Ze = !0;
          return;
        default:
          oe = oe.return;
      }
  }
  function _i(t) {
    if (t !== oe) return !1;
    if (!xt) return nd(t), (xt = !0), !1;
    var e = t.tag,
      n;
    if (
      ((n = e !== 3 && e !== 27) &&
        ((n = e === 5) &&
          ((n = t.type),
          (n =
            !(n !== "form" && n !== "button") || pu(t.type, t.memoizedProps))),
        (n = !n)),
      n && jt && la(t),
      nd(t),
      e === 13)
    ) {
      if (((t = t.memoizedState), (t = t !== null ? t.dehydrated : null), !t))
        throw Error(r(317));
      t: {
        for (t = t.nextSibling, e = 0; t; ) {
          if (t.nodeType === 8)
            if (((n = t.data), n === "/$")) {
              if (e === 0) {
                jt = Ye(t.nextSibling);
                break t;
              }
              e--;
            } else (n !== "$" && n !== "$!" && n !== "$?") || e++;
          t = t.nextSibling;
        }
        jt = null;
      }
    } else
      e === 27
        ? ((e = jt), Hn(t.type) ? ((t = bu), (bu = null), (jt = t)) : (jt = e))
        : (jt = oe ? Ye(t.stateNode.nextSibling) : null);
    return !0;
  }
  function Ui() {
    (jt = oe = null), (xt = !1);
  }
  function ad() {
    var t = ia;
    return (
      t !== null &&
        (pe === null ? (pe = t) : pe.push.apply(pe, t), (ia = null)),
      t
    );
  }
  function ji(t) {
    ia === null ? (ia = [t]) : ia.push(t);
  }
  var tr = U(null),
    sa = null,
    ln = null;
  function En(t, e, n) {
    q(tr, e._currentValue), (e._currentValue = n);
  }
  function sn(t) {
    (t._currentValue = tr.current), Q(tr);
  }
  function er(t, e, n) {
    for (; t !== null; ) {
      var i = t.alternate;
      if (
        ((t.childLanes & e) !== e
          ? ((t.childLanes |= e), i !== null && (i.childLanes |= e))
          : i !== null && (i.childLanes & e) !== e && (i.childLanes |= e),
        t === n)
      )
        break;
      t = t.return;
    }
  }
  function nr(t, e, n, i) {
    var s = t.child;
    for (s !== null && (s.return = t); s !== null; ) {
      var u = s.dependencies;
      if (u !== null) {
        var d = s.child;
        u = u.firstContext;
        t: for (; u !== null; ) {
          var y = u;
          u = s;
          for (var x = 0; x < e.length; x++)
            if (y.context === e[x]) {
              (u.lanes |= n),
                (y = u.alternate),
                y !== null && (y.lanes |= n),
                er(u.return, n, t),
                i || (d = null);
              break t;
            }
          u = y.next;
        }
      } else if (s.tag === 18) {
        if (((d = s.return), d === null)) throw Error(r(341));
        (d.lanes |= n),
          (u = d.alternate),
          u !== null && (u.lanes |= n),
          er(d, n, t),
          (d = null);
      } else d = s.child;
      if (d !== null) d.return = s;
      else
        for (d = s; d !== null; ) {
          if (d === t) {
            d = null;
            break;
          }
          if (((s = d.sibling), s !== null)) {
            (s.return = d.return), (d = s);
            break;
          }
          d = d.return;
        }
      s = d;
    }
  }
  function Bi(t, e, n, i) {
    t = null;
    for (var s = e, u = !1; s !== null; ) {
      if (!u) {
        if ((s.flags & 524288) !== 0) u = !0;
        else if ((s.flags & 262144) !== 0) break;
      }
      if (s.tag === 10) {
        var d = s.alternate;
        if (d === null) throw Error(r(387));
        if (((d = d.memoizedProps), d !== null)) {
          var y = s.type;
          xe(s.pendingProps.value, d.value) ||
            (t !== null ? t.push(y) : (t = [y]));
        }
      } else if (s === vt.current) {
        if (((d = s.alternate), d === null)) throw Error(r(387));
        d.memoizedState.memoizedState !== s.memoizedState.memoizedState &&
          (t !== null ? t.push(dl) : (t = [dl]));
      }
      s = s.return;
    }
    t !== null && nr(e, t, n, i), (e.flags |= 262144);
  }
  function ls(t) {
    for (t = t.firstContext; t !== null; ) {
      if (!xe(t.context._currentValue, t.memoizedValue)) return !0;
      t = t.next;
    }
    return !1;
  }
  function oa(t) {
    (sa = t),
      (ln = null),
      (t = t.dependencies),
      t !== null && (t.firstContext = null);
  }
  function ae(t) {
    return id(sa, t);
  }
  function ss(t, e) {
    return sa === null && oa(t), id(t, e);
  }
  function id(t, e) {
    var n = e._currentValue;
    if (((e = { context: e, memoizedValue: n, next: null }), ln === null)) {
      if (t === null) throw Error(r(308));
      (ln = e),
        (t.dependencies = { lanes: 0, firstContext: e }),
        (t.flags |= 524288);
    } else ln = ln.next = e;
    return n;
  }
  var x0 =
      typeof AbortController < "u"
        ? AbortController
        : function () {
            var t = [],
              e = (this.signal = {
                aborted: !1,
                addEventListener: function (n, i) {
                  t.push(i);
                },
              });
            this.abort = function () {
              (e.aborted = !0),
                t.forEach(function (n) {
                  return n();
                });
            };
          },
    S0 = a.unstable_scheduleCallback,
    T0 = a.unstable_NormalPriority,
    Zt = {
      $$typeof: X,
      Consumer: null,
      Provider: null,
      _currentValue: null,
      _currentValue2: null,
      _threadCount: 0,
    };
  function ar() {
    return { controller: new x0(), data: new Map(), refCount: 0 };
  }
  function Li(t) {
    t.refCount--,
      t.refCount === 0 &&
        S0(T0, function () {
          t.controller.abort();
        });
  }
  var Hi = null,
    ir = 0,
    Ha = 0,
    Ga = null;
  function A0(t, e) {
    if (Hi === null) {
      var n = (Hi = []);
      (ir = 0),
        (Ha = su()),
        (Ga = {
          status: "pending",
          value: void 0,
          then: function (i) {
            n.push(i);
          },
        });
    }
    return ir++, e.then(ld, ld), e;
  }
  function ld() {
    if (--ir === 0 && Hi !== null) {
      Ga !== null && (Ga.status = "fulfilled");
      var t = Hi;
      (Hi = null), (Ha = 0), (Ga = null);
      for (var e = 0; e < t.length; e++) (0, t[e])();
    }
  }
  function E0(t, e) {
    var n = [],
      i = {
        status: "pending",
        value: null,
        reason: null,
        then: function (s) {
          n.push(s);
        },
      };
    return (
      t.then(
        function () {
          (i.status = "fulfilled"), (i.value = e);
          for (var s = 0; s < n.length; s++) (0, n[s])(e);
        },
        function (s) {
          for (i.status = "rejected", i.reason = s, s = 0; s < n.length; s++)
            (0, n[s])(void 0);
        }
      ),
      i
    );
  }
  var sd = C.S;
  C.S = function (t, e) {
    typeof e == "object" &&
      e !== null &&
      typeof e.then == "function" &&
      A0(t, e),
      sd !== null && sd(t, e);
  };
  var ra = U(null);
  function lr() {
    var t = ra.current;
    return t !== null ? t : Rt.pooledCache;
  }
  function os(t, e) {
    e === null ? q(ra, ra.current) : q(ra, e.pool);
  }
  function od() {
    var t = lr();
    return t === null ? null : { parent: Zt._currentValue, pool: t };
  }
  var Gi = Error(r(460)),
    rd = Error(r(474)),
    rs = Error(r(542)),
    sr = { then: function () {} };
  function ud(t) {
    return (t = t.status), t === "fulfilled" || t === "rejected";
  }
  function us() {}
  function cd(t, e, n) {
    switch (
      ((n = t[n]),
      n === void 0 ? t.push(e) : n !== e && (e.then(us, us), (e = n)),
      e.status)
    ) {
      case "fulfilled":
        return e.value;
      case "rejected":
        throw ((t = e.reason), dd(t), t);
      default:
        if (typeof e.status == "string") e.then(us, us);
        else {
          if (((t = Rt), t !== null && 100 < t.shellSuspendCounter))
            throw Error(r(482));
          (t = e),
            (t.status = "pending"),
            t.then(
              function (i) {
                if (e.status === "pending") {
                  var s = e;
                  (s.status = "fulfilled"), (s.value = i);
                }
              },
              function (i) {
                if (e.status === "pending") {
                  var s = e;
                  (s.status = "rejected"), (s.reason = i);
                }
              }
            );
        }
        switch (e.status) {
          case "fulfilled":
            return e.value;
          case "rejected":
            throw ((t = e.reason), dd(t), t);
        }
        throw ((qi = e), Gi);
    }
  }
  var qi = null;
  function fd() {
    if (qi === null) throw Error(r(459));
    var t = qi;
    return (qi = null), t;
  }
  function dd(t) {
    if (t === Gi || t === rs) throw Error(r(483));
  }
  var Mn = !1;
  function or(t) {
    t.updateQueue = {
      baseState: t.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, lanes: 0, hiddenCallbacks: null },
      callbacks: null,
    };
  }
  function rr(t, e) {
    (t = t.updateQueue),
      e.updateQueue === t &&
        (e.updateQueue = {
          baseState: t.baseState,
          firstBaseUpdate: t.firstBaseUpdate,
          lastBaseUpdate: t.lastBaseUpdate,
          shared: t.shared,
          callbacks: null,
        });
  }
  function Dn(t) {
    return { lane: t, tag: 0, payload: null, callback: null, next: null };
  }
  function wn(t, e, n) {
    var i = t.updateQueue;
    if (i === null) return null;
    if (((i = i.shared), (St & 2) !== 0)) {
      var s = i.pending;
      return (
        s === null ? (e.next = e) : ((e.next = s.next), (s.next = e)),
        (i.pending = e),
        (e = es(t)),
        $f(t, null, n),
        e
      );
    }
    return ts(t, i, e, n), es(t);
  }
  function Yi(t, e, n) {
    if (
      ((e = e.updateQueue), e !== null && ((e = e.shared), (n & 4194048) !== 0))
    ) {
      var i = e.lanes;
      (i &= t.pendingLanes), (n |= i), (e.lanes = n), lf(t, n);
    }
  }
  function ur(t, e) {
    var n = t.updateQueue,
      i = t.alternate;
    if (i !== null && ((i = i.updateQueue), n === i)) {
      var s = null,
        u = null;
      if (((n = n.firstBaseUpdate), n !== null)) {
        do {
          var d = {
            lane: n.lane,
            tag: n.tag,
            payload: n.payload,
            callback: null,
            next: null,
          };
          u === null ? (s = u = d) : (u = u.next = d), (n = n.next);
        } while (n !== null);
        u === null ? (s = u = e) : (u = u.next = e);
      } else s = u = e;
      (n = {
        baseState: i.baseState,
        firstBaseUpdate: s,
        lastBaseUpdate: u,
        shared: i.shared,
        callbacks: i.callbacks,
      }),
        (t.updateQueue = n);
      return;
    }
    (t = n.lastBaseUpdate),
      t === null ? (n.firstBaseUpdate = e) : (t.next = e),
      (n.lastBaseUpdate = e);
  }
  var cr = !1;
  function ki() {
    if (cr) {
      var t = Ga;
      if (t !== null) throw t;
    }
  }
  function Xi(t, e, n, i) {
    cr = !1;
    var s = t.updateQueue;
    Mn = !1;
    var u = s.firstBaseUpdate,
      d = s.lastBaseUpdate,
      y = s.shared.pending;
    if (y !== null) {
      s.shared.pending = null;
      var x = y,
        D = x.next;
      (x.next = null), d === null ? (u = D) : (d.next = D), (d = x);
      var V = t.alternate;
      V !== null &&
        ((V = V.updateQueue),
        (y = V.lastBaseUpdate),
        y !== d &&
          (y === null ? (V.firstBaseUpdate = D) : (y.next = D),
          (V.lastBaseUpdate = x)));
    }
    if (u !== null) {
      var N = s.baseState;
      (d = 0), (V = D = x = null), (y = u);
      do {
        var w = y.lane & -536870913,
          R = w !== y.lane;
        if (R ? (yt & w) === w : (i & w) === w) {
          w !== 0 && w === Ha && (cr = !0),
            V !== null &&
              (V = V.next =
                {
                  lane: 0,
                  tag: y.tag,
                  payload: y.payload,
                  callback: null,
                  next: null,
                });
          t: {
            var at = t,
              tt = y;
            w = e;
            var Mt = n;
            switch (tt.tag) {
              case 1:
                if (((at = tt.payload), typeof at == "function")) {
                  N = at.call(Mt, N, w);
                  break t;
                }
                N = at;
                break t;
              case 3:
                at.flags = (at.flags & -65537) | 128;
              case 0:
                if (
                  ((at = tt.payload),
                  (w = typeof at == "function" ? at.call(Mt, N, w) : at),
                  w == null)
                )
                  break t;
                N = v({}, N, w);
                break t;
              case 2:
                Mn = !0;
            }
          }
          (w = y.callback),
            w !== null &&
              ((t.flags |= 64),
              R && (t.flags |= 8192),
              (R = s.callbacks),
              R === null ? (s.callbacks = [w]) : R.push(w));
        } else
          (R = {
            lane: w,
            tag: y.tag,
            payload: y.payload,
            callback: y.callback,
            next: null,
          }),
            V === null ? ((D = V = R), (x = N)) : (V = V.next = R),
            (d |= w);
        if (((y = y.next), y === null)) {
          if (((y = s.shared.pending), y === null)) break;
          (R = y),
            (y = R.next),
            (R.next = null),
            (s.lastBaseUpdate = R),
            (s.shared.pending = null);
        }
      } while (!0);
      V === null && (x = N),
        (s.baseState = x),
        (s.firstBaseUpdate = D),
        (s.lastBaseUpdate = V),
        u === null && (s.shared.lanes = 0),
        (Un |= d),
        (t.lanes = d),
        (t.memoizedState = N);
    }
  }
  function hd(t, e) {
    if (typeof t != "function") throw Error(r(191, t));
    t.call(e);
  }
  function md(t, e) {
    var n = t.callbacks;
    if (n !== null)
      for (t.callbacks = null, t = 0; t < n.length; t++) hd(n[t], e);
  }
  var qa = U(null),
    cs = U(0);
  function pd(t, e) {
    (t = hn), q(cs, t), q(qa, e), (hn = t | e.baseLanes);
  }
  function fr() {
    q(cs, hn), q(qa, qa.current);
  }
  function dr() {
    (hn = cs.current), Q(qa), Q(cs);
  }
  var Rn = 0,
    ut = null,
    At = null,
    Yt = null,
    fs = !1,
    Ya = !1,
    ua = !1,
    ds = 0,
    Zi = 0,
    ka = null,
    M0 = 0;
  function Ht() {
    throw Error(r(321));
  }
  function hr(t, e) {
    if (e === null) return !1;
    for (var n = 0; n < e.length && n < t.length; n++)
      if (!xe(t[n], e[n])) return !1;
    return !0;
  }
  function mr(t, e, n, i, s, u) {
    return (
      (Rn = u),
      (ut = e),
      (e.memoizedState = null),
      (e.updateQueue = null),
      (e.lanes = 0),
      (C.H = t === null || t.memoizedState === null ? $d : Id),
      (ua = !1),
      (u = n(i, s)),
      (ua = !1),
      Ya && (u = yd(e, n, i, s)),
      gd(t),
      u
    );
  }
  function gd(t) {
    C.H = vs;
    var e = At !== null && At.next !== null;
    if (((Rn = 0), (Yt = At = ut = null), (fs = !1), (Zi = 0), (ka = null), e))
      throw Error(r(300));
    t === null ||
      Pt ||
      ((t = t.dependencies), t !== null && ls(t) && (Pt = !0));
  }
  function yd(t, e, n, i) {
    ut = t;
    var s = 0;
    do {
      if ((Ya && (ka = null), (Zi = 0), (Ya = !1), 25 <= s))
        throw Error(r(301));
      if (((s += 1), (Yt = At = null), t.updateQueue != null)) {
        var u = t.updateQueue;
        (u.lastEffect = null),
          (u.events = null),
          (u.stores = null),
          u.memoCache != null && (u.memoCache.index = 0);
      }
      (C.H = z0), (u = e(n, i));
    } while (Ya);
    return u;
  }
  function D0() {
    var t = C.H,
      e = t.useState()[0];
    return (
      (e = typeof e.then == "function" ? Qi(e) : e),
      (t = t.useState()[0]),
      (At !== null ? At.memoizedState : null) !== t && (ut.flags |= 1024),
      e
    );
  }
  function pr() {
    var t = ds !== 0;
    return (ds = 0), t;
  }
  function gr(t, e, n) {
    (e.updateQueue = t.updateQueue), (e.flags &= -2053), (t.lanes &= ~n);
  }
  function yr(t) {
    if (fs) {
      for (t = t.memoizedState; t !== null; ) {
        var e = t.queue;
        e !== null && (e.pending = null), (t = t.next);
      }
      fs = !1;
    }
    (Rn = 0), (Yt = At = ut = null), (Ya = !1), (Zi = ds = 0), (ka = null);
  }
  function he() {
    var t = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null,
    };
    return Yt === null ? (ut.memoizedState = Yt = t) : (Yt = Yt.next = t), Yt;
  }
  function kt() {
    if (At === null) {
      var t = ut.alternate;
      t = t !== null ? t.memoizedState : null;
    } else t = At.next;
    var e = Yt === null ? ut.memoizedState : Yt.next;
    if (e !== null) (Yt = e), (At = t);
    else {
      if (t === null)
        throw ut.alternate === null ? Error(r(467)) : Error(r(310));
      (At = t),
        (t = {
          memoizedState: At.memoizedState,
          baseState: At.baseState,
          baseQueue: At.baseQueue,
          queue: At.queue,
          next: null,
        }),
        Yt === null ? (ut.memoizedState = Yt = t) : (Yt = Yt.next = t);
    }
    return Yt;
  }
  function vr() {
    return { lastEffect: null, events: null, stores: null, memoCache: null };
  }
  function Qi(t) {
    var e = Zi;
    return (
      (Zi += 1),
      ka === null && (ka = []),
      (t = cd(ka, t, e)),
      (e = ut),
      (Yt === null ? e.memoizedState : Yt.next) === null &&
        ((e = e.alternate),
        (C.H = e === null || e.memoizedState === null ? $d : Id)),
      t
    );
  }
  function hs(t) {
    if (t !== null && typeof t == "object") {
      if (typeof t.then == "function") return Qi(t);
      if (t.$$typeof === X) return ae(t);
    }
    throw Error(r(438, String(t)));
  }
  function br(t) {
    var e = null,
      n = ut.updateQueue;
    if ((n !== null && (e = n.memoCache), e == null)) {
      var i = ut.alternate;
      i !== null &&
        ((i = i.updateQueue),
        i !== null &&
          ((i = i.memoCache),
          i != null &&
            (e = {
              data: i.data.map(function (s) {
                return s.slice();
              }),
              index: 0,
            })));
    }
    if (
      (e == null && (e = { data: [], index: 0 }),
      n === null && ((n = vr()), (ut.updateQueue = n)),
      (n.memoCache = e),
      (n = e.data[e.index]),
      n === void 0)
    )
      for (n = e.data[e.index] = Array(t), i = 0; i < t; i++) n[i] = Ut;
    return e.index++, n;
  }
  function on(t, e) {
    return typeof e == "function" ? e(t) : e;
  }
  function ms(t) {
    var e = kt();
    return xr(e, At, t);
  }
  function xr(t, e, n) {
    var i = t.queue;
    if (i === null) throw Error(r(311));
    i.lastRenderedReducer = n;
    var s = t.baseQueue,
      u = i.pending;
    if (u !== null) {
      if (s !== null) {
        var d = s.next;
        (s.next = u.next), (u.next = d);
      }
      (e.baseQueue = s = u), (i.pending = null);
    }
    if (((u = t.baseState), s === null)) t.memoizedState = u;
    else {
      e = s.next;
      var y = (d = null),
        x = null,
        D = e,
        V = !1;
      do {
        var N = D.lane & -536870913;
        if (N !== D.lane ? (yt & N) === N : (Rn & N) === N) {
          var w = D.revertLane;
          if (w === 0)
            x !== null &&
              (x = x.next =
                {
                  lane: 0,
                  revertLane: 0,
                  action: D.action,
                  hasEagerState: D.hasEagerState,
                  eagerState: D.eagerState,
                  next: null,
                }),
              N === Ha && (V = !0);
          else if ((Rn & w) === w) {
            (D = D.next), w === Ha && (V = !0);
            continue;
          } else
            (N = {
              lane: 0,
              revertLane: D.revertLane,
              action: D.action,
              hasEagerState: D.hasEagerState,
              eagerState: D.eagerState,
              next: null,
            }),
              x === null ? ((y = x = N), (d = u)) : (x = x.next = N),
              (ut.lanes |= w),
              (Un |= w);
          (N = D.action),
            ua && n(u, N),
            (u = D.hasEagerState ? D.eagerState : n(u, N));
        } else
          (w = {
            lane: N,
            revertLane: D.revertLane,
            action: D.action,
            hasEagerState: D.hasEagerState,
            eagerState: D.eagerState,
            next: null,
          }),
            x === null ? ((y = x = w), (d = u)) : (x = x.next = w),
            (ut.lanes |= N),
            (Un |= N);
        D = D.next;
      } while (D !== null && D !== e);
      if (
        (x === null ? (d = u) : (x.next = y),
        !xe(u, t.memoizedState) && ((Pt = !0), V && ((n = Ga), n !== null)))
      )
        throw n;
      (t.memoizedState = u),
        (t.baseState = d),
        (t.baseQueue = x),
        (i.lastRenderedState = u);
    }
    return s === null && (i.lanes = 0), [t.memoizedState, i.dispatch];
  }
  function Sr(t) {
    var e = kt(),
      n = e.queue;
    if (n === null) throw Error(r(311));
    n.lastRenderedReducer = t;
    var i = n.dispatch,
      s = n.pending,
      u = e.memoizedState;
    if (s !== null) {
      n.pending = null;
      var d = (s = s.next);
      do (u = t(u, d.action)), (d = d.next);
      while (d !== s);
      xe(u, e.memoizedState) || (Pt = !0),
        (e.memoizedState = u),
        e.baseQueue === null && (e.baseState = u),
        (n.lastRenderedState = u);
    }
    return [u, i];
  }
  function vd(t, e, n) {
    var i = ut,
      s = kt(),
      u = xt;
    if (u) {
      if (n === void 0) throw Error(r(407));
      n = n();
    } else n = e();
    var d = !xe((At || s).memoizedState, n);
    d && ((s.memoizedState = n), (Pt = !0)), (s = s.queue);
    var y = Sd.bind(null, i, s, t);
    if (
      (Ki(2048, 8, y, [t]),
      s.getSnapshot !== e || d || (Yt !== null && Yt.memoizedState.tag & 1))
    ) {
      if (
        ((i.flags |= 2048),
        Xa(9, ps(), xd.bind(null, i, s, n, e), null),
        Rt === null)
      )
        throw Error(r(349));
      u || (Rn & 124) !== 0 || bd(i, e, n);
    }
    return n;
  }
  function bd(t, e, n) {
    (t.flags |= 16384),
      (t = { getSnapshot: e, value: n }),
      (e = ut.updateQueue),
      e === null
        ? ((e = vr()), (ut.updateQueue = e), (e.stores = [t]))
        : ((n = e.stores), n === null ? (e.stores = [t]) : n.push(t));
  }
  function xd(t, e, n, i) {
    (e.value = n), (e.getSnapshot = i), Td(e) && Ad(t);
  }
  function Sd(t, e, n) {
    return n(function () {
      Td(e) && Ad(t);
    });
  }
  function Td(t) {
    var e = t.getSnapshot;
    t = t.value;
    try {
      var n = e();
      return !xe(t, n);
    } catch {
      return !0;
    }
  }
  function Ad(t) {
    var e = Ua(t, 2);
    e !== null && De(e, t, 2);
  }
  function Tr(t) {
    var e = he();
    if (typeof t == "function") {
      var n = t;
      if (((t = n()), ua)) {
        Sn(!0);
        try {
          n();
        } finally {
          Sn(!1);
        }
      }
    }
    return (
      (e.memoizedState = e.baseState = t),
      (e.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: on,
        lastRenderedState: t,
      }),
      e
    );
  }
  function Ed(t, e, n, i) {
    return (t.baseState = n), xr(t, At, typeof i == "function" ? i : on);
  }
  function w0(t, e, n, i, s) {
    if (ys(t)) throw Error(r(485));
    if (((t = e.action), t !== null)) {
      var u = {
        payload: s,
        action: t,
        next: null,
        isTransition: !0,
        status: "pending",
        value: null,
        reason: null,
        listeners: [],
        then: function (d) {
          u.listeners.push(d);
        },
      };
      C.T !== null ? n(!0) : (u.isTransition = !1),
        i(u),
        (n = e.pending),
        n === null
          ? ((u.next = e.pending = u), Md(e, u))
          : ((u.next = n.next), (e.pending = n.next = u));
    }
  }
  function Md(t, e) {
    var n = e.action,
      i = e.payload,
      s = t.state;
    if (e.isTransition) {
      var u = C.T,
        d = {};
      C.T = d;
      try {
        var y = n(s, i),
          x = C.S;
        x !== null && x(d, y), Dd(t, e, y);
      } catch (D) {
        Ar(t, e, D);
      } finally {
        C.T = u;
      }
    } else
      try {
        (u = n(s, i)), Dd(t, e, u);
      } catch (D) {
        Ar(t, e, D);
      }
  }
  function Dd(t, e, n) {
    n !== null && typeof n == "object" && typeof n.then == "function"
      ? n.then(
          function (i) {
            wd(t, e, i);
          },
          function (i) {
            return Ar(t, e, i);
          }
        )
      : wd(t, e, n);
  }
  function wd(t, e, n) {
    (e.status = "fulfilled"),
      (e.value = n),
      Rd(e),
      (t.state = n),
      (e = t.pending),
      e !== null &&
        ((n = e.next),
        n === e ? (t.pending = null) : ((n = n.next), (e.next = n), Md(t, n)));
  }
  function Ar(t, e, n) {
    var i = t.pending;
    if (((t.pending = null), i !== null)) {
      i = i.next;
      do (e.status = "rejected"), (e.reason = n), Rd(e), (e = e.next);
      while (e !== i);
    }
    t.action = null;
  }
  function Rd(t) {
    t = t.listeners;
    for (var e = 0; e < t.length; e++) (0, t[e])();
  }
  function Od(t, e) {
    return e;
  }
  function Cd(t, e) {
    if (xt) {
      var n = Rt.formState;
      if (n !== null) {
        t: {
          var i = ut;
          if (xt) {
            if (jt) {
              e: {
                for (var s = jt, u = Ze; s.nodeType !== 8; ) {
                  if (!u) {
                    s = null;
                    break e;
                  }
                  if (((s = Ye(s.nextSibling)), s === null)) {
                    s = null;
                    break e;
                  }
                }
                (u = s.data), (s = u === "F!" || u === "F" ? s : null);
              }
              if (s) {
                (jt = Ye(s.nextSibling)), (i = s.data === "F!");
                break t;
              }
            }
            la(i);
          }
          i = !1;
        }
        i && (e = n[0]);
      }
    }
    return (
      (n = he()),
      (n.memoizedState = n.baseState = e),
      (i = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Od,
        lastRenderedState: e,
      }),
      (n.queue = i),
      (n = Pd.bind(null, ut, i)),
      (i.dispatch = n),
      (i = Tr(!1)),
      (u = Rr.bind(null, ut, !1, i.queue)),
      (i = he()),
      (s = { state: e, dispatch: null, action: t, pending: null }),
      (i.queue = s),
      (n = w0.bind(null, ut, s, u, n)),
      (s.dispatch = n),
      (i.memoizedState = t),
      [e, n, !1]
    );
  }
  function Vd(t) {
    var e = kt();
    return zd(e, At, t);
  }
  function zd(t, e, n) {
    if (
      ((e = xr(t, e, Od)[0]),
      (t = ms(on)[0]),
      typeof e == "object" && e !== null && typeof e.then == "function")
    )
      try {
        var i = Qi(e);
      } catch (d) {
        throw d === Gi ? rs : d;
      }
    else i = e;
    e = kt();
    var s = e.queue,
      u = s.dispatch;
    return (
      n !== e.memoizedState &&
        ((ut.flags |= 2048), Xa(9, ps(), R0.bind(null, s, n), null)),
      [i, u, t]
    );
  }
  function R0(t, e) {
    t.action = e;
  }
  function Nd(t) {
    var e = kt(),
      n = At;
    if (n !== null) return zd(e, n, t);
    kt(), (e = e.memoizedState), (n = kt());
    var i = n.queue.dispatch;
    return (n.memoizedState = t), [e, i, !1];
  }
  function Xa(t, e, n, i) {
    return (
      (t = { tag: t, create: n, deps: i, inst: e, next: null }),
      (e = ut.updateQueue),
      e === null && ((e = vr()), (ut.updateQueue = e)),
      (n = e.lastEffect),
      n === null
        ? (e.lastEffect = t.next = t)
        : ((i = n.next), (n.next = t), (t.next = i), (e.lastEffect = t)),
      t
    );
  }
  function ps() {
    return { destroy: void 0, resource: void 0 };
  }
  function _d() {
    return kt().memoizedState;
  }
  function gs(t, e, n, i) {
    var s = he();
    (i = i === void 0 ? null : i),
      (ut.flags |= t),
      (s.memoizedState = Xa(1 | e, ps(), n, i));
  }
  function Ki(t, e, n, i) {
    var s = kt();
    i = i === void 0 ? null : i;
    var u = s.memoizedState.inst;
    At !== null && i !== null && hr(i, At.memoizedState.deps)
      ? (s.memoizedState = Xa(e, u, n, i))
      : ((ut.flags |= t), (s.memoizedState = Xa(1 | e, u, n, i)));
  }
  function Ud(t, e) {
    gs(8390656, 8, t, e);
  }
  function jd(t, e) {
    Ki(2048, 8, t, e);
  }
  function Bd(t, e) {
    return Ki(4, 2, t, e);
  }
  function Ld(t, e) {
    return Ki(4, 4, t, e);
  }
  function Hd(t, e) {
    if (typeof e == "function") {
      t = t();
      var n = e(t);
      return function () {
        typeof n == "function" ? n() : e(null);
      };
    }
    if (e != null)
      return (
        (t = t()),
        (e.current = t),
        function () {
          e.current = null;
        }
      );
  }
  function Gd(t, e, n) {
    (n = n != null ? n.concat([t]) : null), Ki(4, 4, Hd.bind(null, e, t), n);
  }
  function Er() {}
  function qd(t, e) {
    var n = kt();
    e = e === void 0 ? null : e;
    var i = n.memoizedState;
    return e !== null && hr(e, i[1]) ? i[0] : ((n.memoizedState = [t, e]), t);
  }
  function Yd(t, e) {
    var n = kt();
    e = e === void 0 ? null : e;
    var i = n.memoizedState;
    if (e !== null && hr(e, i[1])) return i[0];
    if (((i = t()), ua)) {
      Sn(!0);
      try {
        t();
      } finally {
        Sn(!1);
      }
    }
    return (n.memoizedState = [i, e]), i;
  }
  function Mr(t, e, n) {
    return n === void 0 || (Rn & 1073741824) !== 0
      ? (t.memoizedState = e)
      : ((t.memoizedState = n), (t = Zh()), (ut.lanes |= t), (Un |= t), n);
  }
  function kd(t, e, n, i) {
    return xe(n, e)
      ? n
      : qa.current !== null
      ? ((t = Mr(t, n, i)), xe(t, e) || (Pt = !0), t)
      : (Rn & 42) === 0
      ? ((Pt = !0), (t.memoizedState = n))
      : ((t = Zh()), (ut.lanes |= t), (Un |= t), e);
  }
  function Xd(t, e, n, i, s) {
    var u = H.p;
    H.p = u !== 0 && 8 > u ? u : 8;
    var d = C.T,
      y = {};
    (C.T = y), Rr(t, !1, e, n);
    try {
      var x = s(),
        D = C.S;
      if (
        (D !== null && D(y, x),
        x !== null && typeof x == "object" && typeof x.then == "function")
      ) {
        var V = E0(x, i);
        Ji(t, e, V, Me(t));
      } else Ji(t, e, i, Me(t));
    } catch (N) {
      Ji(t, e, { then: function () {}, status: "rejected", reason: N }, Me());
    } finally {
      (H.p = u), (C.T = d);
    }
  }
  function O0() {}
  function Dr(t, e, n, i) {
    if (t.tag !== 5) throw Error(r(476));
    var s = Zd(t).queue;
    Xd(
      t,
      s,
      e,
      _,
      n === null
        ? O0
        : function () {
            return Qd(t), n(i);
          }
    );
  }
  function Zd(t) {
    var e = t.memoizedState;
    if (e !== null) return e;
    e = {
      memoizedState: _,
      baseState: _,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: on,
        lastRenderedState: _,
      },
      next: null,
    };
    var n = {};
    return (
      (e.next = {
        memoizedState: n,
        baseState: n,
        baseQueue: null,
        queue: {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: on,
          lastRenderedState: n,
        },
        next: null,
      }),
      (t.memoizedState = e),
      (t = t.alternate),
      t !== null && (t.memoizedState = e),
      e
    );
  }
  function Qd(t) {
    var e = Zd(t).next.queue;
    Ji(t, e, {}, Me());
  }
  function wr() {
    return ae(dl);
  }
  function Kd() {
    return kt().memoizedState;
  }
  function Jd() {
    return kt().memoizedState;
  }
  function C0(t) {
    for (var e = t.return; e !== null; ) {
      switch (e.tag) {
        case 24:
        case 3:
          var n = Me();
          t = Dn(n);
          var i = wn(e, t, n);
          i !== null && (De(i, e, n), Yi(i, e, n)),
            (e = { cache: ar() }),
            (t.payload = e);
          return;
      }
      e = e.return;
    }
  }
  function V0(t, e, n) {
    var i = Me();
    (n = {
      lane: i,
      revertLane: 0,
      action: n,
      hasEagerState: !1,
      eagerState: null,
      next: null,
    }),
      ys(t)
        ? Fd(e, n)
        : ((n = Ko(t, e, n, i)), n !== null && (De(n, t, i), Wd(n, e, i)));
  }
  function Pd(t, e, n) {
    var i = Me();
    Ji(t, e, n, i);
  }
  function Ji(t, e, n, i) {
    var s = {
      lane: i,
      revertLane: 0,
      action: n,
      hasEagerState: !1,
      eagerState: null,
      next: null,
    };
    if (ys(t)) Fd(e, s);
    else {
      var u = t.alternate;
      if (
        t.lanes === 0 &&
        (u === null || u.lanes === 0) &&
        ((u = e.lastRenderedReducer), u !== null)
      )
        try {
          var d = e.lastRenderedState,
            y = u(d, n);
          if (((s.hasEagerState = !0), (s.eagerState = y), xe(y, d)))
            return ts(t, e, s, 0), Rt === null && Il(), !1;
        } catch {
        } finally {
        }
      if (((n = Ko(t, e, s, i)), n !== null))
        return De(n, t, i), Wd(n, e, i), !0;
    }
    return !1;
  }
  function Rr(t, e, n, i) {
    if (
      ((i = {
        lane: 2,
        revertLane: su(),
        action: i,
        hasEagerState: !1,
        eagerState: null,
        next: null,
      }),
      ys(t))
    ) {
      if (e) throw Error(r(479));
    } else (e = Ko(t, n, i, 2)), e !== null && De(e, t, 2);
  }
  function ys(t) {
    var e = t.alternate;
    return t === ut || (e !== null && e === ut);
  }
  function Fd(t, e) {
    Ya = fs = !0;
    var n = t.pending;
    n === null ? (e.next = e) : ((e.next = n.next), (n.next = e)),
      (t.pending = e);
  }
  function Wd(t, e, n) {
    if ((n & 4194048) !== 0) {
      var i = e.lanes;
      (i &= t.pendingLanes), (n |= i), (e.lanes = n), lf(t, n);
    }
  }
  var vs = {
      readContext: ae,
      use: hs,
      useCallback: Ht,
      useContext: Ht,
      useEffect: Ht,
      useImperativeHandle: Ht,
      useLayoutEffect: Ht,
      useInsertionEffect: Ht,
      useMemo: Ht,
      useReducer: Ht,
      useRef: Ht,
      useState: Ht,
      useDebugValue: Ht,
      useDeferredValue: Ht,
      useTransition: Ht,
      useSyncExternalStore: Ht,
      useId: Ht,
      useHostTransitionStatus: Ht,
      useFormState: Ht,
      useActionState: Ht,
      useOptimistic: Ht,
      useMemoCache: Ht,
      useCacheRefresh: Ht,
    },
    $d = {
      readContext: ae,
      use: hs,
      useCallback: function (t, e) {
        return (he().memoizedState = [t, e === void 0 ? null : e]), t;
      },
      useContext: ae,
      useEffect: Ud,
      useImperativeHandle: function (t, e, n) {
        (n = n != null ? n.concat([t]) : null),
          gs(4194308, 4, Hd.bind(null, e, t), n);
      },
      useLayoutEffect: function (t, e) {
        return gs(4194308, 4, t, e);
      },
      useInsertionEffect: function (t, e) {
        gs(4, 2, t, e);
      },
      useMemo: function (t, e) {
        var n = he();
        e = e === void 0 ? null : e;
        var i = t();
        if (ua) {
          Sn(!0);
          try {
            t();
          } finally {
            Sn(!1);
          }
        }
        return (n.memoizedState = [i, e]), i;
      },
      useReducer: function (t, e, n) {
        var i = he();
        if (n !== void 0) {
          var s = n(e);
          if (ua) {
            Sn(!0);
            try {
              n(e);
            } finally {
              Sn(!1);
            }
          }
        } else s = e;
        return (
          (i.memoizedState = i.baseState = s),
          (t = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: t,
            lastRenderedState: s,
          }),
          (i.queue = t),
          (t = t.dispatch = V0.bind(null, ut, t)),
          [i.memoizedState, t]
        );
      },
      useRef: function (t) {
        var e = he();
        return (t = { current: t }), (e.memoizedState = t);
      },
      useState: function (t) {
        t = Tr(t);
        var e = t.queue,
          n = Pd.bind(null, ut, e);
        return (e.dispatch = n), [t.memoizedState, n];
      },
      useDebugValue: Er,
      useDeferredValue: function (t, e) {
        var n = he();
        return Mr(n, t, e);
      },
      useTransition: function () {
        var t = Tr(!1);
        return (
          (t = Xd.bind(null, ut, t.queue, !0, !1)),
          (he().memoizedState = t),
          [!1, t]
        );
      },
      useSyncExternalStore: function (t, e, n) {
        var i = ut,
          s = he();
        if (xt) {
          if (n === void 0) throw Error(r(407));
          n = n();
        } else {
          if (((n = e()), Rt === null)) throw Error(r(349));
          (yt & 124) !== 0 || bd(i, e, n);
        }
        s.memoizedState = n;
        var u = { value: n, getSnapshot: e };
        return (
          (s.queue = u),
          Ud(Sd.bind(null, i, u, t), [t]),
          (i.flags |= 2048),
          Xa(9, ps(), xd.bind(null, i, u, n, e), null),
          n
        );
      },
      useId: function () {
        var t = he(),
          e = Rt.identifierPrefix;
        if (xt) {
          var n = an,
            i = nn;
          (n = (i & ~(1 << (32 - be(i) - 1))).toString(32) + n),
            (e = "«" + e + "R" + n),
            (n = ds++),
            0 < n && (e += "H" + n.toString(32)),
            (e += "»");
        } else (n = M0++), (e = "«" + e + "r" + n.toString(32) + "»");
        return (t.memoizedState = e);
      },
      useHostTransitionStatus: wr,
      useFormState: Cd,
      useActionState: Cd,
      useOptimistic: function (t) {
        var e = he();
        e.memoizedState = e.baseState = t;
        var n = {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: null,
          lastRenderedState: null,
        };
        return (
          (e.queue = n),
          (e = Rr.bind(null, ut, !0, n)),
          (n.dispatch = e),
          [t, e]
        );
      },
      useMemoCache: br,
      useCacheRefresh: function () {
        return (he().memoizedState = C0.bind(null, ut));
      },
    },
    Id = {
      readContext: ae,
      use: hs,
      useCallback: qd,
      useContext: ae,
      useEffect: jd,
      useImperativeHandle: Gd,
      useInsertionEffect: Bd,
      useLayoutEffect: Ld,
      useMemo: Yd,
      useReducer: ms,
      useRef: _d,
      useState: function () {
        return ms(on);
      },
      useDebugValue: Er,
      useDeferredValue: function (t, e) {
        var n = kt();
        return kd(n, At.memoizedState, t, e);
      },
      useTransition: function () {
        var t = ms(on)[0],
          e = kt().memoizedState;
        return [typeof t == "boolean" ? t : Qi(t), e];
      },
      useSyncExternalStore: vd,
      useId: Kd,
      useHostTransitionStatus: wr,
      useFormState: Vd,
      useActionState: Vd,
      useOptimistic: function (t, e) {
        var n = kt();
        return Ed(n, At, t, e);
      },
      useMemoCache: br,
      useCacheRefresh: Jd,
    },
    z0 = {
      readContext: ae,
      use: hs,
      useCallback: qd,
      useContext: ae,
      useEffect: jd,
      useImperativeHandle: Gd,
      useInsertionEffect: Bd,
      useLayoutEffect: Ld,
      useMemo: Yd,
      useReducer: Sr,
      useRef: _d,
      useState: function () {
        return Sr(on);
      },
      useDebugValue: Er,
      useDeferredValue: function (t, e) {
        var n = kt();
        return At === null ? Mr(n, t, e) : kd(n, At.memoizedState, t, e);
      },
      useTransition: function () {
        var t = Sr(on)[0],
          e = kt().memoizedState;
        return [typeof t == "boolean" ? t : Qi(t), e];
      },
      useSyncExternalStore: vd,
      useId: Kd,
      useHostTransitionStatus: wr,
      useFormState: Nd,
      useActionState: Nd,
      useOptimistic: function (t, e) {
        var n = kt();
        return At !== null
          ? Ed(n, At, t, e)
          : ((n.baseState = t), [t, n.queue.dispatch]);
      },
      useMemoCache: br,
      useCacheRefresh: Jd,
    },
    Za = null,
    Pi = 0;
  function bs(t) {
    var e = Pi;
    return (Pi += 1), Za === null && (Za = []), cd(Za, t, e);
  }
  function Fi(t, e) {
    (e = e.props.ref), (t.ref = e !== void 0 ? e : null);
  }
  function xs(t, e) {
    throw e.$$typeof === b
      ? Error(r(525))
      : ((t = Object.prototype.toString.call(e)),
        Error(
          r(
            31,
            t === "[object Object]"
              ? "object with keys {" + Object.keys(e).join(", ") + "}"
              : t
          )
        ));
  }
  function th(t) {
    var e = t._init;
    return e(t._payload);
  }
  function eh(t) {
    function e(E, T) {
      if (t) {
        var M = E.deletions;
        M === null ? ((E.deletions = [T]), (E.flags |= 16)) : M.push(T);
      }
    }
    function n(E, T) {
      if (!t) return null;
      for (; T !== null; ) e(E, T), (T = T.sibling);
      return null;
    }
    function i(E) {
      for (var T = new Map(); E !== null; )
        E.key !== null ? T.set(E.key, E) : T.set(E.index, E), (E = E.sibling);
      return T;
    }
    function s(E, T) {
      return (E = en(E, T)), (E.index = 0), (E.sibling = null), E;
    }
    function u(E, T, M) {
      return (
        (E.index = M),
        t
          ? ((M = E.alternate),
            M !== null
              ? ((M = M.index), M < T ? ((E.flags |= 67108866), T) : M)
              : ((E.flags |= 67108866), T))
          : ((E.flags |= 1048576), T)
      );
    }
    function d(E) {
      return t && E.alternate === null && (E.flags |= 67108866), E;
    }
    function y(E, T, M, z) {
      return T === null || T.tag !== 6
        ? ((T = Po(M, E.mode, z)), (T.return = E), T)
        : ((T = s(T, M)), (T.return = E), T);
    }
    function x(E, T, M, z) {
      var J = M.type;
      return J === B
        ? V(E, T, M.props.children, z, M.key)
        : T !== null &&
          (T.elementType === J ||
            (typeof J == "object" &&
              J !== null &&
              J.$$typeof === G &&
              th(J) === T.type))
        ? ((T = s(T, M.props)), Fi(T, M), (T.return = E), T)
        : ((T = ns(M.type, M.key, M.props, null, E.mode, z)),
          Fi(T, M),
          (T.return = E),
          T);
    }
    function D(E, T, M, z) {
      return T === null ||
        T.tag !== 4 ||
        T.stateNode.containerInfo !== M.containerInfo ||
        T.stateNode.implementation !== M.implementation
        ? ((T = Fo(M, E.mode, z)), (T.return = E), T)
        : ((T = s(T, M.children || [])), (T.return = E), T);
    }
    function V(E, T, M, z, J) {
      return T === null || T.tag !== 7
        ? ((T = ea(M, E.mode, z, J)), (T.return = E), T)
        : ((T = s(T, M)), (T.return = E), T);
    }
    function N(E, T, M) {
      if (
        (typeof T == "string" && T !== "") ||
        typeof T == "number" ||
        typeof T == "bigint"
      )
        return (T = Po("" + T, E.mode, M)), (T.return = E), T;
      if (typeof T == "object" && T !== null) {
        switch (T.$$typeof) {
          case A:
            return (
              (M = ns(T.type, T.key, T.props, null, E.mode, M)),
              Fi(M, T),
              (M.return = E),
              M
            );
          case O:
            return (T = Fo(T, E.mode, M)), (T.return = E), T;
          case G:
            var z = T._init;
            return (T = z(T._payload)), N(E, T, M);
        }
        if (Ct(T) || Ot(T))
          return (T = ea(T, E.mode, M, null)), (T.return = E), T;
        if (typeof T.then == "function") return N(E, bs(T), M);
        if (T.$$typeof === X) return N(E, ss(E, T), M);
        xs(E, T);
      }
      return null;
    }
    function w(E, T, M, z) {
      var J = T !== null ? T.key : null;
      if (
        (typeof M == "string" && M !== "") ||
        typeof M == "number" ||
        typeof M == "bigint"
      )
        return J !== null ? null : y(E, T, "" + M, z);
      if (typeof M == "object" && M !== null) {
        switch (M.$$typeof) {
          case A:
            return M.key === J ? x(E, T, M, z) : null;
          case O:
            return M.key === J ? D(E, T, M, z) : null;
          case G:
            return (J = M._init), (M = J(M._payload)), w(E, T, M, z);
        }
        if (Ct(M) || Ot(M)) return J !== null ? null : V(E, T, M, z, null);
        if (typeof M.then == "function") return w(E, T, bs(M), z);
        if (M.$$typeof === X) return w(E, T, ss(E, M), z);
        xs(E, M);
      }
      return null;
    }
    function R(E, T, M, z, J) {
      if (
        (typeof z == "string" && z !== "") ||
        typeof z == "number" ||
        typeof z == "bigint"
      )
        return (E = E.get(M) || null), y(T, E, "" + z, J);
      if (typeof z == "object" && z !== null) {
        switch (z.$$typeof) {
          case A:
            return (
              (E = E.get(z.key === null ? M : z.key) || null), x(T, E, z, J)
            );
          case O:
            return (
              (E = E.get(z.key === null ? M : z.key) || null), D(T, E, z, J)
            );
          case G:
            var ft = z._init;
            return (z = ft(z._payload)), R(E, T, M, z, J);
        }
        if (Ct(z) || Ot(z)) return (E = E.get(M) || null), V(T, E, z, J, null);
        if (typeof z.then == "function") return R(E, T, M, bs(z), J);
        if (z.$$typeof === X) return R(E, T, M, ss(T, z), J);
        xs(T, z);
      }
      return null;
    }
    function at(E, T, M, z) {
      for (
        var J = null, ft = null, I = T, et = (T = 0), Wt = null;
        I !== null && et < M.length;
        et++
      ) {
        I.index > et ? ((Wt = I), (I = null)) : (Wt = I.sibling);
        var bt = w(E, I, M[et], z);
        if (bt === null) {
          I === null && (I = Wt);
          break;
        }
        t && I && bt.alternate === null && e(E, I),
          (T = u(bt, T, et)),
          ft === null ? (J = bt) : (ft.sibling = bt),
          (ft = bt),
          (I = Wt);
      }
      if (et === M.length) return n(E, I), xt && aa(E, et), J;
      if (I === null) {
        for (; et < M.length; et++)
          (I = N(E, M[et], z)),
            I !== null &&
              ((T = u(I, T, et)),
              ft === null ? (J = I) : (ft.sibling = I),
              (ft = I));
        return xt && aa(E, et), J;
      }
      for (I = i(I); et < M.length; et++)
        (Wt = R(I, E, et, M[et], z)),
          Wt !== null &&
            (t &&
              Wt.alternate !== null &&
              I.delete(Wt.key === null ? et : Wt.key),
            (T = u(Wt, T, et)),
            ft === null ? (J = Wt) : (ft.sibling = Wt),
            (ft = Wt));
      return (
        t &&
          I.forEach(function (Xn) {
            return e(E, Xn);
          }),
        xt && aa(E, et),
        J
      );
    }
    function tt(E, T, M, z) {
      if (M == null) throw Error(r(151));
      for (
        var J = null, ft = null, I = T, et = (T = 0), Wt = null, bt = M.next();
        I !== null && !bt.done;
        et++, bt = M.next()
      ) {
        I.index > et ? ((Wt = I), (I = null)) : (Wt = I.sibling);
        var Xn = w(E, I, bt.value, z);
        if (Xn === null) {
          I === null && (I = Wt);
          break;
        }
        t && I && Xn.alternate === null && e(E, I),
          (T = u(Xn, T, et)),
          ft === null ? (J = Xn) : (ft.sibling = Xn),
          (ft = Xn),
          (I = Wt);
      }
      if (bt.done) return n(E, I), xt && aa(E, et), J;
      if (I === null) {
        for (; !bt.done; et++, bt = M.next())
          (bt = N(E, bt.value, z)),
            bt !== null &&
              ((T = u(bt, T, et)),
              ft === null ? (J = bt) : (ft.sibling = bt),
              (ft = bt));
        return xt && aa(E, et), J;
      }
      for (I = i(I); !bt.done; et++, bt = M.next())
        (bt = R(I, E, et, bt.value, z)),
          bt !== null &&
            (t &&
              bt.alternate !== null &&
              I.delete(bt.key === null ? et : bt.key),
            (T = u(bt, T, et)),
            ft === null ? (J = bt) : (ft.sibling = bt),
            (ft = bt));
      return (
        t &&
          I.forEach(function (Nb) {
            return e(E, Nb);
          }),
        xt && aa(E, et),
        J
      );
    }
    function Mt(E, T, M, z) {
      if (
        (typeof M == "object" &&
          M !== null &&
          M.type === B &&
          M.key === null &&
          (M = M.props.children),
        typeof M == "object" && M !== null)
      ) {
        switch (M.$$typeof) {
          case A:
            t: {
              for (var J = M.key; T !== null; ) {
                if (T.key === J) {
                  if (((J = M.type), J === B)) {
                    if (T.tag === 7) {
                      n(E, T.sibling),
                        (z = s(T, M.props.children)),
                        (z.return = E),
                        (E = z);
                      break t;
                    }
                  } else if (
                    T.elementType === J ||
                    (typeof J == "object" &&
                      J !== null &&
                      J.$$typeof === G &&
                      th(J) === T.type)
                  ) {
                    n(E, T.sibling),
                      (z = s(T, M.props)),
                      Fi(z, M),
                      (z.return = E),
                      (E = z);
                    break t;
                  }
                  n(E, T);
                  break;
                } else e(E, T);
                T = T.sibling;
              }
              M.type === B
                ? ((z = ea(M.props.children, E.mode, z, M.key)),
                  (z.return = E),
                  (E = z))
                : ((z = ns(M.type, M.key, M.props, null, E.mode, z)),
                  Fi(z, M),
                  (z.return = E),
                  (E = z));
            }
            return d(E);
          case O:
            t: {
              for (J = M.key; T !== null; ) {
                if (T.key === J)
                  if (
                    T.tag === 4 &&
                    T.stateNode.containerInfo === M.containerInfo &&
                    T.stateNode.implementation === M.implementation
                  ) {
                    n(E, T.sibling),
                      (z = s(T, M.children || [])),
                      (z.return = E),
                      (E = z);
                    break t;
                  } else {
                    n(E, T);
                    break;
                  }
                else e(E, T);
                T = T.sibling;
              }
              (z = Fo(M, E.mode, z)), (z.return = E), (E = z);
            }
            return d(E);
          case G:
            return (J = M._init), (M = J(M._payload)), Mt(E, T, M, z);
        }
        if (Ct(M)) return at(E, T, M, z);
        if (Ot(M)) {
          if (((J = Ot(M)), typeof J != "function")) throw Error(r(150));
          return (M = J.call(M)), tt(E, T, M, z);
        }
        if (typeof M.then == "function") return Mt(E, T, bs(M), z);
        if (M.$$typeof === X) return Mt(E, T, ss(E, M), z);
        xs(E, M);
      }
      return (typeof M == "string" && M !== "") ||
        typeof M == "number" ||
        typeof M == "bigint"
        ? ((M = "" + M),
          T !== null && T.tag === 6
            ? (n(E, T.sibling), (z = s(T, M)), (z.return = E), (E = z))
            : (n(E, T), (z = Po(M, E.mode, z)), (z.return = E), (E = z)),
          d(E))
        : n(E, T);
    }
    return function (E, T, M, z) {
      try {
        Pi = 0;
        var J = Mt(E, T, M, z);
        return (Za = null), J;
      } catch (I) {
        if (I === Gi || I === rs) throw I;
        var ft = Se(29, I, null, E.mode);
        return (ft.lanes = z), (ft.return = E), ft;
      } finally {
      }
    };
  }
  var Qa = eh(!0),
    nh = eh(!1),
    _e = U(null),
    Qe = null;
  function On(t) {
    var e = t.alternate;
    q(Qt, Qt.current & 1),
      q(_e, t),
      Qe === null &&
        (e === null || qa.current !== null || e.memoizedState !== null) &&
        (Qe = t);
  }
  function ah(t) {
    if (t.tag === 22) {
      if ((q(Qt, Qt.current), q(_e, t), Qe === null)) {
        var e = t.alternate;
        e !== null && e.memoizedState !== null && (Qe = t);
      }
    } else Cn();
  }
  function Cn() {
    q(Qt, Qt.current), q(_e, _e.current);
  }
  function rn(t) {
    Q(_e), Qe === t && (Qe = null), Q(Qt);
  }
  var Qt = U(0);
  function Ss(t) {
    for (var e = t; e !== null; ) {
      if (e.tag === 13) {
        var n = e.memoizedState;
        if (
          n !== null &&
          ((n = n.dehydrated), n === null || n.data === "$?" || vu(n))
        )
          return e;
      } else if (e.tag === 19 && e.memoizedProps.revealOrder !== void 0) {
        if ((e.flags & 128) !== 0) return e;
      } else if (e.child !== null) {
        (e.child.return = e), (e = e.child);
        continue;
      }
      if (e === t) break;
      for (; e.sibling === null; ) {
        if (e.return === null || e.return === t) return null;
        e = e.return;
      }
      (e.sibling.return = e.return), (e = e.sibling);
    }
    return null;
  }
  function Or(t, e, n, i) {
    (e = t.memoizedState),
      (n = n(i, e)),
      (n = n == null ? e : v({}, e, n)),
      (t.memoizedState = n),
      t.lanes === 0 && (t.updateQueue.baseState = n);
  }
  var Cr = {
    enqueueSetState: function (t, e, n) {
      t = t._reactInternals;
      var i = Me(),
        s = Dn(i);
      (s.payload = e),
        n != null && (s.callback = n),
        (e = wn(t, s, i)),
        e !== null && (De(e, t, i), Yi(e, t, i));
    },
    enqueueReplaceState: function (t, e, n) {
      t = t._reactInternals;
      var i = Me(),
        s = Dn(i);
      (s.tag = 1),
        (s.payload = e),
        n != null && (s.callback = n),
        (e = wn(t, s, i)),
        e !== null && (De(e, t, i), Yi(e, t, i));
    },
    enqueueForceUpdate: function (t, e) {
      t = t._reactInternals;
      var n = Me(),
        i = Dn(n);
      (i.tag = 2),
        e != null && (i.callback = e),
        (e = wn(t, i, n)),
        e !== null && (De(e, t, n), Yi(e, t, n));
    },
  };
  function ih(t, e, n, i, s, u, d) {
    return (
      (t = t.stateNode),
      typeof t.shouldComponentUpdate == "function"
        ? t.shouldComponentUpdate(i, u, d)
        : e.prototype && e.prototype.isPureReactComponent
        ? !zi(n, i) || !zi(s, u)
        : !0
    );
  }
  function lh(t, e, n, i) {
    (t = e.state),
      typeof e.componentWillReceiveProps == "function" &&
        e.componentWillReceiveProps(n, i),
      typeof e.UNSAFE_componentWillReceiveProps == "function" &&
        e.UNSAFE_componentWillReceiveProps(n, i),
      e.state !== t && Cr.enqueueReplaceState(e, e.state, null);
  }
  function ca(t, e) {
    var n = e;
    if ("ref" in e) {
      n = {};
      for (var i in e) i !== "ref" && (n[i] = e[i]);
    }
    if ((t = t.defaultProps)) {
      n === e && (n = v({}, n));
      for (var s in t) n[s] === void 0 && (n[s] = t[s]);
    }
    return n;
  }
  var Ts =
    typeof reportError == "function"
      ? reportError
      : function (t) {
          if (
            typeof window == "object" &&
            typeof window.ErrorEvent == "function"
          ) {
            var e = new window.ErrorEvent("error", {
              bubbles: !0,
              cancelable: !0,
              message:
                typeof t == "object" &&
                t !== null &&
                typeof t.message == "string"
                  ? String(t.message)
                  : String(t),
              error: t,
            });
            if (!window.dispatchEvent(e)) return;
          } else if (
            typeof process == "object" &&
            typeof process.emit == "function"
          ) {
            process.emit("uncaughtException", t);
            return;
          }
          console.error(t);
        };
  function sh(t) {
    Ts(t);
  }
  function oh(t) {
    console.error(t);
  }
  function rh(t) {
    Ts(t);
  }
  function As(t, e) {
    try {
      var n = t.onUncaughtError;
      n(e.value, { componentStack: e.stack });
    } catch (i) {
      setTimeout(function () {
        throw i;
      });
    }
  }
  function uh(t, e, n) {
    try {
      var i = t.onCaughtError;
      i(n.value, {
        componentStack: n.stack,
        errorBoundary: e.tag === 1 ? e.stateNode : null,
      });
    } catch (s) {
      setTimeout(function () {
        throw s;
      });
    }
  }
  function Vr(t, e, n) {
    return (
      (n = Dn(n)),
      (n.tag = 3),
      (n.payload = { element: null }),
      (n.callback = function () {
        As(t, e);
      }),
      n
    );
  }
  function ch(t) {
    return (t = Dn(t)), (t.tag = 3), t;
  }
  function fh(t, e, n, i) {
    var s = n.type.getDerivedStateFromError;
    if (typeof s == "function") {
      var u = i.value;
      (t.payload = function () {
        return s(u);
      }),
        (t.callback = function () {
          uh(e, n, i);
        });
    }
    var d = n.stateNode;
    d !== null &&
      typeof d.componentDidCatch == "function" &&
      (t.callback = function () {
        uh(e, n, i),
          typeof s != "function" &&
            (jn === null ? (jn = new Set([this])) : jn.add(this));
        var y = i.stack;
        this.componentDidCatch(i.value, {
          componentStack: y !== null ? y : "",
        });
      });
  }
  function N0(t, e, n, i, s) {
    if (
      ((n.flags |= 32768),
      i !== null && typeof i == "object" && typeof i.then == "function")
    ) {
      if (
        ((e = n.alternate),
        e !== null && Bi(e, n, s, !0),
        (n = _e.current),
        n !== null)
      ) {
        switch (n.tag) {
          case 13:
            return (
              Qe === null ? eu() : n.alternate === null && Bt === 0 && (Bt = 3),
              (n.flags &= -257),
              (n.flags |= 65536),
              (n.lanes = s),
              i === sr
                ? (n.flags |= 16384)
                : ((e = n.updateQueue),
                  e === null ? (n.updateQueue = new Set([i])) : e.add(i),
                  au(t, i, s)),
              !1
            );
          case 22:
            return (
              (n.flags |= 65536),
              i === sr
                ? (n.flags |= 16384)
                : ((e = n.updateQueue),
                  e === null
                    ? ((e = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([i]),
                      }),
                      (n.updateQueue = e))
                    : ((n = e.retryQueue),
                      n === null ? (e.retryQueue = new Set([i])) : n.add(i)),
                  au(t, i, s)),
              !1
            );
        }
        throw Error(r(435, n.tag));
      }
      return au(t, i, s), eu(), !1;
    }
    if (xt)
      return (
        (e = _e.current),
        e !== null
          ? ((e.flags & 65536) === 0 && (e.flags |= 256),
            (e.flags |= 65536),
            (e.lanes = s),
            i !== Io && ((t = Error(r(422), { cause: i })), ji(Ce(t, n))))
          : (i !== Io && ((e = Error(r(423), { cause: i })), ji(Ce(e, n))),
            (t = t.current.alternate),
            (t.flags |= 65536),
            (s &= -s),
            (t.lanes |= s),
            (i = Ce(i, n)),
            (s = Vr(t.stateNode, i, s)),
            ur(t, s),
            Bt !== 4 && (Bt = 2)),
        !1
      );
    var u = Error(r(520), { cause: i });
    if (
      ((u = Ce(u, n)),
      al === null ? (al = [u]) : al.push(u),
      Bt !== 4 && (Bt = 2),
      e === null)
    )
      return !0;
    (i = Ce(i, n)), (n = e);
    do {
      switch (n.tag) {
        case 3:
          return (
            (n.flags |= 65536),
            (t = s & -s),
            (n.lanes |= t),
            (t = Vr(n.stateNode, i, t)),
            ur(n, t),
            !1
          );
        case 1:
          if (
            ((e = n.type),
            (u = n.stateNode),
            (n.flags & 128) === 0 &&
              (typeof e.getDerivedStateFromError == "function" ||
                (u !== null &&
                  typeof u.componentDidCatch == "function" &&
                  (jn === null || !jn.has(u)))))
          )
            return (
              (n.flags |= 65536),
              (s &= -s),
              (n.lanes |= s),
              (s = ch(s)),
              fh(s, t, n, i),
              ur(n, s),
              !1
            );
      }
      n = n.return;
    } while (n !== null);
    return !1;
  }
  var dh = Error(r(461)),
    Pt = !1;
  function $t(t, e, n, i) {
    e.child = t === null ? nh(e, null, n, i) : Qa(e, t.child, n, i);
  }
  function hh(t, e, n, i, s) {
    n = n.render;
    var u = e.ref;
    if ("ref" in i) {
      var d = {};
      for (var y in i) y !== "ref" && (d[y] = i[y]);
    } else d = i;
    return (
      oa(e),
      (i = mr(t, e, n, d, u, s)),
      (y = pr()),
      t !== null && !Pt
        ? (gr(t, e, s), un(t, e, s))
        : (xt && y && Wo(e), (e.flags |= 1), $t(t, e, i, s), e.child)
    );
  }
  function mh(t, e, n, i, s) {
    if (t === null) {
      var u = n.type;
      return typeof u == "function" &&
        !Jo(u) &&
        u.defaultProps === void 0 &&
        n.compare === null
        ? ((e.tag = 15), (e.type = u), ph(t, e, u, i, s))
        : ((t = ns(n.type, null, i, e, e.mode, s)),
          (t.ref = e.ref),
          (t.return = e),
          (e.child = t));
    }
    if (((u = t.child), !Hr(t, s))) {
      var d = u.memoizedProps;
      if (
        ((n = n.compare), (n = n !== null ? n : zi), n(d, i) && t.ref === e.ref)
      )
        return un(t, e, s);
    }
    return (
      (e.flags |= 1),
      (t = en(u, i)),
      (t.ref = e.ref),
      (t.return = e),
      (e.child = t)
    );
  }
  function ph(t, e, n, i, s) {
    if (t !== null) {
      var u = t.memoizedProps;
      if (zi(u, i) && t.ref === e.ref)
        if (((Pt = !1), (e.pendingProps = i = u), Hr(t, s)))
          (t.flags & 131072) !== 0 && (Pt = !0);
        else return (e.lanes = t.lanes), un(t, e, s);
    }
    return zr(t, e, n, i, s);
  }
  function gh(t, e, n) {
    var i = e.pendingProps,
      s = i.children,
      u = t !== null ? t.memoizedState : null;
    if (i.mode === "hidden") {
      if ((e.flags & 128) !== 0) {
        if (((i = u !== null ? u.baseLanes | n : n), t !== null)) {
          for (s = e.child = t.child, u = 0; s !== null; )
            (u = u | s.lanes | s.childLanes), (s = s.sibling);
          e.childLanes = u & ~i;
        } else (e.childLanes = 0), (e.child = null);
        return yh(t, e, i, n);
      }
      if ((n & 536870912) !== 0)
        (e.memoizedState = { baseLanes: 0, cachePool: null }),
          t !== null && os(e, u !== null ? u.cachePool : null),
          u !== null ? pd(e, u) : fr(),
          ah(e);
      else
        return (
          (e.lanes = e.childLanes = 536870912),
          yh(t, e, u !== null ? u.baseLanes | n : n, n)
        );
    } else
      u !== null
        ? (os(e, u.cachePool), pd(e, u), Cn(), (e.memoizedState = null))
        : (t !== null && os(e, null), fr(), Cn());
    return $t(t, e, s, n), e.child;
  }
  function yh(t, e, n, i) {
    var s = lr();
    return (
      (s = s === null ? null : { parent: Zt._currentValue, pool: s }),
      (e.memoizedState = { baseLanes: n, cachePool: s }),
      t !== null && os(e, null),
      fr(),
      ah(e),
      t !== null && Bi(t, e, i, !0),
      null
    );
  }
  function Es(t, e) {
    var n = e.ref;
    if (n === null) t !== null && t.ref !== null && (e.flags |= 4194816);
    else {
      if (typeof n != "function" && typeof n != "object") throw Error(r(284));
      (t === null || t.ref !== n) && (e.flags |= 4194816);
    }
  }
  function zr(t, e, n, i, s) {
    return (
      oa(e),
      (n = mr(t, e, n, i, void 0, s)),
      (i = pr()),
      t !== null && !Pt
        ? (gr(t, e, s), un(t, e, s))
        : (xt && i && Wo(e), (e.flags |= 1), $t(t, e, n, s), e.child)
    );
  }
  function vh(t, e, n, i, s, u) {
    return (
      oa(e),
      (e.updateQueue = null),
      (n = yd(e, i, n, s)),
      gd(t),
      (i = pr()),
      t !== null && !Pt
        ? (gr(t, e, u), un(t, e, u))
        : (xt && i && Wo(e), (e.flags |= 1), $t(t, e, n, u), e.child)
    );
  }
  function bh(t, e, n, i, s) {
    if ((oa(e), e.stateNode === null)) {
      var u = ja,
        d = n.contextType;
      typeof d == "object" && d !== null && (u = ae(d)),
        (u = new n(i, u)),
        (e.memoizedState =
          u.state !== null && u.state !== void 0 ? u.state : null),
        (u.updater = Cr),
        (e.stateNode = u),
        (u._reactInternals = e),
        (u = e.stateNode),
        (u.props = i),
        (u.state = e.memoizedState),
        (u.refs = {}),
        or(e),
        (d = n.contextType),
        (u.context = typeof d == "object" && d !== null ? ae(d) : ja),
        (u.state = e.memoizedState),
        (d = n.getDerivedStateFromProps),
        typeof d == "function" && (Or(e, n, d, i), (u.state = e.memoizedState)),
        typeof n.getDerivedStateFromProps == "function" ||
          typeof u.getSnapshotBeforeUpdate == "function" ||
          (typeof u.UNSAFE_componentWillMount != "function" &&
            typeof u.componentWillMount != "function") ||
          ((d = u.state),
          typeof u.componentWillMount == "function" && u.componentWillMount(),
          typeof u.UNSAFE_componentWillMount == "function" &&
            u.UNSAFE_componentWillMount(),
          d !== u.state && Cr.enqueueReplaceState(u, u.state, null),
          Xi(e, i, u, s),
          ki(),
          (u.state = e.memoizedState)),
        typeof u.componentDidMount == "function" && (e.flags |= 4194308),
        (i = !0);
    } else if (t === null) {
      u = e.stateNode;
      var y = e.memoizedProps,
        x = ca(n, y);
      u.props = x;
      var D = u.context,
        V = n.contextType;
      (d = ja), typeof V == "object" && V !== null && (d = ae(V));
      var N = n.getDerivedStateFromProps;
      (V =
        typeof N == "function" ||
        typeof u.getSnapshotBeforeUpdate == "function"),
        (y = e.pendingProps !== y),
        V ||
          (typeof u.UNSAFE_componentWillReceiveProps != "function" &&
            typeof u.componentWillReceiveProps != "function") ||
          ((y || D !== d) && lh(e, u, i, d)),
        (Mn = !1);
      var w = e.memoizedState;
      (u.state = w),
        Xi(e, i, u, s),
        ki(),
        (D = e.memoizedState),
        y || w !== D || Mn
          ? (typeof N == "function" && (Or(e, n, N, i), (D = e.memoizedState)),
            (x = Mn || ih(e, n, x, i, w, D, d))
              ? (V ||
                  (typeof u.UNSAFE_componentWillMount != "function" &&
                    typeof u.componentWillMount != "function") ||
                  (typeof u.componentWillMount == "function" &&
                    u.componentWillMount(),
                  typeof u.UNSAFE_componentWillMount == "function" &&
                    u.UNSAFE_componentWillMount()),
                typeof u.componentDidMount == "function" &&
                  (e.flags |= 4194308))
              : (typeof u.componentDidMount == "function" &&
                  (e.flags |= 4194308),
                (e.memoizedProps = i),
                (e.memoizedState = D)),
            (u.props = i),
            (u.state = D),
            (u.context = d),
            (i = x))
          : (typeof u.componentDidMount == "function" && (e.flags |= 4194308),
            (i = !1));
    } else {
      (u = e.stateNode),
        rr(t, e),
        (d = e.memoizedProps),
        (V = ca(n, d)),
        (u.props = V),
        (N = e.pendingProps),
        (w = u.context),
        (D = n.contextType),
        (x = ja),
        typeof D == "object" && D !== null && (x = ae(D)),
        (y = n.getDerivedStateFromProps),
        (D =
          typeof y == "function" ||
          typeof u.getSnapshotBeforeUpdate == "function") ||
          (typeof u.UNSAFE_componentWillReceiveProps != "function" &&
            typeof u.componentWillReceiveProps != "function") ||
          ((d !== N || w !== x) && lh(e, u, i, x)),
        (Mn = !1),
        (w = e.memoizedState),
        (u.state = w),
        Xi(e, i, u, s),
        ki();
      var R = e.memoizedState;
      d !== N ||
      w !== R ||
      Mn ||
      (t !== null && t.dependencies !== null && ls(t.dependencies))
        ? (typeof y == "function" && (Or(e, n, y, i), (R = e.memoizedState)),
          (V =
            Mn ||
            ih(e, n, V, i, w, R, x) ||
            (t !== null && t.dependencies !== null && ls(t.dependencies)))
            ? (D ||
                (typeof u.UNSAFE_componentWillUpdate != "function" &&
                  typeof u.componentWillUpdate != "function") ||
                (typeof u.componentWillUpdate == "function" &&
                  u.componentWillUpdate(i, R, x),
                typeof u.UNSAFE_componentWillUpdate == "function" &&
                  u.UNSAFE_componentWillUpdate(i, R, x)),
              typeof u.componentDidUpdate == "function" && (e.flags |= 4),
              typeof u.getSnapshotBeforeUpdate == "function" &&
                (e.flags |= 1024))
            : (typeof u.componentDidUpdate != "function" ||
                (d === t.memoizedProps && w === t.memoizedState) ||
                (e.flags |= 4),
              typeof u.getSnapshotBeforeUpdate != "function" ||
                (d === t.memoizedProps && w === t.memoizedState) ||
                (e.flags |= 1024),
              (e.memoizedProps = i),
              (e.memoizedState = R)),
          (u.props = i),
          (u.state = R),
          (u.context = x),
          (i = V))
        : (typeof u.componentDidUpdate != "function" ||
            (d === t.memoizedProps && w === t.memoizedState) ||
            (e.flags |= 4),
          typeof u.getSnapshotBeforeUpdate != "function" ||
            (d === t.memoizedProps && w === t.memoizedState) ||
            (e.flags |= 1024),
          (i = !1));
    }
    return (
      (u = i),
      Es(t, e),
      (i = (e.flags & 128) !== 0),
      u || i
        ? ((u = e.stateNode),
          (n =
            i && typeof n.getDerivedStateFromError != "function"
              ? null
              : u.render()),
          (e.flags |= 1),
          t !== null && i
            ? ((e.child = Qa(e, t.child, null, s)),
              (e.child = Qa(e, null, n, s)))
            : $t(t, e, n, s),
          (e.memoizedState = u.state),
          (t = e.child))
        : (t = un(t, e, s)),
      t
    );
  }
  function xh(t, e, n, i) {
    return Ui(), (e.flags |= 256), $t(t, e, n, i), e.child;
  }
  var Nr = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null,
  };
  function _r(t) {
    return { baseLanes: t, cachePool: od() };
  }
  function Ur(t, e, n) {
    return (t = t !== null ? t.childLanes & ~n : 0), e && (t |= Ue), t;
  }
  function Sh(t, e, n) {
    var i = e.pendingProps,
      s = !1,
      u = (e.flags & 128) !== 0,
      d;
    if (
      ((d = u) ||
        (d =
          t !== null && t.memoizedState === null ? !1 : (Qt.current & 2) !== 0),
      d && ((s = !0), (e.flags &= -129)),
      (d = (e.flags & 32) !== 0),
      (e.flags &= -33),
      t === null)
    ) {
      if (xt) {
        if ((s ? On(e) : Cn(), xt)) {
          var y = jt,
            x;
          if ((x = y)) {
            t: {
              for (x = y, y = Ze; x.nodeType !== 8; ) {
                if (!y) {
                  y = null;
                  break t;
                }
                if (((x = Ye(x.nextSibling)), x === null)) {
                  y = null;
                  break t;
                }
              }
              y = x;
            }
            y !== null
              ? ((e.memoizedState = {
                  dehydrated: y,
                  treeContext: na !== null ? { id: nn, overflow: an } : null,
                  retryLane: 536870912,
                  hydrationErrors: null,
                }),
                (x = Se(18, null, null, 0)),
                (x.stateNode = y),
                (x.return = e),
                (e.child = x),
                (oe = e),
                (jt = null),
                (x = !0))
              : (x = !1);
          }
          x || la(e);
        }
        if (
          ((y = e.memoizedState),
          y !== null && ((y = y.dehydrated), y !== null))
        )
          return vu(y) ? (e.lanes = 32) : (e.lanes = 536870912), null;
        rn(e);
      }
      return (
        (y = i.children),
        (i = i.fallback),
        s
          ? (Cn(),
            (s = e.mode),
            (y = Ms({ mode: "hidden", children: y }, s)),
            (i = ea(i, s, n, null)),
            (y.return = e),
            (i.return = e),
            (y.sibling = i),
            (e.child = y),
            (s = e.child),
            (s.memoizedState = _r(n)),
            (s.childLanes = Ur(t, d, n)),
            (e.memoizedState = Nr),
            i)
          : (On(e), jr(e, y))
      );
    }
    if (
      ((x = t.memoizedState), x !== null && ((y = x.dehydrated), y !== null))
    ) {
      if (u)
        e.flags & 256
          ? (On(e), (e.flags &= -257), (e = Br(t, e, n)))
          : e.memoizedState !== null
          ? (Cn(), (e.child = t.child), (e.flags |= 128), (e = null))
          : (Cn(),
            (s = i.fallback),
            (y = e.mode),
            (i = Ms({ mode: "visible", children: i.children }, y)),
            (s = ea(s, y, n, null)),
            (s.flags |= 2),
            (i.return = e),
            (s.return = e),
            (i.sibling = s),
            (e.child = i),
            Qa(e, t.child, null, n),
            (i = e.child),
            (i.memoizedState = _r(n)),
            (i.childLanes = Ur(t, d, n)),
            (e.memoizedState = Nr),
            (e = s));
      else if ((On(e), vu(y))) {
        if (((d = y.nextSibling && y.nextSibling.dataset), d)) var D = d.dgst;
        (d = D),
          (i = Error(r(419))),
          (i.stack = ""),
          (i.digest = d),
          ji({ value: i, source: null, stack: null }),
          (e = Br(t, e, n));
      } else if (
        (Pt || Bi(t, e, n, !1), (d = (n & t.childLanes) !== 0), Pt || d)
      ) {
        if (
          ((d = Rt),
          d !== null &&
            ((i = n & -n),
            (i = (i & 42) !== 0 ? 1 : bo(i)),
            (i = (i & (d.suspendedLanes | n)) !== 0 ? 0 : i),
            i !== 0 && i !== x.retryLane))
        )
          throw ((x.retryLane = i), Ua(t, i), De(d, t, i), dh);
        y.data === "$?" || eu(), (e = Br(t, e, n));
      } else
        y.data === "$?"
          ? ((e.flags |= 192), (e.child = t.child), (e = null))
          : ((t = x.treeContext),
            (jt = Ye(y.nextSibling)),
            (oe = e),
            (xt = !0),
            (ia = null),
            (Ze = !1),
            t !== null &&
              ((ze[Ne++] = nn),
              (ze[Ne++] = an),
              (ze[Ne++] = na),
              (nn = t.id),
              (an = t.overflow),
              (na = e)),
            (e = jr(e, i.children)),
            (e.flags |= 4096));
      return e;
    }
    return s
      ? (Cn(),
        (s = i.fallback),
        (y = e.mode),
        (x = t.child),
        (D = x.sibling),
        (i = en(x, { mode: "hidden", children: i.children })),
        (i.subtreeFlags = x.subtreeFlags & 65011712),
        D !== null ? (s = en(D, s)) : ((s = ea(s, y, n, null)), (s.flags |= 2)),
        (s.return = e),
        (i.return = e),
        (i.sibling = s),
        (e.child = i),
        (i = s),
        (s = e.child),
        (y = t.child.memoizedState),
        y === null
          ? (y = _r(n))
          : ((x = y.cachePool),
            x !== null
              ? ((D = Zt._currentValue),
                (x = x.parent !== D ? { parent: D, pool: D } : x))
              : (x = od()),
            (y = { baseLanes: y.baseLanes | n, cachePool: x })),
        (s.memoizedState = y),
        (s.childLanes = Ur(t, d, n)),
        (e.memoizedState = Nr),
        i)
      : (On(e),
        (n = t.child),
        (t = n.sibling),
        (n = en(n, { mode: "visible", children: i.children })),
        (n.return = e),
        (n.sibling = null),
        t !== null &&
          ((d = e.deletions),
          d === null ? ((e.deletions = [t]), (e.flags |= 16)) : d.push(t)),
        (e.child = n),
        (e.memoizedState = null),
        n);
  }
  function jr(t, e) {
    return (
      (e = Ms({ mode: "visible", children: e }, t.mode)),
      (e.return = t),
      (t.child = e)
    );
  }
  function Ms(t, e) {
    return (
      (t = Se(22, t, null, e)),
      (t.lanes = 0),
      (t.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null,
      }),
      t
    );
  }
  function Br(t, e, n) {
    return (
      Qa(e, t.child, null, n),
      (t = jr(e, e.pendingProps.children)),
      (t.flags |= 2),
      (e.memoizedState = null),
      t
    );
  }
  function Th(t, e, n) {
    t.lanes |= e;
    var i = t.alternate;
    i !== null && (i.lanes |= e), er(t.return, e, n);
  }
  function Lr(t, e, n, i, s) {
    var u = t.memoizedState;
    u === null
      ? (t.memoizedState = {
          isBackwards: e,
          rendering: null,
          renderingStartTime: 0,
          last: i,
          tail: n,
          tailMode: s,
        })
      : ((u.isBackwards = e),
        (u.rendering = null),
        (u.renderingStartTime = 0),
        (u.last = i),
        (u.tail = n),
        (u.tailMode = s));
  }
  function Ah(t, e, n) {
    var i = e.pendingProps,
      s = i.revealOrder,
      u = i.tail;
    if (($t(t, e, i.children, n), (i = Qt.current), (i & 2) !== 0))
      (i = (i & 1) | 2), (e.flags |= 128);
    else {
      if (t !== null && (t.flags & 128) !== 0)
        t: for (t = e.child; t !== null; ) {
          if (t.tag === 13) t.memoizedState !== null && Th(t, n, e);
          else if (t.tag === 19) Th(t, n, e);
          else if (t.child !== null) {
            (t.child.return = t), (t = t.child);
            continue;
          }
          if (t === e) break t;
          for (; t.sibling === null; ) {
            if (t.return === null || t.return === e) break t;
            t = t.return;
          }
          (t.sibling.return = t.return), (t = t.sibling);
        }
      i &= 1;
    }
    switch ((q(Qt, i), s)) {
      case "forwards":
        for (n = e.child, s = null; n !== null; )
          (t = n.alternate),
            t !== null && Ss(t) === null && (s = n),
            (n = n.sibling);
        (n = s),
          n === null
            ? ((s = e.child), (e.child = null))
            : ((s = n.sibling), (n.sibling = null)),
          Lr(e, !1, s, n, u);
        break;
      case "backwards":
        for (n = null, s = e.child, e.child = null; s !== null; ) {
          if (((t = s.alternate), t !== null && Ss(t) === null)) {
            e.child = s;
            break;
          }
          (t = s.sibling), (s.sibling = n), (n = s), (s = t);
        }
        Lr(e, !0, n, null, u);
        break;
      case "together":
        Lr(e, !1, null, null, void 0);
        break;
      default:
        e.memoizedState = null;
    }
    return e.child;
  }
  function un(t, e, n) {
    if (
      (t !== null && (e.dependencies = t.dependencies),
      (Un |= e.lanes),
      (n & e.childLanes) === 0)
    )
      if (t !== null) {
        if ((Bi(t, e, n, !1), (n & e.childLanes) === 0)) return null;
      } else return null;
    if (t !== null && e.child !== t.child) throw Error(r(153));
    if (e.child !== null) {
      for (
        t = e.child, n = en(t, t.pendingProps), e.child = n, n.return = e;
        t.sibling !== null;

      )
        (t = t.sibling),
          (n = n.sibling = en(t, t.pendingProps)),
          (n.return = e);
      n.sibling = null;
    }
    return e.child;
  }
  function Hr(t, e) {
    return (t.lanes & e) !== 0
      ? !0
      : ((t = t.dependencies), !!(t !== null && ls(t)));
  }
  function _0(t, e, n) {
    switch (e.tag) {
      case 3:
        Dt(e, e.stateNode.containerInfo),
          En(e, Zt, t.memoizedState.cache),
          Ui();
        break;
      case 27:
      case 5:
        vn(e);
        break;
      case 4:
        Dt(e, e.stateNode.containerInfo);
        break;
      case 10:
        En(e, e.type, e.memoizedProps.value);
        break;
      case 13:
        var i = e.memoizedState;
        if (i !== null)
          return i.dehydrated !== null
            ? (On(e), (e.flags |= 128), null)
            : (n & e.child.childLanes) !== 0
            ? Sh(t, e, n)
            : (On(e), (t = un(t, e, n)), t !== null ? t.sibling : null);
        On(e);
        break;
      case 19:
        var s = (t.flags & 128) !== 0;
        if (
          ((i = (n & e.childLanes) !== 0),
          i || (Bi(t, e, n, !1), (i = (n & e.childLanes) !== 0)),
          s)
        ) {
          if (i) return Ah(t, e, n);
          e.flags |= 128;
        }
        if (
          ((s = e.memoizedState),
          s !== null &&
            ((s.rendering = null), (s.tail = null), (s.lastEffect = null)),
          q(Qt, Qt.current),
          i)
        )
          break;
        return null;
      case 22:
      case 23:
        return (e.lanes = 0), gh(t, e, n);
      case 24:
        En(e, Zt, t.memoizedState.cache);
    }
    return un(t, e, n);
  }
  function Eh(t, e, n) {
    if (t !== null)
      if (t.memoizedProps !== e.pendingProps) Pt = !0;
      else {
        if (!Hr(t, n) && (e.flags & 128) === 0) return (Pt = !1), _0(t, e, n);
        Pt = (t.flags & 131072) !== 0;
      }
    else (Pt = !1), xt && (e.flags & 1048576) !== 0 && td(e, is, e.index);
    switch (((e.lanes = 0), e.tag)) {
      case 16:
        t: {
          t = e.pendingProps;
          var i = e.elementType,
            s = i._init;
          if (((i = s(i._payload)), (e.type = i), typeof i == "function"))
            Jo(i)
              ? ((t = ca(i, t)), (e.tag = 1), (e = bh(null, e, i, t, n)))
              : ((e.tag = 0), (e = zr(null, e, i, t, n)));
          else {
            if (i != null) {
              if (((s = i.$$typeof), s === lt)) {
                (e.tag = 11), (e = hh(null, e, i, t, n));
                break t;
              } else if (s === rt) {
                (e.tag = 14), (e = mh(null, e, i, t, n));
                break t;
              }
            }
            throw ((e = ce(i) || i), Error(r(306, e, "")));
          }
        }
        return e;
      case 0:
        return zr(t, e, e.type, e.pendingProps, n);
      case 1:
        return (i = e.type), (s = ca(i, e.pendingProps)), bh(t, e, i, s, n);
      case 3:
        t: {
          if ((Dt(e, e.stateNode.containerInfo), t === null))
            throw Error(r(387));
          i = e.pendingProps;
          var u = e.memoizedState;
          (s = u.element), rr(t, e), Xi(e, i, null, n);
          var d = e.memoizedState;
          if (
            ((i = d.cache),
            En(e, Zt, i),
            i !== u.cache && nr(e, [Zt], n, !0),
            ki(),
            (i = d.element),
            u.isDehydrated)
          )
            if (
              ((u = { element: i, isDehydrated: !1, cache: d.cache }),
              (e.updateQueue.baseState = u),
              (e.memoizedState = u),
              e.flags & 256)
            ) {
              e = xh(t, e, i, n);
              break t;
            } else if (i !== s) {
              (s = Ce(Error(r(424)), e)), ji(s), (e = xh(t, e, i, n));
              break t;
            } else {
              switch (((t = e.stateNode.containerInfo), t.nodeType)) {
                case 9:
                  t = t.body;
                  break;
                default:
                  t = t.nodeName === "HTML" ? t.ownerDocument.body : t;
              }
              for (
                jt = Ye(t.firstChild),
                  oe = e,
                  xt = !0,
                  ia = null,
                  Ze = !0,
                  n = nh(e, null, i, n),
                  e.child = n;
                n;

              )
                (n.flags = (n.flags & -3) | 4096), (n = n.sibling);
            }
          else {
            if ((Ui(), i === s)) {
              e = un(t, e, n);
              break t;
            }
            $t(t, e, i, n);
          }
          e = e.child;
        }
        return e;
      case 26:
        return (
          Es(t, e),
          t === null
            ? (n = Rm(e.type, null, e.pendingProps, null))
              ? (e.memoizedState = n)
              : xt ||
                ((n = e.type),
                (t = e.pendingProps),
                (i = Hs(st.current).createElement(n)),
                (i[ne] = e),
                (i[fe] = t),
                te(i, n, t),
                Jt(i),
                (e.stateNode = i))
            : (e.memoizedState = Rm(
                e.type,
                t.memoizedProps,
                e.pendingProps,
                t.memoizedState
              )),
          null
        );
      case 27:
        return (
          vn(e),
          t === null &&
            xt &&
            ((i = e.stateNode = Mm(e.type, e.pendingProps, st.current)),
            (oe = e),
            (Ze = !0),
            (s = jt),
            Hn(e.type) ? ((bu = s), (jt = Ye(i.firstChild))) : (jt = s)),
          $t(t, e, e.pendingProps.children, n),
          Es(t, e),
          t === null && (e.flags |= 4194304),
          e.child
        );
      case 5:
        return (
          t === null &&
            xt &&
            ((s = i = jt) &&
              ((i = rb(i, e.type, e.pendingProps, Ze)),
              i !== null
                ? ((e.stateNode = i),
                  (oe = e),
                  (jt = Ye(i.firstChild)),
                  (Ze = !1),
                  (s = !0))
                : (s = !1)),
            s || la(e)),
          vn(e),
          (s = e.type),
          (u = e.pendingProps),
          (d = t !== null ? t.memoizedProps : null),
          (i = u.children),
          pu(s, u) ? (i = null) : d !== null && pu(s, d) && (e.flags |= 32),
          e.memoizedState !== null &&
            ((s = mr(t, e, D0, null, null, n)), (dl._currentValue = s)),
          Es(t, e),
          $t(t, e, i, n),
          e.child
        );
      case 6:
        return (
          t === null &&
            xt &&
            ((t = n = jt) &&
              ((n = ub(n, e.pendingProps, Ze)),
              n !== null
                ? ((e.stateNode = n), (oe = e), (jt = null), (t = !0))
                : (t = !1)),
            t || la(e)),
          null
        );
      case 13:
        return Sh(t, e, n);
      case 4:
        return (
          Dt(e, e.stateNode.containerInfo),
          (i = e.pendingProps),
          t === null ? (e.child = Qa(e, null, i, n)) : $t(t, e, i, n),
          e.child
        );
      case 11:
        return hh(t, e, e.type, e.pendingProps, n);
      case 7:
        return $t(t, e, e.pendingProps, n), e.child;
      case 8:
        return $t(t, e, e.pendingProps.children, n), e.child;
      case 12:
        return $t(t, e, e.pendingProps.children, n), e.child;
      case 10:
        return (
          (i = e.pendingProps),
          En(e, e.type, i.value),
          $t(t, e, i.children, n),
          e.child
        );
      case 9:
        return (
          (s = e.type._context),
          (i = e.pendingProps.children),
          oa(e),
          (s = ae(s)),
          (i = i(s)),
          (e.flags |= 1),
          $t(t, e, i, n),
          e.child
        );
      case 14:
        return mh(t, e, e.type, e.pendingProps, n);
      case 15:
        return ph(t, e, e.type, e.pendingProps, n);
      case 19:
        return Ah(t, e, n);
      case 31:
        return (
          (i = e.pendingProps),
          (n = e.mode),
          (i = { mode: i.mode, children: i.children }),
          t === null
            ? ((n = Ms(i, n)),
              (n.ref = e.ref),
              (e.child = n),
              (n.return = e),
              (e = n))
            : ((n = en(t.child, i)),
              (n.ref = e.ref),
              (e.child = n),
              (n.return = e),
              (e = n)),
          e
        );
      case 22:
        return gh(t, e, n);
      case 24:
        return (
          oa(e),
          (i = ae(Zt)),
          t === null
            ? ((s = lr()),
              s === null &&
                ((s = Rt),
                (u = ar()),
                (s.pooledCache = u),
                u.refCount++,
                u !== null && (s.pooledCacheLanes |= n),
                (s = u)),
              (e.memoizedState = { parent: i, cache: s }),
              or(e),
              En(e, Zt, s))
            : ((t.lanes & n) !== 0 && (rr(t, e), Xi(e, null, null, n), ki()),
              (s = t.memoizedState),
              (u = e.memoizedState),
              s.parent !== i
                ? ((s = { parent: i, cache: i }),
                  (e.memoizedState = s),
                  e.lanes === 0 &&
                    (e.memoizedState = e.updateQueue.baseState = s),
                  En(e, Zt, i))
                : ((i = u.cache),
                  En(e, Zt, i),
                  i !== s.cache && nr(e, [Zt], n, !0))),
          $t(t, e, e.pendingProps.children, n),
          e.child
        );
      case 29:
        throw e.pendingProps;
    }
    throw Error(r(156, e.tag));
  }
  function cn(t) {
    t.flags |= 4;
  }
  function Mh(t, e) {
    if (e.type !== "stylesheet" || (e.state.loading & 4) !== 0)
      t.flags &= -16777217;
    else if (((t.flags |= 16777216), !Nm(e))) {
      if (
        ((e = _e.current),
        e !== null &&
          ((yt & 4194048) === yt
            ? Qe !== null
            : ((yt & 62914560) !== yt && (yt & 536870912) === 0) || e !== Qe))
      )
        throw ((qi = sr), rd);
      t.flags |= 8192;
    }
  }
  function Ds(t, e) {
    e !== null && (t.flags |= 4),
      t.flags & 16384 &&
        ((e = t.tag !== 22 ? nf() : 536870912), (t.lanes |= e), (Fa |= e));
  }
  function Wi(t, e) {
    if (!xt)
      switch (t.tailMode) {
        case "hidden":
          e = t.tail;
          for (var n = null; e !== null; )
            e.alternate !== null && (n = e), (e = e.sibling);
          n === null ? (t.tail = null) : (n.sibling = null);
          break;
        case "collapsed":
          n = t.tail;
          for (var i = null; n !== null; )
            n.alternate !== null && (i = n), (n = n.sibling);
          i === null
            ? e || t.tail === null
              ? (t.tail = null)
              : (t.tail.sibling = null)
            : (i.sibling = null);
      }
  }
  function zt(t) {
    var e = t.alternate !== null && t.alternate.child === t.child,
      n = 0,
      i = 0;
    if (e)
      for (var s = t.child; s !== null; )
        (n |= s.lanes | s.childLanes),
          (i |= s.subtreeFlags & 65011712),
          (i |= s.flags & 65011712),
          (s.return = t),
          (s = s.sibling);
    else
      for (s = t.child; s !== null; )
        (n |= s.lanes | s.childLanes),
          (i |= s.subtreeFlags),
          (i |= s.flags),
          (s.return = t),
          (s = s.sibling);
    return (t.subtreeFlags |= i), (t.childLanes = n), e;
  }
  function U0(t, e, n) {
    var i = e.pendingProps;
    switch (($o(e), e.tag)) {
      case 31:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return zt(e), null;
      case 1:
        return zt(e), null;
      case 3:
        return (
          (n = e.stateNode),
          (i = null),
          t !== null && (i = t.memoizedState.cache),
          e.memoizedState.cache !== i && (e.flags |= 2048),
          sn(Zt),
          ye(),
          n.pendingContext &&
            ((n.context = n.pendingContext), (n.pendingContext = null)),
          (t === null || t.child === null) &&
            (_i(e)
              ? cn(e)
              : t === null ||
                (t.memoizedState.isDehydrated && (e.flags & 256) === 0) ||
                ((e.flags |= 1024), ad())),
          zt(e),
          null
        );
      case 26:
        return (
          (n = e.memoizedState),
          t === null
            ? (cn(e),
              n !== null ? (zt(e), Mh(e, n)) : (zt(e), (e.flags &= -16777217)))
            : n
            ? n !== t.memoizedState
              ? (cn(e), zt(e), Mh(e, n))
              : (zt(e), (e.flags &= -16777217))
            : (t.memoizedProps !== i && cn(e), zt(e), (e.flags &= -16777217)),
          null
        );
      case 27:
        bn(e), (n = st.current);
        var s = e.type;
        if (t !== null && e.stateNode != null) t.memoizedProps !== i && cn(e);
        else {
          if (!i) {
            if (e.stateNode === null) throw Error(r(166));
            return zt(e), null;
          }
          (t = K.current),
            _i(e) ? ed(e) : ((t = Mm(s, i, n)), (e.stateNode = t), cn(e));
        }
        return zt(e), null;
      case 5:
        if ((bn(e), (n = e.type), t !== null && e.stateNode != null))
          t.memoizedProps !== i && cn(e);
        else {
          if (!i) {
            if (e.stateNode === null) throw Error(r(166));
            return zt(e), null;
          }
          if (((t = K.current), _i(e))) ed(e);
          else {
            switch (((s = Hs(st.current)), t)) {
              case 1:
                t = s.createElementNS("http://www.w3.org/2000/svg", n);
                break;
              case 2:
                t = s.createElementNS("http://www.w3.org/1998/Math/MathML", n);
                break;
              default:
                switch (n) {
                  case "svg":
                    t = s.createElementNS("http://www.w3.org/2000/svg", n);
                    break;
                  case "math":
                    t = s.createElementNS(
                      "http://www.w3.org/1998/Math/MathML",
                      n
                    );
                    break;
                  case "script":
                    (t = s.createElement("div")),
                      (t.innerHTML = "<script></script>"),
                      (t = t.removeChild(t.firstChild));
                    break;
                  case "select":
                    (t =
                      typeof i.is == "string"
                        ? s.createElement("select", { is: i.is })
                        : s.createElement("select")),
                      i.multiple
                        ? (t.multiple = !0)
                        : i.size && (t.size = i.size);
                    break;
                  default:
                    t =
                      typeof i.is == "string"
                        ? s.createElement(n, { is: i.is })
                        : s.createElement(n);
                }
            }
            (t[ne] = e), (t[fe] = i);
            t: for (s = e.child; s !== null; ) {
              if (s.tag === 5 || s.tag === 6) t.appendChild(s.stateNode);
              else if (s.tag !== 4 && s.tag !== 27 && s.child !== null) {
                (s.child.return = s), (s = s.child);
                continue;
              }
              if (s === e) break t;
              for (; s.sibling === null; ) {
                if (s.return === null || s.return === e) break t;
                s = s.return;
              }
              (s.sibling.return = s.return), (s = s.sibling);
            }
            e.stateNode = t;
            t: switch ((te(t, n, i), n)) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                t = !!i.autoFocus;
                break t;
              case "img":
                t = !0;
                break t;
              default:
                t = !1;
            }
            t && cn(e);
          }
        }
        return zt(e), (e.flags &= -16777217), null;
      case 6:
        if (t && e.stateNode != null) t.memoizedProps !== i && cn(e);
        else {
          if (typeof i != "string" && e.stateNode === null) throw Error(r(166));
          if (((t = st.current), _i(e))) {
            if (
              ((t = e.stateNode),
              (n = e.memoizedProps),
              (i = null),
              (s = oe),
              s !== null)
            )
              switch (s.tag) {
                case 27:
                case 5:
                  i = s.memoizedProps;
              }
            (t[ne] = e),
              (t = !!(
                t.nodeValue === n ||
                (i !== null && i.suppressHydrationWarning === !0) ||
                vm(t.nodeValue, n)
              )),
              t || la(e);
          } else (t = Hs(t).createTextNode(i)), (t[ne] = e), (e.stateNode = t);
        }
        return zt(e), null;
      case 13:
        if (
          ((i = e.memoizedState),
          t === null ||
            (t.memoizedState !== null && t.memoizedState.dehydrated !== null))
        ) {
          if (((s = _i(e)), i !== null && i.dehydrated !== null)) {
            if (t === null) {
              if (!s) throw Error(r(318));
              if (
                ((s = e.memoizedState),
                (s = s !== null ? s.dehydrated : null),
                !s)
              )
                throw Error(r(317));
              s[ne] = e;
            } else
              Ui(),
                (e.flags & 128) === 0 && (e.memoizedState = null),
                (e.flags |= 4);
            zt(e), (s = !1);
          } else
            (s = ad()),
              t !== null &&
                t.memoizedState !== null &&
                (t.memoizedState.hydrationErrors = s),
              (s = !0);
          if (!s) return e.flags & 256 ? (rn(e), e) : (rn(e), null);
        }
        if ((rn(e), (e.flags & 128) !== 0)) return (e.lanes = n), e;
        if (
          ((n = i !== null), (t = t !== null && t.memoizedState !== null), n)
        ) {
          (i = e.child),
            (s = null),
            i.alternate !== null &&
              i.alternate.memoizedState !== null &&
              i.alternate.memoizedState.cachePool !== null &&
              (s = i.alternate.memoizedState.cachePool.pool);
          var u = null;
          i.memoizedState !== null &&
            i.memoizedState.cachePool !== null &&
            (u = i.memoizedState.cachePool.pool),
            u !== s && (i.flags |= 2048);
        }
        return (
          n !== t && n && (e.child.flags |= 8192),
          Ds(e, e.updateQueue),
          zt(e),
          null
        );
      case 4:
        return ye(), t === null && cu(e.stateNode.containerInfo), zt(e), null;
      case 10:
        return sn(e.type), zt(e), null;
      case 19:
        if ((Q(Qt), (s = e.memoizedState), s === null)) return zt(e), null;
        if (((i = (e.flags & 128) !== 0), (u = s.rendering), u === null))
          if (i) Wi(s, !1);
          else {
            if (Bt !== 0 || (t !== null && (t.flags & 128) !== 0))
              for (t = e.child; t !== null; ) {
                if (((u = Ss(t)), u !== null)) {
                  for (
                    e.flags |= 128,
                      Wi(s, !1),
                      t = u.updateQueue,
                      e.updateQueue = t,
                      Ds(e, t),
                      e.subtreeFlags = 0,
                      t = n,
                      n = e.child;
                    n !== null;

                  )
                    If(n, t), (n = n.sibling);
                  return q(Qt, (Qt.current & 1) | 2), e.child;
                }
                t = t.sibling;
              }
            s.tail !== null &&
              Xe() > Os &&
              ((e.flags |= 128), (i = !0), Wi(s, !1), (e.lanes = 4194304));
          }
        else {
          if (!i)
            if (((t = Ss(u)), t !== null)) {
              if (
                ((e.flags |= 128),
                (i = !0),
                (t = t.updateQueue),
                (e.updateQueue = t),
                Ds(e, t),
                Wi(s, !0),
                s.tail === null &&
                  s.tailMode === "hidden" &&
                  !u.alternate &&
                  !xt)
              )
                return zt(e), null;
            } else
              2 * Xe() - s.renderingStartTime > Os &&
                n !== 536870912 &&
                ((e.flags |= 128), (i = !0), Wi(s, !1), (e.lanes = 4194304));
          s.isBackwards
            ? ((u.sibling = e.child), (e.child = u))
            : ((t = s.last),
              t !== null ? (t.sibling = u) : (e.child = u),
              (s.last = u));
        }
        return s.tail !== null
          ? ((e = s.tail),
            (s.rendering = e),
            (s.tail = e.sibling),
            (s.renderingStartTime = Xe()),
            (e.sibling = null),
            (t = Qt.current),
            q(Qt, i ? (t & 1) | 2 : t & 1),
            e)
          : (zt(e), null);
      case 22:
      case 23:
        return (
          rn(e),
          dr(),
          (i = e.memoizedState !== null),
          t !== null
            ? (t.memoizedState !== null) !== i && (e.flags |= 8192)
            : i && (e.flags |= 8192),
          i
            ? (n & 536870912) !== 0 &&
              (e.flags & 128) === 0 &&
              (zt(e), e.subtreeFlags & 6 && (e.flags |= 8192))
            : zt(e),
          (n = e.updateQueue),
          n !== null && Ds(e, n.retryQueue),
          (n = null),
          t !== null &&
            t.memoizedState !== null &&
            t.memoizedState.cachePool !== null &&
            (n = t.memoizedState.cachePool.pool),
          (i = null),
          e.memoizedState !== null &&
            e.memoizedState.cachePool !== null &&
            (i = e.memoizedState.cachePool.pool),
          i !== n && (e.flags |= 2048),
          t !== null && Q(ra),
          null
        );
      case 24:
        return (
          (n = null),
          t !== null && (n = t.memoizedState.cache),
          e.memoizedState.cache !== n && (e.flags |= 2048),
          sn(Zt),
          zt(e),
          null
        );
      case 25:
        return null;
      case 30:
        return null;
    }
    throw Error(r(156, e.tag));
  }
  function j0(t, e) {
    switch (($o(e), e.tag)) {
      case 1:
        return (
          (t = e.flags), t & 65536 ? ((e.flags = (t & -65537) | 128), e) : null
        );
      case 3:
        return (
          sn(Zt),
          ye(),
          (t = e.flags),
          (t & 65536) !== 0 && (t & 128) === 0
            ? ((e.flags = (t & -65537) | 128), e)
            : null
        );
      case 26:
      case 27:
      case 5:
        return bn(e), null;
      case 13:
        if (
          (rn(e), (t = e.memoizedState), t !== null && t.dehydrated !== null)
        ) {
          if (e.alternate === null) throw Error(r(340));
          Ui();
        }
        return (
          (t = e.flags), t & 65536 ? ((e.flags = (t & -65537) | 128), e) : null
        );
      case 19:
        return Q(Qt), null;
      case 4:
        return ye(), null;
      case 10:
        return sn(e.type), null;
      case 22:
      case 23:
        return (
          rn(e),
          dr(),
          t !== null && Q(ra),
          (t = e.flags),
          t & 65536 ? ((e.flags = (t & -65537) | 128), e) : null
        );
      case 24:
        return sn(Zt), null;
      case 25:
        return null;
      default:
        return null;
    }
  }
  function Dh(t, e) {
    switch (($o(e), e.tag)) {
      case 3:
        sn(Zt), ye();
        break;
      case 26:
      case 27:
      case 5:
        bn(e);
        break;
      case 4:
        ye();
        break;
      case 13:
        rn(e);
        break;
      case 19:
        Q(Qt);
        break;
      case 10:
        sn(e.type);
        break;
      case 22:
      case 23:
        rn(e), dr(), t !== null && Q(ra);
        break;
      case 24:
        sn(Zt);
    }
  }
  function $i(t, e) {
    try {
      var n = e.updateQueue,
        i = n !== null ? n.lastEffect : null;
      if (i !== null) {
        var s = i.next;
        n = s;
        do {
          if ((n.tag & t) === t) {
            i = void 0;
            var u = n.create,
              d = n.inst;
            (i = u()), (d.destroy = i);
          }
          n = n.next;
        } while (n !== s);
      }
    } catch (y) {
      wt(e, e.return, y);
    }
  }
  function Vn(t, e, n) {
    try {
      var i = e.updateQueue,
        s = i !== null ? i.lastEffect : null;
      if (s !== null) {
        var u = s.next;
        i = u;
        do {
          if ((i.tag & t) === t) {
            var d = i.inst,
              y = d.destroy;
            if (y !== void 0) {
              (d.destroy = void 0), (s = e);
              var x = n,
                D = y;
              try {
                D();
              } catch (V) {
                wt(s, x, V);
              }
            }
          }
          i = i.next;
        } while (i !== u);
      }
    } catch (V) {
      wt(e, e.return, V);
    }
  }
  function wh(t) {
    var e = t.updateQueue;
    if (e !== null) {
      var n = t.stateNode;
      try {
        md(e, n);
      } catch (i) {
        wt(t, t.return, i);
      }
    }
  }
  function Rh(t, e, n) {
    (n.props = ca(t.type, t.memoizedProps)), (n.state = t.memoizedState);
    try {
      n.componentWillUnmount();
    } catch (i) {
      wt(t, e, i);
    }
  }
  function Ii(t, e) {
    try {
      var n = t.ref;
      if (n !== null) {
        switch (t.tag) {
          case 26:
          case 27:
          case 5:
            var i = t.stateNode;
            break;
          case 30:
            i = t.stateNode;
            break;
          default:
            i = t.stateNode;
        }
        typeof n == "function" ? (t.refCleanup = n(i)) : (n.current = i);
      }
    } catch (s) {
      wt(t, e, s);
    }
  }
  function Ke(t, e) {
    var n = t.ref,
      i = t.refCleanup;
    if (n !== null)
      if (typeof i == "function")
        try {
          i();
        } catch (s) {
          wt(t, e, s);
        } finally {
          (t.refCleanup = null),
            (t = t.alternate),
            t != null && (t.refCleanup = null);
        }
      else if (typeof n == "function")
        try {
          n(null);
        } catch (s) {
          wt(t, e, s);
        }
      else n.current = null;
  }
  function Oh(t) {
    var e = t.type,
      n = t.memoizedProps,
      i = t.stateNode;
    try {
      t: switch (e) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          n.autoFocus && i.focus();
          break t;
        case "img":
          n.src ? (i.src = n.src) : n.srcSet && (i.srcset = n.srcSet);
      }
    } catch (s) {
      wt(t, t.return, s);
    }
  }
  function Gr(t, e, n) {
    try {
      var i = t.stateNode;
      ab(i, t.type, n, e), (i[fe] = e);
    } catch (s) {
      wt(t, t.return, s);
    }
  }
  function Ch(t) {
    return (
      t.tag === 5 ||
      t.tag === 3 ||
      t.tag === 26 ||
      (t.tag === 27 && Hn(t.type)) ||
      t.tag === 4
    );
  }
  function qr(t) {
    t: for (;;) {
      for (; t.sibling === null; ) {
        if (t.return === null || Ch(t.return)) return null;
        t = t.return;
      }
      for (
        t.sibling.return = t.return, t = t.sibling;
        t.tag !== 5 && t.tag !== 6 && t.tag !== 18;

      ) {
        if (
          (t.tag === 27 && Hn(t.type)) ||
          t.flags & 2 ||
          t.child === null ||
          t.tag === 4
        )
          continue t;
        (t.child.return = t), (t = t.child);
      }
      if (!(t.flags & 2)) return t.stateNode;
    }
  }
  function Yr(t, e, n) {
    var i = t.tag;
    if (i === 5 || i === 6)
      (t = t.stateNode),
        e
          ? (n.nodeType === 9
              ? n.body
              : n.nodeName === "HTML"
              ? n.ownerDocument.body
              : n
            ).insertBefore(t, e)
          : ((e =
              n.nodeType === 9
                ? n.body
                : n.nodeName === "HTML"
                ? n.ownerDocument.body
                : n),
            e.appendChild(t),
            (n = n._reactRootContainer),
            n != null || e.onclick !== null || (e.onclick = Ls));
    else if (
      i !== 4 &&
      (i === 27 && Hn(t.type) && ((n = t.stateNode), (e = null)),
      (t = t.child),
      t !== null)
    )
      for (Yr(t, e, n), t = t.sibling; t !== null; )
        Yr(t, e, n), (t = t.sibling);
  }
  function ws(t, e, n) {
    var i = t.tag;
    if (i === 5 || i === 6)
      (t = t.stateNode), e ? n.insertBefore(t, e) : n.appendChild(t);
    else if (
      i !== 4 &&
      (i === 27 && Hn(t.type) && (n = t.stateNode), (t = t.child), t !== null)
    )
      for (ws(t, e, n), t = t.sibling; t !== null; )
        ws(t, e, n), (t = t.sibling);
  }
  function Vh(t) {
    var e = t.stateNode,
      n = t.memoizedProps;
    try {
      for (var i = t.type, s = e.attributes; s.length; )
        e.removeAttributeNode(s[0]);
      te(e, i, n), (e[ne] = t), (e[fe] = n);
    } catch (u) {
      wt(t, t.return, u);
    }
  }
  var fn = !1,
    Gt = !1,
    kr = !1,
    zh = typeof WeakSet == "function" ? WeakSet : Set,
    Ft = null;
  function B0(t, e) {
    if (((t = t.containerInfo), (hu = Zs), (t = kf(t)), qo(t))) {
      if ("selectionStart" in t)
        var n = { start: t.selectionStart, end: t.selectionEnd };
      else
        t: {
          n = ((n = t.ownerDocument) && n.defaultView) || window;
          var i = n.getSelection && n.getSelection();
          if (i && i.rangeCount !== 0) {
            n = i.anchorNode;
            var s = i.anchorOffset,
              u = i.focusNode;
            i = i.focusOffset;
            try {
              n.nodeType, u.nodeType;
            } catch {
              n = null;
              break t;
            }
            var d = 0,
              y = -1,
              x = -1,
              D = 0,
              V = 0,
              N = t,
              w = null;
            e: for (;;) {
              for (
                var R;
                N !== n || (s !== 0 && N.nodeType !== 3) || (y = d + s),
                  N !== u || (i !== 0 && N.nodeType !== 3) || (x = d + i),
                  N.nodeType === 3 && (d += N.nodeValue.length),
                  (R = N.firstChild) !== null;

              )
                (w = N), (N = R);
              for (;;) {
                if (N === t) break e;
                if (
                  (w === n && ++D === s && (y = d),
                  w === u && ++V === i && (x = d),
                  (R = N.nextSibling) !== null)
                )
                  break;
                (N = w), (w = N.parentNode);
              }
              N = R;
            }
            n = y === -1 || x === -1 ? null : { start: y, end: x };
          } else n = null;
        }
      n = n || { start: 0, end: 0 };
    } else n = null;
    for (
      mu = { focusedElem: t, selectionRange: n }, Zs = !1, Ft = e;
      Ft !== null;

    )
      if (
        ((e = Ft), (t = e.child), (e.subtreeFlags & 1024) !== 0 && t !== null)
      )
        (t.return = e), (Ft = t);
      else
        for (; Ft !== null; ) {
          switch (((e = Ft), (u = e.alternate), (t = e.flags), e.tag)) {
            case 0:
              break;
            case 11:
            case 15:
              break;
            case 1:
              if ((t & 1024) !== 0 && u !== null) {
                (t = void 0),
                  (n = e),
                  (s = u.memoizedProps),
                  (u = u.memoizedState),
                  (i = n.stateNode);
                try {
                  var at = ca(n.type, s, n.elementType === n.type);
                  (t = i.getSnapshotBeforeUpdate(at, u)),
                    (i.__reactInternalSnapshotBeforeUpdate = t);
                } catch (tt) {
                  wt(n, n.return, tt);
                }
              }
              break;
            case 3:
              if ((t & 1024) !== 0) {
                if (
                  ((t = e.stateNode.containerInfo), (n = t.nodeType), n === 9)
                )
                  yu(t);
                else if (n === 1)
                  switch (t.nodeName) {
                    case "HEAD":
                    case "HTML":
                    case "BODY":
                      yu(t);
                      break;
                    default:
                      t.textContent = "";
                  }
              }
              break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
              break;
            default:
              if ((t & 1024) !== 0) throw Error(r(163));
          }
          if (((t = e.sibling), t !== null)) {
            (t.return = e.return), (Ft = t);
            break;
          }
          Ft = e.return;
        }
  }
  function Nh(t, e, n) {
    var i = n.flags;
    switch (n.tag) {
      case 0:
      case 11:
      case 15:
        zn(t, n), i & 4 && $i(5, n);
        break;
      case 1:
        if ((zn(t, n), i & 4))
          if (((t = n.stateNode), e === null))
            try {
              t.componentDidMount();
            } catch (d) {
              wt(n, n.return, d);
            }
          else {
            var s = ca(n.type, e.memoizedProps);
            e = e.memoizedState;
            try {
              t.componentDidUpdate(s, e, t.__reactInternalSnapshotBeforeUpdate);
            } catch (d) {
              wt(n, n.return, d);
            }
          }
        i & 64 && wh(n), i & 512 && Ii(n, n.return);
        break;
      case 3:
        if ((zn(t, n), i & 64 && ((t = n.updateQueue), t !== null))) {
          if (((e = null), n.child !== null))
            switch (n.child.tag) {
              case 27:
              case 5:
                e = n.child.stateNode;
                break;
              case 1:
                e = n.child.stateNode;
            }
          try {
            md(t, e);
          } catch (d) {
            wt(n, n.return, d);
          }
        }
        break;
      case 27:
        e === null && i & 4 && Vh(n);
      case 26:
      case 5:
        zn(t, n), e === null && i & 4 && Oh(n), i & 512 && Ii(n, n.return);
        break;
      case 12:
        zn(t, n);
        break;
      case 13:
        zn(t, n),
          i & 4 && jh(t, n),
          i & 64 &&
            ((t = n.memoizedState),
            t !== null &&
              ((t = t.dehydrated),
              t !== null && ((n = Q0.bind(null, n)), cb(t, n))));
        break;
      case 22:
        if (((i = n.memoizedState !== null || fn), !i)) {
          (e = (e !== null && e.memoizedState !== null) || Gt), (s = fn);
          var u = Gt;
          (fn = i),
            (Gt = e) && !u ? Nn(t, n, (n.subtreeFlags & 8772) !== 0) : zn(t, n),
            (fn = s),
            (Gt = u);
        }
        break;
      case 30:
        break;
      default:
        zn(t, n);
    }
  }
  function _h(t) {
    var e = t.alternate;
    e !== null && ((t.alternate = null), _h(e)),
      (t.child = null),
      (t.deletions = null),
      (t.sibling = null),
      t.tag === 5 && ((e = t.stateNode), e !== null && To(e)),
      (t.stateNode = null),
      (t.return = null),
      (t.dependencies = null),
      (t.memoizedProps = null),
      (t.memoizedState = null),
      (t.pendingProps = null),
      (t.stateNode = null),
      (t.updateQueue = null);
  }
  var Vt = null,
    me = !1;
  function dn(t, e, n) {
    for (n = n.child; n !== null; ) Uh(t, e, n), (n = n.sibling);
  }
  function Uh(t, e, n) {
    if (ve && typeof ve.onCommitFiberUnmount == "function")
      try {
        ve.onCommitFiberUnmount(xi, n);
      } catch {}
    switch (n.tag) {
      case 26:
        Gt || Ke(n, e),
          dn(t, e, n),
          n.memoizedState
            ? n.memoizedState.count--
            : n.stateNode && ((n = n.stateNode), n.parentNode.removeChild(n));
        break;
      case 27:
        Gt || Ke(n, e);
        var i = Vt,
          s = me;
        Hn(n.type) && ((Vt = n.stateNode), (me = !1)),
          dn(t, e, n),
          rl(n.stateNode),
          (Vt = i),
          (me = s);
        break;
      case 5:
        Gt || Ke(n, e);
      case 6:
        if (
          ((i = Vt),
          (s = me),
          (Vt = null),
          dn(t, e, n),
          (Vt = i),
          (me = s),
          Vt !== null)
        )
          if (me)
            try {
              (Vt.nodeType === 9
                ? Vt.body
                : Vt.nodeName === "HTML"
                ? Vt.ownerDocument.body
                : Vt
              ).removeChild(n.stateNode);
            } catch (u) {
              wt(n, e, u);
            }
          else
            try {
              Vt.removeChild(n.stateNode);
            } catch (u) {
              wt(n, e, u);
            }
        break;
      case 18:
        Vt !== null &&
          (me
            ? ((t = Vt),
              Am(
                t.nodeType === 9
                  ? t.body
                  : t.nodeName === "HTML"
                  ? t.ownerDocument.body
                  : t,
                n.stateNode
              ),
              gl(t))
            : Am(Vt, n.stateNode));
        break;
      case 4:
        (i = Vt),
          (s = me),
          (Vt = n.stateNode.containerInfo),
          (me = !0),
          dn(t, e, n),
          (Vt = i),
          (me = s);
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        Gt || Vn(2, n, e), Gt || Vn(4, n, e), dn(t, e, n);
        break;
      case 1:
        Gt ||
          (Ke(n, e),
          (i = n.stateNode),
          typeof i.componentWillUnmount == "function" && Rh(n, e, i)),
          dn(t, e, n);
        break;
      case 21:
        dn(t, e, n);
        break;
      case 22:
        (Gt = (i = Gt) || n.memoizedState !== null), dn(t, e, n), (Gt = i);
        break;
      default:
        dn(t, e, n);
    }
  }
  function jh(t, e) {
    if (
      e.memoizedState === null &&
      ((t = e.alternate),
      t !== null &&
        ((t = t.memoizedState), t !== null && ((t = t.dehydrated), t !== null)))
    )
      try {
        gl(t);
      } catch (n) {
        wt(e, e.return, n);
      }
  }
  function L0(t) {
    switch (t.tag) {
      case 13:
      case 19:
        var e = t.stateNode;
        return e === null && (e = t.stateNode = new zh()), e;
      case 22:
        return (
          (t = t.stateNode),
          (e = t._retryCache),
          e === null && (e = t._retryCache = new zh()),
          e
        );
      default:
        throw Error(r(435, t.tag));
    }
  }
  function Xr(t, e) {
    var n = L0(t);
    e.forEach(function (i) {
      var s = K0.bind(null, t, i);
      n.has(i) || (n.add(i), i.then(s, s));
    });
  }
  function Te(t, e) {
    var n = e.deletions;
    if (n !== null)
      for (var i = 0; i < n.length; i++) {
        var s = n[i],
          u = t,
          d = e,
          y = d;
        t: for (; y !== null; ) {
          switch (y.tag) {
            case 27:
              if (Hn(y.type)) {
                (Vt = y.stateNode), (me = !1);
                break t;
              }
              break;
            case 5:
              (Vt = y.stateNode), (me = !1);
              break t;
            case 3:
            case 4:
              (Vt = y.stateNode.containerInfo), (me = !0);
              break t;
          }
          y = y.return;
        }
        if (Vt === null) throw Error(r(160));
        Uh(u, d, s),
          (Vt = null),
          (me = !1),
          (u = s.alternate),
          u !== null && (u.return = null),
          (s.return = null);
      }
    if (e.subtreeFlags & 13878)
      for (e = e.child; e !== null; ) Bh(e, t), (e = e.sibling);
  }
  var qe = null;
  function Bh(t, e) {
    var n = t.alternate,
      i = t.flags;
    switch (t.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        Te(e, t),
          Ae(t),
          i & 4 && (Vn(3, t, t.return), $i(3, t), Vn(5, t, t.return));
        break;
      case 1:
        Te(e, t),
          Ae(t),
          i & 512 && (Gt || n === null || Ke(n, n.return)),
          i & 64 &&
            fn &&
            ((t = t.updateQueue),
            t !== null &&
              ((i = t.callbacks),
              i !== null &&
                ((n = t.shared.hiddenCallbacks),
                (t.shared.hiddenCallbacks = n === null ? i : n.concat(i)))));
        break;
      case 26:
        var s = qe;
        if (
          (Te(e, t),
          Ae(t),
          i & 512 && (Gt || n === null || Ke(n, n.return)),
          i & 4)
        ) {
          var u = n !== null ? n.memoizedState : null;
          if (((i = t.memoizedState), n === null))
            if (i === null)
              if (t.stateNode === null) {
                t: {
                  (i = t.type),
                    (n = t.memoizedProps),
                    (s = s.ownerDocument || s);
                  e: switch (i) {
                    case "title":
                      (u = s.getElementsByTagName("title")[0]),
                        (!u ||
                          u[Ai] ||
                          u[ne] ||
                          u.namespaceURI === "http://www.w3.org/2000/svg" ||
                          u.hasAttribute("itemprop")) &&
                          ((u = s.createElement(i)),
                          s.head.insertBefore(
                            u,
                            s.querySelector("head > title")
                          )),
                        te(u, i, n),
                        (u[ne] = t),
                        Jt(u),
                        (i = u);
                      break t;
                    case "link":
                      var d = Vm("link", "href", s).get(i + (n.href || ""));
                      if (d) {
                        for (var y = 0; y < d.length; y++)
                          if (
                            ((u = d[y]),
                            u.getAttribute("href") ===
                              (n.href == null || n.href === ""
                                ? null
                                : n.href) &&
                              u.getAttribute("rel") ===
                                (n.rel == null ? null : n.rel) &&
                              u.getAttribute("title") ===
                                (n.title == null ? null : n.title) &&
                              u.getAttribute("crossorigin") ===
                                (n.crossOrigin == null ? null : n.crossOrigin))
                          ) {
                            d.splice(y, 1);
                            break e;
                          }
                      }
                      (u = s.createElement(i)),
                        te(u, i, n),
                        s.head.appendChild(u);
                      break;
                    case "meta":
                      if (
                        (d = Vm("meta", "content", s).get(
                          i + (n.content || "")
                        ))
                      ) {
                        for (y = 0; y < d.length; y++)
                          if (
                            ((u = d[y]),
                            u.getAttribute("content") ===
                              (n.content == null ? null : "" + n.content) &&
                              u.getAttribute("name") ===
                                (n.name == null ? null : n.name) &&
                              u.getAttribute("property") ===
                                (n.property == null ? null : n.property) &&
                              u.getAttribute("http-equiv") ===
                                (n.httpEquiv == null ? null : n.httpEquiv) &&
                              u.getAttribute("charset") ===
                                (n.charSet == null ? null : n.charSet))
                          ) {
                            d.splice(y, 1);
                            break e;
                          }
                      }
                      (u = s.createElement(i)),
                        te(u, i, n),
                        s.head.appendChild(u);
                      break;
                    default:
                      throw Error(r(468, i));
                  }
                  (u[ne] = t), Jt(u), (i = u);
                }
                t.stateNode = i;
              } else zm(s, t.type, t.stateNode);
            else t.stateNode = Cm(s, i, t.memoizedProps);
          else
            u !== i
              ? (u === null
                  ? n.stateNode !== null &&
                    ((n = n.stateNode), n.parentNode.removeChild(n))
                  : u.count--,
                i === null
                  ? zm(s, t.type, t.stateNode)
                  : Cm(s, i, t.memoizedProps))
              : i === null &&
                t.stateNode !== null &&
                Gr(t, t.memoizedProps, n.memoizedProps);
        }
        break;
      case 27:
        Te(e, t),
          Ae(t),
          i & 512 && (Gt || n === null || Ke(n, n.return)),
          n !== null && i & 4 && Gr(t, t.memoizedProps, n.memoizedProps);
        break;
      case 5:
        if (
          (Te(e, t),
          Ae(t),
          i & 512 && (Gt || n === null || Ke(n, n.return)),
          t.flags & 32)
        ) {
          s = t.stateNode;
          try {
            Ra(s, "");
          } catch (R) {
            wt(t, t.return, R);
          }
        }
        i & 4 &&
          t.stateNode != null &&
          ((s = t.memoizedProps), Gr(t, s, n !== null ? n.memoizedProps : s)),
          i & 1024 && (kr = !0);
        break;
      case 6:
        if ((Te(e, t), Ae(t), i & 4)) {
          if (t.stateNode === null) throw Error(r(162));
          (i = t.memoizedProps), (n = t.stateNode);
          try {
            n.nodeValue = i;
          } catch (R) {
            wt(t, t.return, R);
          }
        }
        break;
      case 3:
        if (
          ((Ys = null),
          (s = qe),
          (qe = Gs(e.containerInfo)),
          Te(e, t),
          (qe = s),
          Ae(t),
          i & 4 && n !== null && n.memoizedState.isDehydrated)
        )
          try {
            gl(e.containerInfo);
          } catch (R) {
            wt(t, t.return, R);
          }
        kr && ((kr = !1), Lh(t));
        break;
      case 4:
        (i = qe),
          (qe = Gs(t.stateNode.containerInfo)),
          Te(e, t),
          Ae(t),
          (qe = i);
        break;
      case 12:
        Te(e, t), Ae(t);
        break;
      case 13:
        Te(e, t),
          Ae(t),
          t.child.flags & 8192 &&
            (t.memoizedState !== null) !=
              (n !== null && n.memoizedState !== null) &&
            (Fr = Xe()),
          i & 4 &&
            ((i = t.updateQueue),
            i !== null && ((t.updateQueue = null), Xr(t, i)));
        break;
      case 22:
        s = t.memoizedState !== null;
        var x = n !== null && n.memoizedState !== null,
          D = fn,
          V = Gt;
        if (
          ((fn = D || s),
          (Gt = V || x),
          Te(e, t),
          (Gt = V),
          (fn = D),
          Ae(t),
          i & 8192)
        )
          t: for (
            e = t.stateNode,
              e._visibility = s ? e._visibility & -2 : e._visibility | 1,
              s && (n === null || x || fn || Gt || fa(t)),
              n = null,
              e = t;
            ;

          ) {
            if (e.tag === 5 || e.tag === 26) {
              if (n === null) {
                x = n = e;
                try {
                  if (((u = x.stateNode), s))
                    (d = u.style),
                      typeof d.setProperty == "function"
                        ? d.setProperty("display", "none", "important")
                        : (d.display = "none");
                  else {
                    y = x.stateNode;
                    var N = x.memoizedProps.style,
                      w =
                        N != null && N.hasOwnProperty("display")
                          ? N.display
                          : null;
                    y.style.display =
                      w == null || typeof w == "boolean" ? "" : ("" + w).trim();
                  }
                } catch (R) {
                  wt(x, x.return, R);
                }
              }
            } else if (e.tag === 6) {
              if (n === null) {
                x = e;
                try {
                  x.stateNode.nodeValue = s ? "" : x.memoizedProps;
                } catch (R) {
                  wt(x, x.return, R);
                }
              }
            } else if (
              ((e.tag !== 22 && e.tag !== 23) ||
                e.memoizedState === null ||
                e === t) &&
              e.child !== null
            ) {
              (e.child.return = e), (e = e.child);
              continue;
            }
            if (e === t) break t;
            for (; e.sibling === null; ) {
              if (e.return === null || e.return === t) break t;
              n === e && (n = null), (e = e.return);
            }
            n === e && (n = null),
              (e.sibling.return = e.return),
              (e = e.sibling);
          }
        i & 4 &&
          ((i = t.updateQueue),
          i !== null &&
            ((n = i.retryQueue),
            n !== null && ((i.retryQueue = null), Xr(t, n))));
        break;
      case 19:
        Te(e, t),
          Ae(t),
          i & 4 &&
            ((i = t.updateQueue),
            i !== null && ((t.updateQueue = null), Xr(t, i)));
        break;
      case 30:
        break;
      case 21:
        break;
      default:
        Te(e, t), Ae(t);
    }
  }
  function Ae(t) {
    var e = t.flags;
    if (e & 2) {
      try {
        for (var n, i = t.return; i !== null; ) {
          if (Ch(i)) {
            n = i;
            break;
          }
          i = i.return;
        }
        if (n == null) throw Error(r(160));
        switch (n.tag) {
          case 27:
            var s = n.stateNode,
              u = qr(t);
            ws(t, u, s);
            break;
          case 5:
            var d = n.stateNode;
            n.flags & 32 && (Ra(d, ""), (n.flags &= -33));
            var y = qr(t);
            ws(t, y, d);
            break;
          case 3:
          case 4:
            var x = n.stateNode.containerInfo,
              D = qr(t);
            Yr(t, D, x);
            break;
          default:
            throw Error(r(161));
        }
      } catch (V) {
        wt(t, t.return, V);
      }
      t.flags &= -3;
    }
    e & 4096 && (t.flags &= -4097);
  }
  function Lh(t) {
    if (t.subtreeFlags & 1024)
      for (t = t.child; t !== null; ) {
        var e = t;
        Lh(e),
          e.tag === 5 && e.flags & 1024 && e.stateNode.reset(),
          (t = t.sibling);
      }
  }
  function zn(t, e) {
    if (e.subtreeFlags & 8772)
      for (e = e.child; e !== null; ) Nh(t, e.alternate, e), (e = e.sibling);
  }
  function fa(t) {
    for (t = t.child; t !== null; ) {
      var e = t;
      switch (e.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          Vn(4, e, e.return), fa(e);
          break;
        case 1:
          Ke(e, e.return);
          var n = e.stateNode;
          typeof n.componentWillUnmount == "function" && Rh(e, e.return, n),
            fa(e);
          break;
        case 27:
          rl(e.stateNode);
        case 26:
        case 5:
          Ke(e, e.return), fa(e);
          break;
        case 22:
          e.memoizedState === null && fa(e);
          break;
        case 30:
          fa(e);
          break;
        default:
          fa(e);
      }
      t = t.sibling;
    }
  }
  function Nn(t, e, n) {
    for (n = n && (e.subtreeFlags & 8772) !== 0, e = e.child; e !== null; ) {
      var i = e.alternate,
        s = t,
        u = e,
        d = u.flags;
      switch (u.tag) {
        case 0:
        case 11:
        case 15:
          Nn(s, u, n), $i(4, u);
          break;
        case 1:
          if (
            (Nn(s, u, n),
            (i = u),
            (s = i.stateNode),
            typeof s.componentDidMount == "function")
          )
            try {
              s.componentDidMount();
            } catch (D) {
              wt(i, i.return, D);
            }
          if (((i = u), (s = i.updateQueue), s !== null)) {
            var y = i.stateNode;
            try {
              var x = s.shared.hiddenCallbacks;
              if (x !== null)
                for (s.shared.hiddenCallbacks = null, s = 0; s < x.length; s++)
                  hd(x[s], y);
            } catch (D) {
              wt(i, i.return, D);
            }
          }
          n && d & 64 && wh(u), Ii(u, u.return);
          break;
        case 27:
          Vh(u);
        case 26:
        case 5:
          Nn(s, u, n), n && i === null && d & 4 && Oh(u), Ii(u, u.return);
          break;
        case 12:
          Nn(s, u, n);
          break;
        case 13:
          Nn(s, u, n), n && d & 4 && jh(s, u);
          break;
        case 22:
          u.memoizedState === null && Nn(s, u, n), Ii(u, u.return);
          break;
        case 30:
          break;
        default:
          Nn(s, u, n);
      }
      e = e.sibling;
    }
  }
  function Zr(t, e) {
    var n = null;
    t !== null &&
      t.memoizedState !== null &&
      t.memoizedState.cachePool !== null &&
      (n = t.memoizedState.cachePool.pool),
      (t = null),
      e.memoizedState !== null &&
        e.memoizedState.cachePool !== null &&
        (t = e.memoizedState.cachePool.pool),
      t !== n && (t != null && t.refCount++, n != null && Li(n));
  }
  function Qr(t, e) {
    (t = null),
      e.alternate !== null && (t = e.alternate.memoizedState.cache),
      (e = e.memoizedState.cache),
      e !== t && (e.refCount++, t != null && Li(t));
  }
  function Je(t, e, n, i) {
    if (e.subtreeFlags & 10256)
      for (e = e.child; e !== null; ) Hh(t, e, n, i), (e = e.sibling);
  }
  function Hh(t, e, n, i) {
    var s = e.flags;
    switch (e.tag) {
      case 0:
      case 11:
      case 15:
        Je(t, e, n, i), s & 2048 && $i(9, e);
        break;
      case 1:
        Je(t, e, n, i);
        break;
      case 3:
        Je(t, e, n, i),
          s & 2048 &&
            ((t = null),
            e.alternate !== null && (t = e.alternate.memoizedState.cache),
            (e = e.memoizedState.cache),
            e !== t && (e.refCount++, t != null && Li(t)));
        break;
      case 12:
        if (s & 2048) {
          Je(t, e, n, i), (t = e.stateNode);
          try {
            var u = e.memoizedProps,
              d = u.id,
              y = u.onPostCommit;
            typeof y == "function" &&
              y(
                d,
                e.alternate === null ? "mount" : "update",
                t.passiveEffectDuration,
                -0
              );
          } catch (x) {
            wt(e, e.return, x);
          }
        } else Je(t, e, n, i);
        break;
      case 13:
        Je(t, e, n, i);
        break;
      case 23:
        break;
      case 22:
        (u = e.stateNode),
          (d = e.alternate),
          e.memoizedState !== null
            ? u._visibility & 2
              ? Je(t, e, n, i)
              : tl(t, e)
            : u._visibility & 2
            ? Je(t, e, n, i)
            : ((u._visibility |= 2),
              Ka(t, e, n, i, (e.subtreeFlags & 10256) !== 0)),
          s & 2048 && Zr(d, e);
        break;
      case 24:
        Je(t, e, n, i), s & 2048 && Qr(e.alternate, e);
        break;
      default:
        Je(t, e, n, i);
    }
  }
  function Ka(t, e, n, i, s) {
    for (s = s && (e.subtreeFlags & 10256) !== 0, e = e.child; e !== null; ) {
      var u = t,
        d = e,
        y = n,
        x = i,
        D = d.flags;
      switch (d.tag) {
        case 0:
        case 11:
        case 15:
          Ka(u, d, y, x, s), $i(8, d);
          break;
        case 23:
          break;
        case 22:
          var V = d.stateNode;
          d.memoizedState !== null
            ? V._visibility & 2
              ? Ka(u, d, y, x, s)
              : tl(u, d)
            : ((V._visibility |= 2), Ka(u, d, y, x, s)),
            s && D & 2048 && Zr(d.alternate, d);
          break;
        case 24:
          Ka(u, d, y, x, s), s && D & 2048 && Qr(d.alternate, d);
          break;
        default:
          Ka(u, d, y, x, s);
      }
      e = e.sibling;
    }
  }
  function tl(t, e) {
    if (e.subtreeFlags & 10256)
      for (e = e.child; e !== null; ) {
        var n = t,
          i = e,
          s = i.flags;
        switch (i.tag) {
          case 22:
            tl(n, i), s & 2048 && Zr(i.alternate, i);
            break;
          case 24:
            tl(n, i), s & 2048 && Qr(i.alternate, i);
            break;
          default:
            tl(n, i);
        }
        e = e.sibling;
      }
  }
  var el = 8192;
  function Ja(t) {
    if (t.subtreeFlags & el)
      for (t = t.child; t !== null; ) Gh(t), (t = t.sibling);
  }
  function Gh(t) {
    switch (t.tag) {
      case 26:
        Ja(t),
          t.flags & el &&
            t.memoizedState !== null &&
            Ab(qe, t.memoizedState, t.memoizedProps);
        break;
      case 5:
        Ja(t);
        break;
      case 3:
      case 4:
        var e = qe;
        (qe = Gs(t.stateNode.containerInfo)), Ja(t), (qe = e);
        break;
      case 22:
        t.memoizedState === null &&
          ((e = t.alternate),
          e !== null && e.memoizedState !== null
            ? ((e = el), (el = 16777216), Ja(t), (el = e))
            : Ja(t));
        break;
      default:
        Ja(t);
    }
  }
  function qh(t) {
    var e = t.alternate;
    if (e !== null && ((t = e.child), t !== null)) {
      e.child = null;
      do (e = t.sibling), (t.sibling = null), (t = e);
      while (t !== null);
    }
  }
  function nl(t) {
    var e = t.deletions;
    if ((t.flags & 16) !== 0) {
      if (e !== null)
        for (var n = 0; n < e.length; n++) {
          var i = e[n];
          (Ft = i), kh(i, t);
        }
      qh(t);
    }
    if (t.subtreeFlags & 10256)
      for (t = t.child; t !== null; ) Yh(t), (t = t.sibling);
  }
  function Yh(t) {
    switch (t.tag) {
      case 0:
      case 11:
      case 15:
        nl(t), t.flags & 2048 && Vn(9, t, t.return);
        break;
      case 3:
        nl(t);
        break;
      case 12:
        nl(t);
        break;
      case 22:
        var e = t.stateNode;
        t.memoizedState !== null &&
        e._visibility & 2 &&
        (t.return === null || t.return.tag !== 13)
          ? ((e._visibility &= -3), Rs(t))
          : nl(t);
        break;
      default:
        nl(t);
    }
  }
  function Rs(t) {
    var e = t.deletions;
    if ((t.flags & 16) !== 0) {
      if (e !== null)
        for (var n = 0; n < e.length; n++) {
          var i = e[n];
          (Ft = i), kh(i, t);
        }
      qh(t);
    }
    for (t = t.child; t !== null; ) {
      switch (((e = t), e.tag)) {
        case 0:
        case 11:
        case 15:
          Vn(8, e, e.return), Rs(e);
          break;
        case 22:
          (n = e.stateNode),
            n._visibility & 2 && ((n._visibility &= -3), Rs(e));
          break;
        default:
          Rs(e);
      }
      t = t.sibling;
    }
  }
  function kh(t, e) {
    for (; Ft !== null; ) {
      var n = Ft;
      switch (n.tag) {
        case 0:
        case 11:
        case 15:
          Vn(8, n, e);
          break;
        case 23:
        case 22:
          if (n.memoizedState !== null && n.memoizedState.cachePool !== null) {
            var i = n.memoizedState.cachePool.pool;
            i != null && i.refCount++;
          }
          break;
        case 24:
          Li(n.memoizedState.cache);
      }
      if (((i = n.child), i !== null)) (i.return = n), (Ft = i);
      else
        t: for (n = t; Ft !== null; ) {
          i = Ft;
          var s = i.sibling,
            u = i.return;
          if ((_h(i), i === n)) {
            Ft = null;
            break t;
          }
          if (s !== null) {
            (s.return = u), (Ft = s);
            break t;
          }
          Ft = u;
        }
    }
  }
  var H0 = {
      getCacheForType: function (t) {
        var e = ae(Zt),
          n = e.data.get(t);
        return n === void 0 && ((n = t()), e.data.set(t, n)), n;
      },
    },
    G0 = typeof WeakMap == "function" ? WeakMap : Map,
    St = 0,
    Rt = null,
    ht = null,
    yt = 0,
    Tt = 0,
    Ee = null,
    _n = !1,
    Pa = !1,
    Kr = !1,
    hn = 0,
    Bt = 0,
    Un = 0,
    da = 0,
    Jr = 0,
    Ue = 0,
    Fa = 0,
    al = null,
    pe = null,
    Pr = !1,
    Fr = 0,
    Os = 1 / 0,
    Cs = null,
    jn = null,
    It = 0,
    Bn = null,
    Wa = null,
    $a = 0,
    Wr = 0,
    $r = null,
    Xh = null,
    il = 0,
    Ir = null;
  function Me() {
    if ((St & 2) !== 0 && yt !== 0) return yt & -yt;
    if (C.T !== null) {
      var t = Ha;
      return t !== 0 ? t : su();
    }
    return sf();
  }
  function Zh() {
    Ue === 0 && (Ue = (yt & 536870912) === 0 || xt ? ef() : 536870912);
    var t = _e.current;
    return t !== null && (t.flags |= 32), Ue;
  }
  function De(t, e, n) {
    ((t === Rt && (Tt === 2 || Tt === 9)) || t.cancelPendingCommit !== null) &&
      (Ia(t, 0), Ln(t, yt, Ue, !1)),
      Ti(t, n),
      ((St & 2) === 0 || t !== Rt) &&
        (t === Rt &&
          ((St & 2) === 0 && (da |= n), Bt === 4 && Ln(t, yt, Ue, !1)),
        Pe(t));
  }
  function Qh(t, e, n) {
    if ((St & 6) !== 0) throw Error(r(327));
    var i = (!n && (e & 124) === 0 && (e & t.expiredLanes) === 0) || Si(t, e),
      s = i ? k0(t, e) : nu(t, e, !0),
      u = i;
    do {
      if (s === 0) {
        Pa && !i && Ln(t, e, 0, !1);
        break;
      } else {
        if (((n = t.current.alternate), u && !q0(n))) {
          (s = nu(t, e, !1)), (u = !1);
          continue;
        }
        if (s === 2) {
          if (((u = e), t.errorRecoveryDisabledLanes & u)) var d = 0;
          else
            (d = t.pendingLanes & -536870913),
              (d = d !== 0 ? d : d & 536870912 ? 536870912 : 0);
          if (d !== 0) {
            e = d;
            t: {
              var y = t;
              s = al;
              var x = y.current.memoizedState.isDehydrated;
              if ((x && (Ia(y, d).flags |= 256), (d = nu(y, d, !1)), d !== 2)) {
                if (Kr && !x) {
                  (y.errorRecoveryDisabledLanes |= u), (da |= u), (s = 4);
                  break t;
                }
                (u = pe),
                  (pe = s),
                  u !== null && (pe === null ? (pe = u) : pe.push.apply(pe, u));
              }
              s = d;
            }
            if (((u = !1), s !== 2)) continue;
          }
        }
        if (s === 1) {
          Ia(t, 0), Ln(t, e, 0, !0);
          break;
        }
        t: {
          switch (((i = t), (u = s), u)) {
            case 0:
            case 1:
              throw Error(r(345));
            case 4:
              if ((e & 4194048) !== e) break;
            case 6:
              Ln(i, e, Ue, !_n);
              break t;
            case 2:
              pe = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(r(329));
          }
          if ((e & 62914560) === e && ((s = Fr + 300 - Xe()), 10 < s)) {
            if ((Ln(i, e, Ue, !_n), ql(i, 0, !0) !== 0)) break t;
            i.timeoutHandle = Sm(
              Kh.bind(null, i, n, pe, Cs, Pr, e, Ue, da, Fa, _n, u, 2, -0, 0),
              s
            );
            break t;
          }
          Kh(i, n, pe, Cs, Pr, e, Ue, da, Fa, _n, u, 0, -0, 0);
        }
      }
      break;
    } while (!0);
    Pe(t);
  }
  function Kh(t, e, n, i, s, u, d, y, x, D, V, N, w, R) {
    if (
      ((t.timeoutHandle = -1),
      (N = e.subtreeFlags),
      (N & 8192 || (N & 16785408) === 16785408) &&
        ((fl = { stylesheets: null, count: 0, unsuspend: Tb }),
        Gh(e),
        (N = Eb()),
        N !== null))
    ) {
      (t.cancelPendingCommit = N(
        tm.bind(null, t, e, u, n, i, s, d, y, x, V, 1, w, R)
      )),
        Ln(t, u, d, !D);
      return;
    }
    tm(t, e, u, n, i, s, d, y, x);
  }
  function q0(t) {
    for (var e = t; ; ) {
      var n = e.tag;
      if (
        (n === 0 || n === 11 || n === 15) &&
        e.flags & 16384 &&
        ((n = e.updateQueue), n !== null && ((n = n.stores), n !== null))
      )
        for (var i = 0; i < n.length; i++) {
          var s = n[i],
            u = s.getSnapshot;
          s = s.value;
          try {
            if (!xe(u(), s)) return !1;
          } catch {
            return !1;
          }
        }
      if (((n = e.child), e.subtreeFlags & 16384 && n !== null))
        (n.return = e), (e = n);
      else {
        if (e === t) break;
        for (; e.sibling === null; ) {
          if (e.return === null || e.return === t) return !0;
          e = e.return;
        }
        (e.sibling.return = e.return), (e = e.sibling);
      }
    }
    return !0;
  }
  function Ln(t, e, n, i) {
    (e &= ~Jr),
      (e &= ~da),
      (t.suspendedLanes |= e),
      (t.pingedLanes &= ~e),
      i && (t.warmLanes |= e),
      (i = t.expirationTimes);
    for (var s = e; 0 < s; ) {
      var u = 31 - be(s),
        d = 1 << u;
      (i[u] = -1), (s &= ~d);
    }
    n !== 0 && af(t, n, e);
  }
  function Vs() {
    return (St & 6) === 0 ? (ll(0), !1) : !0;
  }
  function tu() {
    if (ht !== null) {
      if (Tt === 0) var t = ht.return;
      else (t = ht), (ln = sa = null), yr(t), (Za = null), (Pi = 0), (t = ht);
      for (; t !== null; ) Dh(t.alternate, t), (t = t.return);
      ht = null;
    }
  }
  function Ia(t, e) {
    var n = t.timeoutHandle;
    n !== -1 && ((t.timeoutHandle = -1), lb(n)),
      (n = t.cancelPendingCommit),
      n !== null && ((t.cancelPendingCommit = null), n()),
      tu(),
      (Rt = t),
      (ht = n = en(t.current, null)),
      (yt = e),
      (Tt = 0),
      (Ee = null),
      (_n = !1),
      (Pa = Si(t, e)),
      (Kr = !1),
      (Fa = Ue = Jr = da = Un = Bt = 0),
      (pe = al = null),
      (Pr = !1),
      (e & 8) !== 0 && (e |= e & 32);
    var i = t.entangledLanes;
    if (i !== 0)
      for (t = t.entanglements, i &= e; 0 < i; ) {
        var s = 31 - be(i),
          u = 1 << s;
        (e |= t[s]), (i &= ~u);
      }
    return (hn = e), Il(), n;
  }
  function Jh(t, e) {
    (ut = null),
      (C.H = vs),
      e === Gi || e === rs
        ? ((e = fd()), (Tt = 3))
        : e === rd
        ? ((e = fd()), (Tt = 4))
        : (Tt =
            e === dh
              ? 8
              : e !== null &&
                typeof e == "object" &&
                typeof e.then == "function"
              ? 6
              : 1),
      (Ee = e),
      ht === null && ((Bt = 1), As(t, Ce(e, t.current)));
  }
  function Ph() {
    var t = C.H;
    return (C.H = vs), t === null ? vs : t;
  }
  function Fh() {
    var t = C.A;
    return (C.A = H0), t;
  }
  function eu() {
    (Bt = 4),
      _n || ((yt & 4194048) !== yt && _e.current !== null) || (Pa = !0),
      ((Un & 134217727) === 0 && (da & 134217727) === 0) ||
        Rt === null ||
        Ln(Rt, yt, Ue, !1);
  }
  function nu(t, e, n) {
    var i = St;
    St |= 2;
    var s = Ph(),
      u = Fh();
    (Rt !== t || yt !== e) && ((Cs = null), Ia(t, e)), (e = !1);
    var d = Bt;
    t: do
      try {
        if (Tt !== 0 && ht !== null) {
          var y = ht,
            x = Ee;
          switch (Tt) {
            case 8:
              tu(), (d = 6);
              break t;
            case 3:
            case 2:
            case 9:
            case 6:
              _e.current === null && (e = !0);
              var D = Tt;
              if (((Tt = 0), (Ee = null), ti(t, y, x, D), n && Pa)) {
                d = 0;
                break t;
              }
              break;
            default:
              (D = Tt), (Tt = 0), (Ee = null), ti(t, y, x, D);
          }
        }
        Y0(), (d = Bt);
        break;
      } catch (V) {
        Jh(t, V);
      }
    while (!0);
    return (
      e && t.shellSuspendCounter++,
      (ln = sa = null),
      (St = i),
      (C.H = s),
      (C.A = u),
      ht === null && ((Rt = null), (yt = 0), Il()),
      d
    );
  }
  function Y0() {
    for (; ht !== null; ) Wh(ht);
  }
  function k0(t, e) {
    var n = St;
    St |= 2;
    var i = Ph(),
      s = Fh();
    Rt !== t || yt !== e
      ? ((Cs = null), (Os = Xe() + 500), Ia(t, e))
      : (Pa = Si(t, e));
    t: do
      try {
        if (Tt !== 0 && ht !== null) {
          e = ht;
          var u = Ee;
          e: switch (Tt) {
            case 1:
              (Tt = 0), (Ee = null), ti(t, e, u, 1);
              break;
            case 2:
            case 9:
              if (ud(u)) {
                (Tt = 0), (Ee = null), $h(e);
                break;
              }
              (e = function () {
                (Tt !== 2 && Tt !== 9) || Rt !== t || (Tt = 7), Pe(t);
              }),
                u.then(e, e);
              break t;
            case 3:
              Tt = 7;
              break t;
            case 4:
              Tt = 5;
              break t;
            case 7:
              ud(u)
                ? ((Tt = 0), (Ee = null), $h(e))
                : ((Tt = 0), (Ee = null), ti(t, e, u, 7));
              break;
            case 5:
              var d = null;
              switch (ht.tag) {
                case 26:
                  d = ht.memoizedState;
                case 5:
                case 27:
                  var y = ht;
                  if (!d || Nm(d)) {
                    (Tt = 0), (Ee = null);
                    var x = y.sibling;
                    if (x !== null) ht = x;
                    else {
                      var D = y.return;
                      D !== null ? ((ht = D), zs(D)) : (ht = null);
                    }
                    break e;
                  }
              }
              (Tt = 0), (Ee = null), ti(t, e, u, 5);
              break;
            case 6:
              (Tt = 0), (Ee = null), ti(t, e, u, 6);
              break;
            case 8:
              tu(), (Bt = 6);
              break t;
            default:
              throw Error(r(462));
          }
        }
        X0();
        break;
      } catch (V) {
        Jh(t, V);
      }
    while (!0);
    return (
      (ln = sa = null),
      (C.H = i),
      (C.A = s),
      (St = n),
      ht !== null ? 0 : ((Rt = null), (yt = 0), Il(), Bt)
    );
  }
  function X0() {
    for (; ht !== null && !dv(); ) Wh(ht);
  }
  function Wh(t) {
    var e = Eh(t.alternate, t, hn);
    (t.memoizedProps = t.pendingProps), e === null ? zs(t) : (ht = e);
  }
  function $h(t) {
    var e = t,
      n = e.alternate;
    switch (e.tag) {
      case 15:
      case 0:
        e = vh(n, e, e.pendingProps, e.type, void 0, yt);
        break;
      case 11:
        e = vh(n, e, e.pendingProps, e.type.render, e.ref, yt);
        break;
      case 5:
        yr(e);
      default:
        Dh(n, e), (e = ht = If(e, hn)), (e = Eh(n, e, hn));
    }
    (t.memoizedProps = t.pendingProps), e === null ? zs(t) : (ht = e);
  }
  function ti(t, e, n, i) {
    (ln = sa = null), yr(e), (Za = null), (Pi = 0);
    var s = e.return;
    try {
      if (N0(t, s, e, n, yt)) {
        (Bt = 1), As(t, Ce(n, t.current)), (ht = null);
        return;
      }
    } catch (u) {
      if (s !== null) throw ((ht = s), u);
      (Bt = 1), As(t, Ce(n, t.current)), (ht = null);
      return;
    }
    e.flags & 32768
      ? (xt || i === 1
          ? (t = !0)
          : Pa || (yt & 536870912) !== 0
          ? (t = !1)
          : ((_n = t = !0),
            (i === 2 || i === 9 || i === 3 || i === 6) &&
              ((i = _e.current),
              i !== null && i.tag === 13 && (i.flags |= 16384))),
        Ih(e, t))
      : zs(e);
  }
  function zs(t) {
    var e = t;
    do {
      if ((e.flags & 32768) !== 0) {
        Ih(e, _n);
        return;
      }
      t = e.return;
      var n = U0(e.alternate, e, hn);
      if (n !== null) {
        ht = n;
        return;
      }
      if (((e = e.sibling), e !== null)) {
        ht = e;
        return;
      }
      ht = e = t;
    } while (e !== null);
    Bt === 0 && (Bt = 5);
  }
  function Ih(t, e) {
    do {
      var n = j0(t.alternate, t);
      if (n !== null) {
        (n.flags &= 32767), (ht = n);
        return;
      }
      if (
        ((n = t.return),
        n !== null &&
          ((n.flags |= 32768), (n.subtreeFlags = 0), (n.deletions = null)),
        !e && ((t = t.sibling), t !== null))
      ) {
        ht = t;
        return;
      }
      ht = t = n;
    } while (t !== null);
    (Bt = 6), (ht = null);
  }
  function tm(t, e, n, i, s, u, d, y, x) {
    t.cancelPendingCommit = null;
    do Ns();
    while (It !== 0);
    if ((St & 6) !== 0) throw Error(r(327));
    if (e !== null) {
      if (e === t.current) throw Error(r(177));
      if (
        ((u = e.lanes | e.childLanes),
        (u |= Qo),
        Tv(t, n, u, d, y, x),
        t === Rt && ((ht = Rt = null), (yt = 0)),
        (Wa = e),
        (Bn = t),
        ($a = n),
        (Wr = u),
        ($r = s),
        (Xh = i),
        (e.subtreeFlags & 10256) !== 0 || (e.flags & 10256) !== 0
          ? ((t.callbackNode = null),
            (t.callbackPriority = 0),
            J0(Ll, function () {
              return lm(), null;
            }))
          : ((t.callbackNode = null), (t.callbackPriority = 0)),
        (i = (e.flags & 13878) !== 0),
        (e.subtreeFlags & 13878) !== 0 || i)
      ) {
        (i = C.T), (C.T = null), (s = H.p), (H.p = 2), (d = St), (St |= 4);
        try {
          B0(t, e, n);
        } finally {
          (St = d), (H.p = s), (C.T = i);
        }
      }
      (It = 1), em(), nm(), am();
    }
  }
  function em() {
    if (It === 1) {
      It = 0;
      var t = Bn,
        e = Wa,
        n = (e.flags & 13878) !== 0;
      if ((e.subtreeFlags & 13878) !== 0 || n) {
        (n = C.T), (C.T = null);
        var i = H.p;
        H.p = 2;
        var s = St;
        St |= 4;
        try {
          Bh(e, t);
          var u = mu,
            d = kf(t.containerInfo),
            y = u.focusedElem,
            x = u.selectionRange;
          if (
            d !== y &&
            y &&
            y.ownerDocument &&
            Yf(y.ownerDocument.documentElement, y)
          ) {
            if (x !== null && qo(y)) {
              var D = x.start,
                V = x.end;
              if ((V === void 0 && (V = D), "selectionStart" in y))
                (y.selectionStart = D),
                  (y.selectionEnd = Math.min(V, y.value.length));
              else {
                var N = y.ownerDocument || document,
                  w = (N && N.defaultView) || window;
                if (w.getSelection) {
                  var R = w.getSelection(),
                    at = y.textContent.length,
                    tt = Math.min(x.start, at),
                    Mt = x.end === void 0 ? tt : Math.min(x.end, at);
                  !R.extend && tt > Mt && ((d = Mt), (Mt = tt), (tt = d));
                  var E = qf(y, tt),
                    T = qf(y, Mt);
                  if (
                    E &&
                    T &&
                    (R.rangeCount !== 1 ||
                      R.anchorNode !== E.node ||
                      R.anchorOffset !== E.offset ||
                      R.focusNode !== T.node ||
                      R.focusOffset !== T.offset)
                  ) {
                    var M = N.createRange();
                    M.setStart(E.node, E.offset),
                      R.removeAllRanges(),
                      tt > Mt
                        ? (R.addRange(M), R.extend(T.node, T.offset))
                        : (M.setEnd(T.node, T.offset), R.addRange(M));
                  }
                }
              }
            }
            for (N = [], R = y; (R = R.parentNode); )
              R.nodeType === 1 &&
                N.push({ element: R, left: R.scrollLeft, top: R.scrollTop });
            for (
              typeof y.focus == "function" && y.focus(), y = 0;
              y < N.length;
              y++
            ) {
              var z = N[y];
              (z.element.scrollLeft = z.left), (z.element.scrollTop = z.top);
            }
          }
          (Zs = !!hu), (mu = hu = null);
        } finally {
          (St = s), (H.p = i), (C.T = n);
        }
      }
      (t.current = e), (It = 2);
    }
  }
  function nm() {
    if (It === 2) {
      It = 0;
      var t = Bn,
        e = Wa,
        n = (e.flags & 8772) !== 0;
      if ((e.subtreeFlags & 8772) !== 0 || n) {
        (n = C.T), (C.T = null);
        var i = H.p;
        H.p = 2;
        var s = St;
        St |= 4;
        try {
          Nh(t, e.alternate, e);
        } finally {
          (St = s), (H.p = i), (C.T = n);
        }
      }
      It = 3;
    }
  }
  function am() {
    if (It === 4 || It === 3) {
      (It = 0), hv();
      var t = Bn,
        e = Wa,
        n = $a,
        i = Xh;
      (e.subtreeFlags & 10256) !== 0 || (e.flags & 10256) !== 0
        ? (It = 5)
        : ((It = 0), (Wa = Bn = null), im(t, t.pendingLanes));
      var s = t.pendingLanes;
      if (
        (s === 0 && (jn = null),
        xo(n),
        (e = e.stateNode),
        ve && typeof ve.onCommitFiberRoot == "function")
      )
        try {
          ve.onCommitFiberRoot(xi, e, void 0, (e.current.flags & 128) === 128);
        } catch {}
      if (i !== null) {
        (e = C.T), (s = H.p), (H.p = 2), (C.T = null);
        try {
          for (var u = t.onRecoverableError, d = 0; d < i.length; d++) {
            var y = i[d];
            u(y.value, { componentStack: y.stack });
          }
        } finally {
          (C.T = e), (H.p = s);
        }
      }
      ($a & 3) !== 0 && Ns(),
        Pe(t),
        (s = t.pendingLanes),
        (n & 4194090) !== 0 && (s & 42) !== 0
          ? t === Ir
            ? il++
            : ((il = 0), (Ir = t))
          : (il = 0),
        ll(0);
    }
  }
  function im(t, e) {
    (t.pooledCacheLanes &= e) === 0 &&
      ((e = t.pooledCache), e != null && ((t.pooledCache = null), Li(e)));
  }
  function Ns(t) {
    return em(), nm(), am(), lm();
  }
  function lm() {
    if (It !== 5) return !1;
    var t = Bn,
      e = Wr;
    Wr = 0;
    var n = xo($a),
      i = C.T,
      s = H.p;
    try {
      (H.p = 32 > n ? 32 : n), (C.T = null), (n = $r), ($r = null);
      var u = Bn,
        d = $a;
      if (((It = 0), (Wa = Bn = null), ($a = 0), (St & 6) !== 0))
        throw Error(r(331));
      var y = St;
      if (
        ((St |= 4),
        Yh(u.current),
        Hh(u, u.current, d, n),
        (St = y),
        ll(0, !1),
        ve && typeof ve.onPostCommitFiberRoot == "function")
      )
        try {
          ve.onPostCommitFiberRoot(xi, u);
        } catch {}
      return !0;
    } finally {
      (H.p = s), (C.T = i), im(t, e);
    }
  }
  function sm(t, e, n) {
    (e = Ce(n, e)),
      (e = Vr(t.stateNode, e, 2)),
      (t = wn(t, e, 2)),
      t !== null && (Ti(t, 2), Pe(t));
  }
  function wt(t, e, n) {
    if (t.tag === 3) sm(t, t, n);
    else
      for (; e !== null; ) {
        if (e.tag === 3) {
          sm(e, t, n);
          break;
        } else if (e.tag === 1) {
          var i = e.stateNode;
          if (
            typeof e.type.getDerivedStateFromError == "function" ||
            (typeof i.componentDidCatch == "function" &&
              (jn === null || !jn.has(i)))
          ) {
            (t = Ce(n, t)),
              (n = ch(2)),
              (i = wn(e, n, 2)),
              i !== null && (fh(n, i, e, t), Ti(i, 2), Pe(i));
            break;
          }
        }
        e = e.return;
      }
  }
  function au(t, e, n) {
    var i = t.pingCache;
    if (i === null) {
      i = t.pingCache = new G0();
      var s = new Set();
      i.set(e, s);
    } else (s = i.get(e)), s === void 0 && ((s = new Set()), i.set(e, s));
    s.has(n) ||
      ((Kr = !0), s.add(n), (t = Z0.bind(null, t, e, n)), e.then(t, t));
  }
  function Z0(t, e, n) {
    var i = t.pingCache;
    i !== null && i.delete(e),
      (t.pingedLanes |= t.suspendedLanes & n),
      (t.warmLanes &= ~n),
      Rt === t &&
        (yt & n) === n &&
        (Bt === 4 || (Bt === 3 && (yt & 62914560) === yt && 300 > Xe() - Fr)
          ? (St & 2) === 0 && Ia(t, 0)
          : (Jr |= n),
        Fa === yt && (Fa = 0)),
      Pe(t);
  }
  function om(t, e) {
    e === 0 && (e = nf()), (t = Ua(t, e)), t !== null && (Ti(t, e), Pe(t));
  }
  function Q0(t) {
    var e = t.memoizedState,
      n = 0;
    e !== null && (n = e.retryLane), om(t, n);
  }
  function K0(t, e) {
    var n = 0;
    switch (t.tag) {
      case 13:
        var i = t.stateNode,
          s = t.memoizedState;
        s !== null && (n = s.retryLane);
        break;
      case 19:
        i = t.stateNode;
        break;
      case 22:
        i = t.stateNode._retryCache;
        break;
      default:
        throw Error(r(314));
    }
    i !== null && i.delete(e), om(t, n);
  }
  function J0(t, e) {
    return go(t, e);
  }
  var _s = null,
    ei = null,
    iu = !1,
    Us = !1,
    lu = !1,
    ha = 0;
  function Pe(t) {
    t !== ei &&
      t.next === null &&
      (ei === null ? (_s = ei = t) : (ei = ei.next = t)),
      (Us = !0),
      iu || ((iu = !0), F0());
  }
  function ll(t, e) {
    if (!lu && Us) {
      lu = !0;
      do
        for (var n = !1, i = _s; i !== null; ) {
          if (t !== 0) {
            var s = i.pendingLanes;
            if (s === 0) var u = 0;
            else {
              var d = i.suspendedLanes,
                y = i.pingedLanes;
              (u = (1 << (31 - be(42 | t) + 1)) - 1),
                (u &= s & ~(d & ~y)),
                (u = u & 201326741 ? (u & 201326741) | 1 : u ? u | 2 : 0);
            }
            u !== 0 && ((n = !0), fm(i, u));
          } else
            (u = yt),
              (u = ql(
                i,
                i === Rt ? u : 0,
                i.cancelPendingCommit !== null || i.timeoutHandle !== -1
              )),
              (u & 3) === 0 || Si(i, u) || ((n = !0), fm(i, u));
          i = i.next;
        }
      while (n);
      lu = !1;
    }
  }
  function P0() {
    rm();
  }
  function rm() {
    Us = iu = !1;
    var t = 0;
    ha !== 0 && (ib() && (t = ha), (ha = 0));
    for (var e = Xe(), n = null, i = _s; i !== null; ) {
      var s = i.next,
        u = um(i, e);
      u === 0
        ? ((i.next = null),
          n === null ? (_s = s) : (n.next = s),
          s === null && (ei = n))
        : ((n = i), (t !== 0 || (u & 3) !== 0) && (Us = !0)),
        (i = s);
    }
    ll(t);
  }
  function um(t, e) {
    for (
      var n = t.suspendedLanes,
        i = t.pingedLanes,
        s = t.expirationTimes,
        u = t.pendingLanes & -62914561;
      0 < u;

    ) {
      var d = 31 - be(u),
        y = 1 << d,
        x = s[d];
      x === -1
        ? ((y & n) === 0 || (y & i) !== 0) && (s[d] = Sv(y, e))
        : x <= e && (t.expiredLanes |= y),
        (u &= ~y);
    }
    if (
      ((e = Rt),
      (n = yt),
      (n = ql(
        t,
        t === e ? n : 0,
        t.cancelPendingCommit !== null || t.timeoutHandle !== -1
      )),
      (i = t.callbackNode),
      n === 0 ||
        (t === e && (Tt === 2 || Tt === 9)) ||
        t.cancelPendingCommit !== null)
    )
      return (
        i !== null && i !== null && yo(i),
        (t.callbackNode = null),
        (t.callbackPriority = 0)
      );
    if ((n & 3) === 0 || Si(t, n)) {
      if (((e = n & -n), e === t.callbackPriority)) return e;
      switch ((i !== null && yo(i), xo(n))) {
        case 2:
        case 8:
          n = Ic;
          break;
        case 32:
          n = Ll;
          break;
        case 268435456:
          n = tf;
          break;
        default:
          n = Ll;
      }
      return (
        (i = cm.bind(null, t)),
        (n = go(n, i)),
        (t.callbackPriority = e),
        (t.callbackNode = n),
        e
      );
    }
    return (
      i !== null && i !== null && yo(i),
      (t.callbackPriority = 2),
      (t.callbackNode = null),
      2
    );
  }
  function cm(t, e) {
    if (It !== 0 && It !== 5)
      return (t.callbackNode = null), (t.callbackPriority = 0), null;
    var n = t.callbackNode;
    if (Ns() && t.callbackNode !== n) return null;
    var i = yt;
    return (
      (i = ql(
        t,
        t === Rt ? i : 0,
        t.cancelPendingCommit !== null || t.timeoutHandle !== -1
      )),
      i === 0
        ? null
        : (Qh(t, i, e),
          um(t, Xe()),
          t.callbackNode != null && t.callbackNode === n
            ? cm.bind(null, t)
            : null)
    );
  }
  function fm(t, e) {
    if (Ns()) return null;
    Qh(t, e, !0);
  }
  function F0() {
    sb(function () {
      (St & 6) !== 0 ? go($c, P0) : rm();
    });
  }
  function su() {
    return ha === 0 && (ha = ef()), ha;
  }
  function dm(t) {
    return t == null || typeof t == "symbol" || typeof t == "boolean"
      ? null
      : typeof t == "function"
      ? t
      : Ql("" + t);
  }
  function hm(t, e) {
    var n = e.ownerDocument.createElement("input");
    return (
      (n.name = e.name),
      (n.value = e.value),
      t.id && n.setAttribute("form", t.id),
      e.parentNode.insertBefore(n, e),
      (t = new FormData(t)),
      n.parentNode.removeChild(n),
      t
    );
  }
  function W0(t, e, n, i, s) {
    if (e === "submit" && n && n.stateNode === s) {
      var u = dm((s[fe] || null).action),
        d = i.submitter;
      d &&
        ((e = (e = d[fe] || null)
          ? dm(e.formAction)
          : d.getAttribute("formAction")),
        e !== null && ((u = e), (d = null)));
      var y = new Fl("action", "action", null, i, s);
      t.push({
        event: y,
        listeners: [
          {
            instance: null,
            listener: function () {
              if (i.defaultPrevented) {
                if (ha !== 0) {
                  var x = d ? hm(s, d) : new FormData(s);
                  Dr(
                    n,
                    { pending: !0, data: x, method: s.method, action: u },
                    null,
                    x
                  );
                }
              } else
                typeof u == "function" &&
                  (y.preventDefault(),
                  (x = d ? hm(s, d) : new FormData(s)),
                  Dr(
                    n,
                    { pending: !0, data: x, method: s.method, action: u },
                    u,
                    x
                  ));
            },
            currentTarget: s,
          },
        ],
      });
    }
  }
  for (var ou = 0; ou < Zo.length; ou++) {
    var ru = Zo[ou],
      $0 = ru.toLowerCase(),
      I0 = ru[0].toUpperCase() + ru.slice(1);
    Ge($0, "on" + I0);
  }
  Ge(Qf, "onAnimationEnd"),
    Ge(Kf, "onAnimationIteration"),
    Ge(Jf, "onAnimationStart"),
    Ge("dblclick", "onDoubleClick"),
    Ge("focusin", "onFocus"),
    Ge("focusout", "onBlur"),
    Ge(g0, "onTransitionRun"),
    Ge(y0, "onTransitionStart"),
    Ge(v0, "onTransitionCancel"),
    Ge(Pf, "onTransitionEnd"),
    Ma("onMouseEnter", ["mouseout", "mouseover"]),
    Ma("onMouseLeave", ["mouseout", "mouseover"]),
    Ma("onPointerEnter", ["pointerout", "pointerover"]),
    Ma("onPointerLeave", ["pointerout", "pointerover"]),
    Wn(
      "onChange",
      "change click focusin focusout input keydown keyup selectionchange".split(
        " "
      )
    ),
    Wn(
      "onSelect",
      "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
        " "
      )
    ),
    Wn("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]),
    Wn(
      "onCompositionEnd",
      "compositionend focusout keydown keypress keyup mousedown".split(" ")
    ),
    Wn(
      "onCompositionStart",
      "compositionstart focusout keydown keypress keyup mousedown".split(" ")
    ),
    Wn(
      "onCompositionUpdate",
      "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
    );
  var sl =
      "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
        " "
      ),
    tb = new Set(
      "beforetoggle cancel close invalid load scroll scrollend toggle"
        .split(" ")
        .concat(sl)
    );
  function mm(t, e) {
    e = (e & 4) !== 0;
    for (var n = 0; n < t.length; n++) {
      var i = t[n],
        s = i.event;
      i = i.listeners;
      t: {
        var u = void 0;
        if (e)
          for (var d = i.length - 1; 0 <= d; d--) {
            var y = i[d],
              x = y.instance,
              D = y.currentTarget;
            if (((y = y.listener), x !== u && s.isPropagationStopped()))
              break t;
            (u = y), (s.currentTarget = D);
            try {
              u(s);
            } catch (V) {
              Ts(V);
            }
            (s.currentTarget = null), (u = x);
          }
        else
          for (d = 0; d < i.length; d++) {
            if (
              ((y = i[d]),
              (x = y.instance),
              (D = y.currentTarget),
              (y = y.listener),
              x !== u && s.isPropagationStopped())
            )
              break t;
            (u = y), (s.currentTarget = D);
            try {
              u(s);
            } catch (V) {
              Ts(V);
            }
            (s.currentTarget = null), (u = x);
          }
      }
    }
  }
  function mt(t, e) {
    var n = e[So];
    n === void 0 && (n = e[So] = new Set());
    var i = t + "__bubble";
    n.has(i) || (pm(e, t, 2, !1), n.add(i));
  }
  function uu(t, e, n) {
    var i = 0;
    e && (i |= 4), pm(n, t, i, e);
  }
  var js = "_reactListening" + Math.random().toString(36).slice(2);
  function cu(t) {
    if (!t[js]) {
      (t[js] = !0),
        rf.forEach(function (n) {
          n !== "selectionchange" && (tb.has(n) || uu(n, !1, t), uu(n, !0, t));
        });
      var e = t.nodeType === 9 ? t : t.ownerDocument;
      e === null || e[js] || ((e[js] = !0), uu("selectionchange", !1, e));
    }
  }
  function pm(t, e, n, i) {
    switch (Hm(e)) {
      case 2:
        var s = wb;
        break;
      case 8:
        s = Rb;
        break;
      default:
        s = Eu;
    }
    (n = s.bind(null, e, n, t)),
      (s = void 0),
      !zo ||
        (e !== "touchstart" && e !== "touchmove" && e !== "wheel") ||
        (s = !0),
      i
        ? s !== void 0
          ? t.addEventListener(e, n, { capture: !0, passive: s })
          : t.addEventListener(e, n, !0)
        : s !== void 0
        ? t.addEventListener(e, n, { passive: s })
        : t.addEventListener(e, n, !1);
  }
  function fu(t, e, n, i, s) {
    var u = i;
    if ((e & 1) === 0 && (e & 2) === 0 && i !== null)
      t: for (;;) {
        if (i === null) return;
        var d = i.tag;
        if (d === 3 || d === 4) {
          var y = i.stateNode.containerInfo;
          if (y === s) break;
          if (d === 4)
            for (d = i.return; d !== null; ) {
              var x = d.tag;
              if ((x === 3 || x === 4) && d.stateNode.containerInfo === s)
                return;
              d = d.return;
            }
          for (; y !== null; ) {
            if (((d = Ta(y)), d === null)) return;
            if (((x = d.tag), x === 5 || x === 6 || x === 26 || x === 27)) {
              i = u = d;
              continue t;
            }
            y = y.parentNode;
          }
        }
        i = i.return;
      }
    Tf(function () {
      var D = u,
        V = Co(n),
        N = [];
      t: {
        var w = Ff.get(t);
        if (w !== void 0) {
          var R = Fl,
            at = t;
          switch (t) {
            case "keypress":
              if (Jl(n) === 0) break t;
            case "keydown":
            case "keyup":
              R = Jv;
              break;
            case "focusin":
              (at = "focus"), (R = jo);
              break;
            case "focusout":
              (at = "blur"), (R = jo);
              break;
            case "beforeblur":
            case "afterblur":
              R = jo;
              break;
            case "click":
              if (n.button === 2) break t;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              R = Mf;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              R = jv;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              R = Wv;
              break;
            case Qf:
            case Kf:
            case Jf:
              R = Hv;
              break;
            case Pf:
              R = Iv;
              break;
            case "scroll":
            case "scrollend":
              R = _v;
              break;
            case "wheel":
              R = e0;
              break;
            case "copy":
            case "cut":
            case "paste":
              R = qv;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              R = wf;
              break;
            case "toggle":
            case "beforetoggle":
              R = a0;
          }
          var tt = (e & 4) !== 0,
            Mt = !tt && (t === "scroll" || t === "scrollend"),
            E = tt ? (w !== null ? w + "Capture" : null) : w;
          tt = [];
          for (var T = D, M; T !== null; ) {
            var z = T;
            if (
              ((M = z.stateNode),
              (z = z.tag),
              (z !== 5 && z !== 26 && z !== 27) ||
                M === null ||
                E === null ||
                ((z = Mi(T, E)), z != null && tt.push(ol(T, z, M))),
              Mt)
            )
              break;
            T = T.return;
          }
          0 < tt.length &&
            ((w = new R(w, at, null, n, V)),
            N.push({ event: w, listeners: tt }));
        }
      }
      if ((e & 7) === 0) {
        t: {
          if (
            ((w = t === "mouseover" || t === "pointerover"),
            (R = t === "mouseout" || t === "pointerout"),
            w &&
              n !== Oo &&
              (at = n.relatedTarget || n.fromElement) &&
              (Ta(at) || at[Sa]))
          )
            break t;
          if (
            (R || w) &&
            ((w =
              V.window === V
                ? V
                : (w = V.ownerDocument)
                ? w.defaultView || w.parentWindow
                : window),
            R
              ? ((at = n.relatedTarget || n.toElement),
                (R = D),
                (at = at ? Ta(at) : null),
                at !== null &&
                  ((Mt = h(at)),
                  (tt = at.tag),
                  at !== Mt || (tt !== 5 && tt !== 27 && tt !== 6)) &&
                  (at = null))
              : ((R = null), (at = D)),
            R !== at)
          ) {
            if (
              ((tt = Mf),
              (z = "onMouseLeave"),
              (E = "onMouseEnter"),
              (T = "mouse"),
              (t === "pointerout" || t === "pointerover") &&
                ((tt = wf),
                (z = "onPointerLeave"),
                (E = "onPointerEnter"),
                (T = "pointer")),
              (Mt = R == null ? w : Ei(R)),
              (M = at == null ? w : Ei(at)),
              (w = new tt(z, T + "leave", R, n, V)),
              (w.target = Mt),
              (w.relatedTarget = M),
              (z = null),
              Ta(V) === D &&
                ((tt = new tt(E, T + "enter", at, n, V)),
                (tt.target = M),
                (tt.relatedTarget = Mt),
                (z = tt)),
              (Mt = z),
              R && at)
            )
              e: {
                for (tt = R, E = at, T = 0, M = tt; M; M = ni(M)) T++;
                for (M = 0, z = E; z; z = ni(z)) M++;
                for (; 0 < T - M; ) (tt = ni(tt)), T--;
                for (; 0 < M - T; ) (E = ni(E)), M--;
                for (; T--; ) {
                  if (tt === E || (E !== null && tt === E.alternate)) break e;
                  (tt = ni(tt)), (E = ni(E));
                }
                tt = null;
              }
            else tt = null;
            R !== null && gm(N, w, R, tt, !1),
              at !== null && Mt !== null && gm(N, Mt, at, tt, !0);
          }
        }
        t: {
          if (
            ((w = D ? Ei(D) : window),
            (R = w.nodeName && w.nodeName.toLowerCase()),
            R === "select" || (R === "input" && w.type === "file"))
          )
            var J = Uf;
          else if (Nf(w))
            if (jf) J = h0;
            else {
              J = f0;
              var ft = c0;
            }
          else
            (R = w.nodeName),
              !R ||
              R.toLowerCase() !== "input" ||
              (w.type !== "checkbox" && w.type !== "radio")
                ? D && Ro(D.elementType) && (J = Uf)
                : (J = d0);
          if (J && (J = J(t, D))) {
            _f(N, J, n, V);
            break t;
          }
          ft && ft(t, w, D),
            t === "focusout" &&
              D &&
              w.type === "number" &&
              D.memoizedProps.value != null &&
              wo(w, "number", w.value);
        }
        switch (((ft = D ? Ei(D) : window), t)) {
          case "focusin":
            (Nf(ft) || ft.contentEditable === "true") &&
              ((za = ft), (Yo = D), (Ni = null));
            break;
          case "focusout":
            Ni = Yo = za = null;
            break;
          case "mousedown":
            ko = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            (ko = !1), Xf(N, n, V);
            break;
          case "selectionchange":
            if (p0) break;
          case "keydown":
          case "keyup":
            Xf(N, n, V);
        }
        var I;
        if (Lo)
          t: {
            switch (t) {
              case "compositionstart":
                var et = "onCompositionStart";
                break t;
              case "compositionend":
                et = "onCompositionEnd";
                break t;
              case "compositionupdate":
                et = "onCompositionUpdate";
                break t;
            }
            et = void 0;
          }
        else
          Va
            ? Vf(t, n) && (et = "onCompositionEnd")
            : t === "keydown" &&
              n.keyCode === 229 &&
              (et = "onCompositionStart");
        et &&
          (Rf &&
            n.locale !== "ko" &&
            (Va || et !== "onCompositionStart"
              ? et === "onCompositionEnd" && Va && (I = Af())
              : ((An = V),
                (No = "value" in An ? An.value : An.textContent),
                (Va = !0))),
          (ft = Bs(D, et)),
          0 < ft.length &&
            ((et = new Df(et, t, null, n, V)),
            N.push({ event: et, listeners: ft }),
            I ? (et.data = I) : ((I = zf(n)), I !== null && (et.data = I)))),
          (I = l0 ? s0(t, n) : o0(t, n)) &&
            ((et = Bs(D, "onBeforeInput")),
            0 < et.length &&
              ((ft = new Df("onBeforeInput", "beforeinput", null, n, V)),
              N.push({ event: ft, listeners: et }),
              (ft.data = I))),
          W0(N, t, D, n, V);
      }
      mm(N, e);
    });
  }
  function ol(t, e, n) {
    return { instance: t, listener: e, currentTarget: n };
  }
  function Bs(t, e) {
    for (var n = e + "Capture", i = []; t !== null; ) {
      var s = t,
        u = s.stateNode;
      if (
        ((s = s.tag),
        (s !== 5 && s !== 26 && s !== 27) ||
          u === null ||
          ((s = Mi(t, n)),
          s != null && i.unshift(ol(t, s, u)),
          (s = Mi(t, e)),
          s != null && i.push(ol(t, s, u))),
        t.tag === 3)
      )
        return i;
      t = t.return;
    }
    return [];
  }
  function ni(t) {
    if (t === null) return null;
    do t = t.return;
    while (t && t.tag !== 5 && t.tag !== 27);
    return t || null;
  }
  function gm(t, e, n, i, s) {
    for (var u = e._reactName, d = []; n !== null && n !== i; ) {
      var y = n,
        x = y.alternate,
        D = y.stateNode;
      if (((y = y.tag), x !== null && x === i)) break;
      (y !== 5 && y !== 26 && y !== 27) ||
        D === null ||
        ((x = D),
        s
          ? ((D = Mi(n, u)), D != null && d.unshift(ol(n, D, x)))
          : s || ((D = Mi(n, u)), D != null && d.push(ol(n, D, x)))),
        (n = n.return);
    }
    d.length !== 0 && t.push({ event: e, listeners: d });
  }
  var eb = /\r\n?/g,
    nb = /\u0000|\uFFFD/g;
  function ym(t) {
    return (typeof t == "string" ? t : "" + t)
      .replace(
        eb,
        `
`
      )
      .replace(nb, "");
  }
  function vm(t, e) {
    return (e = ym(e)), ym(t) === e;
  }
  function Ls() {}
  function Et(t, e, n, i, s, u) {
    switch (n) {
      case "children":
        typeof i == "string"
          ? e === "body" || (e === "textarea" && i === "") || Ra(t, i)
          : (typeof i == "number" || typeof i == "bigint") &&
            e !== "body" &&
            Ra(t, "" + i);
        break;
      case "className":
        kl(t, "class", i);
        break;
      case "tabIndex":
        kl(t, "tabindex", i);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        kl(t, n, i);
        break;
      case "style":
        xf(t, i, u);
        break;
      case "data":
        if (e !== "object") {
          kl(t, "data", i);
          break;
        }
      case "src":
      case "href":
        if (i === "" && (e !== "a" || n !== "href")) {
          t.removeAttribute(n);
          break;
        }
        if (
          i == null ||
          typeof i == "function" ||
          typeof i == "symbol" ||
          typeof i == "boolean"
        ) {
          t.removeAttribute(n);
          break;
        }
        (i = Ql("" + i)), t.setAttribute(n, i);
        break;
      case "action":
      case "formAction":
        if (typeof i == "function") {
          t.setAttribute(
            n,
            "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
          );
          break;
        } else
          typeof u == "function" &&
            (n === "formAction"
              ? (e !== "input" && Et(t, e, "name", s.name, s, null),
                Et(t, e, "formEncType", s.formEncType, s, null),
                Et(t, e, "formMethod", s.formMethod, s, null),
                Et(t, e, "formTarget", s.formTarget, s, null))
              : (Et(t, e, "encType", s.encType, s, null),
                Et(t, e, "method", s.method, s, null),
                Et(t, e, "target", s.target, s, null)));
        if (i == null || typeof i == "symbol" || typeof i == "boolean") {
          t.removeAttribute(n);
          break;
        }
        (i = Ql("" + i)), t.setAttribute(n, i);
        break;
      case "onClick":
        i != null && (t.onclick = Ls);
        break;
      case "onScroll":
        i != null && mt("scroll", t);
        break;
      case "onScrollEnd":
        i != null && mt("scrollend", t);
        break;
      case "dangerouslySetInnerHTML":
        if (i != null) {
          if (typeof i != "object" || !("__html" in i)) throw Error(r(61));
          if (((n = i.__html), n != null)) {
            if (s.children != null) throw Error(r(60));
            t.innerHTML = n;
          }
        }
        break;
      case "multiple":
        t.multiple = i && typeof i != "function" && typeof i != "symbol";
        break;
      case "muted":
        t.muted = i && typeof i != "function" && typeof i != "symbol";
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "ref":
        break;
      case "autoFocus":
        break;
      case "xlinkHref":
        if (
          i == null ||
          typeof i == "function" ||
          typeof i == "boolean" ||
          typeof i == "symbol"
        ) {
          t.removeAttribute("xlink:href");
          break;
        }
        (n = Ql("" + i)),
          t.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", n);
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        i != null && typeof i != "function" && typeof i != "symbol"
          ? t.setAttribute(n, "" + i)
          : t.removeAttribute(n);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        i && typeof i != "function" && typeof i != "symbol"
          ? t.setAttribute(n, "")
          : t.removeAttribute(n);
        break;
      case "capture":
      case "download":
        i === !0
          ? t.setAttribute(n, "")
          : i !== !1 &&
            i != null &&
            typeof i != "function" &&
            typeof i != "symbol"
          ? t.setAttribute(n, i)
          : t.removeAttribute(n);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        i != null &&
        typeof i != "function" &&
        typeof i != "symbol" &&
        !isNaN(i) &&
        1 <= i
          ? t.setAttribute(n, i)
          : t.removeAttribute(n);
        break;
      case "rowSpan":
      case "start":
        i == null || typeof i == "function" || typeof i == "symbol" || isNaN(i)
          ? t.removeAttribute(n)
          : t.setAttribute(n, i);
        break;
      case "popover":
        mt("beforetoggle", t), mt("toggle", t), Yl(t, "popover", i);
        break;
      case "xlinkActuate":
        Ie(t, "http://www.w3.org/1999/xlink", "xlink:actuate", i);
        break;
      case "xlinkArcrole":
        Ie(t, "http://www.w3.org/1999/xlink", "xlink:arcrole", i);
        break;
      case "xlinkRole":
        Ie(t, "http://www.w3.org/1999/xlink", "xlink:role", i);
        break;
      case "xlinkShow":
        Ie(t, "http://www.w3.org/1999/xlink", "xlink:show", i);
        break;
      case "xlinkTitle":
        Ie(t, "http://www.w3.org/1999/xlink", "xlink:title", i);
        break;
      case "xlinkType":
        Ie(t, "http://www.w3.org/1999/xlink", "xlink:type", i);
        break;
      case "xmlBase":
        Ie(t, "http://www.w3.org/XML/1998/namespace", "xml:base", i);
        break;
      case "xmlLang":
        Ie(t, "http://www.w3.org/XML/1998/namespace", "xml:lang", i);
        break;
      case "xmlSpace":
        Ie(t, "http://www.w3.org/XML/1998/namespace", "xml:space", i);
        break;
      case "is":
        Yl(t, "is", i);
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        (!(2 < n.length) ||
          (n[0] !== "o" && n[0] !== "O") ||
          (n[1] !== "n" && n[1] !== "N")) &&
          ((n = zv.get(n) || n), Yl(t, n, i));
    }
  }
  function du(t, e, n, i, s, u) {
    switch (n) {
      case "style":
        xf(t, i, u);
        break;
      case "dangerouslySetInnerHTML":
        if (i != null) {
          if (typeof i != "object" || !("__html" in i)) throw Error(r(61));
          if (((n = i.__html), n != null)) {
            if (s.children != null) throw Error(r(60));
            t.innerHTML = n;
          }
        }
        break;
      case "children":
        typeof i == "string"
          ? Ra(t, i)
          : (typeof i == "number" || typeof i == "bigint") && Ra(t, "" + i);
        break;
      case "onScroll":
        i != null && mt("scroll", t);
        break;
      case "onScrollEnd":
        i != null && mt("scrollend", t);
        break;
      case "onClick":
        i != null && (t.onclick = Ls);
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "innerHTML":
      case "ref":
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!uf.hasOwnProperty(n))
          t: {
            if (
              n[0] === "o" &&
              n[1] === "n" &&
              ((s = n.endsWith("Capture")),
              (e = n.slice(2, s ? n.length - 7 : void 0)),
              (u = t[fe] || null),
              (u = u != null ? u[n] : null),
              typeof u == "function" && t.removeEventListener(e, u, s),
              typeof i == "function")
            ) {
              typeof u != "function" &&
                u !== null &&
                (n in t
                  ? (t[n] = null)
                  : t.hasAttribute(n) && t.removeAttribute(n)),
                t.addEventListener(e, i, s);
              break t;
            }
            n in t
              ? (t[n] = i)
              : i === !0
              ? t.setAttribute(n, "")
              : Yl(t, n, i);
          }
    }
  }
  function te(t, e, n) {
    switch (e) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "img":
        mt("error", t), mt("load", t);
        var i = !1,
          s = !1,
          u;
        for (u in n)
          if (n.hasOwnProperty(u)) {
            var d = n[u];
            if (d != null)
              switch (u) {
                case "src":
                  i = !0;
                  break;
                case "srcSet":
                  s = !0;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(r(137, e));
                default:
                  Et(t, e, u, d, n, null);
              }
          }
        s && Et(t, e, "srcSet", n.srcSet, n, null),
          i && Et(t, e, "src", n.src, n, null);
        return;
      case "input":
        mt("invalid", t);
        var y = (u = d = s = null),
          x = null,
          D = null;
        for (i in n)
          if (n.hasOwnProperty(i)) {
            var V = n[i];
            if (V != null)
              switch (i) {
                case "name":
                  s = V;
                  break;
                case "type":
                  d = V;
                  break;
                case "checked":
                  x = V;
                  break;
                case "defaultChecked":
                  D = V;
                  break;
                case "value":
                  u = V;
                  break;
                case "defaultValue":
                  y = V;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (V != null) throw Error(r(137, e));
                  break;
                default:
                  Et(t, e, i, V, n, null);
              }
          }
        gf(t, u, y, x, D, d, s, !1), Xl(t);
        return;
      case "select":
        mt("invalid", t), (i = d = u = null);
        for (s in n)
          if (n.hasOwnProperty(s) && ((y = n[s]), y != null))
            switch (s) {
              case "value":
                u = y;
                break;
              case "defaultValue":
                d = y;
                break;
              case "multiple":
                i = y;
              default:
                Et(t, e, s, y, n, null);
            }
        (e = u),
          (n = d),
          (t.multiple = !!i),
          e != null ? wa(t, !!i, e, !1) : n != null && wa(t, !!i, n, !0);
        return;
      case "textarea":
        mt("invalid", t), (u = s = i = null);
        for (d in n)
          if (n.hasOwnProperty(d) && ((y = n[d]), y != null))
            switch (d) {
              case "value":
                i = y;
                break;
              case "defaultValue":
                s = y;
                break;
              case "children":
                u = y;
                break;
              case "dangerouslySetInnerHTML":
                if (y != null) throw Error(r(91));
                break;
              default:
                Et(t, e, d, y, n, null);
            }
        vf(t, i, s, u), Xl(t);
        return;
      case "option":
        for (x in n)
          if (n.hasOwnProperty(x) && ((i = n[x]), i != null))
            switch (x) {
              case "selected":
                t.selected =
                  i && typeof i != "function" && typeof i != "symbol";
                break;
              default:
                Et(t, e, x, i, n, null);
            }
        return;
      case "dialog":
        mt("beforetoggle", t), mt("toggle", t), mt("cancel", t), mt("close", t);
        break;
      case "iframe":
      case "object":
        mt("load", t);
        break;
      case "video":
      case "audio":
        for (i = 0; i < sl.length; i++) mt(sl[i], t);
        break;
      case "image":
        mt("error", t), mt("load", t);
        break;
      case "details":
        mt("toggle", t);
        break;
      case "embed":
      case "source":
      case "link":
        mt("error", t), mt("load", t);
      case "area":
      case "base":
      case "br":
      case "col":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "track":
      case "wbr":
      case "menuitem":
        for (D in n)
          if (n.hasOwnProperty(D) && ((i = n[D]), i != null))
            switch (D) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(r(137, e));
              default:
                Et(t, e, D, i, n, null);
            }
        return;
      default:
        if (Ro(e)) {
          for (V in n)
            n.hasOwnProperty(V) &&
              ((i = n[V]), i !== void 0 && du(t, e, V, i, n, void 0));
          return;
        }
    }
    for (y in n)
      n.hasOwnProperty(y) && ((i = n[y]), i != null && Et(t, e, y, i, n, null));
  }
  function ab(t, e, n, i) {
    switch (e) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "input":
        var s = null,
          u = null,
          d = null,
          y = null,
          x = null,
          D = null,
          V = null;
        for (R in n) {
          var N = n[R];
          if (n.hasOwnProperty(R) && N != null)
            switch (R) {
              case "checked":
                break;
              case "value":
                break;
              case "defaultValue":
                x = N;
              default:
                i.hasOwnProperty(R) || Et(t, e, R, null, i, N);
            }
        }
        for (var w in i) {
          var R = i[w];
          if (((N = n[w]), i.hasOwnProperty(w) && (R != null || N != null)))
            switch (w) {
              case "type":
                u = R;
                break;
              case "name":
                s = R;
                break;
              case "checked":
                D = R;
                break;
              case "defaultChecked":
                V = R;
                break;
              case "value":
                d = R;
                break;
              case "defaultValue":
                y = R;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                if (R != null) throw Error(r(137, e));
                break;
              default:
                R !== N && Et(t, e, w, R, i, N);
            }
        }
        Do(t, d, y, x, D, V, u, s);
        return;
      case "select":
        R = d = y = w = null;
        for (u in n)
          if (((x = n[u]), n.hasOwnProperty(u) && x != null))
            switch (u) {
              case "value":
                break;
              case "multiple":
                R = x;
              default:
                i.hasOwnProperty(u) || Et(t, e, u, null, i, x);
            }
        for (s in i)
          if (
            ((u = i[s]),
            (x = n[s]),
            i.hasOwnProperty(s) && (u != null || x != null))
          )
            switch (s) {
              case "value":
                w = u;
                break;
              case "defaultValue":
                y = u;
                break;
              case "multiple":
                d = u;
              default:
                u !== x && Et(t, e, s, u, i, x);
            }
        (e = y),
          (n = d),
          (i = R),
          w != null
            ? wa(t, !!n, w, !1)
            : !!i != !!n &&
              (e != null ? wa(t, !!n, e, !0) : wa(t, !!n, n ? [] : "", !1));
        return;
      case "textarea":
        R = w = null;
        for (y in n)
          if (
            ((s = n[y]),
            n.hasOwnProperty(y) && s != null && !i.hasOwnProperty(y))
          )
            switch (y) {
              case "value":
                break;
              case "children":
                break;
              default:
                Et(t, e, y, null, i, s);
            }
        for (d in i)
          if (
            ((s = i[d]),
            (u = n[d]),
            i.hasOwnProperty(d) && (s != null || u != null))
          )
            switch (d) {
              case "value":
                w = s;
                break;
              case "defaultValue":
                R = s;
                break;
              case "children":
                break;
              case "dangerouslySetInnerHTML":
                if (s != null) throw Error(r(91));
                break;
              default:
                s !== u && Et(t, e, d, s, i, u);
            }
        yf(t, w, R);
        return;
      case "option":
        for (var at in n)
          if (
            ((w = n[at]),
            n.hasOwnProperty(at) && w != null && !i.hasOwnProperty(at))
          )
            switch (at) {
              case "selected":
                t.selected = !1;
                break;
              default:
                Et(t, e, at, null, i, w);
            }
        for (x in i)
          if (
            ((w = i[x]),
            (R = n[x]),
            i.hasOwnProperty(x) && w !== R && (w != null || R != null))
          )
            switch (x) {
              case "selected":
                t.selected =
                  w && typeof w != "function" && typeof w != "symbol";
                break;
              default:
                Et(t, e, x, w, i, R);
            }
        return;
      case "img":
      case "link":
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
      case "menuitem":
        for (var tt in n)
          (w = n[tt]),
            n.hasOwnProperty(tt) &&
              w != null &&
              !i.hasOwnProperty(tt) &&
              Et(t, e, tt, null, i, w);
        for (D in i)
          if (
            ((w = i[D]),
            (R = n[D]),
            i.hasOwnProperty(D) && w !== R && (w != null || R != null))
          )
            switch (D) {
              case "children":
              case "dangerouslySetInnerHTML":
                if (w != null) throw Error(r(137, e));
                break;
              default:
                Et(t, e, D, w, i, R);
            }
        return;
      default:
        if (Ro(e)) {
          for (var Mt in n)
            (w = n[Mt]),
              n.hasOwnProperty(Mt) &&
                w !== void 0 &&
                !i.hasOwnProperty(Mt) &&
                du(t, e, Mt, void 0, i, w);
          for (V in i)
            (w = i[V]),
              (R = n[V]),
              !i.hasOwnProperty(V) ||
                w === R ||
                (w === void 0 && R === void 0) ||
                du(t, e, V, w, i, R);
          return;
        }
    }
    for (var E in n)
      (w = n[E]),
        n.hasOwnProperty(E) &&
          w != null &&
          !i.hasOwnProperty(E) &&
          Et(t, e, E, null, i, w);
    for (N in i)
      (w = i[N]),
        (R = n[N]),
        !i.hasOwnProperty(N) ||
          w === R ||
          (w == null && R == null) ||
          Et(t, e, N, w, i, R);
  }
  var hu = null,
    mu = null;
  function Hs(t) {
    return t.nodeType === 9 ? t : t.ownerDocument;
  }
  function bm(t) {
    switch (t) {
      case "http://www.w3.org/2000/svg":
        return 1;
      case "http://www.w3.org/1998/Math/MathML":
        return 2;
      default:
        return 0;
    }
  }
  function xm(t, e) {
    if (t === 0)
      switch (e) {
        case "svg":
          return 1;
        case "math":
          return 2;
        default:
          return 0;
      }
    return t === 1 && e === "foreignObject" ? 0 : t;
  }
  function pu(t, e) {
    return (
      t === "textarea" ||
      t === "noscript" ||
      typeof e.children == "string" ||
      typeof e.children == "number" ||
      typeof e.children == "bigint" ||
      (typeof e.dangerouslySetInnerHTML == "object" &&
        e.dangerouslySetInnerHTML !== null &&
        e.dangerouslySetInnerHTML.__html != null)
    );
  }
  var gu = null;
  function ib() {
    var t = window.event;
    return t && t.type === "popstate"
      ? t === gu
        ? !1
        : ((gu = t), !0)
      : ((gu = null), !1);
  }
  var Sm = typeof setTimeout == "function" ? setTimeout : void 0,
    lb = typeof clearTimeout == "function" ? clearTimeout : void 0,
    Tm = typeof Promise == "function" ? Promise : void 0,
    sb =
      typeof queueMicrotask == "function"
        ? queueMicrotask
        : typeof Tm < "u"
        ? function (t) {
            return Tm.resolve(null).then(t).catch(ob);
          }
        : Sm;
  function ob(t) {
    setTimeout(function () {
      throw t;
    });
  }
  function Hn(t) {
    return t === "head";
  }
  function Am(t, e) {
    var n = e,
      i = 0,
      s = 0;
    do {
      var u = n.nextSibling;
      if ((t.removeChild(n), u && u.nodeType === 8))
        if (((n = u.data), n === "/$")) {
          if (0 < i && 8 > i) {
            n = i;
            var d = t.ownerDocument;
            if ((n & 1 && rl(d.documentElement), n & 2 && rl(d.body), n & 4))
              for (n = d.head, rl(n), d = n.firstChild; d; ) {
                var y = d.nextSibling,
                  x = d.nodeName;
                d[Ai] ||
                  x === "SCRIPT" ||
                  x === "STYLE" ||
                  (x === "LINK" && d.rel.toLowerCase() === "stylesheet") ||
                  n.removeChild(d),
                  (d = y);
              }
          }
          if (s === 0) {
            t.removeChild(u), gl(e);
            return;
          }
          s--;
        } else
          n === "$" || n === "$?" || n === "$!"
            ? s++
            : (i = n.charCodeAt(0) - 48);
      else i = 0;
      n = u;
    } while (n);
    gl(e);
  }
  function yu(t) {
    var e = t.firstChild;
    for (e && e.nodeType === 10 && (e = e.nextSibling); e; ) {
      var n = e;
      switch (((e = e.nextSibling), n.nodeName)) {
        case "HTML":
        case "HEAD":
        case "BODY":
          yu(n), To(n);
          continue;
        case "SCRIPT":
        case "STYLE":
          continue;
        case "LINK":
          if (n.rel.toLowerCase() === "stylesheet") continue;
      }
      t.removeChild(n);
    }
  }
  function rb(t, e, n, i) {
    for (; t.nodeType === 1; ) {
      var s = n;
      if (t.nodeName.toLowerCase() !== e.toLowerCase()) {
        if (!i && (t.nodeName !== "INPUT" || t.type !== "hidden")) break;
      } else if (i) {
        if (!t[Ai])
          switch (e) {
            case "meta":
              if (!t.hasAttribute("itemprop")) break;
              return t;
            case "link":
              if (
                ((u = t.getAttribute("rel")),
                u === "stylesheet" && t.hasAttribute("data-precedence"))
              )
                break;
              if (
                u !== s.rel ||
                t.getAttribute("href") !==
                  (s.href == null || s.href === "" ? null : s.href) ||
                t.getAttribute("crossorigin") !==
                  (s.crossOrigin == null ? null : s.crossOrigin) ||
                t.getAttribute("title") !== (s.title == null ? null : s.title)
              )
                break;
              return t;
            case "style":
              if (t.hasAttribute("data-precedence")) break;
              return t;
            case "script":
              if (
                ((u = t.getAttribute("src")),
                (u !== (s.src == null ? null : s.src) ||
                  t.getAttribute("type") !== (s.type == null ? null : s.type) ||
                  t.getAttribute("crossorigin") !==
                    (s.crossOrigin == null ? null : s.crossOrigin)) &&
                  u &&
                  t.hasAttribute("async") &&
                  !t.hasAttribute("itemprop"))
              )
                break;
              return t;
            default:
              return t;
          }
      } else if (e === "input" && t.type === "hidden") {
        var u = s.name == null ? null : "" + s.name;
        if (s.type === "hidden" && t.getAttribute("name") === u) return t;
      } else return t;
      if (((t = Ye(t.nextSibling)), t === null)) break;
    }
    return null;
  }
  function ub(t, e, n) {
    if (e === "") return null;
    for (; t.nodeType !== 3; )
      if (
        ((t.nodeType !== 1 || t.nodeName !== "INPUT" || t.type !== "hidden") &&
          !n) ||
        ((t = Ye(t.nextSibling)), t === null)
      )
        return null;
    return t;
  }
  function vu(t) {
    return (
      t.data === "$!" ||
      (t.data === "$?" && t.ownerDocument.readyState === "complete")
    );
  }
  function cb(t, e) {
    var n = t.ownerDocument;
    if (t.data !== "$?" || n.readyState === "complete") e();
    else {
      var i = function () {
        e(), n.removeEventListener("DOMContentLoaded", i);
      };
      n.addEventListener("DOMContentLoaded", i), (t._reactRetry = i);
    }
  }
  function Ye(t) {
    for (; t != null; t = t.nextSibling) {
      var e = t.nodeType;
      if (e === 1 || e === 3) break;
      if (e === 8) {
        if (
          ((e = t.data),
          e === "$" || e === "$!" || e === "$?" || e === "F!" || e === "F")
        )
          break;
        if (e === "/$") return null;
      }
    }
    return t;
  }
  var bu = null;
  function Em(t) {
    t = t.previousSibling;
    for (var e = 0; t; ) {
      if (t.nodeType === 8) {
        var n = t.data;
        if (n === "$" || n === "$!" || n === "$?") {
          if (e === 0) return t;
          e--;
        } else n === "/$" && e++;
      }
      t = t.previousSibling;
    }
    return null;
  }
  function Mm(t, e, n) {
    switch (((e = Hs(n)), t)) {
      case "html":
        if (((t = e.documentElement), !t)) throw Error(r(452));
        return t;
      case "head":
        if (((t = e.head), !t)) throw Error(r(453));
        return t;
      case "body":
        if (((t = e.body), !t)) throw Error(r(454));
        return t;
      default:
        throw Error(r(451));
    }
  }
  function rl(t) {
    for (var e = t.attributes; e.length; ) t.removeAttributeNode(e[0]);
    To(t);
  }
  var je = new Map(),
    Dm = new Set();
  function Gs(t) {
    return typeof t.getRootNode == "function"
      ? t.getRootNode()
      : t.nodeType === 9
      ? t
      : t.ownerDocument;
  }
  var mn = H.d;
  H.d = { f: fb, r: db, D: hb, C: mb, L: pb, m: gb, X: vb, S: yb, M: bb };
  function fb() {
    var t = mn.f(),
      e = Vs();
    return t || e;
  }
  function db(t) {
    var e = Aa(t);
    e !== null && e.tag === 5 && e.type === "form" ? Qd(e) : mn.r(t);
  }
  var ai = typeof document > "u" ? null : document;
  function wm(t, e, n) {
    var i = ai;
    if (i && typeof e == "string" && e) {
      var s = Oe(e);
      (s = 'link[rel="' + t + '"][href="' + s + '"]'),
        typeof n == "string" && (s += '[crossorigin="' + n + '"]'),
        Dm.has(s) ||
          (Dm.add(s),
          (t = { rel: t, crossOrigin: n, href: e }),
          i.querySelector(s) === null &&
            ((e = i.createElement("link")),
            te(e, "link", t),
            Jt(e),
            i.head.appendChild(e)));
    }
  }
  function hb(t) {
    mn.D(t), wm("dns-prefetch", t, null);
  }
  function mb(t, e) {
    mn.C(t, e), wm("preconnect", t, e);
  }
  function pb(t, e, n) {
    mn.L(t, e, n);
    var i = ai;
    if (i && t && e) {
      var s = 'link[rel="preload"][as="' + Oe(e) + '"]';
      e === "image" && n && n.imageSrcSet
        ? ((s += '[imagesrcset="' + Oe(n.imageSrcSet) + '"]'),
          typeof n.imageSizes == "string" &&
            (s += '[imagesizes="' + Oe(n.imageSizes) + '"]'))
        : (s += '[href="' + Oe(t) + '"]');
      var u = s;
      switch (e) {
        case "style":
          u = ii(t);
          break;
        case "script":
          u = li(t);
      }
      je.has(u) ||
        ((t = v(
          {
            rel: "preload",
            href: e === "image" && n && n.imageSrcSet ? void 0 : t,
            as: e,
          },
          n
        )),
        je.set(u, t),
        i.querySelector(s) !== null ||
          (e === "style" && i.querySelector(ul(u))) ||
          (e === "script" && i.querySelector(cl(u))) ||
          ((e = i.createElement("link")),
          te(e, "link", t),
          Jt(e),
          i.head.appendChild(e)));
    }
  }
  function gb(t, e) {
    mn.m(t, e);
    var n = ai;
    if (n && t) {
      var i = e && typeof e.as == "string" ? e.as : "script",
        s =
          'link[rel="modulepreload"][as="' + Oe(i) + '"][href="' + Oe(t) + '"]',
        u = s;
      switch (i) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          u = li(t);
      }
      if (
        !je.has(u) &&
        ((t = v({ rel: "modulepreload", href: t }, e)),
        je.set(u, t),
        n.querySelector(s) === null)
      ) {
        switch (i) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            if (n.querySelector(cl(u))) return;
        }
        (i = n.createElement("link")),
          te(i, "link", t),
          Jt(i),
          n.head.appendChild(i);
      }
    }
  }
  function yb(t, e, n) {
    mn.S(t, e, n);
    var i = ai;
    if (i && t) {
      var s = Ea(i).hoistableStyles,
        u = ii(t);
      e = e || "default";
      var d = s.get(u);
      if (!d) {
        var y = { loading: 0, preload: null };
        if ((d = i.querySelector(ul(u)))) y.loading = 5;
        else {
          (t = v({ rel: "stylesheet", href: t, "data-precedence": e }, n)),
            (n = je.get(u)) && xu(t, n);
          var x = (d = i.createElement("link"));
          Jt(x),
            te(x, "link", t),
            (x._p = new Promise(function (D, V) {
              (x.onload = D), (x.onerror = V);
            })),
            x.addEventListener("load", function () {
              y.loading |= 1;
            }),
            x.addEventListener("error", function () {
              y.loading |= 2;
            }),
            (y.loading |= 4),
            qs(d, e, i);
        }
        (d = { type: "stylesheet", instance: d, count: 1, state: y }),
          s.set(u, d);
      }
    }
  }
  function vb(t, e) {
    mn.X(t, e);
    var n = ai;
    if (n && t) {
      var i = Ea(n).hoistableScripts,
        s = li(t),
        u = i.get(s);
      u ||
        ((u = n.querySelector(cl(s))),
        u ||
          ((t = v({ src: t, async: !0 }, e)),
          (e = je.get(s)) && Su(t, e),
          (u = n.createElement("script")),
          Jt(u),
          te(u, "link", t),
          n.head.appendChild(u)),
        (u = { type: "script", instance: u, count: 1, state: null }),
        i.set(s, u));
    }
  }
  function bb(t, e) {
    mn.M(t, e);
    var n = ai;
    if (n && t) {
      var i = Ea(n).hoistableScripts,
        s = li(t),
        u = i.get(s);
      u ||
        ((u = n.querySelector(cl(s))),
        u ||
          ((t = v({ src: t, async: !0, type: "module" }, e)),
          (e = je.get(s)) && Su(t, e),
          (u = n.createElement("script")),
          Jt(u),
          te(u, "link", t),
          n.head.appendChild(u)),
        (u = { type: "script", instance: u, count: 1, state: null }),
        i.set(s, u));
    }
  }
  function Rm(t, e, n, i) {
    var s = (s = st.current) ? Gs(s) : null;
    if (!s) throw Error(r(446));
    switch (t) {
      case "meta":
      case "title":
        return null;
      case "style":
        return typeof n.precedence == "string" && typeof n.href == "string"
          ? ((e = ii(n.href)),
            (n = Ea(s).hoistableStyles),
            (i = n.get(e)),
            i ||
              ((i = { type: "style", instance: null, count: 0, state: null }),
              n.set(e, i)),
            i)
          : { type: "void", instance: null, count: 0, state: null };
      case "link":
        if (
          n.rel === "stylesheet" &&
          typeof n.href == "string" &&
          typeof n.precedence == "string"
        ) {
          t = ii(n.href);
          var u = Ea(s).hoistableStyles,
            d = u.get(t);
          if (
            (d ||
              ((s = s.ownerDocument || s),
              (d = {
                type: "stylesheet",
                instance: null,
                count: 0,
                state: { loading: 0, preload: null },
              }),
              u.set(t, d),
              (u = s.querySelector(ul(t))) &&
                !u._p &&
                ((d.instance = u), (d.state.loading = 5)),
              je.has(t) ||
                ((n = {
                  rel: "preload",
                  as: "style",
                  href: n.href,
                  crossOrigin: n.crossOrigin,
                  integrity: n.integrity,
                  media: n.media,
                  hrefLang: n.hrefLang,
                  referrerPolicy: n.referrerPolicy,
                }),
                je.set(t, n),
                u || xb(s, t, n, d.state))),
            e && i === null)
          )
            throw Error(r(528, ""));
          return d;
        }
        if (e && i !== null) throw Error(r(529, ""));
        return null;
      case "script":
        return (
          (e = n.async),
          (n = n.src),
          typeof n == "string" &&
          e &&
          typeof e != "function" &&
          typeof e != "symbol"
            ? ((e = li(n)),
              (n = Ea(s).hoistableScripts),
              (i = n.get(e)),
              i ||
                ((i = {
                  type: "script",
                  instance: null,
                  count: 0,
                  state: null,
                }),
                n.set(e, i)),
              i)
            : { type: "void", instance: null, count: 0, state: null }
        );
      default:
        throw Error(r(444, t));
    }
  }
  function ii(t) {
    return 'href="' + Oe(t) + '"';
  }
  function ul(t) {
    return 'link[rel="stylesheet"][' + t + "]";
  }
  function Om(t) {
    return v({}, t, { "data-precedence": t.precedence, precedence: null });
  }
  function xb(t, e, n, i) {
    t.querySelector('link[rel="preload"][as="style"][' + e + "]")
      ? (i.loading = 1)
      : ((e = t.createElement("link")),
        (i.preload = e),
        e.addEventListener("load", function () {
          return (i.loading |= 1);
        }),
        e.addEventListener("error", function () {
          return (i.loading |= 2);
        }),
        te(e, "link", n),
        Jt(e),
        t.head.appendChild(e));
  }
  function li(t) {
    return '[src="' + Oe(t) + '"]';
  }
  function cl(t) {
    return "script[async]" + t;
  }
  function Cm(t, e, n) {
    if ((e.count++, e.instance === null))
      switch (e.type) {
        case "style":
          var i = t.querySelector('style[data-href~="' + Oe(n.href) + '"]');
          if (i) return (e.instance = i), Jt(i), i;
          var s = v({}, n, {
            "data-href": n.href,
            "data-precedence": n.precedence,
            href: null,
            precedence: null,
          });
          return (
            (i = (t.ownerDocument || t).createElement("style")),
            Jt(i),
            te(i, "style", s),
            qs(i, n.precedence, t),
            (e.instance = i)
          );
        case "stylesheet":
          s = ii(n.href);
          var u = t.querySelector(ul(s));
          if (u) return (e.state.loading |= 4), (e.instance = u), Jt(u), u;
          (i = Om(n)),
            (s = je.get(s)) && xu(i, s),
            (u = (t.ownerDocument || t).createElement("link")),
            Jt(u);
          var d = u;
          return (
            (d._p = new Promise(function (y, x) {
              (d.onload = y), (d.onerror = x);
            })),
            te(u, "link", i),
            (e.state.loading |= 4),
            qs(u, n.precedence, t),
            (e.instance = u)
          );
        case "script":
          return (
            (u = li(n.src)),
            (s = t.querySelector(cl(u)))
              ? ((e.instance = s), Jt(s), s)
              : ((i = n),
                (s = je.get(u)) && ((i = v({}, n)), Su(i, s)),
                (t = t.ownerDocument || t),
                (s = t.createElement("script")),
                Jt(s),
                te(s, "link", i),
                t.head.appendChild(s),
                (e.instance = s))
          );
        case "void":
          return null;
        default:
          throw Error(r(443, e.type));
      }
    else
      e.type === "stylesheet" &&
        (e.state.loading & 4) === 0 &&
        ((i = e.instance), (e.state.loading |= 4), qs(i, n.precedence, t));
    return e.instance;
  }
  function qs(t, e, n) {
    for (
      var i = n.querySelectorAll(
          'link[rel="stylesheet"][data-precedence],style[data-precedence]'
        ),
        s = i.length ? i[i.length - 1] : null,
        u = s,
        d = 0;
      d < i.length;
      d++
    ) {
      var y = i[d];
      if (y.dataset.precedence === e) u = y;
      else if (u !== s) break;
    }
    u
      ? u.parentNode.insertBefore(t, u.nextSibling)
      : ((e = n.nodeType === 9 ? n.head : n), e.insertBefore(t, e.firstChild));
  }
  function xu(t, e) {
    t.crossOrigin == null && (t.crossOrigin = e.crossOrigin),
      t.referrerPolicy == null && (t.referrerPolicy = e.referrerPolicy),
      t.title == null && (t.title = e.title);
  }
  function Su(t, e) {
    t.crossOrigin == null && (t.crossOrigin = e.crossOrigin),
      t.referrerPolicy == null && (t.referrerPolicy = e.referrerPolicy),
      t.integrity == null && (t.integrity = e.integrity);
  }
  var Ys = null;
  function Vm(t, e, n) {
    if (Ys === null) {
      var i = new Map(),
        s = (Ys = new Map());
      s.set(n, i);
    } else (s = Ys), (i = s.get(n)), i || ((i = new Map()), s.set(n, i));
    if (i.has(t)) return i;
    for (
      i.set(t, null), n = n.getElementsByTagName(t), s = 0;
      s < n.length;
      s++
    ) {
      var u = n[s];
      if (
        !(
          u[Ai] ||
          u[ne] ||
          (t === "link" && u.getAttribute("rel") === "stylesheet")
        ) &&
        u.namespaceURI !== "http://www.w3.org/2000/svg"
      ) {
        var d = u.getAttribute(e) || "";
        d = t + d;
        var y = i.get(d);
        y ? y.push(u) : i.set(d, [u]);
      }
    }
    return i;
  }
  function zm(t, e, n) {
    (t = t.ownerDocument || t),
      t.head.insertBefore(
        n,
        e === "title" ? t.querySelector("head > title") : null
      );
  }
  function Sb(t, e, n) {
    if (n === 1 || e.itemProp != null) return !1;
    switch (t) {
      case "meta":
      case "title":
        return !0;
      case "style":
        if (
          typeof e.precedence != "string" ||
          typeof e.href != "string" ||
          e.href === ""
        )
          break;
        return !0;
      case "link":
        if (
          typeof e.rel != "string" ||
          typeof e.href != "string" ||
          e.href === "" ||
          e.onLoad ||
          e.onError
        )
          break;
        switch (e.rel) {
          case "stylesheet":
            return (
              (t = e.disabled), typeof e.precedence == "string" && t == null
            );
          default:
            return !0;
        }
      case "script":
        if (
          e.async &&
          typeof e.async != "function" &&
          typeof e.async != "symbol" &&
          !e.onLoad &&
          !e.onError &&
          e.src &&
          typeof e.src == "string"
        )
          return !0;
    }
    return !1;
  }
  function Nm(t) {
    return !(t.type === "stylesheet" && (t.state.loading & 3) === 0);
  }
  var fl = null;
  function Tb() {}
  function Ab(t, e, n) {
    if (fl === null) throw Error(r(475));
    var i = fl;
    if (
      e.type === "stylesheet" &&
      (typeof n.media != "string" || matchMedia(n.media).matches !== !1) &&
      (e.state.loading & 4) === 0
    ) {
      if (e.instance === null) {
        var s = ii(n.href),
          u = t.querySelector(ul(s));
        if (u) {
          (t = u._p),
            t !== null &&
              typeof t == "object" &&
              typeof t.then == "function" &&
              (i.count++, (i = ks.bind(i)), t.then(i, i)),
            (e.state.loading |= 4),
            (e.instance = u),
            Jt(u);
          return;
        }
        (u = t.ownerDocument || t),
          (n = Om(n)),
          (s = je.get(s)) && xu(n, s),
          (u = u.createElement("link")),
          Jt(u);
        var d = u;
        (d._p = new Promise(function (y, x) {
          (d.onload = y), (d.onerror = x);
        })),
          te(u, "link", n),
          (e.instance = u);
      }
      i.stylesheets === null && (i.stylesheets = new Map()),
        i.stylesheets.set(e, t),
        (t = e.state.preload) &&
          (e.state.loading & 3) === 0 &&
          (i.count++,
          (e = ks.bind(i)),
          t.addEventListener("load", e),
          t.addEventListener("error", e));
    }
  }
  function Eb() {
    if (fl === null) throw Error(r(475));
    var t = fl;
    return (
      t.stylesheets && t.count === 0 && Tu(t, t.stylesheets),
      0 < t.count
        ? function (e) {
            var n = setTimeout(function () {
              if ((t.stylesheets && Tu(t, t.stylesheets), t.unsuspend)) {
                var i = t.unsuspend;
                (t.unsuspend = null), i();
              }
            }, 6e4);
            return (
              (t.unsuspend = e),
              function () {
                (t.unsuspend = null), clearTimeout(n);
              }
            );
          }
        : null
    );
  }
  function ks() {
    if ((this.count--, this.count === 0)) {
      if (this.stylesheets) Tu(this, this.stylesheets);
      else if (this.unsuspend) {
        var t = this.unsuspend;
        (this.unsuspend = null), t();
      }
    }
  }
  var Xs = null;
  function Tu(t, e) {
    (t.stylesheets = null),
      t.unsuspend !== null &&
        (t.count++,
        (Xs = new Map()),
        e.forEach(Mb, t),
        (Xs = null),
        ks.call(t));
  }
  function Mb(t, e) {
    if (!(e.state.loading & 4)) {
      var n = Xs.get(t);
      if (n) var i = n.get(null);
      else {
        (n = new Map()), Xs.set(t, n);
        for (
          var s = t.querySelectorAll(
              "link[data-precedence],style[data-precedence]"
            ),
            u = 0;
          u < s.length;
          u++
        ) {
          var d = s[u];
          (d.nodeName === "LINK" || d.getAttribute("media") !== "not all") &&
            (n.set(d.dataset.precedence, d), (i = d));
        }
        i && n.set(null, i);
      }
      (s = e.instance),
        (d = s.getAttribute("data-precedence")),
        (u = n.get(d) || i),
        u === i && n.set(null, s),
        n.set(d, s),
        this.count++,
        (i = ks.bind(this)),
        s.addEventListener("load", i),
        s.addEventListener("error", i),
        u
          ? u.parentNode.insertBefore(s, u.nextSibling)
          : ((t = t.nodeType === 9 ? t.head : t),
            t.insertBefore(s, t.firstChild)),
        (e.state.loading |= 4);
    }
  }
  var dl = {
    $$typeof: X,
    Provider: null,
    Consumer: null,
    _currentValue: _,
    _currentValue2: _,
    _threadCount: 0,
  };
  function Db(t, e, n, i, s, u, d, y) {
    (this.tag = 1),
      (this.containerInfo = t),
      (this.pingCache = this.current = this.pendingChildren = null),
      (this.timeoutHandle = -1),
      (this.callbackNode =
        this.next =
        this.pendingContext =
        this.context =
        this.cancelPendingCommit =
          null),
      (this.callbackPriority = 0),
      (this.expirationTimes = vo(-1)),
      (this.entangledLanes =
        this.shellSuspendCounter =
        this.errorRecoveryDisabledLanes =
        this.expiredLanes =
        this.warmLanes =
        this.pingedLanes =
        this.suspendedLanes =
        this.pendingLanes =
          0),
      (this.entanglements = vo(0)),
      (this.hiddenUpdates = vo(null)),
      (this.identifierPrefix = i),
      (this.onUncaughtError = s),
      (this.onCaughtError = u),
      (this.onRecoverableError = d),
      (this.pooledCache = null),
      (this.pooledCacheLanes = 0),
      (this.formState = y),
      (this.incompleteTransitions = new Map());
  }
  function _m(t, e, n, i, s, u, d, y, x, D, V, N) {
    return (
      (t = new Db(t, e, n, d, y, x, D, N)),
      (e = 1),
      u === !0 && (e |= 24),
      (u = Se(3, null, null, e)),
      (t.current = u),
      (u.stateNode = t),
      (e = ar()),
      e.refCount++,
      (t.pooledCache = e),
      e.refCount++,
      (u.memoizedState = { element: i, isDehydrated: n, cache: e }),
      or(u),
      t
    );
  }
  function Um(t) {
    return t ? ((t = ja), t) : ja;
  }
  function jm(t, e, n, i, s, u) {
    (s = Um(s)),
      i.context === null ? (i.context = s) : (i.pendingContext = s),
      (i = Dn(e)),
      (i.payload = { element: n }),
      (u = u === void 0 ? null : u),
      u !== null && (i.callback = u),
      (n = wn(t, i, e)),
      n !== null && (De(n, t, e), Yi(n, t, e));
  }
  function Bm(t, e) {
    if (((t = t.memoizedState), t !== null && t.dehydrated !== null)) {
      var n = t.retryLane;
      t.retryLane = n !== 0 && n < e ? n : e;
    }
  }
  function Au(t, e) {
    Bm(t, e), (t = t.alternate) && Bm(t, e);
  }
  function Lm(t) {
    if (t.tag === 13) {
      var e = Ua(t, 67108864);
      e !== null && De(e, t, 67108864), Au(t, 67108864);
    }
  }
  var Zs = !0;
  function wb(t, e, n, i) {
    var s = C.T;
    C.T = null;
    var u = H.p;
    try {
      (H.p = 2), Eu(t, e, n, i);
    } finally {
      (H.p = u), (C.T = s);
    }
  }
  function Rb(t, e, n, i) {
    var s = C.T;
    C.T = null;
    var u = H.p;
    try {
      (H.p = 8), Eu(t, e, n, i);
    } finally {
      (H.p = u), (C.T = s);
    }
  }
  function Eu(t, e, n, i) {
    if (Zs) {
      var s = Mu(i);
      if (s === null) fu(t, e, i, Qs, n), Gm(t, i);
      else if (Cb(s, t, e, n, i)) i.stopPropagation();
      else if ((Gm(t, i), e & 4 && -1 < Ob.indexOf(t))) {
        for (; s !== null; ) {
          var u = Aa(s);
          if (u !== null)
            switch (u.tag) {
              case 3:
                if (((u = u.stateNode), u.current.memoizedState.isDehydrated)) {
                  var d = Fn(u.pendingLanes);
                  if (d !== 0) {
                    var y = u;
                    for (y.pendingLanes |= 2, y.entangledLanes |= 2; d; ) {
                      var x = 1 << (31 - be(d));
                      (y.entanglements[1] |= x), (d &= ~x);
                    }
                    Pe(u), (St & 6) === 0 && ((Os = Xe() + 500), ll(0));
                  }
                }
                break;
              case 13:
                (y = Ua(u, 2)), y !== null && De(y, u, 2), Vs(), Au(u, 2);
            }
          if (((u = Mu(i)), u === null && fu(t, e, i, Qs, n), u === s)) break;
          s = u;
        }
        s !== null && i.stopPropagation();
      } else fu(t, e, i, null, n);
    }
  }
  function Mu(t) {
    return (t = Co(t)), Du(t);
  }
  var Qs = null;
  function Du(t) {
    if (((Qs = null), (t = Ta(t)), t !== null)) {
      var e = h(t);
      if (e === null) t = null;
      else {
        var n = e.tag;
        if (n === 13) {
          if (((t = f(e)), t !== null)) return t;
          t = null;
        } else if (n === 3) {
          if (e.stateNode.current.memoizedState.isDehydrated)
            return e.tag === 3 ? e.stateNode.containerInfo : null;
          t = null;
        } else e !== t && (t = null);
      }
    }
    return (Qs = t), null;
  }
  function Hm(t) {
    switch (t) {
      case "beforetoggle":
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "toggle":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (mv()) {
          case $c:
            return 2;
          case Ic:
            return 8;
          case Ll:
          case pv:
            return 32;
          case tf:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var wu = !1,
    Gn = null,
    qn = null,
    Yn = null,
    hl = new Map(),
    ml = new Map(),
    kn = [],
    Ob =
      "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
        " "
      );
  function Gm(t, e) {
    switch (t) {
      case "focusin":
      case "focusout":
        Gn = null;
        break;
      case "dragenter":
      case "dragleave":
        qn = null;
        break;
      case "mouseover":
      case "mouseout":
        Yn = null;
        break;
      case "pointerover":
      case "pointerout":
        hl.delete(e.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        ml.delete(e.pointerId);
    }
  }
  function pl(t, e, n, i, s, u) {
    return t === null || t.nativeEvent !== u
      ? ((t = {
          blockedOn: e,
          domEventName: n,
          eventSystemFlags: i,
          nativeEvent: u,
          targetContainers: [s],
        }),
        e !== null && ((e = Aa(e)), e !== null && Lm(e)),
        t)
      : ((t.eventSystemFlags |= i),
        (e = t.targetContainers),
        s !== null && e.indexOf(s) === -1 && e.push(s),
        t);
  }
  function Cb(t, e, n, i, s) {
    switch (e) {
      case "focusin":
        return (Gn = pl(Gn, t, e, n, i, s)), !0;
      case "dragenter":
        return (qn = pl(qn, t, e, n, i, s)), !0;
      case "mouseover":
        return (Yn = pl(Yn, t, e, n, i, s)), !0;
      case "pointerover":
        var u = s.pointerId;
        return hl.set(u, pl(hl.get(u) || null, t, e, n, i, s)), !0;
      case "gotpointercapture":
        return (
          (u = s.pointerId), ml.set(u, pl(ml.get(u) || null, t, e, n, i, s)), !0
        );
    }
    return !1;
  }
  function qm(t) {
    var e = Ta(t.target);
    if (e !== null) {
      var n = h(e);
      if (n !== null) {
        if (((e = n.tag), e === 13)) {
          if (((e = f(n)), e !== null)) {
            (t.blockedOn = e),
              Av(t.priority, function () {
                if (n.tag === 13) {
                  var i = Me();
                  i = bo(i);
                  var s = Ua(n, i);
                  s !== null && De(s, n, i), Au(n, i);
                }
              });
            return;
          }
        } else if (e === 3 && n.stateNode.current.memoizedState.isDehydrated) {
          t.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
          return;
        }
      }
    }
    t.blockedOn = null;
  }
  function Ks(t) {
    if (t.blockedOn !== null) return !1;
    for (var e = t.targetContainers; 0 < e.length; ) {
      var n = Mu(t.nativeEvent);
      if (n === null) {
        n = t.nativeEvent;
        var i = new n.constructor(n.type, n);
        (Oo = i), n.target.dispatchEvent(i), (Oo = null);
      } else return (e = Aa(n)), e !== null && Lm(e), (t.blockedOn = n), !1;
      e.shift();
    }
    return !0;
  }
  function Ym(t, e, n) {
    Ks(t) && n.delete(e);
  }
  function Vb() {
    (wu = !1),
      Gn !== null && Ks(Gn) && (Gn = null),
      qn !== null && Ks(qn) && (qn = null),
      Yn !== null && Ks(Yn) && (Yn = null),
      hl.forEach(Ym),
      ml.forEach(Ym);
  }
  function Js(t, e) {
    t.blockedOn === e &&
      ((t.blockedOn = null),
      wu ||
        ((wu = !0),
        a.unstable_scheduleCallback(a.unstable_NormalPriority, Vb)));
  }
  var Ps = null;
  function km(t) {
    Ps !== t &&
      ((Ps = t),
      a.unstable_scheduleCallback(a.unstable_NormalPriority, function () {
        Ps === t && (Ps = null);
        for (var e = 0; e < t.length; e += 3) {
          var n = t[e],
            i = t[e + 1],
            s = t[e + 2];
          if (typeof i != "function") {
            if (Du(i || n) === null) continue;
            break;
          }
          var u = Aa(n);
          u !== null &&
            (t.splice(e, 3),
            (e -= 3),
            Dr(u, { pending: !0, data: s, method: n.method, action: i }, i, s));
        }
      }));
  }
  function gl(t) {
    function e(x) {
      return Js(x, t);
    }
    Gn !== null && Js(Gn, t),
      qn !== null && Js(qn, t),
      Yn !== null && Js(Yn, t),
      hl.forEach(e),
      ml.forEach(e);
    for (var n = 0; n < kn.length; n++) {
      var i = kn[n];
      i.blockedOn === t && (i.blockedOn = null);
    }
    for (; 0 < kn.length && ((n = kn[0]), n.blockedOn === null); )
      qm(n), n.blockedOn === null && kn.shift();
    if (((n = (t.ownerDocument || t).$$reactFormReplay), n != null))
      for (i = 0; i < n.length; i += 3) {
        var s = n[i],
          u = n[i + 1],
          d = s[fe] || null;
        if (typeof u == "function") d || km(n);
        else if (d) {
          var y = null;
          if (u && u.hasAttribute("formAction")) {
            if (((s = u), (d = u[fe] || null))) y = d.formAction;
            else if (Du(s) !== null) continue;
          } else y = d.action;
          typeof y == "function" ? (n[i + 1] = y) : (n.splice(i, 3), (i -= 3)),
            km(n);
        }
      }
  }
  function Ru(t) {
    this._internalRoot = t;
  }
  (Fs.prototype.render = Ru.prototype.render =
    function (t) {
      var e = this._internalRoot;
      if (e === null) throw Error(r(409));
      var n = e.current,
        i = Me();
      jm(n, i, t, e, null, null);
    }),
    (Fs.prototype.unmount = Ru.prototype.unmount =
      function () {
        var t = this._internalRoot;
        if (t !== null) {
          this._internalRoot = null;
          var e = t.containerInfo;
          jm(t.current, 2, null, t, null, null), Vs(), (e[Sa] = null);
        }
      });
  function Fs(t) {
    this._internalRoot = t;
  }
  Fs.prototype.unstable_scheduleHydration = function (t) {
    if (t) {
      var e = sf();
      t = { blockedOn: null, target: t, priority: e };
      for (var n = 0; n < kn.length && e !== 0 && e < kn[n].priority; n++);
      kn.splice(n, 0, t), n === 0 && qm(t);
    }
  };
  var Xm = l.version;
  if (Xm !== "19.1.0") throw Error(r(527, Xm, "19.1.0"));
  H.findDOMNode = function (t) {
    var e = t._reactInternals;
    if (e === void 0)
      throw typeof t.render == "function"
        ? Error(r(188))
        : ((t = Object.keys(t).join(",")), Error(r(268, t)));
    return (
      (t = p(e)),
      (t = t !== null ? g(t) : null),
      (t = t === null ? null : t.stateNode),
      t
    );
  };
  var zb = {
    bundleType: 0,
    version: "19.1.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: C,
    reconcilerVersion: "19.1.0",
  };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var Ws = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!Ws.isDisabled && Ws.supportsFiber)
      try {
        (xi = Ws.inject(zb)), (ve = Ws);
      } catch {}
  }
  return (
    (vl.createRoot = function (t, e) {
      if (!c(t)) throw Error(r(299));
      var n = !1,
        i = "",
        s = sh,
        u = oh,
        d = rh,
        y = null;
      return (
        e != null &&
          (e.unstable_strictMode === !0 && (n = !0),
          e.identifierPrefix !== void 0 && (i = e.identifierPrefix),
          e.onUncaughtError !== void 0 && (s = e.onUncaughtError),
          e.onCaughtError !== void 0 && (u = e.onCaughtError),
          e.onRecoverableError !== void 0 && (d = e.onRecoverableError),
          e.unstable_transitionCallbacks !== void 0 &&
            (y = e.unstable_transitionCallbacks)),
        (e = _m(t, 1, !1, null, null, n, i, s, u, d, y, null)),
        (t[Sa] = e.current),
        cu(t),
        new Ru(e)
      );
    }),
    (vl.hydrateRoot = function (t, e, n) {
      if (!c(t)) throw Error(r(299));
      var i = !1,
        s = "",
        u = sh,
        d = oh,
        y = rh,
        x = null,
        D = null;
      return (
        n != null &&
          (n.unstable_strictMode === !0 && (i = !0),
          n.identifierPrefix !== void 0 && (s = n.identifierPrefix),
          n.onUncaughtError !== void 0 && (u = n.onUncaughtError),
          n.onCaughtError !== void 0 && (d = n.onCaughtError),
          n.onRecoverableError !== void 0 && (y = n.onRecoverableError),
          n.unstable_transitionCallbacks !== void 0 &&
            (x = n.unstable_transitionCallbacks),
          n.formState !== void 0 && (D = n.formState)),
        (e = _m(t, 1, !0, e, n ?? null, i, s, u, d, y, x, D)),
        (e.context = Um(null)),
        (n = e.current),
        (i = Me()),
        (i = bo(i)),
        (s = Dn(i)),
        (s.callback = null),
        wn(n, s, i),
        (n = i),
        (e.current.lanes = n),
        Ti(e, n),
        Pe(e),
        (t[Sa] = e.current),
        cu(t),
        new Fs(e)
      );
    }),
    (vl.version = "19.1.0"),
    vl
  );
}
var tp;
function Yb() {
  if (tp) return Vu.exports;
  tp = 1;
  function a() {
    if (
      !(
        typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" ||
        typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"
      )
    )
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(a);
      } catch (l) {
        console.error(l);
      }
  }
  return a(), (Vu.exports = qb()), Vu.exports;
}
var kb = Yb();
const Tg = W.createContext({});
function Xb(a) {
  const l = W.useRef(null);
  return l.current === null && (l.current = a()), l.current;
}
const bc = typeof window < "u",
  Zb = bc ? W.useLayoutEffect : W.useEffect,
  xc = W.createContext(null);
function Sc(a, l) {
  a.indexOf(l) === -1 && a.push(l);
}
function Tc(a, l) {
  const o = a.indexOf(l);
  o > -1 && a.splice(o, 1);
}
const gn = (a, l, o) => (o > l ? l : o < a ? a : o);
let Ac = () => {};
const yn = {},
  Ag = (a) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(a);
function Eg(a) {
  return typeof a == "object" && a !== null;
}
const Mg = (a) => /^0[^.\s]+$/u.test(a);
function Ec(a) {
  let l;
  return () => (l === void 0 && (l = a()), l);
}
const He = (a) => a,
  Qb = (a, l) => (o) => l(a(o)),
  _l = (...a) => a.reduce(Qb),
  wl = (a, l, o) => {
    const r = l - a;
    return r === 0 ? 1 : (o - a) / r;
  };
class Mc {
  constructor() {
    this.subscriptions = [];
  }
  add(l) {
    return Sc(this.subscriptions, l), () => Tc(this.subscriptions, l);
  }
  notify(l, o, r) {
    const c = this.subscriptions.length;
    if (c)
      if (c === 1) this.subscriptions[0](l, o, r);
      else
        for (let h = 0; h < c; h++) {
          const f = this.subscriptions[h];
          f && f(l, o, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const Fe = (a) => a * 1e3,
  We = (a) => a / 1e3;
function Dg(a, l) {
  return l ? a * (1e3 / l) : 0;
}
const wg = (a, l, o) =>
    (((1 - 3 * o + 3 * l) * a + (3 * o - 6 * l)) * a + 3 * l) * a,
  Kb = 1e-7,
  Jb = 12;
function Pb(a, l, o, r, c) {
  let h,
    f,
    m = 0;
  do (f = l + (o - l) / 2), (h = wg(f, r, c) - a), h > 0 ? (o = f) : (l = f);
  while (Math.abs(h) > Kb && ++m < Jb);
  return f;
}
function Ul(a, l, o, r) {
  if (a === l && o === r) return He;
  const c = (h) => Pb(h, 0, 1, a, o);
  return (h) => (h === 0 || h === 1 ? h : wg(c(h), l, r));
}
const Rg = (a) => (l) => l <= 0.5 ? a(2 * l) / 2 : (2 - a(2 * (1 - l))) / 2,
  Og = (a) => (l) => 1 - a(1 - l),
  Cg = Ul(0.33, 1.53, 0.69, 0.99),
  Dc = Og(Cg),
  Vg = Rg(Dc),
  zg = (a) =>
    (a *= 2) < 1 ? 0.5 * Dc(a) : 0.5 * (2 - Math.pow(2, -10 * (a - 1))),
  wc = (a) => 1 - Math.sin(Math.acos(a)),
  Ng = Og(wc),
  _g = Rg(wc),
  Fb = Ul(0.42, 0, 1, 1),
  Wb = Ul(0, 0, 0.58, 1),
  Ug = Ul(0.42, 0, 0.58, 1),
  $b = (a) => Array.isArray(a) && typeof a[0] != "number",
  jg = (a) => Array.isArray(a) && typeof a[0] == "number",
  Ib = {
    linear: He,
    easeIn: Fb,
    easeInOut: Ug,
    easeOut: Wb,
    circIn: wc,
    circInOut: _g,
    circOut: Ng,
    backIn: Dc,
    backInOut: Vg,
    backOut: Cg,
    anticipate: zg,
  },
  t1 = (a) => typeof a == "string",
  ep = (a) => {
    if (jg(a)) {
      Ac(a.length === 4);
      const [l, o, r, c] = a;
      return Ul(l, o, r, c);
    } else if (t1(a)) return Ib[a];
    return a;
  },
  $s = [
    "setup",
    "read",
    "resolveKeyframes",
    "preUpdate",
    "update",
    "preRender",
    "render",
    "postRender",
  ],
  np = { value: null };
function e1(a, l) {
  let o = new Set(),
    r = new Set(),
    c = !1,
    h = !1;
  const f = new WeakSet();
  let m = { delta: 0, timestamp: 0, isProcessing: !1 },
    p = 0;
  function g(b) {
    f.has(b) && (v.schedule(b), a()), p++, b(m);
  }
  const v = {
    schedule: (b, A = !1, O = !1) => {
      const L = O && c ? o : r;
      return A && f.add(b), L.has(b) || L.add(b), b;
    },
    cancel: (b) => {
      r.delete(b), f.delete(b);
    },
    process: (b) => {
      if (((m = b), c)) {
        h = !0;
        return;
      }
      (c = !0),
        ([o, r] = [r, o]),
        o.forEach(g),
        l && np.value && np.value.frameloop[l].push(p),
        (p = 0),
        o.clear(),
        (c = !1),
        h && ((h = !1), v.process(b));
    },
  };
  return v;
}
const n1 = 40;
function Bg(a, l) {
  let o = !1,
    r = !0;
  const c = { delta: 0, timestamp: 0, isProcessing: !1 },
    h = () => (o = !0),
    f = $s.reduce((X, lt) => ((X[lt] = e1(h, l ? lt : void 0)), X), {}),
    {
      setup: m,
      read: p,
      resolveKeyframes: g,
      preUpdate: v,
      update: b,
      preRender: A,
      render: O,
      postRender: B,
    } = f,
    L = () => {
      const X = yn.useManualTiming ? c.timestamp : performance.now();
      (o = !1),
        yn.useManualTiming ||
          (c.delta = r ? 1e3 / 60 : Math.max(Math.min(X - c.timestamp, n1), 1)),
        (c.timestamp = X),
        (c.isProcessing = !0),
        m.process(c),
        p.process(c),
        g.process(c),
        v.process(c),
        b.process(c),
        A.process(c),
        O.process(c),
        B.process(c),
        (c.isProcessing = !1),
        o && l && ((r = !1), a(L));
    },
    Y = () => {
      (o = !0), (r = !0), c.isProcessing || a(L);
    };
  return {
    schedule: $s.reduce((X, lt) => {
      const k = f[lt];
      return (
        (X[lt] = (nt, rt = !1, G = !1) => (o || Y(), k.schedule(nt, rt, G))), X
      );
    }, {}),
    cancel: (X) => {
      for (let lt = 0; lt < $s.length; lt++) f[$s[lt]].cancel(X);
    },
    state: c,
    steps: f,
  };
}
const {
  schedule: _t,
  cancel: Kn,
  state: ee,
  steps: Uu,
} = Bg(typeof requestAnimationFrame < "u" ? requestAnimationFrame : He, !0);
let ao;
function a1() {
  ao = void 0;
}
const ge = {
    now: () => (
      ao === void 0 &&
        ge.set(
          ee.isProcessing || yn.useManualTiming
            ? ee.timestamp
            : performance.now()
        ),
      ao
    ),
    set: (a) => {
      (ao = a), queueMicrotask(a1);
    },
  },
  Lg = (a) => (l) => typeof l == "string" && l.startsWith(a),
  Rc = Lg("--"),
  i1 = Lg("var(--"),
  Oc = (a) => (i1(a) ? l1.test(a.split("/*")[0].trim()) : !1),
  l1 =
    /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu,
  pi = {
    test: (a) => typeof a == "number",
    parse: parseFloat,
    transform: (a) => a,
  },
  Rl = { ...pi, transform: (a) => gn(0, 1, a) },
  Is = { ...pi, default: 1 },
  Tl = (a) => Math.round(a * 1e5) / 1e5,
  Cc = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function s1(a) {
  return a == null;
}
const o1 =
    /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu,
  Vc = (a, l) => (o) =>
    !!(
      (typeof o == "string" && o1.test(o) && o.startsWith(a)) ||
      (l && !s1(o) && Object.prototype.hasOwnProperty.call(o, l))
    ),
  Hg = (a, l, o) => (r) => {
    if (typeof r != "string") return r;
    const [c, h, f, m] = r.match(Cc);
    return {
      [a]: parseFloat(c),
      [l]: parseFloat(h),
      [o]: parseFloat(f),
      alpha: m !== void 0 ? parseFloat(m) : 1,
    };
  },
  r1 = (a) => gn(0, 255, a),
  ju = { ...pi, transform: (a) => Math.round(r1(a)) },
  ya = {
    test: Vc("rgb", "red"),
    parse: Hg("red", "green", "blue"),
    transform: ({ red: a, green: l, blue: o, alpha: r = 1 }) =>
      "rgba(" +
      ju.transform(a) +
      ", " +
      ju.transform(l) +
      ", " +
      ju.transform(o) +
      ", " +
      Tl(Rl.transform(r)) +
      ")",
  };
function u1(a) {
  let l = "",
    o = "",
    r = "",
    c = "";
  return (
    a.length > 5
      ? ((l = a.substring(1, 3)),
        (o = a.substring(3, 5)),
        (r = a.substring(5, 7)),
        (c = a.substring(7, 9)))
      : ((l = a.substring(1, 2)),
        (o = a.substring(2, 3)),
        (r = a.substring(3, 4)),
        (c = a.substring(4, 5)),
        (l += l),
        (o += o),
        (r += r),
        (c += c)),
    {
      red: parseInt(l, 16),
      green: parseInt(o, 16),
      blue: parseInt(r, 16),
      alpha: c ? parseInt(c, 16) / 255 : 1,
    }
  );
}
const Pu = { test: Vc("#"), parse: u1, transform: ya.transform },
  jl = (a) => ({
    test: (l) =>
      typeof l == "string" && l.endsWith(a) && l.split(" ").length === 1,
    parse: parseFloat,
    transform: (l) => `${l}${a}`,
  }),
  Qn = jl("deg"),
  $e = jl("%"),
  it = jl("px"),
  c1 = jl("vh"),
  f1 = jl("vw"),
  ap = {
    ...$e,
    parse: (a) => $e.parse(a) / 100,
    transform: (a) => $e.transform(a * 100),
  },
  ri = {
    test: Vc("hsl", "hue"),
    parse: Hg("hue", "saturation", "lightness"),
    transform: ({ hue: a, saturation: l, lightness: o, alpha: r = 1 }) =>
      "hsla(" +
      Math.round(a) +
      ", " +
      $e.transform(Tl(l)) +
      ", " +
      $e.transform(Tl(o)) +
      ", " +
      Tl(Rl.transform(r)) +
      ")",
  },
  le = {
    test: (a) => ya.test(a) || Pu.test(a) || ri.test(a),
    parse: (a) =>
      ya.test(a) ? ya.parse(a) : ri.test(a) ? ri.parse(a) : Pu.parse(a),
    transform: (a) =>
      typeof a == "string"
        ? a
        : a.hasOwnProperty("red")
        ? ya.transform(a)
        : ri.transform(a),
  },
  d1 =
    /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function h1(a) {
  var l, o;
  return (
    isNaN(a) &&
    typeof a == "string" &&
    (((l = a.match(Cc)) == null ? void 0 : l.length) || 0) +
      (((o = a.match(d1)) == null ? void 0 : o.length) || 0) >
      0
  );
}
const Gg = "number",
  qg = "color",
  m1 = "var",
  p1 = "var(",
  ip = "${}",
  g1 =
    /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function Ol(a) {
  const l = a.toString(),
    o = [],
    r = { color: [], number: [], var: [] },
    c = [];
  let h = 0;
  const m = l
    .replace(
      g1,
      (p) => (
        le.test(p)
          ? (r.color.push(h), c.push(qg), o.push(le.parse(p)))
          : p.startsWith(p1)
          ? (r.var.push(h), c.push(m1), o.push(p))
          : (r.number.push(h), c.push(Gg), o.push(parseFloat(p))),
        ++h,
        ip
      )
    )
    .split(ip);
  return { values: o, split: m, indexes: r, types: c };
}
function Yg(a) {
  return Ol(a).values;
}
function kg(a) {
  const { split: l, types: o } = Ol(a),
    r = l.length;
  return (c) => {
    let h = "";
    for (let f = 0; f < r; f++)
      if (((h += l[f]), c[f] !== void 0)) {
        const m = o[f];
        m === Gg
          ? (h += Tl(c[f]))
          : m === qg
          ? (h += le.transform(c[f]))
          : (h += c[f]);
      }
    return h;
  };
}
const y1 = (a) => (typeof a == "number" ? 0 : a);
function v1(a) {
  const l = Yg(a);
  return kg(a)(l.map(y1));
}
const Jn = {
  test: h1,
  parse: Yg,
  createTransformer: kg,
  getAnimatableNone: v1,
};
function Bu(a, l, o) {
  return (
    o < 0 && (o += 1),
    o > 1 && (o -= 1),
    o < 1 / 6
      ? a + (l - a) * 6 * o
      : o < 1 / 2
      ? l
      : o < 2 / 3
      ? a + (l - a) * (2 / 3 - o) * 6
      : a
  );
}
function b1({ hue: a, saturation: l, lightness: o, alpha: r }) {
  (a /= 360), (l /= 100), (o /= 100);
  let c = 0,
    h = 0,
    f = 0;
  if (!l) c = h = f = o;
  else {
    const m = o < 0.5 ? o * (1 + l) : o + l - o * l,
      p = 2 * o - m;
    (c = Bu(p, m, a + 1 / 3)), (h = Bu(p, m, a)), (f = Bu(p, m, a - 1 / 3));
  }
  return {
    red: Math.round(c * 255),
    green: Math.round(h * 255),
    blue: Math.round(f * 255),
    alpha: r,
  };
}
function oo(a, l) {
  return (o) => (o > 0 ? l : a);
}
const Nt = (a, l, o) => a + (l - a) * o,
  Lu = (a, l, o) => {
    const r = a * a,
      c = o * (l * l - r) + r;
    return c < 0 ? 0 : Math.sqrt(c);
  },
  x1 = [Pu, ya, ri],
  S1 = (a) => x1.find((l) => l.test(a));
function lp(a) {
  const l = S1(a);
  if (!l) return !1;
  let o = l.parse(a);
  return l === ri && (o = b1(o)), o;
}
const sp = (a, l) => {
    const o = lp(a),
      r = lp(l);
    if (!o || !r) return oo(a, l);
    const c = { ...o };
    return (h) => (
      (c.red = Lu(o.red, r.red, h)),
      (c.green = Lu(o.green, r.green, h)),
      (c.blue = Lu(o.blue, r.blue, h)),
      (c.alpha = Nt(o.alpha, r.alpha, h)),
      ya.transform(c)
    );
  },
  Fu = new Set(["none", "hidden"]);
function T1(a, l) {
  return Fu.has(a) ? (o) => (o <= 0 ? a : l) : (o) => (o >= 1 ? l : a);
}
function A1(a, l) {
  return (o) => Nt(a, l, o);
}
function zc(a) {
  return typeof a == "number"
    ? A1
    : typeof a == "string"
    ? Oc(a)
      ? oo
      : le.test(a)
      ? sp
      : D1
    : Array.isArray(a)
    ? Xg
    : typeof a == "object"
    ? le.test(a)
      ? sp
      : E1
    : oo;
}
function Xg(a, l) {
  const o = [...a],
    r = o.length,
    c = a.map((h, f) => zc(h)(h, l[f]));
  return (h) => {
    for (let f = 0; f < r; f++) o[f] = c[f](h);
    return o;
  };
}
function E1(a, l) {
  const o = { ...a, ...l },
    r = {};
  for (const c in o)
    a[c] !== void 0 && l[c] !== void 0 && (r[c] = zc(a[c])(a[c], l[c]));
  return (c) => {
    for (const h in r) o[h] = r[h](c);
    return o;
  };
}
function M1(a, l) {
  const o = [],
    r = { color: 0, var: 0, number: 0 };
  for (let c = 0; c < l.values.length; c++) {
    const h = l.types[c],
      f = a.indexes[h][r[h]],
      m = a.values[f] ?? 0;
    (o[c] = m), r[h]++;
  }
  return o;
}
const D1 = (a, l) => {
  const o = Jn.createTransformer(l),
    r = Ol(a),
    c = Ol(l);
  return r.indexes.var.length === c.indexes.var.length &&
    r.indexes.color.length === c.indexes.color.length &&
    r.indexes.number.length >= c.indexes.number.length
    ? (Fu.has(a) && !c.values.length) || (Fu.has(l) && !r.values.length)
      ? T1(a, l)
      : _l(Xg(M1(r, c), c.values), o)
    : oo(a, l);
};
function Zg(a, l, o) {
  return typeof a == "number" && typeof l == "number" && typeof o == "number"
    ? Nt(a, l, o)
    : zc(a)(a, l);
}
const w1 = (a) => {
    const l = ({ timestamp: o }) => a(o);
    return {
      start: (o = !0) => _t.update(l, o),
      stop: () => Kn(l),
      now: () => (ee.isProcessing ? ee.timestamp : ge.now()),
    };
  },
  Qg = (a, l, o = 10) => {
    let r = "";
    const c = Math.max(Math.round(l / o), 2);
    for (let h = 0; h < c; h++) r += a(h / (c - 1)) + ", ";
    return `linear(${r.substring(0, r.length - 2)})`;
  },
  ro = 2e4;
function Nc(a) {
  let l = 0;
  const o = 50;
  let r = a.next(l);
  for (; !r.done && l < ro; ) (l += o), (r = a.next(l));
  return l >= ro ? 1 / 0 : l;
}
function R1(a, l = 100, o) {
  const r = o({ ...a, keyframes: [0, l] }),
    c = Math.min(Nc(r), ro);
  return {
    type: "keyframes",
    ease: (h) => r.next(c * h).value / l,
    duration: We(c),
  };
}
const O1 = 5;
function Kg(a, l, o) {
  const r = Math.max(l - O1, 0);
  return Dg(o - a(r), l - r);
}
const Lt = {
    stiffness: 100,
    damping: 10,
    mass: 1,
    velocity: 0,
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    restSpeed: { granular: 0.01, default: 2 },
    restDelta: { granular: 0.005, default: 0.5 },
    minDuration: 0.01,
    maxDuration: 10,
    minDamping: 0.05,
    maxDamping: 1,
  },
  op = 0.001;
function C1({
  duration: a = Lt.duration,
  bounce: l = Lt.bounce,
  velocity: o = Lt.velocity,
  mass: r = Lt.mass,
}) {
  let c,
    h,
    f = 1 - l;
  (f = gn(Lt.minDamping, Lt.maxDamping, f)),
    (a = gn(Lt.minDuration, Lt.maxDuration, We(a))),
    f < 1
      ? ((c = (g) => {
          const v = g * f,
            b = v * a,
            A = v - o,
            O = Wu(g, f),
            B = Math.exp(-b);
          return op - (A / O) * B;
        }),
        (h = (g) => {
          const b = g * f * a,
            A = b * o + o,
            O = Math.pow(f, 2) * Math.pow(g, 2) * a,
            B = Math.exp(-b),
            L = Wu(Math.pow(g, 2), f);
          return ((-c(g) + op > 0 ? -1 : 1) * ((A - O) * B)) / L;
        }))
      : ((c = (g) => {
          const v = Math.exp(-g * a),
            b = (g - o) * a + 1;
          return -0.001 + v * b;
        }),
        (h = (g) => {
          const v = Math.exp(-g * a),
            b = (o - g) * (a * a);
          return v * b;
        }));
  const m = 5 / a,
    p = z1(c, h, m);
  if (((a = Fe(a)), isNaN(p)))
    return { stiffness: Lt.stiffness, damping: Lt.damping, duration: a };
  {
    const g = Math.pow(p, 2) * r;
    return { stiffness: g, damping: f * 2 * Math.sqrt(r * g), duration: a };
  }
}
const V1 = 12;
function z1(a, l, o) {
  let r = o;
  for (let c = 1; c < V1; c++) r = r - a(r) / l(r);
  return r;
}
function Wu(a, l) {
  return a * Math.sqrt(1 - l * l);
}
const N1 = ["duration", "bounce"],
  _1 = ["stiffness", "damping", "mass"];
function rp(a, l) {
  return l.some((o) => a[o] !== void 0);
}
function U1(a) {
  let l = {
    velocity: Lt.velocity,
    stiffness: Lt.stiffness,
    damping: Lt.damping,
    mass: Lt.mass,
    isResolvedFromDuration: !1,
    ...a,
  };
  if (!rp(a, _1) && rp(a, N1))
    if (a.visualDuration) {
      const o = a.visualDuration,
        r = (2 * Math.PI) / (o * 1.2),
        c = r * r,
        h = 2 * gn(0.05, 1, 1 - (a.bounce || 0)) * Math.sqrt(c);
      l = { ...l, mass: Lt.mass, stiffness: c, damping: h };
    } else {
      const o = C1(a);
      (l = { ...l, ...o, mass: Lt.mass }), (l.isResolvedFromDuration = !0);
    }
  return l;
}
function uo(a = Lt.visualDuration, l = Lt.bounce) {
  const o =
    typeof a != "object"
      ? { visualDuration: a, keyframes: [0, 1], bounce: l }
      : a;
  let { restSpeed: r, restDelta: c } = o;
  const h = o.keyframes[0],
    f = o.keyframes[o.keyframes.length - 1],
    m = { done: !1, value: h },
    {
      stiffness: p,
      damping: g,
      mass: v,
      duration: b,
      velocity: A,
      isResolvedFromDuration: O,
    } = U1({ ...o, velocity: -We(o.velocity || 0) }),
    B = A || 0,
    L = g / (2 * Math.sqrt(p * v)),
    Y = f - h,
    Z = We(Math.sqrt(p / v)),
    $ = Math.abs(Y) < 5;
  r || (r = $ ? Lt.restSpeed.granular : Lt.restSpeed.default),
    c || (c = $ ? Lt.restDelta.granular : Lt.restDelta.default);
  let X;
  if (L < 1) {
    const k = Wu(Z, L);
    X = (nt) => {
      const rt = Math.exp(-L * Z * nt);
      return (
        f -
        rt * (((B + L * Z * Y) / k) * Math.sin(k * nt) + Y * Math.cos(k * nt))
      );
    };
  } else if (L === 1) X = (k) => f - Math.exp(-Z * k) * (Y + (B + Z * Y) * k);
  else {
    const k = Z * Math.sqrt(L * L - 1);
    X = (nt) => {
      const rt = Math.exp(-L * Z * nt),
        G = Math.min(k * nt, 300);
      return (
        f - (rt * ((B + L * Z * Y) * Math.sinh(G) + k * Y * Math.cosh(G))) / k
      );
    };
  }
  const lt = {
    calculatedDuration: (O && b) || null,
    next: (k) => {
      const nt = X(k);
      if (O) m.done = k >= b;
      else {
        let rt = k === 0 ? B : 0;
        L < 1 && (rt = k === 0 ? Fe(B) : Kg(X, k, nt));
        const G = Math.abs(rt) <= r,
          pt = Math.abs(f - nt) <= c;
        m.done = G && pt;
      }
      return (m.value = m.done ? f : nt), m;
    },
    toString: () => {
      const k = Math.min(Nc(lt), ro),
        nt = Qg((rt) => lt.next(k * rt).value, k, 30);
      return k + "ms " + nt;
    },
    toTransition: () => {},
  };
  return lt;
}
uo.applyToOptions = (a) => {
  const l = R1(a, 100, uo);
  return (
    (a.ease = l.ease), (a.duration = Fe(l.duration)), (a.type = "keyframes"), a
  );
};
function $u({
  keyframes: a,
  velocity: l = 0,
  power: o = 0.8,
  timeConstant: r = 325,
  bounceDamping: c = 10,
  bounceStiffness: h = 500,
  modifyTarget: f,
  min: m,
  max: p,
  restDelta: g = 0.5,
  restSpeed: v,
}) {
  const b = a[0],
    A = { done: !1, value: b },
    O = (G) => (m !== void 0 && G < m) || (p !== void 0 && G > p),
    B = (G) =>
      m === void 0
        ? p
        : p === void 0 || Math.abs(m - G) < Math.abs(p - G)
        ? m
        : p;
  let L = o * l;
  const Y = b + L,
    Z = f === void 0 ? Y : f(Y);
  Z !== Y && (L = Z - b);
  const $ = (G) => -L * Math.exp(-G / r),
    X = (G) => Z + $(G),
    lt = (G) => {
      const pt = $(G),
        Ut = X(G);
      (A.done = Math.abs(pt) <= g), (A.value = A.done ? Z : Ut);
    };
  let k, nt;
  const rt = (G) => {
    O(A.value) &&
      ((k = G),
      (nt = uo({
        keyframes: [A.value, B(A.value)],
        velocity: Kg(X, G, A.value),
        damping: c,
        stiffness: h,
        restDelta: g,
        restSpeed: v,
      })));
  };
  return (
    rt(0),
    {
      calculatedDuration: null,
      next: (G) => {
        let pt = !1;
        return (
          !nt && k === void 0 && ((pt = !0), lt(G), rt(G)),
          k !== void 0 && G >= k ? nt.next(G - k) : (!pt && lt(G), A)
        );
      },
    }
  );
}
function j1(a, l, o) {
  const r = [],
    c = o || yn.mix || Zg,
    h = a.length - 1;
  for (let f = 0; f < h; f++) {
    let m = c(a[f], a[f + 1]);
    if (l) {
      const p = Array.isArray(l) ? l[f] || He : l;
      m = _l(p, m);
    }
    r.push(m);
  }
  return r;
}
function B1(a, l, { clamp: o = !0, ease: r, mixer: c } = {}) {
  const h = a.length;
  if ((Ac(h === l.length), h === 1)) return () => l[0];
  if (h === 2 && l[0] === l[1]) return () => l[1];
  const f = a[0] === a[1];
  a[0] > a[h - 1] && ((a = [...a].reverse()), (l = [...l].reverse()));
  const m = j1(l, r, c),
    p = m.length,
    g = (v) => {
      if (f && v < a[0]) return l[0];
      let b = 0;
      if (p > 1) for (; b < a.length - 2 && !(v < a[b + 1]); b++);
      const A = wl(a[b], a[b + 1], v);
      return m[b](A);
    };
  return o ? (v) => g(gn(a[0], a[h - 1], v)) : g;
}
function L1(a, l) {
  const o = a[a.length - 1];
  for (let r = 1; r <= l; r++) {
    const c = wl(0, l, r);
    a.push(Nt(o, 1, c));
  }
}
function H1(a) {
  const l = [0];
  return L1(l, a.length - 1), l;
}
function G1(a, l) {
  return a.map((o) => o * l);
}
function q1(a, l) {
  return a.map(() => l || Ug).splice(0, a.length - 1);
}
function Al({
  duration: a = 300,
  keyframes: l,
  times: o,
  ease: r = "easeInOut",
}) {
  const c = $b(r) ? r.map(ep) : ep(r),
    h = { done: !1, value: l[0] },
    f = G1(o && o.length === l.length ? o : H1(l), a),
    m = B1(f, l, { ease: Array.isArray(c) ? c : q1(l, c) });
  return {
    calculatedDuration: a,
    next: (p) => ((h.value = m(p)), (h.done = p >= a), h),
  };
}
const Y1 = (a) => a !== null;
function _c(a, { repeat: l, repeatType: o = "loop" }, r, c = 1) {
  const h = a.filter(Y1),
    m = c < 0 || (l && o !== "loop" && l % 2 === 1) ? 0 : h.length - 1;
  return !m || r === void 0 ? h[m] : r;
}
const k1 = { decay: $u, inertia: $u, tween: Al, keyframes: Al, spring: uo };
function Jg(a) {
  typeof a.type == "string" && (a.type = k1[a.type]);
}
class Uc {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((l) => {
      this.resolve = l;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  then(l, o) {
    return this.finished.then(l, o);
  }
}
const X1 = (a) => a / 100;
class jc extends Uc {
  constructor(l) {
    super(),
      (this.state = "idle"),
      (this.startTime = null),
      (this.isStopped = !1),
      (this.currentTime = 0),
      (this.holdTime = null),
      (this.playbackSpeed = 1),
      (this.stop = () => {
        var r, c;
        const { motionValue: o } = this.options;
        o && o.updatedAt !== ge.now() && this.tick(ge.now()),
          (this.isStopped = !0),
          this.state !== "idle" &&
            (this.teardown(),
            (c = (r = this.options).onStop) == null || c.call(r));
      }),
      (this.options = l),
      this.initAnimation(),
      this.play(),
      l.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const { options: l } = this;
    Jg(l);
    const {
      type: o = Al,
      repeat: r = 0,
      repeatDelay: c = 0,
      repeatType: h,
      velocity: f = 0,
    } = l;
    let { keyframes: m } = l;
    const p = o || Al;
    p !== Al &&
      typeof m[0] != "number" &&
      ((this.mixKeyframes = _l(X1, Zg(m[0], m[1]))), (m = [0, 100]));
    const g = p({ ...l, keyframes: m });
    h === "mirror" &&
      (this.mirroredGenerator = p({
        ...l,
        keyframes: [...m].reverse(),
        velocity: -f,
      })),
      g.calculatedDuration === null && (g.calculatedDuration = Nc(g));
    const { calculatedDuration: v } = g;
    (this.calculatedDuration = v),
      (this.resolvedDuration = v + c),
      (this.totalDuration = this.resolvedDuration * (r + 1) - c),
      (this.generator = g);
  }
  updateTime(l) {
    const o = Math.round(l - this.startTime) * this.playbackSpeed;
    this.holdTime !== null
      ? (this.currentTime = this.holdTime)
      : (this.currentTime = o);
  }
  tick(l, o = !1) {
    const {
      generator: r,
      totalDuration: c,
      mixKeyframes: h,
      mirroredGenerator: f,
      resolvedDuration: m,
      calculatedDuration: p,
    } = this;
    if (this.startTime === null) return r.next(0);
    const {
      delay: g = 0,
      keyframes: v,
      repeat: b,
      repeatType: A,
      repeatDelay: O,
      type: B,
      onUpdate: L,
      finalKeyframe: Y,
    } = this.options;
    this.speed > 0
      ? (this.startTime = Math.min(this.startTime, l))
      : this.speed < 0 &&
        (this.startTime = Math.min(l - c / this.speed, this.startTime)),
      o ? (this.currentTime = l) : this.updateTime(l);
    const Z = this.currentTime - g * (this.playbackSpeed >= 0 ? 1 : -1),
      $ = this.playbackSpeed >= 0 ? Z < 0 : Z > c;
    (this.currentTime = Math.max(Z, 0)),
      this.state === "finished" &&
        this.holdTime === null &&
        (this.currentTime = c);
    let X = this.currentTime,
      lt = r;
    if (b) {
      const G = Math.min(this.currentTime, c) / m;
      let pt = Math.floor(G),
        Ut = G % 1;
      !Ut && G >= 1 && (Ut = 1),
        Ut === 1 && pt--,
        (pt = Math.min(pt, b + 1)),
        !!(pt % 2) &&
          (A === "reverse"
            ? ((Ut = 1 - Ut), O && (Ut -= O / m))
            : A === "mirror" && (lt = f)),
        (X = gn(0, 1, Ut) * m);
    }
    const k = $ ? { done: !1, value: v[0] } : lt.next(X);
    h && (k.value = h(k.value));
    let { done: nt } = k;
    !$ &&
      p !== null &&
      (nt =
        this.playbackSpeed >= 0
          ? this.currentTime >= c
          : this.currentTime <= 0);
    const rt =
      this.holdTime === null &&
      (this.state === "finished" || (this.state === "running" && nt));
    return (
      rt && B !== $u && (k.value = _c(v, this.options, Y, this.speed)),
      L && L(k.value),
      rt && this.finish(),
      k
    );
  }
  then(l, o) {
    return this.finished.then(l, o);
  }
  get duration() {
    return We(this.calculatedDuration);
  }
  get time() {
    return We(this.currentTime);
  }
  set time(l) {
    var o;
    (l = Fe(l)),
      (this.currentTime = l),
      this.startTime === null ||
      this.holdTime !== null ||
      this.playbackSpeed === 0
        ? (this.holdTime = l)
        : this.driver &&
          (this.startTime = this.driver.now() - l / this.playbackSpeed),
      (o = this.driver) == null || o.start(!1);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(l) {
    this.updateTime(ge.now());
    const o = this.playbackSpeed !== l;
    (this.playbackSpeed = l), o && (this.time = We(this.currentTime));
  }
  play() {
    var c, h;
    if (this.isStopped) return;
    const { driver: l = w1, startTime: o } = this.options;
    this.driver || (this.driver = l((f) => this.tick(f))),
      (h = (c = this.options).onPlay) == null || h.call(c);
    const r = this.driver.now();
    this.state === "finished"
      ? (this.updateFinished(), (this.startTime = r))
      : this.holdTime !== null
      ? (this.startTime = r - this.holdTime)
      : this.startTime || (this.startTime = o ?? r),
      this.state === "finished" &&
        this.speed < 0 &&
        (this.startTime += this.calculatedDuration),
      (this.holdTime = null),
      (this.state = "running"),
      this.driver.start();
  }
  pause() {
    (this.state = "paused"),
      this.updateTime(ge.now()),
      (this.holdTime = this.currentTime);
  }
  complete() {
    this.state !== "running" && this.play(),
      (this.state = "finished"),
      (this.holdTime = null);
  }
  finish() {
    var l, o;
    this.notifyFinished(),
      this.teardown(),
      (this.state = "finished"),
      (o = (l = this.options).onComplete) == null || o.call(l);
  }
  cancel() {
    var l, o;
    (this.holdTime = null),
      (this.startTime = 0),
      this.tick(0),
      this.teardown(),
      (o = (l = this.options).onCancel) == null || o.call(l);
  }
  teardown() {
    (this.state = "idle"),
      this.stopDriver(),
      (this.startTime = this.holdTime = null);
  }
  stopDriver() {
    this.driver && (this.driver.stop(), (this.driver = void 0));
  }
  sample(l) {
    return (this.startTime = 0), this.tick(l, !0);
  }
  attachTimeline(l) {
    var o;
    return (
      this.options.allowFlatten &&
        ((this.options.type = "keyframes"),
        (this.options.ease = "linear"),
        this.initAnimation()),
      (o = this.driver) == null || o.stop(),
      l.observe(this)
    );
  }
}
function Z1(a) {
  for (let l = 1; l < a.length; l++) a[l] ?? (a[l] = a[l - 1]);
}
const va = (a) => (a * 180) / Math.PI,
  Iu = (a) => {
    const l = va(Math.atan2(a[1], a[0]));
    return tc(l);
  },
  Q1 = {
    x: 4,
    y: 5,
    translateX: 4,
    translateY: 5,
    scaleX: 0,
    scaleY: 3,
    scale: (a) => (Math.abs(a[0]) + Math.abs(a[3])) / 2,
    rotate: Iu,
    rotateZ: Iu,
    skewX: (a) => va(Math.atan(a[1])),
    skewY: (a) => va(Math.atan(a[2])),
    skew: (a) => (Math.abs(a[1]) + Math.abs(a[2])) / 2,
  },
  tc = (a) => ((a = a % 360), a < 0 && (a += 360), a),
  up = Iu,
  cp = (a) => Math.sqrt(a[0] * a[0] + a[1] * a[1]),
  fp = (a) => Math.sqrt(a[4] * a[4] + a[5] * a[5]),
  K1 = {
    x: 12,
    y: 13,
    z: 14,
    translateX: 12,
    translateY: 13,
    translateZ: 14,
    scaleX: cp,
    scaleY: fp,
    scale: (a) => (cp(a) + fp(a)) / 2,
    rotateX: (a) => tc(va(Math.atan2(a[6], a[5]))),
    rotateY: (a) => tc(va(Math.atan2(-a[2], a[0]))),
    rotateZ: up,
    rotate: up,
    skewX: (a) => va(Math.atan(a[4])),
    skewY: (a) => va(Math.atan(a[1])),
    skew: (a) => (Math.abs(a[1]) + Math.abs(a[4])) / 2,
  };
function ec(a) {
  return a.includes("scale") ? 1 : 0;
}
function nc(a, l) {
  if (!a || a === "none") return ec(l);
  const o = a.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let r, c;
  if (o) (r = K1), (c = o);
  else {
    const m = a.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    (r = Q1), (c = m);
  }
  if (!c) return ec(l);
  const h = r[l],
    f = c[1].split(",").map(P1);
  return typeof h == "function" ? h(f) : f[h];
}
const J1 = (a, l) => {
  const { transform: o = "none" } = getComputedStyle(a);
  return nc(o, l);
};
function P1(a) {
  return parseFloat(a.trim());
}
const gi = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY",
  ],
  yi = new Set(gi),
  dp = (a) => a === pi || a === it,
  F1 = new Set(["x", "y", "z"]),
  W1 = gi.filter((a) => !F1.has(a));
function $1(a) {
  const l = [];
  return (
    W1.forEach((o) => {
      const r = a.getValue(o);
      r !== void 0 &&
        (l.push([o, r.get()]), r.set(o.startsWith("scale") ? 1 : 0));
    }),
    l
  );
}
const ba = {
  width: ({ x: a }, { paddingLeft: l = "0", paddingRight: o = "0" }) =>
    a.max - a.min - parseFloat(l) - parseFloat(o),
  height: ({ y: a }, { paddingTop: l = "0", paddingBottom: o = "0" }) =>
    a.max - a.min - parseFloat(l) - parseFloat(o),
  top: (a, { top: l }) => parseFloat(l),
  left: (a, { left: l }) => parseFloat(l),
  bottom: ({ y: a }, { top: l }) => parseFloat(l) + (a.max - a.min),
  right: ({ x: a }, { left: l }) => parseFloat(l) + (a.max - a.min),
  x: (a, { transform: l }) => nc(l, "x"),
  y: (a, { transform: l }) => nc(l, "y"),
};
ba.translateX = ba.x;
ba.translateY = ba.y;
const xa = new Set();
let ac = !1,
  ic = !1,
  lc = !1;
function Pg() {
  if (ic) {
    const a = Array.from(xa).filter((r) => r.needsMeasurement),
      l = new Set(a.map((r) => r.element)),
      o = new Map();
    l.forEach((r) => {
      const c = $1(r);
      c.length && (o.set(r, c), r.render());
    }),
      a.forEach((r) => r.measureInitialState()),
      l.forEach((r) => {
        r.render();
        const c = o.get(r);
        c &&
          c.forEach(([h, f]) => {
            var m;
            (m = r.getValue(h)) == null || m.set(f);
          });
      }),
      a.forEach((r) => r.measureEndState()),
      a.forEach((r) => {
        r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
      });
  }
  (ic = !1), (ac = !1), xa.forEach((a) => a.complete(lc)), xa.clear();
}
function Fg() {
  xa.forEach((a) => {
    a.readKeyframes(), a.needsMeasurement && (ic = !0);
  });
}
function I1() {
  (lc = !0), Fg(), Pg(), (lc = !1);
}
class Bc {
  constructor(l, o, r, c, h, f = !1) {
    (this.state = "pending"),
      (this.isAsync = !1),
      (this.needsMeasurement = !1),
      (this.unresolvedKeyframes = [...l]),
      (this.onComplete = o),
      (this.name = r),
      (this.motionValue = c),
      (this.element = h),
      (this.isAsync = f);
  }
  scheduleResolve() {
    (this.state = "scheduled"),
      this.isAsync
        ? (xa.add(this),
          ac || ((ac = !0), _t.read(Fg), _t.resolveKeyframes(Pg)))
        : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const {
      unresolvedKeyframes: l,
      name: o,
      element: r,
      motionValue: c,
    } = this;
    if (l[0] === null) {
      const h = c == null ? void 0 : c.get(),
        f = l[l.length - 1];
      if (h !== void 0) l[0] = h;
      else if (r && o) {
        const m = r.readValue(o, f);
        m != null && (l[0] = m);
      }
      l[0] === void 0 && (l[0] = f), c && h === void 0 && c.set(l[0]);
    }
    Z1(l);
  }
  setFinalKeyframe() {}
  measureInitialState() {}
  renderEndStyles() {}
  measureEndState() {}
  complete(l = !1) {
    (this.state = "complete"),
      this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, l),
      xa.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (xa.delete(this), (this.state = "pending"));
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const tx = (a) => a.startsWith("--");
function ex(a, l, o) {
  tx(l) ? a.style.setProperty(l, o) : (a.style[l] = o);
}
const nx = Ec(() => window.ScrollTimeline !== void 0),
  ax = {};
function ix(a, l) {
  const o = Ec(a);
  return () => ax[l] ?? o();
}
const Wg = ix(() => {
    try {
      document
        .createElement("div")
        .animate({ opacity: 0 }, { easing: "linear(0, 1)" });
    } catch {
      return !1;
    }
    return !0;
  }, "linearEasing"),
  Sl = ([a, l, o, r]) => `cubic-bezier(${a}, ${l}, ${o}, ${r})`,
  hp = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: Sl([0, 0.65, 0.55, 1]),
    circOut: Sl([0.55, 0, 1, 0.45]),
    backIn: Sl([0.31, 0.01, 0.66, -0.59]),
    backOut: Sl([0.33, 1.53, 0.69, 0.99]),
  };
function $g(a, l) {
  if (a)
    return typeof a == "function"
      ? Wg()
        ? Qg(a, l)
        : "ease-out"
      : jg(a)
      ? Sl(a)
      : Array.isArray(a)
      ? a.map((o) => $g(o, l) || hp.easeOut)
      : hp[a];
}
function lx(
  a,
  l,
  o,
  {
    delay: r = 0,
    duration: c = 300,
    repeat: h = 0,
    repeatType: f = "loop",
    ease: m = "easeOut",
    times: p,
  } = {},
  g = void 0
) {
  const v = { [l]: o };
  p && (v.offset = p);
  const b = $g(m, c);
  Array.isArray(b) && (v.easing = b);
  const A = {
    delay: r,
    duration: c,
    easing: Array.isArray(b) ? "linear" : b,
    fill: "both",
    iterations: h + 1,
    direction: f === "reverse" ? "alternate" : "normal",
  };
  return g && (A.pseudoElement = g), a.animate(v, A);
}
function Ig(a) {
  return typeof a == "function" && "applyToOptions" in a;
}
function sx({ type: a, ...l }) {
  return Ig(a) && Wg()
    ? a.applyToOptions(l)
    : (l.duration ?? (l.duration = 300), l.ease ?? (l.ease = "easeOut"), l);
}
class ox extends Uc {
  constructor(l) {
    if ((super(), (this.finishedTime = null), (this.isStopped = !1), !l))
      return;
    const {
      element: o,
      name: r,
      keyframes: c,
      pseudoElement: h,
      allowFlatten: f = !1,
      finalKeyframe: m,
      onComplete: p,
    } = l;
    (this.isPseudoElement = !!h),
      (this.allowFlatten = f),
      (this.options = l),
      Ac(typeof l.type != "string");
    const g = sx(l);
    (this.animation = lx(o, r, c, g, h)),
      g.autoplay === !1 && this.animation.pause(),
      (this.animation.onfinish = () => {
        if (((this.finishedTime = this.time), !h)) {
          const v = _c(c, this.options, m, this.speed);
          this.updateMotionValue ? this.updateMotionValue(v) : ex(o, r, v),
            this.animation.cancel();
        }
        p == null || p(), this.notifyFinished();
      });
  }
  play() {
    this.isStopped ||
      (this.animation.play(),
      this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    var l, o;
    (o = (l = this.animation).finish) == null || o.call(l);
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {}
  }
  stop() {
    if (this.isStopped) return;
    this.isStopped = !0;
    const { state: l } = this;
    l === "idle" ||
      l === "finished" ||
      (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(),
      this.isPseudoElement || this.cancel());
  }
  commitStyles() {
    var l, o;
    this.isPseudoElement ||
      (o = (l = this.animation).commitStyles) == null ||
      o.call(l);
  }
  get duration() {
    var o, r;
    const l =
      ((r =
        (o = this.animation.effect) == null ? void 0 : o.getComputedTiming) ==
      null
        ? void 0
        : r.call(o).duration) || 0;
    return We(Number(l));
  }
  get time() {
    return We(Number(this.animation.currentTime) || 0);
  }
  set time(l) {
    (this.finishedTime = null), (this.animation.currentTime = Fe(l));
  }
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(l) {
    l < 0 && (this.finishedTime = null), (this.animation.playbackRate = l);
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return Number(this.animation.startTime);
  }
  set startTime(l) {
    this.animation.startTime = l;
  }
  attachTimeline({ timeline: l, observe: o }) {
    var r;
    return (
      this.allowFlatten &&
        ((r = this.animation.effect) == null ||
          r.updateTiming({ easing: "linear" })),
      (this.animation.onfinish = null),
      l && nx() ? ((this.animation.timeline = l), He) : o(this)
    );
  }
}
const ty = { anticipate: zg, backInOut: Vg, circInOut: _g };
function rx(a) {
  return a in ty;
}
function ux(a) {
  typeof a.ease == "string" && rx(a.ease) && (a.ease = ty[a.ease]);
}
const mp = 10;
class cx extends ox {
  constructor(l) {
    ux(l),
      Jg(l),
      super(l),
      l.startTime && (this.startTime = l.startTime),
      (this.options = l);
  }
  updateMotionValue(l) {
    const {
      motionValue: o,
      onUpdate: r,
      onComplete: c,
      element: h,
      ...f
    } = this.options;
    if (!o) return;
    if (l !== void 0) {
      o.set(l);
      return;
    }
    const m = new jc({ ...f, autoplay: !1 }),
      p = Fe(this.finishedTime ?? this.time);
    o.setWithVelocity(m.sample(p - mp).value, m.sample(p).value, mp), m.stop();
  }
}
const pp = (a, l) =>
  l === "zIndex"
    ? !1
    : !!(
        typeof a == "number" ||
        Array.isArray(a) ||
        (typeof a == "string" &&
          (Jn.test(a) || a === "0") &&
          !a.startsWith("url("))
      );
function fx(a) {
  const l = a[0];
  if (a.length === 1) return !0;
  for (let o = 0; o < a.length; o++) if (a[o] !== l) return !0;
}
function dx(a, l, o, r) {
  const c = a[0];
  if (c === null) return !1;
  if (l === "display" || l === "visibility") return !0;
  const h = a[a.length - 1],
    f = pp(c, l),
    m = pp(h, l);
  return !f || !m ? !1 : fx(a) || ((o === "spring" || Ig(o)) && r);
}
function ey(a) {
  return Eg(a) && "offsetHeight" in a;
}
const hx = new Set(["opacity", "clipPath", "filter", "transform"]),
  mx = Ec(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function px(a) {
  var g;
  const {
    motionValue: l,
    name: o,
    repeatDelay: r,
    repeatType: c,
    damping: h,
    type: f,
  } = a;
  if (!ey((g = l == null ? void 0 : l.owner) == null ? void 0 : g.current))
    return !1;
  const { onUpdate: m, transformTemplate: p } = l.owner.getProps();
  return (
    mx() &&
    o &&
    hx.has(o) &&
    (o !== "transform" || !p) &&
    !m &&
    !r &&
    c !== "mirror" &&
    h !== 0 &&
    f !== "inertia"
  );
}
const gx = 40;
class yx extends Uc {
  constructor({
    autoplay: l = !0,
    delay: o = 0,
    type: r = "keyframes",
    repeat: c = 0,
    repeatDelay: h = 0,
    repeatType: f = "loop",
    keyframes: m,
    name: p,
    motionValue: g,
    element: v,
    ...b
  }) {
    var B;
    super(),
      (this.stop = () => {
        var L, Y;
        this._animation &&
          (this._animation.stop(),
          (L = this.stopTimeline) == null || L.call(this)),
          (Y = this.keyframeResolver) == null || Y.cancel();
      }),
      (this.createdAt = ge.now());
    const A = {
        autoplay: l,
        delay: o,
        type: r,
        repeat: c,
        repeatDelay: h,
        repeatType: f,
        name: p,
        motionValue: g,
        element: v,
        ...b,
      },
      O = (v == null ? void 0 : v.KeyframeResolver) || Bc;
    (this.keyframeResolver = new O(
      m,
      (L, Y, Z) => this.onKeyframesResolved(L, Y, A, !Z),
      p,
      g,
      v
    )),
      (B = this.keyframeResolver) == null || B.scheduleResolve();
  }
  onKeyframesResolved(l, o, r, c) {
    this.keyframeResolver = void 0;
    const {
      name: h,
      type: f,
      velocity: m,
      delay: p,
      isHandoff: g,
      onUpdate: v,
    } = r;
    (this.resolvedAt = ge.now()),
      dx(l, h, f, m) ||
        ((yn.instantAnimations || !p) && (v == null || v(_c(l, r, o))),
        (l[0] = l[l.length - 1]),
        (r.duration = 0),
        (r.repeat = 0));
    const A = {
        startTime: c
          ? this.resolvedAt
            ? this.resolvedAt - this.createdAt > gx
              ? this.resolvedAt
              : this.createdAt
            : this.createdAt
          : void 0,
        finalKeyframe: o,
        ...r,
        keyframes: l,
      },
      O =
        !g && px(A)
          ? new cx({ ...A, element: A.motionValue.owner.current })
          : new jc(A);
    O.finished.then(() => this.notifyFinished()).catch(He),
      this.pendingTimeline &&
        ((this.stopTimeline = O.attachTimeline(this.pendingTimeline)),
        (this.pendingTimeline = void 0)),
      (this._animation = O);
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(l, o) {
    return this.finished.finally(l).then(() => {});
  }
  get animation() {
    var l;
    return (
      this._animation ||
        ((l = this.keyframeResolver) == null || l.resume(), I1()),
      this._animation
    );
  }
  get duration() {
    return this.animation.duration;
  }
  get time() {
    return this.animation.time;
  }
  set time(l) {
    this.animation.time = l;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(l) {
    this.animation.speed = l;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(l) {
    return (
      this._animation
        ? (this.stopTimeline = this.animation.attachTimeline(l))
        : (this.pendingTimeline = l),
      () => this.stop()
    );
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    var l;
    this._animation && this.animation.cancel(),
      (l = this.keyframeResolver) == null || l.cancel();
  }
}
const vx = /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function bx(a) {
  const l = vx.exec(a);
  if (!l) return [,];
  const [, o, r, c] = l;
  return [`--${o ?? r}`, c];
}
function ny(a, l, o = 1) {
  const [r, c] = bx(a);
  if (!r) return;
  const h = window.getComputedStyle(l).getPropertyValue(r);
  if (h) {
    const f = h.trim();
    return Ag(f) ? parseFloat(f) : f;
  }
  return Oc(c) ? ny(c, l, o + 1) : c;
}
function Lc(a, l) {
  return (a == null ? void 0 : a[l]) ?? (a == null ? void 0 : a.default) ?? a;
}
const ay = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    ...gi,
  ]),
  xx = { test: (a) => a === "auto", parse: (a) => a },
  iy = (a) => (l) => l.test(a),
  ly = [pi, it, $e, Qn, f1, c1, xx],
  gp = (a) => ly.find(iy(a));
function Sx(a) {
  return typeof a == "number"
    ? a === 0
    : a !== null
    ? a === "none" || a === "0" || Mg(a)
    : !0;
}
const Tx = new Set(["brightness", "contrast", "saturate", "opacity"]);
function Ax(a) {
  const [l, o] = a.slice(0, -1).split("(");
  if (l === "drop-shadow") return a;
  const [r] = o.match(Cc) || [];
  if (!r) return a;
  const c = o.replace(r, "");
  let h = Tx.has(l) ? 1 : 0;
  return r !== o && (h *= 100), l + "(" + h + c + ")";
}
const Ex = /\b([a-z-]*)\(.*?\)/gu,
  sc = {
    ...Jn,
    getAnimatableNone: (a) => {
      const l = a.match(Ex);
      return l ? l.map(Ax).join(" ") : a;
    },
  },
  yp = { ...pi, transform: Math.round },
  Mx = {
    rotate: Qn,
    rotateX: Qn,
    rotateY: Qn,
    rotateZ: Qn,
    scale: Is,
    scaleX: Is,
    scaleY: Is,
    scaleZ: Is,
    skew: Qn,
    skewX: Qn,
    skewY: Qn,
    distance: it,
    translateX: it,
    translateY: it,
    translateZ: it,
    x: it,
    y: it,
    z: it,
    perspective: it,
    transformPerspective: it,
    opacity: Rl,
    originX: ap,
    originY: ap,
    originZ: it,
  },
  Hc = {
    borderWidth: it,
    borderTopWidth: it,
    borderRightWidth: it,
    borderBottomWidth: it,
    borderLeftWidth: it,
    borderRadius: it,
    radius: it,
    borderTopLeftRadius: it,
    borderTopRightRadius: it,
    borderBottomRightRadius: it,
    borderBottomLeftRadius: it,
    width: it,
    maxWidth: it,
    height: it,
    maxHeight: it,
    top: it,
    right: it,
    bottom: it,
    left: it,
    padding: it,
    paddingTop: it,
    paddingRight: it,
    paddingBottom: it,
    paddingLeft: it,
    margin: it,
    marginTop: it,
    marginRight: it,
    marginBottom: it,
    marginLeft: it,
    backgroundPositionX: it,
    backgroundPositionY: it,
    ...Mx,
    zIndex: yp,
    fillOpacity: Rl,
    strokeOpacity: Rl,
    numOctaves: yp,
  },
  Dx = {
    ...Hc,
    color: le,
    backgroundColor: le,
    outlineColor: le,
    fill: le,
    stroke: le,
    borderColor: le,
    borderTopColor: le,
    borderRightColor: le,
    borderBottomColor: le,
    borderLeftColor: le,
    filter: sc,
    WebkitFilter: sc,
  },
  sy = (a) => Dx[a];
function oy(a, l) {
  let o = sy(a);
  return (
    o !== sc && (o = Jn), o.getAnimatableNone ? o.getAnimatableNone(l) : void 0
  );
}
const wx = new Set(["auto", "none", "0"]);
function Rx(a, l, o) {
  let r = 0,
    c;
  for (; r < a.length && !c; ) {
    const h = a[r];
    typeof h == "string" && !wx.has(h) && Ol(h).values.length && (c = a[r]),
      r++;
  }
  if (c && o) for (const h of l) a[h] = oy(o, c);
}
class Ox extends Bc {
  constructor(l, o, r, c, h) {
    super(l, o, r, c, h, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: l, element: o, name: r } = this;
    if (!o || !o.current) return;
    super.readKeyframes();
    for (let p = 0; p < l.length; p++) {
      let g = l[p];
      if (typeof g == "string" && ((g = g.trim()), Oc(g))) {
        const v = ny(g, o.current);
        v !== void 0 && (l[p] = v),
          p === l.length - 1 && (this.finalKeyframe = g);
      }
    }
    if ((this.resolveNoneKeyframes(), !ay.has(r) || l.length !== 2)) return;
    const [c, h] = l,
      f = gp(c),
      m = gp(h);
    if (f !== m)
      if (dp(f) && dp(m))
        for (let p = 0; p < l.length; p++) {
          const g = l[p];
          typeof g == "string" && (l[p] = parseFloat(g));
        }
      else ba[r] && (this.needsMeasurement = !0);
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: l, name: o } = this,
      r = [];
    for (let c = 0; c < l.length; c++) (l[c] === null || Sx(l[c])) && r.push(c);
    r.length && Rx(l, r, o);
  }
  measureInitialState() {
    const { element: l, unresolvedKeyframes: o, name: r } = this;
    if (!l || !l.current) return;
    r === "height" && (this.suspendedScrollY = window.pageYOffset),
      (this.measuredOrigin = ba[r](
        l.measureViewportBox(),
        window.getComputedStyle(l.current)
      )),
      (o[0] = this.measuredOrigin);
    const c = o[o.length - 1];
    c !== void 0 && l.getValue(r, c).jump(c, !1);
  }
  measureEndState() {
    var m;
    const { element: l, name: o, unresolvedKeyframes: r } = this;
    if (!l || !l.current) return;
    const c = l.getValue(o);
    c && c.jump(this.measuredOrigin, !1);
    const h = r.length - 1,
      f = r[h];
    (r[h] = ba[o](l.measureViewportBox(), window.getComputedStyle(l.current))),
      f !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = f),
      (m = this.removedTransforms) != null &&
        m.length &&
        this.removedTransforms.forEach(([p, g]) => {
          l.getValue(p).set(g);
        }),
      this.resolveNoneKeyframes();
  }
}
function Cx(a, l, o) {
  if (a instanceof EventTarget) return [a];
  if (typeof a == "string") {
    let r = document;
    const c = (o == null ? void 0 : o[a]) ?? r.querySelectorAll(a);
    return c ? Array.from(c) : [];
  }
  return Array.from(a);
}
const ry = (a, l) => (l && typeof a == "number" ? l.transform(a) : a),
  vp = 30,
  Vx = (a) => !isNaN(parseFloat(a));
class zx {
  constructor(l, o = {}) {
    (this.canTrackVelocity = null),
      (this.events = {}),
      (this.updateAndNotify = (r, c = !0) => {
        var f, m;
        const h = ge.now();
        if (
          (this.updatedAt !== h && this.setPrevFrameValue(),
          (this.prev = this.current),
          this.setCurrent(r),
          this.current !== this.prev &&
            ((f = this.events.change) == null || f.notify(this.current),
            this.dependents))
        )
          for (const p of this.dependents) p.dirty();
        c &&
          ((m = this.events.renderRequest) == null || m.notify(this.current));
      }),
      (this.hasAnimated = !1),
      this.setCurrent(l),
      (this.owner = o.owner);
  }
  setCurrent(l) {
    (this.current = l),
      (this.updatedAt = ge.now()),
      this.canTrackVelocity === null &&
        l !== void 0 &&
        (this.canTrackVelocity = Vx(this.current));
  }
  setPrevFrameValue(l = this.current) {
    (this.prevFrameValue = l), (this.prevUpdatedAt = this.updatedAt);
  }
  onChange(l) {
    return this.on("change", l);
  }
  on(l, o) {
    this.events[l] || (this.events[l] = new Mc());
    const r = this.events[l].add(o);
    return l === "change"
      ? () => {
          r(),
            _t.read(() => {
              this.events.change.getSize() || this.stop();
            });
        }
      : r;
  }
  clearListeners() {
    for (const l in this.events) this.events[l].clear();
  }
  attach(l, o) {
    (this.passiveEffect = l), (this.stopPassiveEffect = o);
  }
  set(l, o = !0) {
    !o || !this.passiveEffect
      ? this.updateAndNotify(l, o)
      : this.passiveEffect(l, this.updateAndNotify);
  }
  setWithVelocity(l, o, r) {
    this.set(o),
      (this.prev = void 0),
      (this.prevFrameValue = l),
      (this.prevUpdatedAt = this.updatedAt - r);
  }
  jump(l, o = !0) {
    this.updateAndNotify(l),
      (this.prev = l),
      (this.prevUpdatedAt = this.prevFrameValue = void 0),
      o && this.stop(),
      this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    var l;
    (l = this.events.change) == null || l.notify(this.current);
  }
  addDependent(l) {
    this.dependents || (this.dependents = new Set()), this.dependents.add(l);
  }
  removeDependent(l) {
    this.dependents && this.dependents.delete(l);
  }
  get() {
    return this.current;
  }
  getPrevious() {
    return this.prev;
  }
  getVelocity() {
    const l = ge.now();
    if (
      !this.canTrackVelocity ||
      this.prevFrameValue === void 0 ||
      l - this.updatedAt > vp
    )
      return 0;
    const o = Math.min(this.updatedAt - this.prevUpdatedAt, vp);
    return Dg(parseFloat(this.current) - parseFloat(this.prevFrameValue), o);
  }
  start(l) {
    return (
      this.stop(),
      new Promise((o) => {
        (this.hasAnimated = !0),
          (this.animation = l(o)),
          this.events.animationStart && this.events.animationStart.notify();
      }).then(() => {
        this.events.animationComplete && this.events.animationComplete.notify(),
          this.clearAnimation();
      })
    );
  }
  stop() {
    this.animation &&
      (this.animation.stop(),
      this.events.animationCancel && this.events.animationCancel.notify()),
      this.clearAnimation();
  }
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  destroy() {
    var l, o;
    (l = this.dependents) == null || l.clear(),
      (o = this.events.destroy) == null || o.notify(),
      this.clearListeners(),
      this.stop(),
      this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function hi(a, l) {
  return new zx(a, l);
}
const { schedule: Gc } = Bg(queueMicrotask, !1),
  ke = { x: !1, y: !1 };
function uy() {
  return ke.x || ke.y;
}
function Nx(a) {
  return a === "x" || a === "y"
    ? ke[a]
      ? null
      : ((ke[a] = !0),
        () => {
          ke[a] = !1;
        })
    : ke.x || ke.y
    ? null
    : ((ke.x = ke.y = !0),
      () => {
        ke.x = ke.y = !1;
      });
}
function cy(a, l) {
  const o = Cx(a),
    r = new AbortController(),
    c = { passive: !0, ...l, signal: r.signal };
  return [o, c, () => r.abort()];
}
function bp(a) {
  return !(a.pointerType === "touch" || uy());
}
function _x(a, l, o = {}) {
  const [r, c, h] = cy(a, o),
    f = (m) => {
      if (!bp(m)) return;
      const { target: p } = m,
        g = l(p, m);
      if (typeof g != "function" || !p) return;
      const v = (b) => {
        bp(b) && (g(b), p.removeEventListener("pointerleave", v));
      };
      p.addEventListener("pointerleave", v, c);
    };
  return (
    r.forEach((m) => {
      m.addEventListener("pointerenter", f, c);
    }),
    h
  );
}
const fy = (a, l) => (l ? (a === l ? !0 : fy(a, l.parentElement)) : !1),
  qc = (a) =>
    a.pointerType === "mouse"
      ? typeof a.button != "number" || a.button <= 0
      : a.isPrimary !== !1,
  Ux = new Set(["BUTTON", "INPUT", "SELECT", "TEXTAREA", "A"]);
function jx(a) {
  return Ux.has(a.tagName) || a.tabIndex !== -1;
}
const io = new WeakSet();
function xp(a) {
  return (l) => {
    l.key === "Enter" && a(l);
  };
}
function Hu(a, l) {
  a.dispatchEvent(
    new PointerEvent("pointer" + l, { isPrimary: !0, bubbles: !0 })
  );
}
const Bx = (a, l) => {
  const o = a.currentTarget;
  if (!o) return;
  const r = xp(() => {
    if (io.has(o)) return;
    Hu(o, "down");
    const c = xp(() => {
        Hu(o, "up");
      }),
      h = () => Hu(o, "cancel");
    o.addEventListener("keyup", c, l), o.addEventListener("blur", h, l);
  });
  o.addEventListener("keydown", r, l),
    o.addEventListener("blur", () => o.removeEventListener("keydown", r), l);
};
function Sp(a) {
  return qc(a) && !uy();
}
function Lx(a, l, o = {}) {
  const [r, c, h] = cy(a, o),
    f = (m) => {
      const p = m.currentTarget;
      if (!Sp(m)) return;
      io.add(p);
      const g = l(p, m),
        v = (O, B) => {
          window.removeEventListener("pointerup", b),
            window.removeEventListener("pointercancel", A),
            io.has(p) && io.delete(p),
            Sp(O) && typeof g == "function" && g(O, { success: B });
        },
        b = (O) => {
          v(
            O,
            p === window ||
              p === document ||
              o.useGlobalTarget ||
              fy(p, O.target)
          );
        },
        A = (O) => {
          v(O, !1);
        };
      window.addEventListener("pointerup", b, c),
        window.addEventListener("pointercancel", A, c);
    };
  return (
    r.forEach((m) => {
      (o.useGlobalTarget ? window : m).addEventListener("pointerdown", f, c),
        ey(m) &&
          (m.addEventListener("focus", (g) => Bx(g, c)),
          !jx(m) && !m.hasAttribute("tabindex") && (m.tabIndex = 0));
    }),
    h
  );
}
function dy(a) {
  return Eg(a) && "ownerSVGElement" in a;
}
function Hx(a) {
  return dy(a) && a.tagName === "svg";
}
const se = (a) => !!(a && a.getVelocity),
  Gx = [...ly, le, Jn],
  qx = (a) => Gx.find(iy(a)),
  hy = W.createContext({
    transformPagePoint: (a) => a,
    isStatic: !1,
    reducedMotion: "never",
  });
function Yx(a = !0) {
  const l = W.useContext(xc);
  if (l === null) return [!0, null];
  const { isPresent: o, onExitComplete: r, register: c } = l,
    h = W.useId();
  W.useEffect(() => {
    if (a) return c(h);
  }, [a]);
  const f = W.useCallback(() => a && r && r(h), [h, r, a]);
  return !o && r ? [!1, f] : [!0];
}
const my = W.createContext({ strict: !1 }),
  Tp = {
    animation: [
      "animate",
      "variants",
      "whileHover",
      "whileTap",
      "exit",
      "whileInView",
      "whileFocus",
      "whileDrag",
    ],
    exit: ["exit"],
    drag: ["drag", "dragControls"],
    focus: ["whileFocus"],
    hover: ["whileHover", "onHoverStart", "onHoverEnd"],
    tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
    pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
    inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
    layout: ["layout", "layoutId"],
  },
  mi = {};
for (const a in Tp) mi[a] = { isEnabled: (l) => Tp[a].some((o) => !!l[o]) };
function kx(a) {
  for (const l in a) mi[l] = { ...mi[l], ...a[l] };
}
const Xx = new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport",
]);
function co(a) {
  return (
    a.startsWith("while") ||
    (a.startsWith("drag") && a !== "draggable") ||
    a.startsWith("layout") ||
    a.startsWith("onTap") ||
    a.startsWith("onPan") ||
    a.startsWith("onLayout") ||
    Xx.has(a)
  );
}
let py = (a) => !co(a);
function Zx(a) {
  a && (py = (l) => (l.startsWith("on") ? !co(l) : a(l)));
}
try {
  Zx(require("@emotion/is-prop-valid").default);
} catch {}
function Qx(a, l, o) {
  const r = {};
  for (const c in a)
    (c === "values" && typeof a.values == "object") ||
      ((py(c) ||
        (o === !0 && co(c)) ||
        (!l && !co(c)) ||
        (a.draggable && c.startsWith("onDrag"))) &&
        (r[c] = a[c]));
  return r;
}
function Kx(a) {
  if (typeof Proxy > "u") return a;
  const l = new Map(),
    o = (...r) => a(...r);
  return new Proxy(o, {
    get: (r, c) =>
      c === "create" ? a : (l.has(c) || l.set(c, a(c)), l.get(c)),
  });
}
const ho = W.createContext({});
function mo(a) {
  return a !== null && typeof a == "object" && typeof a.start == "function";
}
function Cl(a) {
  return typeof a == "string" || Array.isArray(a);
}
const Yc = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit",
  ],
  kc = ["initial", ...Yc];
function po(a) {
  return mo(a.animate) || kc.some((l) => Cl(a[l]));
}
function gy(a) {
  return !!(po(a) || a.variants);
}
function Jx(a, l) {
  if (po(a)) {
    const { initial: o, animate: r } = a;
    return {
      initial: o === !1 || Cl(o) ? o : void 0,
      animate: Cl(r) ? r : void 0,
    };
  }
  return a.inherit !== !1 ? l : {};
}
function Px(a) {
  const { initial: l, animate: o } = Jx(a, W.useContext(ho));
  return W.useMemo(() => ({ initial: l, animate: o }), [Ap(l), Ap(o)]);
}
function Ap(a) {
  return Array.isArray(a) ? a.join(" ") : a;
}
const Fx = Symbol.for("motionComponentSymbol");
function ui(a) {
  return (
    a &&
    typeof a == "object" &&
    Object.prototype.hasOwnProperty.call(a, "current")
  );
}
function Wx(a, l, o) {
  return W.useCallback(
    (r) => {
      r && a.onMount && a.onMount(r),
        l && (r ? l.mount(r) : l.unmount()),
        o && (typeof o == "function" ? o(r) : ui(o) && (o.current = r));
    },
    [l]
  );
}
const Xc = (a) => a.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(),
  $x = "framerAppearId",
  yy = "data-" + Xc($x),
  vy = W.createContext({});
function Ix(a, l, o, r, c) {
  var L, Y;
  const { visualElement: h } = W.useContext(ho),
    f = W.useContext(my),
    m = W.useContext(xc),
    p = W.useContext(hy).reducedMotion,
    g = W.useRef(null);
  (r = r || f.renderer),
    !g.current &&
      r &&
      (g.current = r(a, {
        visualState: l,
        parent: h,
        props: o,
        presenceContext: m,
        blockInitialAnimation: m ? m.initial === !1 : !1,
        reducedMotionConfig: p,
      }));
  const v = g.current,
    b = W.useContext(vy);
  v &&
    !v.projection &&
    c &&
    (v.type === "html" || v.type === "svg") &&
    tS(g.current, o, c, b);
  const A = W.useRef(!1);
  W.useInsertionEffect(() => {
    v && A.current && v.update(o, m);
  });
  const O = o[yy],
    B = W.useRef(
      !!O &&
        !((L = window.MotionHandoffIsComplete) != null && L.call(window, O)) &&
        ((Y = window.MotionHasOptimisedAnimation) == null
          ? void 0
          : Y.call(window, O))
    );
  return (
    Zb(() => {
      v &&
        ((A.current = !0),
        (window.MotionIsMounted = !0),
        v.updateFeatures(),
        Gc.render(v.render),
        B.current && v.animationState && v.animationState.animateChanges());
    }),
    W.useEffect(() => {
      v &&
        (!B.current && v.animationState && v.animationState.animateChanges(),
        B.current &&
          (queueMicrotask(() => {
            var Z;
            (Z = window.MotionHandoffMarkAsComplete) == null ||
              Z.call(window, O);
          }),
          (B.current = !1)));
    }),
    v
  );
}
function tS(a, l, o, r) {
  const {
    layoutId: c,
    layout: h,
    drag: f,
    dragConstraints: m,
    layoutScroll: p,
    layoutRoot: g,
    layoutCrossfade: v,
  } = l;
  (a.projection = new o(
    a.latestValues,
    l["data-framer-portal-id"] ? void 0 : by(a.parent)
  )),
    a.projection.setOptions({
      layoutId: c,
      layout: h,
      alwaysMeasureLayout: !!f || (m && ui(m)),
      visualElement: a,
      animationType: typeof h == "string" ? h : "both",
      initialPromotionConfig: r,
      crossfade: v,
      layoutScroll: p,
      layoutRoot: g,
    });
}
function by(a) {
  if (a) return a.options.allowProjection !== !1 ? a.projection : by(a.parent);
}
function eS({
  preloadedFeatures: a,
  createVisualElement: l,
  useRender: o,
  useVisualState: r,
  Component: c,
}) {
  a && kx(a);
  function h(m, p) {
    let g;
    const v = { ...W.useContext(hy), ...m, layoutId: nS(m) },
      { isStatic: b } = v,
      A = Px(m),
      O = r(m, b);
    if (!b && bc) {
      aS();
      const B = iS(v);
      (g = B.MeasureLayout),
        (A.visualElement = Ix(c, O, v, l, B.ProjectionNode));
    }
    return j.jsxs(ho.Provider, {
      value: A,
      children: [
        g && A.visualElement
          ? j.jsx(g, { visualElement: A.visualElement, ...v })
          : null,
        o(c, m, Wx(O, A.visualElement, p), O, b, A.visualElement),
      ],
    });
  }
  h.displayName = `motion.${
    typeof c == "string" ? c : `create(${c.displayName ?? c.name ?? ""})`
  }`;
  const f = W.forwardRef(h);
  return (f[Fx] = c), f;
}
function nS({ layoutId: a }) {
  const l = W.useContext(Tg).id;
  return l && a !== void 0 ? l + "-" + a : a;
}
function aS(a, l) {
  W.useContext(my).strict;
}
function iS(a) {
  const { drag: l, layout: o } = mi;
  if (!l && !o) return {};
  const r = { ...l, ...o };
  return {
    MeasureLayout:
      (l != null && l.isEnabled(a)) || (o != null && o.isEnabled(a))
        ? r.MeasureLayout
        : void 0,
    ProjectionNode: r.ProjectionNode,
  };
}
const Vl = {};
function lS(a) {
  for (const l in a) (Vl[l] = a[l]), Rc(l) && (Vl[l].isCSSVariable = !0);
}
function xy(a, { layout: l, layoutId: o }) {
  return (
    yi.has(a) ||
    a.startsWith("origin") ||
    ((l || o !== void 0) && (!!Vl[a] || a === "opacity"))
  );
}
const sS = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective",
  },
  oS = gi.length;
function rS(a, l, o) {
  let r = "",
    c = !0;
  for (let h = 0; h < oS; h++) {
    const f = gi[h],
      m = a[f];
    if (m === void 0) continue;
    let p = !0;
    if (
      (typeof m == "number"
        ? (p = m === (f.startsWith("scale") ? 1 : 0))
        : (p = parseFloat(m) === 0),
      !p || o)
    ) {
      const g = ry(m, Hc[f]);
      if (!p) {
        c = !1;
        const v = sS[f] || f;
        r += `${v}(${g}) `;
      }
      o && (l[f] = g);
    }
  }
  return (r = r.trim()), o ? (r = o(l, c ? "" : r)) : c && (r = "none"), r;
}
function Zc(a, l, o) {
  const { style: r, vars: c, transformOrigin: h } = a;
  let f = !1,
    m = !1;
  for (const p in l) {
    const g = l[p];
    if (yi.has(p)) {
      f = !0;
      continue;
    } else if (Rc(p)) {
      c[p] = g;
      continue;
    } else {
      const v = ry(g, Hc[p]);
      p.startsWith("origin") ? ((m = !0), (h[p] = v)) : (r[p] = v);
    }
  }
  if (
    (l.transform ||
      (f || o
        ? (r.transform = rS(l, a.transform, o))
        : r.transform && (r.transform = "none")),
    m)
  ) {
    const { originX: p = "50%", originY: g = "50%", originZ: v = 0 } = h;
    r.transformOrigin = `${p} ${g} ${v}`;
  }
}
const Qc = () => ({ style: {}, transform: {}, transformOrigin: {}, vars: {} });
function Sy(a, l, o) {
  for (const r in l) !se(l[r]) && !xy(r, o) && (a[r] = l[r]);
}
function uS({ transformTemplate: a }, l) {
  return W.useMemo(() => {
    const o = Qc();
    return Zc(o, l, a), Object.assign({}, o.vars, o.style);
  }, [l]);
}
function cS(a, l) {
  const o = a.style || {},
    r = {};
  return Sy(r, o, a), Object.assign(r, uS(a, l)), r;
}
function fS(a, l) {
  const o = {},
    r = cS(a, l);
  return (
    a.drag &&
      a.dragListener !== !1 &&
      ((o.draggable = !1),
      (r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none"),
      (r.touchAction =
        a.drag === !0 ? "none" : `pan-${a.drag === "x" ? "y" : "x"}`)),
    a.tabIndex === void 0 &&
      (a.onTap || a.onTapStart || a.whileTap) &&
      (o.tabIndex = 0),
    (o.style = r),
    o
  );
}
const dS = { offset: "stroke-dashoffset", array: "stroke-dasharray" },
  hS = { offset: "strokeDashoffset", array: "strokeDasharray" };
function mS(a, l, o = 1, r = 0, c = !0) {
  a.pathLength = 1;
  const h = c ? dS : hS;
  a[h.offset] = it.transform(-r);
  const f = it.transform(l),
    m = it.transform(o);
  a[h.array] = `${f} ${m}`;
}
function Ty(
  a,
  {
    attrX: l,
    attrY: o,
    attrScale: r,
    pathLength: c,
    pathSpacing: h = 1,
    pathOffset: f = 0,
    ...m
  },
  p,
  g,
  v
) {
  if ((Zc(a, m, g), p)) {
    a.style.viewBox && (a.attrs.viewBox = a.style.viewBox);
    return;
  }
  (a.attrs = a.style), (a.style = {});
  const { attrs: b, style: A } = a;
  b.transform && ((A.transform = b.transform), delete b.transform),
    (A.transform || b.transformOrigin) &&
      ((A.transformOrigin = b.transformOrigin ?? "50% 50%"),
      delete b.transformOrigin),
    A.transform &&
      ((A.transformBox = (v == null ? void 0 : v.transformBox) ?? "fill-box"),
      delete b.transformBox),
    l !== void 0 && (b.x = l),
    o !== void 0 && (b.y = o),
    r !== void 0 && (b.scale = r),
    c !== void 0 && mS(b, c, h, f, !1);
}
const Ay = () => ({ ...Qc(), attrs: {} }),
  Ey = (a) => typeof a == "string" && a.toLowerCase() === "svg";
function pS(a, l, o, r) {
  const c = W.useMemo(() => {
    const h = Ay();
    return (
      Ty(h, l, Ey(r), a.transformTemplate, a.style),
      { ...h.attrs, style: { ...h.style } }
    );
  }, [l]);
  if (a.style) {
    const h = {};
    Sy(h, a.style, a), (c.style = { ...h, ...c.style });
  }
  return c;
}
const gS = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view",
];
function Kc(a) {
  return typeof a != "string" || a.includes("-")
    ? !1
    : !!(gS.indexOf(a) > -1 || /[A-Z]/u.test(a));
}
function yS(a = !1) {
  return (o, r, c, { latestValues: h }, f) => {
    const p = (Kc(o) ? pS : fS)(r, h, f, o),
      g = Qx(r, typeof o == "string", a),
      v = o !== W.Fragment ? { ...g, ...p, ref: c } : {},
      { children: b } = r,
      A = W.useMemo(() => (se(b) ? b.get() : b), [b]);
    return W.createElement(o, { ...v, children: A });
  };
}
function Ep(a) {
  const l = [{}, {}];
  return (
    a == null ||
      a.values.forEach((o, r) => {
        (l[0][r] = o.get()), (l[1][r] = o.getVelocity());
      }),
    l
  );
}
function Jc(a, l, o, r) {
  if (typeof l == "function") {
    const [c, h] = Ep(r);
    l = l(o !== void 0 ? o : a.custom, c, h);
  }
  if (
    (typeof l == "string" && (l = a.variants && a.variants[l]),
    typeof l == "function")
  ) {
    const [c, h] = Ep(r);
    l = l(o !== void 0 ? o : a.custom, c, h);
  }
  return l;
}
function lo(a) {
  return se(a) ? a.get() : a;
}
function vS({ scrapeMotionValuesFromProps: a, createRenderState: l }, o, r, c) {
  return { latestValues: bS(o, r, c, a), renderState: l() };
}
const My = (a) => (l, o) => {
  const r = W.useContext(ho),
    c = W.useContext(xc),
    h = () => vS(a, l, r, c);
  return o ? h() : Xb(h);
};
function bS(a, l, o, r) {
  const c = {},
    h = r(a, {});
  for (const A in h) c[A] = lo(h[A]);
  let { initial: f, animate: m } = a;
  const p = po(a),
    g = gy(a);
  l &&
    g &&
    !p &&
    a.inherit !== !1 &&
    (f === void 0 && (f = l.initial), m === void 0 && (m = l.animate));
  let v = o ? o.initial === !1 : !1;
  v = v || f === !1;
  const b = v ? m : f;
  if (b && typeof b != "boolean" && !mo(b)) {
    const A = Array.isArray(b) ? b : [b];
    for (let O = 0; O < A.length; O++) {
      const B = Jc(a, A[O]);
      if (B) {
        const { transitionEnd: L, transition: Y, ...Z } = B;
        for (const $ in Z) {
          let X = Z[$];
          if (Array.isArray(X)) {
            const lt = v ? X.length - 1 : 0;
            X = X[lt];
          }
          X !== null && (c[$] = X);
        }
        for (const $ in L) c[$] = L[$];
      }
    }
  }
  return c;
}
function Pc(a, l, o) {
  var h;
  const { style: r } = a,
    c = {};
  for (const f in r)
    (se(r[f]) ||
      (l.style && se(l.style[f])) ||
      xy(f, a) ||
      ((h = o == null ? void 0 : o.getValue(f)) == null
        ? void 0
        : h.liveStyle) !== void 0) &&
      (c[f] = r[f]);
  return c;
}
const xS = {
  useVisualState: My({
    scrapeMotionValuesFromProps: Pc,
    createRenderState: Qc,
  }),
};
function Dy(a, l, o) {
  const r = Pc(a, l, o);
  for (const c in a)
    if (se(a[c]) || se(l[c])) {
      const h =
        gi.indexOf(c) !== -1
          ? "attr" + c.charAt(0).toUpperCase() + c.substring(1)
          : c;
      r[h] = a[c];
    }
  return r;
}
const SS = {
  useVisualState: My({
    scrapeMotionValuesFromProps: Dy,
    createRenderState: Ay,
  }),
};
function TS(a, l) {
  return function (r, { forwardMotionProps: c } = { forwardMotionProps: !1 }) {
    const f = {
      ...(Kc(r) ? SS : xS),
      preloadedFeatures: a,
      useRender: yS(c),
      createVisualElement: l,
      Component: r,
    };
    return eS(f);
  };
}
function zl(a, l, o) {
  const r = a.getProps();
  return Jc(r, l, o !== void 0 ? o : r.custom, a);
}
const oc = (a) => Array.isArray(a);
function AS(a, l, o) {
  a.hasValue(l) ? a.getValue(l).set(o) : a.addValue(l, hi(o));
}
function ES(a) {
  return oc(a) ? a[a.length - 1] || 0 : a;
}
function MS(a, l) {
  const o = zl(a, l);
  let { transitionEnd: r = {}, transition: c = {}, ...h } = o || {};
  h = { ...h, ...r };
  for (const f in h) {
    const m = ES(h[f]);
    AS(a, f, m);
  }
}
function DS(a) {
  return !!(se(a) && a.add);
}
function rc(a, l) {
  const o = a.getValue("willChange");
  if (DS(o)) return o.add(l);
  if (!o && yn.WillChange) {
    const r = new yn.WillChange("auto");
    a.addValue("willChange", r), r.add(l);
  }
}
function wy(a) {
  return a.props[yy];
}
const wS = (a) => a !== null;
function RS(a, { repeat: l, repeatType: o = "loop" }, r) {
  const c = a.filter(wS),
    h = l && o !== "loop" && l % 2 === 1 ? 0 : c.length - 1;
  return c[h];
}
const OS = { type: "spring", stiffness: 500, damping: 25, restSpeed: 10 },
  CS = (a) => ({
    type: "spring",
    stiffness: 550,
    damping: a === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10,
  }),
  VS = { type: "keyframes", duration: 0.8 },
  zS = { type: "keyframes", ease: [0.25, 0.1, 0.35, 1], duration: 0.3 },
  NS = (a, { keyframes: l }) =>
    l.length > 2
      ? VS
      : yi.has(a)
      ? a.startsWith("scale")
        ? CS(l[1])
        : OS
      : zS;
function _S({
  when: a,
  delay: l,
  delayChildren: o,
  staggerChildren: r,
  staggerDirection: c,
  repeat: h,
  repeatType: f,
  repeatDelay: m,
  from: p,
  elapsed: g,
  ...v
}) {
  return !!Object.keys(v).length;
}
const Fc =
  (a, l, o, r = {}, c, h) =>
  (f) => {
    const m = Lc(r, a) || {},
      p = m.delay || r.delay || 0;
    let { elapsed: g = 0 } = r;
    g = g - Fe(p);
    const v = {
      keyframes: Array.isArray(o) ? o : [null, o],
      ease: "easeOut",
      velocity: l.getVelocity(),
      ...m,
      delay: -g,
      onUpdate: (A) => {
        l.set(A), m.onUpdate && m.onUpdate(A);
      },
      onComplete: () => {
        f(), m.onComplete && m.onComplete();
      },
      name: a,
      motionValue: l,
      element: h ? void 0 : c,
    };
    _S(m) || Object.assign(v, NS(a, v)),
      v.duration && (v.duration = Fe(v.duration)),
      v.repeatDelay && (v.repeatDelay = Fe(v.repeatDelay)),
      v.from !== void 0 && (v.keyframes[0] = v.from);
    let b = !1;
    if (
      ((v.type === !1 || (v.duration === 0 && !v.repeatDelay)) &&
        ((v.duration = 0), v.delay === 0 && (b = !0)),
      (yn.instantAnimations || yn.skipAnimations) &&
        ((b = !0), (v.duration = 0), (v.delay = 0)),
      (v.allowFlatten = !m.type && !m.ease),
      b && !h && l.get() !== void 0)
    ) {
      const A = RS(v.keyframes, m);
      if (A !== void 0) {
        _t.update(() => {
          v.onUpdate(A), v.onComplete();
        });
        return;
      }
    }
    return m.isSync ? new jc(v) : new yx(v);
  };
function US({ protectedKeys: a, needsAnimating: l }, o) {
  const r = a.hasOwnProperty(o) && l[o] !== !0;
  return (l[o] = !1), r;
}
function Ry(a, l, { delay: o = 0, transitionOverride: r, type: c } = {}) {
  let { transition: h = a.getDefaultTransition(), transitionEnd: f, ...m } = l;
  r && (h = r);
  const p = [],
    g = c && a.animationState && a.animationState.getState()[c];
  for (const v in m) {
    const b = a.getValue(v, a.latestValues[v] ?? null),
      A = m[v];
    if (A === void 0 || (g && US(g, v))) continue;
    const O = { delay: o, ...Lc(h || {}, v) },
      B = b.get();
    if (
      B !== void 0 &&
      !b.isAnimating &&
      !Array.isArray(A) &&
      A === B &&
      !O.velocity
    )
      continue;
    let L = !1;
    if (window.MotionHandoffAnimation) {
      const Z = wy(a);
      if (Z) {
        const $ = window.MotionHandoffAnimation(Z, v, _t);
        $ !== null && ((O.startTime = $), (L = !0));
      }
    }
    rc(a, v),
      b.start(
        Fc(v, b, A, a.shouldReduceMotion && ay.has(v) ? { type: !1 } : O, a, L)
      );
    const Y = b.animation;
    Y && p.push(Y);
  }
  return (
    f &&
      Promise.all(p).then(() => {
        _t.update(() => {
          f && MS(a, f);
        });
      }),
    p
  );
}
function uc(a, l, o = {}) {
  var p;
  const r = zl(
    a,
    l,
    o.type === "exit"
      ? (p = a.presenceContext) == null
        ? void 0
        : p.custom
      : void 0
  );
  let { transition: c = a.getDefaultTransition() || {} } = r || {};
  o.transitionOverride && (c = o.transitionOverride);
  const h = r ? () => Promise.all(Ry(a, r, o)) : () => Promise.resolve(),
    f =
      a.variantChildren && a.variantChildren.size
        ? (g = 0) => {
            const {
              delayChildren: v = 0,
              staggerChildren: b,
              staggerDirection: A,
            } = c;
            return jS(a, l, v + g, b, A, o);
          }
        : () => Promise.resolve(),
    { when: m } = c;
  if (m) {
    const [g, v] = m === "beforeChildren" ? [h, f] : [f, h];
    return g().then(() => v());
  } else return Promise.all([h(), f(o.delay)]);
}
function jS(a, l, o = 0, r = 0, c = 1, h) {
  const f = [],
    m = (a.variantChildren.size - 1) * r,
    p = c === 1 ? (g = 0) => g * r : (g = 0) => m - g * r;
  return (
    Array.from(a.variantChildren)
      .sort(BS)
      .forEach((g, v) => {
        g.notify("AnimationStart", l),
          f.push(
            uc(g, l, { ...h, delay: o + p(v) }).then(() =>
              g.notify("AnimationComplete", l)
            )
          );
      }),
    Promise.all(f)
  );
}
function BS(a, l) {
  return a.sortNodePosition(l);
}
function LS(a, l, o = {}) {
  a.notify("AnimationStart", l);
  let r;
  if (Array.isArray(l)) {
    const c = l.map((h) => uc(a, h, o));
    r = Promise.all(c);
  } else if (typeof l == "string") r = uc(a, l, o);
  else {
    const c = typeof l == "function" ? zl(a, l, o.custom) : l;
    r = Promise.all(Ry(a, c, o));
  }
  return r.then(() => {
    a.notify("AnimationComplete", l);
  });
}
function Oy(a, l) {
  if (!Array.isArray(l)) return !1;
  const o = l.length;
  if (o !== a.length) return !1;
  for (let r = 0; r < o; r++) if (l[r] !== a[r]) return !1;
  return !0;
}
const HS = kc.length;
function Cy(a) {
  if (!a) return;
  if (!a.isControllingVariants) {
    const o = a.parent ? Cy(a.parent) || {} : {};
    return a.props.initial !== void 0 && (o.initial = a.props.initial), o;
  }
  const l = {};
  for (let o = 0; o < HS; o++) {
    const r = kc[o],
      c = a.props[r];
    (Cl(c) || c === !1) && (l[r] = c);
  }
  return l;
}
const GS = [...Yc].reverse(),
  qS = Yc.length;
function YS(a) {
  return (l) =>
    Promise.all(l.map(({ animation: o, options: r }) => LS(a, o, r)));
}
function kS(a) {
  let l = YS(a),
    o = Mp(),
    r = !0;
  const c = (p) => (g, v) => {
    var A;
    const b = zl(
      a,
      v,
      p === "exit"
        ? (A = a.presenceContext) == null
          ? void 0
          : A.custom
        : void 0
    );
    if (b) {
      const { transition: O, transitionEnd: B, ...L } = b;
      g = { ...g, ...L, ...B };
    }
    return g;
  };
  function h(p) {
    l = p(a);
  }
  function f(p) {
    const { props: g } = a,
      v = Cy(a.parent) || {},
      b = [],
      A = new Set();
    let O = {},
      B = 1 / 0;
    for (let Y = 0; Y < qS; Y++) {
      const Z = GS[Y],
        $ = o[Z],
        X = g[Z] !== void 0 ? g[Z] : v[Z],
        lt = Cl(X),
        k = Z === p ? $.isActive : null;
      k === !1 && (B = Y);
      let nt = X === v[Z] && X !== g[Z] && lt;
      if (
        (nt && r && a.manuallyAnimateOnMount && (nt = !1),
        ($.protectedKeys = { ...O }),
        (!$.isActive && k === null) ||
          (!X && !$.prevProp) ||
          mo(X) ||
          typeof X == "boolean")
      )
        continue;
      const rt = XS($.prevProp, X);
      let G = rt || (Z === p && $.isActive && !nt && lt) || (Y > B && lt),
        pt = !1;
      const Ut = Array.isArray(X) ? X : [X];
      let Xt = Ut.reduce(c(Z), {});
      k === !1 && (Xt = {});
      const { prevResolvedValues: Ot = {} } = $,
        we = { ...Ot, ...Xt },
        ce = (H) => {
          (G = !0),
            A.has(H) && ((pt = !0), A.delete(H)),
            ($.needsAnimating[H] = !0);
          const _ = a.getValue(H);
          _ && (_.liveStyle = !1);
        };
      for (const H in we) {
        const _ = Xt[H],
          gt = Ot[H];
        if (O.hasOwnProperty(H)) continue;
        let S = !1;
        oc(_) && oc(gt) ? (S = !Oy(_, gt)) : (S = _ !== gt),
          S
            ? _ != null
              ? ce(H)
              : A.add(H)
            : _ !== void 0 && A.has(H)
            ? ce(H)
            : ($.protectedKeys[H] = !0);
      }
      ($.prevProp = X),
        ($.prevResolvedValues = Xt),
        $.isActive && (O = { ...O, ...Xt }),
        r && a.blockInitialAnimation && (G = !1),
        G &&
          (!(nt && rt) || pt) &&
          b.push(...Ut.map((H) => ({ animation: H, options: { type: Z } })));
    }
    if (A.size) {
      const Y = {};
      if (typeof g.initial != "boolean") {
        const Z = zl(a, Array.isArray(g.initial) ? g.initial[0] : g.initial);
        Z && Z.transition && (Y.transition = Z.transition);
      }
      A.forEach((Z) => {
        const $ = a.getBaseTarget(Z),
          X = a.getValue(Z);
        X && (X.liveStyle = !0), (Y[Z] = $ ?? null);
      }),
        b.push({ animation: Y });
    }
    let L = !!b.length;
    return (
      r &&
        (g.initial === !1 || g.initial === g.animate) &&
        !a.manuallyAnimateOnMount &&
        (L = !1),
      (r = !1),
      L ? l(b) : Promise.resolve()
    );
  }
  function m(p, g) {
    var b;
    if (o[p].isActive === g) return Promise.resolve();
    (b = a.variantChildren) == null ||
      b.forEach((A) => {
        var O;
        return (O = A.animationState) == null ? void 0 : O.setActive(p, g);
      }),
      (o[p].isActive = g);
    const v = f(p);
    for (const A in o) o[A].protectedKeys = {};
    return v;
  }
  return {
    animateChanges: f,
    setActive: m,
    setAnimateFunction: h,
    getState: () => o,
    reset: () => {
      (o = Mp()), (r = !0);
    },
  };
}
function XS(a, l) {
  return typeof l == "string" ? l !== a : Array.isArray(l) ? !Oy(l, a) : !1;
}
function ma(a = !1) {
  return {
    isActive: a,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {},
  };
}
function Mp() {
  return {
    animate: ma(!0),
    whileInView: ma(),
    whileHover: ma(),
    whileTap: ma(),
    whileDrag: ma(),
    whileFocus: ma(),
    exit: ma(),
  };
}
class Pn {
  constructor(l) {
    (this.isMounted = !1), (this.node = l);
  }
  update() {}
}
class ZS extends Pn {
  constructor(l) {
    super(l), l.animationState || (l.animationState = kS(l));
  }
  updateAnimationControlsSubscription() {
    const { animate: l } = this.node.getProps();
    mo(l) && (this.unmountControls = l.subscribe(this.node));
  }
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: l } = this.node.getProps(),
      { animate: o } = this.node.prevProps || {};
    l !== o && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var l;
    this.node.animationState.reset(),
      (l = this.unmountControls) == null || l.call(this);
  }
}
let QS = 0;
class KS extends Pn {
  constructor() {
    super(...arguments), (this.id = QS++);
  }
  update() {
    if (!this.node.presenceContext) return;
    const { isPresent: l, onExitComplete: o } = this.node.presenceContext,
      { isPresent: r } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || l === r) return;
    const c = this.node.animationState.setActive("exit", !l);
    o &&
      !l &&
      c.then(() => {
        o(this.id);
      });
  }
  mount() {
    const { register: l, onExitComplete: o } = this.node.presenceContext || {};
    o && o(this.id), l && (this.unmount = l(this.id));
  }
  unmount() {}
}
const JS = { animation: { Feature: ZS }, exit: { Feature: KS } };
function Nl(a, l, o, r = { passive: !0 }) {
  return a.addEventListener(l, o, r), () => a.removeEventListener(l, o);
}
function Bl(a) {
  return { point: { x: a.pageX, y: a.pageY } };
}
const PS = (a) => (l) => qc(l) && a(l, Bl(l));
function El(a, l, o, r) {
  return Nl(a, l, PS(o), r);
}
function Vy({ top: a, left: l, right: o, bottom: r }) {
  return { x: { min: l, max: o }, y: { min: a, max: r } };
}
function FS({ x: a, y: l }) {
  return { top: l.min, right: a.max, bottom: l.max, left: a.min };
}
function WS(a, l) {
  if (!l) return a;
  const o = l({ x: a.left, y: a.top }),
    r = l({ x: a.right, y: a.bottom });
  return { top: o.y, left: o.x, bottom: r.y, right: r.x };
}
const zy = 1e-4,
  $S = 1 - zy,
  IS = 1 + zy,
  Ny = 0.01,
  tT = 0 - Ny,
  eT = 0 + Ny;
function ue(a) {
  return a.max - a.min;
}
function nT(a, l, o) {
  return Math.abs(a - l) <= o;
}
function Dp(a, l, o, r = 0.5) {
  (a.origin = r),
    (a.originPoint = Nt(l.min, l.max, a.origin)),
    (a.scale = ue(o) / ue(l)),
    (a.translate = Nt(o.min, o.max, a.origin) - a.originPoint),
    ((a.scale >= $S && a.scale <= IS) || isNaN(a.scale)) && (a.scale = 1),
    ((a.translate >= tT && a.translate <= eT) || isNaN(a.translate)) &&
      (a.translate = 0);
}
function Ml(a, l, o, r) {
  Dp(a.x, l.x, o.x, r ? r.originX : void 0),
    Dp(a.y, l.y, o.y, r ? r.originY : void 0);
}
function wp(a, l, o) {
  (a.min = o.min + l.min), (a.max = a.min + ue(l));
}
function aT(a, l, o) {
  wp(a.x, l.x, o.x), wp(a.y, l.y, o.y);
}
function Rp(a, l, o) {
  (a.min = l.min - o.min), (a.max = a.min + ue(l));
}
function Dl(a, l, o) {
  Rp(a.x, l.x, o.x), Rp(a.y, l.y, o.y);
}
const Op = () => ({ translate: 0, scale: 1, origin: 0, originPoint: 0 }),
  ci = () => ({ x: Op(), y: Op() }),
  Cp = () => ({ min: 0, max: 0 }),
  qt = () => ({ x: Cp(), y: Cp() });
function Le(a) {
  return [a("x"), a("y")];
}
function Gu(a) {
  return a === void 0 || a === 1;
}
function cc({ scale: a, scaleX: l, scaleY: o }) {
  return !Gu(a) || !Gu(l) || !Gu(o);
}
function ga(a) {
  return (
    cc(a) ||
    _y(a) ||
    a.z ||
    a.rotate ||
    a.rotateX ||
    a.rotateY ||
    a.skewX ||
    a.skewY
  );
}
function _y(a) {
  return Vp(a.x) || Vp(a.y);
}
function Vp(a) {
  return a && a !== "0%";
}
function fo(a, l, o) {
  const r = a - o,
    c = l * r;
  return o + c;
}
function zp(a, l, o, r, c) {
  return c !== void 0 && (a = fo(a, c, r)), fo(a, o, r) + l;
}
function fc(a, l = 0, o = 1, r, c) {
  (a.min = zp(a.min, l, o, r, c)), (a.max = zp(a.max, l, o, r, c));
}
function Uy(a, { x: l, y: o }) {
  fc(a.x, l.translate, l.scale, l.originPoint),
    fc(a.y, o.translate, o.scale, o.originPoint);
}
const Np = 0.999999999999,
  _p = 1.0000000000001;
function iT(a, l, o, r = !1) {
  const c = o.length;
  if (!c) return;
  l.x = l.y = 1;
  let h, f;
  for (let m = 0; m < c; m++) {
    (h = o[m]), (f = h.projectionDelta);
    const { visualElement: p } = h.options;
    (p && p.props.style && p.props.style.display === "contents") ||
      (r &&
        h.options.layoutScroll &&
        h.scroll &&
        h !== h.root &&
        di(a, { x: -h.scroll.offset.x, y: -h.scroll.offset.y }),
      f && ((l.x *= f.x.scale), (l.y *= f.y.scale), Uy(a, f)),
      r && ga(h.latestValues) && di(a, h.latestValues));
  }
  l.x < _p && l.x > Np && (l.x = 1), l.y < _p && l.y > Np && (l.y = 1);
}
function fi(a, l) {
  (a.min = a.min + l), (a.max = a.max + l);
}
function Up(a, l, o, r, c = 0.5) {
  const h = Nt(a.min, a.max, c);
  fc(a, l, o, h, r);
}
function di(a, l) {
  Up(a.x, l.x, l.scaleX, l.scale, l.originX),
    Up(a.y, l.y, l.scaleY, l.scale, l.originY);
}
function jy(a, l) {
  return Vy(WS(a.getBoundingClientRect(), l));
}
function lT(a, l, o) {
  const r = jy(a, o),
    { scroll: c } = l;
  return c && (fi(r.x, c.offset.x), fi(r.y, c.offset.y)), r;
}
const By = ({ current: a }) => (a ? a.ownerDocument.defaultView : null),
  jp = (a, l) => Math.abs(a - l);
function sT(a, l) {
  const o = jp(a.x, l.x),
    r = jp(a.y, l.y);
  return Math.sqrt(o ** 2 + r ** 2);
}
class Ly {
  constructor(
    l,
    o,
    { transformPagePoint: r, contextWindow: c, dragSnapToOrigin: h = !1 } = {}
  ) {
    if (
      ((this.startEvent = null),
      (this.lastMoveEvent = null),
      (this.lastMoveEventInfo = null),
      (this.handlers = {}),
      (this.contextWindow = window),
      (this.updatePoint = () => {
        if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
        const b = Yu(this.lastMoveEventInfo, this.history),
          A = this.startEvent !== null,
          O = sT(b.offset, { x: 0, y: 0 }) >= 3;
        if (!A && !O) return;
        const { point: B } = b,
          { timestamp: L } = ee;
        this.history.push({ ...B, timestamp: L });
        const { onStart: Y, onMove: Z } = this.handlers;
        A ||
          (Y && Y(this.lastMoveEvent, b),
          (this.startEvent = this.lastMoveEvent)),
          Z && Z(this.lastMoveEvent, b);
      }),
      (this.handlePointerMove = (b, A) => {
        (this.lastMoveEvent = b),
          (this.lastMoveEventInfo = qu(A, this.transformPagePoint)),
          _t.update(this.updatePoint, !0);
      }),
      (this.handlePointerUp = (b, A) => {
        this.end();
        const { onEnd: O, onSessionEnd: B, resumeAnimation: L } = this.handlers;
        if (
          (this.dragSnapToOrigin && L && L(),
          !(this.lastMoveEvent && this.lastMoveEventInfo))
        )
          return;
        const Y = Yu(
          b.type === "pointercancel"
            ? this.lastMoveEventInfo
            : qu(A, this.transformPagePoint),
          this.history
        );
        this.startEvent && O && O(b, Y), B && B(b, Y);
      }),
      !qc(l))
    )
      return;
    (this.dragSnapToOrigin = h),
      (this.handlers = o),
      (this.transformPagePoint = r),
      (this.contextWindow = c || window);
    const f = Bl(l),
      m = qu(f, this.transformPagePoint),
      { point: p } = m,
      { timestamp: g } = ee;
    this.history = [{ ...p, timestamp: g }];
    const { onSessionStart: v } = o;
    v && v(l, Yu(m, this.history)),
      (this.removeListeners = _l(
        El(this.contextWindow, "pointermove", this.handlePointerMove),
        El(this.contextWindow, "pointerup", this.handlePointerUp),
        El(this.contextWindow, "pointercancel", this.handlePointerUp)
      ));
  }
  updateHandlers(l) {
    this.handlers = l;
  }
  end() {
    this.removeListeners && this.removeListeners(), Kn(this.updatePoint);
  }
}
function qu(a, l) {
  return l ? { point: l(a.point) } : a;
}
function Bp(a, l) {
  return { x: a.x - l.x, y: a.y - l.y };
}
function Yu({ point: a }, l) {
  return {
    point: a,
    delta: Bp(a, Hy(l)),
    offset: Bp(a, oT(l)),
    velocity: rT(l, 0.1),
  };
}
function oT(a) {
  return a[0];
}
function Hy(a) {
  return a[a.length - 1];
}
function rT(a, l) {
  if (a.length < 2) return { x: 0, y: 0 };
  let o = a.length - 1,
    r = null;
  const c = Hy(a);
  for (; o >= 0 && ((r = a[o]), !(c.timestamp - r.timestamp > Fe(l))); ) o--;
  if (!r) return { x: 0, y: 0 };
  const h = We(c.timestamp - r.timestamp);
  if (h === 0) return { x: 0, y: 0 };
  const f = { x: (c.x - r.x) / h, y: (c.y - r.y) / h };
  return f.x === 1 / 0 && (f.x = 0), f.y === 1 / 0 && (f.y = 0), f;
}
function uT(a, { min: l, max: o }, r) {
  return (
    l !== void 0 && a < l
      ? (a = r ? Nt(l, a, r.min) : Math.max(a, l))
      : o !== void 0 && a > o && (a = r ? Nt(o, a, r.max) : Math.min(a, o)),
    a
  );
}
function Lp(a, l, o) {
  return {
    min: l !== void 0 ? a.min + l : void 0,
    max: o !== void 0 ? a.max + o - (a.max - a.min) : void 0,
  };
}
function cT(a, { top: l, left: o, bottom: r, right: c }) {
  return { x: Lp(a.x, o, c), y: Lp(a.y, l, r) };
}
function Hp(a, l) {
  let o = l.min - a.min,
    r = l.max - a.max;
  return l.max - l.min < a.max - a.min && ([o, r] = [r, o]), { min: o, max: r };
}
function fT(a, l) {
  return { x: Hp(a.x, l.x), y: Hp(a.y, l.y) };
}
function dT(a, l) {
  let o = 0.5;
  const r = ue(a),
    c = ue(l);
  return (
    c > r
      ? (o = wl(l.min, l.max - r, a.min))
      : r > c && (o = wl(a.min, a.max - c, l.min)),
    gn(0, 1, o)
  );
}
function hT(a, l) {
  const o = {};
  return (
    l.min !== void 0 && (o.min = l.min - a.min),
    l.max !== void 0 && (o.max = l.max - a.min),
    o
  );
}
const dc = 0.35;
function mT(a = dc) {
  return (
    a === !1 ? (a = 0) : a === !0 && (a = dc),
    { x: Gp(a, "left", "right"), y: Gp(a, "top", "bottom") }
  );
}
function Gp(a, l, o) {
  return { min: qp(a, l), max: qp(a, o) };
}
function qp(a, l) {
  return typeof a == "number" ? a : a[l] || 0;
}
const pT = new WeakMap();
class gT {
  constructor(l) {
    (this.openDragLock = null),
      (this.isDragging = !1),
      (this.currentDirection = null),
      (this.originPoint = { x: 0, y: 0 }),
      (this.constraints = !1),
      (this.hasMutatedConstraints = !1),
      (this.elastic = qt()),
      (this.visualElement = l);
  }
  start(l, { snapToCursor: o = !1 } = {}) {
    const { presenceContext: r } = this.visualElement;
    if (r && r.isPresent === !1) return;
    const c = (v) => {
        const { dragSnapToOrigin: b } = this.getProps();
        b ? this.pauseAnimation() : this.stopAnimation(),
          o && this.snapToCursor(Bl(v).point);
      },
      h = (v, b) => {
        const { drag: A, dragPropagation: O, onDragStart: B } = this.getProps();
        if (
          A &&
          !O &&
          (this.openDragLock && this.openDragLock(),
          (this.openDragLock = Nx(A)),
          !this.openDragLock)
        )
          return;
        (this.isDragging = !0),
          (this.currentDirection = null),
          this.resolveConstraints(),
          this.visualElement.projection &&
            ((this.visualElement.projection.isAnimationBlocked = !0),
            (this.visualElement.projection.target = void 0)),
          Le((Y) => {
            let Z = this.getAxisMotionValue(Y).get() || 0;
            if ($e.test(Z)) {
              const { projection: $ } = this.visualElement;
              if ($ && $.layout) {
                const X = $.layout.layoutBox[Y];
                X && (Z = ue(X) * (parseFloat(Z) / 100));
              }
            }
            this.originPoint[Y] = Z;
          }),
          B && _t.postRender(() => B(v, b)),
          rc(this.visualElement, "transform");
        const { animationState: L } = this.visualElement;
        L && L.setActive("whileDrag", !0);
      },
      f = (v, b) => {
        const {
          dragPropagation: A,
          dragDirectionLock: O,
          onDirectionLock: B,
          onDrag: L,
        } = this.getProps();
        if (!A && !this.openDragLock) return;
        const { offset: Y } = b;
        if (O && this.currentDirection === null) {
          (this.currentDirection = yT(Y)),
            this.currentDirection !== null && B && B(this.currentDirection);
          return;
        }
        this.updateAxis("x", b.point, Y),
          this.updateAxis("y", b.point, Y),
          this.visualElement.render(),
          L && L(v, b);
      },
      m = (v, b) => this.stop(v, b),
      p = () =>
        Le((v) => {
          var b;
          return (
            this.getAnimationState(v) === "paused" &&
            ((b = this.getAxisMotionValue(v).animation) == null
              ? void 0
              : b.play())
          );
        }),
      { dragSnapToOrigin: g } = this.getProps();
    this.panSession = new Ly(
      l,
      {
        onSessionStart: c,
        onStart: h,
        onMove: f,
        onSessionEnd: m,
        resumeAnimation: p,
      },
      {
        transformPagePoint: this.visualElement.getTransformPagePoint(),
        dragSnapToOrigin: g,
        contextWindow: By(this.visualElement),
      }
    );
  }
  stop(l, o) {
    const r = this.isDragging;
    if ((this.cancel(), !r)) return;
    const { velocity: c } = o;
    this.startAnimation(c);
    const { onDragEnd: h } = this.getProps();
    h && _t.postRender(() => h(l, o));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: l, animationState: o } = this.visualElement;
    l && (l.isAnimationBlocked = !1),
      this.panSession && this.panSession.end(),
      (this.panSession = void 0);
    const { dragPropagation: r } = this.getProps();
    !r &&
      this.openDragLock &&
      (this.openDragLock(), (this.openDragLock = null)),
      o && o.setActive("whileDrag", !1);
  }
  updateAxis(l, o, r) {
    const { drag: c } = this.getProps();
    if (!r || !to(l, c, this.currentDirection)) return;
    const h = this.getAxisMotionValue(l);
    let f = this.originPoint[l] + r[l];
    this.constraints &&
      this.constraints[l] &&
      (f = uT(f, this.constraints[l], this.elastic[l])),
      h.set(f);
  }
  resolveConstraints() {
    var h;
    const { dragConstraints: l, dragElastic: o } = this.getProps(),
      r =
        this.visualElement.projection && !this.visualElement.projection.layout
          ? this.visualElement.projection.measure(!1)
          : (h = this.visualElement.projection) == null
          ? void 0
          : h.layout,
      c = this.constraints;
    l && ui(l)
      ? this.constraints || (this.constraints = this.resolveRefConstraints())
      : l && r
      ? (this.constraints = cT(r.layoutBox, l))
      : (this.constraints = !1),
      (this.elastic = mT(o)),
      c !== this.constraints &&
        r &&
        this.constraints &&
        !this.hasMutatedConstraints &&
        Le((f) => {
          this.constraints !== !1 &&
            this.getAxisMotionValue(f) &&
            (this.constraints[f] = hT(r.layoutBox[f], this.constraints[f]));
        });
  }
  resolveRefConstraints() {
    const { dragConstraints: l, onMeasureDragConstraints: o } = this.getProps();
    if (!l || !ui(l)) return !1;
    const r = l.current,
      { projection: c } = this.visualElement;
    if (!c || !c.layout) return !1;
    const h = lT(r, c.root, this.visualElement.getTransformPagePoint());
    let f = fT(c.layout.layoutBox, h);
    if (o) {
      const m = o(FS(f));
      (this.hasMutatedConstraints = !!m), m && (f = Vy(m));
    }
    return f;
  }
  startAnimation(l) {
    const {
        drag: o,
        dragMomentum: r,
        dragElastic: c,
        dragTransition: h,
        dragSnapToOrigin: f,
        onDragTransitionEnd: m,
      } = this.getProps(),
      p = this.constraints || {},
      g = Le((v) => {
        if (!to(v, o, this.currentDirection)) return;
        let b = (p && p[v]) || {};
        f && (b = { min: 0, max: 0 });
        const A = c ? 200 : 1e6,
          O = c ? 40 : 1e7,
          B = {
            type: "inertia",
            velocity: r ? l[v] : 0,
            bounceStiffness: A,
            bounceDamping: O,
            timeConstant: 750,
            restDelta: 1,
            restSpeed: 10,
            ...h,
            ...b,
          };
        return this.startAxisValueAnimation(v, B);
      });
    return Promise.all(g).then(m);
  }
  startAxisValueAnimation(l, o) {
    const r = this.getAxisMotionValue(l);
    return (
      rc(this.visualElement, l), r.start(Fc(l, r, 0, o, this.visualElement, !1))
    );
  }
  stopAnimation() {
    Le((l) => this.getAxisMotionValue(l).stop());
  }
  pauseAnimation() {
    Le((l) => {
      var o;
      return (o = this.getAxisMotionValue(l).animation) == null
        ? void 0
        : o.pause();
    });
  }
  getAnimationState(l) {
    var o;
    return (o = this.getAxisMotionValue(l).animation) == null
      ? void 0
      : o.state;
  }
  getAxisMotionValue(l) {
    const o = `_drag${l.toUpperCase()}`,
      r = this.visualElement.getProps(),
      c = r[o];
    return (
      c ||
      this.visualElement.getValue(l, (r.initial ? r.initial[l] : void 0) || 0)
    );
  }
  snapToCursor(l) {
    Le((o) => {
      const { drag: r } = this.getProps();
      if (!to(o, r, this.currentDirection)) return;
      const { projection: c } = this.visualElement,
        h = this.getAxisMotionValue(o);
      if (c && c.layout) {
        const { min: f, max: m } = c.layout.layoutBox[o];
        h.set(l[o] - Nt(f, m, 0.5));
      }
    });
  }
  scalePositionWithinConstraints() {
    if (!this.visualElement.current) return;
    const { drag: l, dragConstraints: o } = this.getProps(),
      { projection: r } = this.visualElement;
    if (!ui(o) || !r || !this.constraints) return;
    this.stopAnimation();
    const c = { x: 0, y: 0 };
    Le((f) => {
      const m = this.getAxisMotionValue(f);
      if (m && this.constraints !== !1) {
        const p = m.get();
        c[f] = dT({ min: p, max: p }, this.constraints[f]);
      }
    });
    const { transformTemplate: h } = this.visualElement.getProps();
    (this.visualElement.current.style.transform = h ? h({}, "") : "none"),
      r.root && r.root.updateScroll(),
      r.updateLayout(),
      this.resolveConstraints(),
      Le((f) => {
        if (!to(f, l, null)) return;
        const m = this.getAxisMotionValue(f),
          { min: p, max: g } = this.constraints[f];
        m.set(Nt(p, g, c[f]));
      });
  }
  addListeners() {
    if (!this.visualElement.current) return;
    pT.set(this.visualElement, this);
    const l = this.visualElement.current,
      o = El(l, "pointerdown", (p) => {
        const { drag: g, dragListener: v = !0 } = this.getProps();
        g && v && this.start(p);
      }),
      r = () => {
        const { dragConstraints: p } = this.getProps();
        ui(p) && p.current && (this.constraints = this.resolveRefConstraints());
      },
      { projection: c } = this.visualElement,
      h = c.addEventListener("measure", r);
    c && !c.layout && (c.root && c.root.updateScroll(), c.updateLayout()),
      _t.read(r);
    const f = Nl(window, "resize", () => this.scalePositionWithinConstraints()),
      m = c.addEventListener(
        "didUpdate",
        ({ delta: p, hasLayoutChanged: g }) => {
          this.isDragging &&
            g &&
            (Le((v) => {
              const b = this.getAxisMotionValue(v);
              b &&
                ((this.originPoint[v] += p[v].translate),
                b.set(b.get() + p[v].translate));
            }),
            this.visualElement.render());
        }
      );
    return () => {
      f(), o(), h(), m && m();
    };
  }
  getProps() {
    const l = this.visualElement.getProps(),
      {
        drag: o = !1,
        dragDirectionLock: r = !1,
        dragPropagation: c = !1,
        dragConstraints: h = !1,
        dragElastic: f = dc,
        dragMomentum: m = !0,
      } = l;
    return {
      ...l,
      drag: o,
      dragDirectionLock: r,
      dragPropagation: c,
      dragConstraints: h,
      dragElastic: f,
      dragMomentum: m,
    };
  }
}
function to(a, l, o) {
  return (l === !0 || l === a) && (o === null || o === a);
}
function yT(a, l = 10) {
  let o = null;
  return Math.abs(a.y) > l ? (o = "y") : Math.abs(a.x) > l && (o = "x"), o;
}
class vT extends Pn {
  constructor(l) {
    super(l),
      (this.removeGroupControls = He),
      (this.removeListeners = He),
      (this.controls = new gT(l));
  }
  mount() {
    const { dragControls: l } = this.node.getProps();
    l && (this.removeGroupControls = l.subscribe(this.controls)),
      (this.removeListeners = this.controls.addListeners() || He);
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const Yp = (a) => (l, o) => {
  a && _t.postRender(() => a(l, o));
};
class bT extends Pn {
  constructor() {
    super(...arguments), (this.removePointerDownListener = He);
  }
  onPointerDown(l) {
    this.session = new Ly(l, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: By(this.node),
    });
  }
  createPanHandlers() {
    const {
      onPanSessionStart: l,
      onPanStart: o,
      onPan: r,
      onPanEnd: c,
    } = this.node.getProps();
    return {
      onSessionStart: Yp(l),
      onStart: Yp(o),
      onMove: r,
      onEnd: (h, f) => {
        delete this.session, c && _t.postRender(() => c(h, f));
      },
    };
  }
  mount() {
    this.removePointerDownListener = El(this.node.current, "pointerdown", (l) =>
      this.onPointerDown(l)
    );
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
const so = { hasAnimatedSinceResize: !0, hasEverUpdated: !1 };
function kp(a, l) {
  return l.max === l.min ? 0 : (a / (l.max - l.min)) * 100;
}
const bl = {
    correct: (a, l) => {
      if (!l.target) return a;
      if (typeof a == "string")
        if (it.test(a)) a = parseFloat(a);
        else return a;
      const o = kp(a, l.target.x),
        r = kp(a, l.target.y);
      return `${o}% ${r}%`;
    },
  },
  xT = {
    correct: (a, { treeScale: l, projectionDelta: o }) => {
      const r = a,
        c = Jn.parse(a);
      if (c.length > 5) return r;
      const h = Jn.createTransformer(a),
        f = typeof c[0] != "number" ? 1 : 0,
        m = o.x.scale * l.x,
        p = o.y.scale * l.y;
      (c[0 + f] /= m), (c[1 + f] /= p);
      const g = Nt(m, p, 0.5);
      return (
        typeof c[2 + f] == "number" && (c[2 + f] /= g),
        typeof c[3 + f] == "number" && (c[3 + f] /= g),
        h(c)
      );
    },
  };
class ST extends W.Component {
  componentDidMount() {
    const {
        visualElement: l,
        layoutGroup: o,
        switchLayoutGroup: r,
        layoutId: c,
      } = this.props,
      { projection: h } = l;
    lS(TT),
      h &&
        (o.group && o.group.add(h),
        r && r.register && c && r.register(h),
        h.root.didUpdate(),
        h.addEventListener("animationComplete", () => {
          this.safeToRemove();
        }),
        h.setOptions({
          ...h.options,
          onExitComplete: () => this.safeToRemove(),
        })),
      (so.hasEverUpdated = !0);
  }
  getSnapshotBeforeUpdate(l) {
    const {
        layoutDependency: o,
        visualElement: r,
        drag: c,
        isPresent: h,
      } = this.props,
      { projection: f } = r;
    return (
      f &&
        ((f.isPresent = h),
        c || l.layoutDependency !== o || o === void 0 || l.isPresent !== h
          ? f.willUpdate()
          : this.safeToRemove(),
        l.isPresent !== h &&
          (h
            ? f.promote()
            : f.relegate() ||
              _t.postRender(() => {
                const m = f.getStack();
                (!m || !m.members.length) && this.safeToRemove();
              }))),
      null
    );
  }
  componentDidUpdate() {
    const { projection: l } = this.props.visualElement;
    l &&
      (l.root.didUpdate(),
      Gc.postRender(() => {
        !l.currentAnimation && l.isLead() && this.safeToRemove();
      }));
  }
  componentWillUnmount() {
    const {
        visualElement: l,
        layoutGroup: o,
        switchLayoutGroup: r,
      } = this.props,
      { projection: c } = l;
    c &&
      (c.scheduleCheckAfterUnmount(),
      o && o.group && o.group.remove(c),
      r && r.deregister && r.deregister(c));
  }
  safeToRemove() {
    const { safeToRemove: l } = this.props;
    l && l();
  }
  render() {
    return null;
  }
}
function Gy(a) {
  const [l, o] = Yx(),
    r = W.useContext(Tg);
  return j.jsx(ST, {
    ...a,
    layoutGroup: r,
    switchLayoutGroup: W.useContext(vy),
    isPresent: l,
    safeToRemove: o,
  });
}
const TT = {
  borderRadius: {
    ...bl,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius",
    ],
  },
  borderTopLeftRadius: bl,
  borderTopRightRadius: bl,
  borderBottomLeftRadius: bl,
  borderBottomRightRadius: bl,
  boxShadow: xT,
};
function AT(a, l, o) {
  const r = se(a) ? a : hi(a);
  return r.start(Fc("", r, l, o)), r.animation;
}
const ET = (a, l) => a.depth - l.depth;
class MT {
  constructor() {
    (this.children = []), (this.isDirty = !1);
  }
  add(l) {
    Sc(this.children, l), (this.isDirty = !0);
  }
  remove(l) {
    Tc(this.children, l), (this.isDirty = !0);
  }
  forEach(l) {
    this.isDirty && this.children.sort(ET),
      (this.isDirty = !1),
      this.children.forEach(l);
  }
}
function DT(a, l) {
  const o = ge.now(),
    r = ({ timestamp: c }) => {
      const h = c - o;
      h >= l && (Kn(r), a(h - l));
    };
  return _t.setup(r, !0), () => Kn(r);
}
const qy = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"],
  wT = qy.length,
  Xp = (a) => (typeof a == "string" ? parseFloat(a) : a),
  Zp = (a) => typeof a == "number" || it.test(a);
function RT(a, l, o, r, c, h) {
  c
    ? ((a.opacity = Nt(0, o.opacity ?? 1, OT(r))),
      (a.opacityExit = Nt(l.opacity ?? 1, 0, CT(r))))
    : h && (a.opacity = Nt(l.opacity ?? 1, o.opacity ?? 1, r));
  for (let f = 0; f < wT; f++) {
    const m = `border${qy[f]}Radius`;
    let p = Qp(l, m),
      g = Qp(o, m);
    if (p === void 0 && g === void 0) continue;
    p || (p = 0),
      g || (g = 0),
      p === 0 || g === 0 || Zp(p) === Zp(g)
        ? ((a[m] = Math.max(Nt(Xp(p), Xp(g), r), 0)),
          ($e.test(g) || $e.test(p)) && (a[m] += "%"))
        : (a[m] = g);
  }
  (l.rotate || o.rotate) && (a.rotate = Nt(l.rotate || 0, o.rotate || 0, r));
}
function Qp(a, l) {
  return a[l] !== void 0 ? a[l] : a.borderRadius;
}
const OT = Yy(0, 0.5, Ng),
  CT = Yy(0.5, 0.95, He);
function Yy(a, l, o) {
  return (r) => (r < a ? 0 : r > l ? 1 : o(wl(a, l, r)));
}
function Kp(a, l) {
  (a.min = l.min), (a.max = l.max);
}
function Be(a, l) {
  Kp(a.x, l.x), Kp(a.y, l.y);
}
function Jp(a, l) {
  (a.translate = l.translate),
    (a.scale = l.scale),
    (a.originPoint = l.originPoint),
    (a.origin = l.origin);
}
function Pp(a, l, o, r, c) {
  return (
    (a -= l), (a = fo(a, 1 / o, r)), c !== void 0 && (a = fo(a, 1 / c, r)), a
  );
}
function VT(a, l = 0, o = 1, r = 0.5, c, h = a, f = a) {
  if (
    ($e.test(l) &&
      ((l = parseFloat(l)), (l = Nt(f.min, f.max, l / 100) - f.min)),
    typeof l != "number")
  )
    return;
  let m = Nt(h.min, h.max, r);
  a === h && (m -= l),
    (a.min = Pp(a.min, l, o, m, c)),
    (a.max = Pp(a.max, l, o, m, c));
}
function Fp(a, l, [o, r, c], h, f) {
  VT(a, l[o], l[r], l[c], l.scale, h, f);
}
const zT = ["x", "scaleX", "originX"],
  NT = ["y", "scaleY", "originY"];
function Wp(a, l, o, r) {
  Fp(a.x, l, zT, o ? o.x : void 0, r ? r.x : void 0),
    Fp(a.y, l, NT, o ? o.y : void 0, r ? r.y : void 0);
}
function $p(a) {
  return a.translate === 0 && a.scale === 1;
}
function ky(a) {
  return $p(a.x) && $p(a.y);
}
function Ip(a, l) {
  return a.min === l.min && a.max === l.max;
}
function _T(a, l) {
  return Ip(a.x, l.x) && Ip(a.y, l.y);
}
function tg(a, l) {
  return (
    Math.round(a.min) === Math.round(l.min) &&
    Math.round(a.max) === Math.round(l.max)
  );
}
function Xy(a, l) {
  return tg(a.x, l.x) && tg(a.y, l.y);
}
function eg(a) {
  return ue(a.x) / ue(a.y);
}
function ng(a, l) {
  return (
    a.translate === l.translate &&
    a.scale === l.scale &&
    a.originPoint === l.originPoint
  );
}
class UT {
  constructor() {
    this.members = [];
  }
  add(l) {
    Sc(this.members, l), l.scheduleRender();
  }
  remove(l) {
    if (
      (Tc(this.members, l),
      l === this.prevLead && (this.prevLead = void 0),
      l === this.lead)
    ) {
      const o = this.members[this.members.length - 1];
      o && this.promote(o);
    }
  }
  relegate(l) {
    const o = this.members.findIndex((c) => l === c);
    if (o === 0) return !1;
    let r;
    for (let c = o; c >= 0; c--) {
      const h = this.members[c];
      if (h.isPresent !== !1) {
        r = h;
        break;
      }
    }
    return r ? (this.promote(r), !0) : !1;
  }
  promote(l, o) {
    const r = this.lead;
    if (l !== r && ((this.prevLead = r), (this.lead = l), l.show(), r)) {
      r.instance && r.scheduleRender(),
        l.scheduleRender(),
        (l.resumeFrom = r),
        o && (l.resumeFrom.preserveOpacity = !0),
        r.snapshot &&
          ((l.snapshot = r.snapshot),
          (l.snapshot.latestValues = r.animationValues || r.latestValues)),
        l.root && l.root.isUpdating && (l.isLayoutDirty = !0);
      const { crossfade: c } = l.options;
      c === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((l) => {
      const { options: o, resumingFrom: r } = l;
      o.onExitComplete && o.onExitComplete(),
        r && r.options.onExitComplete && r.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((l) => {
      l.instance && l.scheduleRender(!1);
    });
  }
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function jT(a, l, o) {
  let r = "";
  const c = a.x.translate / l.x,
    h = a.y.translate / l.y,
    f = (o == null ? void 0 : o.z) || 0;
  if (
    ((c || h || f) && (r = `translate3d(${c}px, ${h}px, ${f}px) `),
    (l.x !== 1 || l.y !== 1) && (r += `scale(${1 / l.x}, ${1 / l.y}) `),
    o)
  ) {
    const {
      transformPerspective: g,
      rotate: v,
      rotateX: b,
      rotateY: A,
      skewX: O,
      skewY: B,
    } = o;
    g && (r = `perspective(${g}px) ${r}`),
      v && (r += `rotate(${v}deg) `),
      b && (r += `rotateX(${b}deg) `),
      A && (r += `rotateY(${A}deg) `),
      O && (r += `skewX(${O}deg) `),
      B && (r += `skewY(${B}deg) `);
  }
  const m = a.x.scale * l.x,
    p = a.y.scale * l.y;
  return (m !== 1 || p !== 1) && (r += `scale(${m}, ${p})`), r || "none";
}
const ku = ["", "X", "Y", "Z"],
  BT = { visibility: "hidden" },
  LT = 1e3;
let HT = 0;
function Xu(a, l, o, r) {
  const { latestValues: c } = l;
  c[a] && ((o[a] = c[a]), l.setStaticValue(a, 0), r && (r[a] = 0));
}
function Zy(a) {
  if (((a.hasCheckedOptimisedAppear = !0), a.root === a)) return;
  const { visualElement: l } = a.options;
  if (!l) return;
  const o = wy(l);
  if (window.MotionHasOptimisedAnimation(o, "transform")) {
    const { layout: c, layoutId: h } = a.options;
    window.MotionCancelOptimisedAnimation(o, "transform", _t, !(c || h));
  }
  const { parent: r } = a;
  r && !r.hasCheckedOptimisedAppear && Zy(r);
}
function Qy({
  attachResizeListener: a,
  defaultParent: l,
  measureScroll: o,
  checkIsScrollRoot: r,
  resetTransform: c,
}) {
  return class {
    constructor(f = {}, m = l == null ? void 0 : l()) {
      (this.id = HT++),
        (this.animationId = 0),
        (this.children = new Set()),
        (this.options = {}),
        (this.isTreeAnimating = !1),
        (this.isAnimationBlocked = !1),
        (this.isLayoutDirty = !1),
        (this.isProjectionDirty = !1),
        (this.isSharedProjectionDirty = !1),
        (this.isTransformDirty = !1),
        (this.updateManuallyBlocked = !1),
        (this.updateBlockedByResize = !1),
        (this.isUpdating = !1),
        (this.isSVG = !1),
        (this.needsReset = !1),
        (this.shouldResetTransform = !1),
        (this.hasCheckedOptimisedAppear = !1),
        (this.treeScale = { x: 1, y: 1 }),
        (this.eventHandlers = new Map()),
        (this.hasTreeAnimated = !1),
        (this.updateScheduled = !1),
        (this.scheduleUpdate = () => this.update()),
        (this.projectionUpdateScheduled = !1),
        (this.checkUpdateFailed = () => {
          this.isUpdating && ((this.isUpdating = !1), this.clearAllSnapshots());
        }),
        (this.updateProjection = () => {
          (this.projectionUpdateScheduled = !1),
            this.nodes.forEach(YT),
            this.nodes.forEach(KT),
            this.nodes.forEach(JT),
            this.nodes.forEach(kT);
        }),
        (this.resolvedRelativeTargetAt = 0),
        (this.hasProjected = !1),
        (this.isVisible = !0),
        (this.animationProgress = 0),
        (this.sharedNodes = new Map()),
        (this.latestValues = f),
        (this.root = m ? m.root || m : this),
        (this.path = m ? [...m.path, m] : []),
        (this.parent = m),
        (this.depth = m ? m.depth + 1 : 0);
      for (let p = 0; p < this.path.length; p++)
        this.path[p].shouldResetTransform = !0;
      this.root === this && (this.nodes = new MT());
    }
    addEventListener(f, m) {
      return (
        this.eventHandlers.has(f) || this.eventHandlers.set(f, new Mc()),
        this.eventHandlers.get(f).add(m)
      );
    }
    notifyListeners(f, ...m) {
      const p = this.eventHandlers.get(f);
      p && p.notify(...m);
    }
    hasListeners(f) {
      return this.eventHandlers.has(f);
    }
    mount(f) {
      if (this.instance) return;
      (this.isSVG = dy(f) && !Hx(f)), (this.instance = f);
      const { layoutId: m, layout: p, visualElement: g } = this.options;
      if (
        (g && !g.current && g.mount(f),
        this.root.nodes.add(this),
        this.parent && this.parent.children.add(this),
        this.root.hasTreeAnimated && (p || m) && (this.isLayoutDirty = !0),
        a)
      ) {
        let v;
        const b = () => (this.root.updateBlockedByResize = !1);
        a(f, () => {
          (this.root.updateBlockedByResize = !0),
            v && v(),
            (v = DT(b, 250)),
            so.hasAnimatedSinceResize &&
              ((so.hasAnimatedSinceResize = !1), this.nodes.forEach(ig));
        });
      }
      m && this.root.registerSharedNode(m, this),
        this.options.animate !== !1 &&
          g &&
          (m || p) &&
          this.addEventListener(
            "didUpdate",
            ({
              delta: v,
              hasLayoutChanged: b,
              hasRelativeLayoutChanged: A,
              layout: O,
            }) => {
              if (this.isTreeAnimationBlocked()) {
                (this.target = void 0), (this.relativeTarget = void 0);
                return;
              }
              const B =
                  this.options.transition || g.getDefaultTransition() || IT,
                { onLayoutAnimationStart: L, onLayoutAnimationComplete: Y } =
                  g.getProps(),
                Z = !this.targetLayout || !Xy(this.targetLayout, O),
                $ = !b && A;
              if (
                this.options.layoutRoot ||
                this.resumeFrom ||
                $ ||
                (b && (Z || !this.currentAnimation))
              ) {
                this.resumeFrom &&
                  ((this.resumingFrom = this.resumeFrom),
                  (this.resumingFrom.resumingFrom = void 0));
                const X = { ...Lc(B, "layout"), onPlay: L, onComplete: Y };
                (g.shouldReduceMotion || this.options.layoutRoot) &&
                  ((X.delay = 0), (X.type = !1)),
                  this.startAnimation(X),
                  this.setAnimationOrigin(v, $);
              } else
                b || ig(this),
                  this.isLead() &&
                    this.options.onExitComplete &&
                    this.options.onExitComplete();
              this.targetLayout = O;
            }
          );
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const f = this.getStack();
      f && f.remove(this),
        this.parent && this.parent.children.delete(this),
        (this.instance = void 0),
        this.eventHandlers.clear(),
        Kn(this.updateProjection);
    }
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return (
        this.isAnimationBlocked ||
        (this.parent && this.parent.isTreeAnimationBlocked()) ||
        !1
      );
    }
    startUpdate() {
      this.isUpdateBlocked() ||
        ((this.isUpdating = !0),
        this.nodes && this.nodes.forEach(PT),
        this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: f } = this.options;
      return f && f.getProps().transformTemplate;
    }
    willUpdate(f = !0) {
      if (((this.root.hasTreeAnimated = !0), this.root.isUpdateBlocked())) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (
        (window.MotionCancelOptimisedAnimation &&
          !this.hasCheckedOptimisedAppear &&
          Zy(this),
        !this.root.isUpdating && this.root.startUpdate(),
        this.isLayoutDirty)
      )
        return;
      this.isLayoutDirty = !0;
      for (let v = 0; v < this.path.length; v++) {
        const b = this.path[v];
        (b.shouldResetTransform = !0),
          b.updateScroll("snapshot"),
          b.options.layoutRoot && b.willUpdate(!1);
      }
      const { layoutId: m, layout: p } = this.options;
      if (m === void 0 && !p) return;
      const g = this.getTransformTemplate();
      (this.prevTransformTemplateValue = g ? g(this.latestValues, "") : void 0),
        this.updateSnapshot(),
        f && this.notifyListeners("willUpdate");
    }
    update() {
      if (((this.updateScheduled = !1), this.isUpdateBlocked())) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(ag);
        return;
      }
      this.isUpdating || this.nodes.forEach(ZT),
        (this.isUpdating = !1),
        this.nodes.forEach(QT),
        this.nodes.forEach(GT),
        this.nodes.forEach(qT),
        this.clearAllSnapshots();
      const m = ge.now();
      (ee.delta = gn(0, 1e3 / 60, m - ee.timestamp)),
        (ee.timestamp = m),
        (ee.isProcessing = !0),
        Uu.update.process(ee),
        Uu.preRender.process(ee),
        Uu.render.process(ee),
        (ee.isProcessing = !1);
    }
    didUpdate() {
      this.updateScheduled ||
        ((this.updateScheduled = !0), Gc.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(XT), this.sharedNodes.forEach(FT);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled ||
        ((this.projectionUpdateScheduled = !0),
        _t.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      _t.postRender(() => {
        this.isLayoutDirty
          ? this.root.didUpdate()
          : this.root.checkUpdateFailed();
      });
    }
    updateSnapshot() {
      this.snapshot ||
        !this.instance ||
        ((this.snapshot = this.measure()),
        this.snapshot &&
          !ue(this.snapshot.measuredBox.x) &&
          !ue(this.snapshot.measuredBox.y) &&
          (this.snapshot = void 0));
    }
    updateLayout() {
      if (
        !this.instance ||
        (this.updateScroll(),
        !(this.options.alwaysMeasureLayout && this.isLead()) &&
          !this.isLayoutDirty)
      )
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let p = 0; p < this.path.length; p++) this.path[p].updateScroll();
      const f = this.layout;
      (this.layout = this.measure(!1)),
        (this.layoutCorrected = qt()),
        (this.isLayoutDirty = !1),
        (this.projectionDelta = void 0),
        this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: m } = this.options;
      m &&
        m.notify(
          "LayoutMeasure",
          this.layout.layoutBox,
          f ? f.layoutBox : void 0
        );
    }
    updateScroll(f = "measure") {
      let m = !!(this.options.layoutScroll && this.instance);
      if (
        (this.scroll &&
          this.scroll.animationId === this.root.animationId &&
          this.scroll.phase === f &&
          (m = !1),
        m && this.instance)
      ) {
        const p = r(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: f,
          isRoot: p,
          offset: o(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : p,
        };
      }
    }
    resetTransform() {
      if (!c) return;
      const f =
          this.isLayoutDirty ||
          this.shouldResetTransform ||
          this.options.alwaysMeasureLayout,
        m = this.projectionDelta && !ky(this.projectionDelta),
        p = this.getTransformTemplate(),
        g = p ? p(this.latestValues, "") : void 0,
        v = g !== this.prevTransformTemplateValue;
      f &&
        this.instance &&
        (m || ga(this.latestValues) || v) &&
        (c(this.instance, g),
        (this.shouldResetTransform = !1),
        this.scheduleRender());
    }
    measure(f = !0) {
      const m = this.measurePageBox();
      let p = this.removeElementScroll(m);
      return (
        f && (p = this.removeTransform(p)),
        tA(p),
        {
          animationId: this.root.animationId,
          measuredBox: m,
          layoutBox: p,
          latestValues: {},
          source: this.id,
        }
      );
    }
    measurePageBox() {
      var g;
      const { visualElement: f } = this.options;
      if (!f) return qt();
      const m = f.measureViewportBox();
      if (
        !(
          ((g = this.scroll) == null ? void 0 : g.wasRoot) || this.path.some(eA)
        )
      ) {
        const { scroll: v } = this.root;
        v && (fi(m.x, v.offset.x), fi(m.y, v.offset.y));
      }
      return m;
    }
    removeElementScroll(f) {
      var p;
      const m = qt();
      if ((Be(m, f), (p = this.scroll) != null && p.wasRoot)) return m;
      for (let g = 0; g < this.path.length; g++) {
        const v = this.path[g],
          { scroll: b, options: A } = v;
        v !== this.root &&
          b &&
          A.layoutScroll &&
          (b.wasRoot && Be(m, f), fi(m.x, b.offset.x), fi(m.y, b.offset.y));
      }
      return m;
    }
    applyTransform(f, m = !1) {
      const p = qt();
      Be(p, f);
      for (let g = 0; g < this.path.length; g++) {
        const v = this.path[g];
        !m &&
          v.options.layoutScroll &&
          v.scroll &&
          v !== v.root &&
          di(p, { x: -v.scroll.offset.x, y: -v.scroll.offset.y }),
          ga(v.latestValues) && di(p, v.latestValues);
      }
      return ga(this.latestValues) && di(p, this.latestValues), p;
    }
    removeTransform(f) {
      const m = qt();
      Be(m, f);
      for (let p = 0; p < this.path.length; p++) {
        const g = this.path[p];
        if (!g.instance || !ga(g.latestValues)) continue;
        cc(g.latestValues) && g.updateSnapshot();
        const v = qt(),
          b = g.measurePageBox();
        Be(v, b),
          Wp(m, g.latestValues, g.snapshot ? g.snapshot.layoutBox : void 0, v);
      }
      return ga(this.latestValues) && Wp(m, this.latestValues), m;
    }
    setTargetDelta(f) {
      (this.targetDelta = f),
        this.root.scheduleUpdateProjection(),
        (this.isProjectionDirty = !0);
    }
    setOptions(f) {
      this.options = {
        ...this.options,
        ...f,
        crossfade: f.crossfade !== void 0 ? f.crossfade : !0,
      };
    }
    clearMeasurements() {
      (this.scroll = void 0),
        (this.layout = void 0),
        (this.snapshot = void 0),
        (this.prevTransformTemplateValue = void 0),
        (this.targetDelta = void 0),
        (this.target = void 0),
        (this.isLayoutDirty = !1);
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent &&
        this.relativeParent.resolvedRelativeTargetAt !== ee.timestamp &&
        this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(f = !1) {
      var A;
      const m = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = m.isProjectionDirty),
        this.isTransformDirty || (this.isTransformDirty = m.isTransformDirty),
        this.isSharedProjectionDirty ||
          (this.isSharedProjectionDirty = m.isSharedProjectionDirty);
      const p = !!this.resumingFrom || this !== m;
      if (
        !(
          f ||
          (p && this.isSharedProjectionDirty) ||
          this.isProjectionDirty ||
          ((A = this.parent) != null && A.isProjectionDirty) ||
          this.attemptToResolveRelativeTarget ||
          this.root.updateBlockedByResize
        )
      )
        return;
      const { layout: v, layoutId: b } = this.options;
      if (!(!this.layout || !(v || b))) {
        if (
          ((this.resolvedRelativeTargetAt = ee.timestamp),
          !this.targetDelta && !this.relativeTarget)
        ) {
          const O = this.getClosestProjectingParent();
          O && O.layout && this.animationProgress !== 1
            ? ((this.relativeParent = O),
              this.forceRelativeParentToResolveTarget(),
              (this.relativeTarget = qt()),
              (this.relativeTargetOrigin = qt()),
              Dl(
                this.relativeTargetOrigin,
                this.layout.layoutBox,
                O.layout.layoutBox
              ),
              Be(this.relativeTarget, this.relativeTargetOrigin))
            : (this.relativeParent = this.relativeTarget = void 0);
        }
        if (
          !(!this.relativeTarget && !this.targetDelta) &&
          (this.target ||
            ((this.target = qt()), (this.targetWithTransforms = qt())),
          this.relativeTarget &&
          this.relativeTargetOrigin &&
          this.relativeParent &&
          this.relativeParent.target
            ? (this.forceRelativeParentToResolveTarget(),
              aT(this.target, this.relativeTarget, this.relativeParent.target))
            : this.targetDelta
            ? (this.resumingFrom
                ? (this.target = this.applyTransform(this.layout.layoutBox))
                : Be(this.target, this.layout.layoutBox),
              Uy(this.target, this.targetDelta))
            : Be(this.target, this.layout.layoutBox),
          this.attemptToResolveRelativeTarget)
        ) {
          this.attemptToResolveRelativeTarget = !1;
          const O = this.getClosestProjectingParent();
          O &&
          !!O.resumingFrom == !!this.resumingFrom &&
          !O.options.layoutScroll &&
          O.target &&
          this.animationProgress !== 1
            ? ((this.relativeParent = O),
              this.forceRelativeParentToResolveTarget(),
              (this.relativeTarget = qt()),
              (this.relativeTargetOrigin = qt()),
              Dl(this.relativeTargetOrigin, this.target, O.target),
              Be(this.relativeTarget, this.relativeTargetOrigin))
            : (this.relativeParent = this.relativeTarget = void 0);
        }
      }
    }
    getClosestProjectingParent() {
      if (
        !(
          !this.parent ||
          cc(this.parent.latestValues) ||
          _y(this.parent.latestValues)
        )
      )
        return this.parent.isProjecting()
          ? this.parent
          : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!(
        (this.relativeTarget || this.targetDelta || this.options.layoutRoot) &&
        this.layout
      );
    }
    calcProjection() {
      var B;
      const f = this.getLead(),
        m = !!this.resumingFrom || this !== f;
      let p = !0;
      if (
        ((this.isProjectionDirty ||
          ((B = this.parent) != null && B.isProjectionDirty)) &&
          (p = !1),
        m &&
          (this.isSharedProjectionDirty || this.isTransformDirty) &&
          (p = !1),
        this.resolvedRelativeTargetAt === ee.timestamp && (p = !1),
        p)
      )
        return;
      const { layout: g, layoutId: v } = this.options;
      if (
        ((this.isTreeAnimating = !!(
          (this.parent && this.parent.isTreeAnimating) ||
          this.currentAnimation ||
          this.pendingAnimation
        )),
        this.isTreeAnimating ||
          (this.targetDelta = this.relativeTarget = void 0),
        !this.layout || !(g || v))
      )
        return;
      Be(this.layoutCorrected, this.layout.layoutBox);
      const b = this.treeScale.x,
        A = this.treeScale.y;
      iT(this.layoutCorrected, this.treeScale, this.path, m),
        f.layout &&
          !f.target &&
          (this.treeScale.x !== 1 || this.treeScale.y !== 1) &&
          ((f.target = f.layout.layoutBox), (f.targetWithTransforms = qt()));
      const { target: O } = f;
      if (!O) {
        this.prevProjectionDelta &&
          (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta
        ? this.createProjectionDeltas()
        : (Jp(this.prevProjectionDelta.x, this.projectionDelta.x),
          Jp(this.prevProjectionDelta.y, this.projectionDelta.y)),
        Ml(this.projectionDelta, this.layoutCorrected, O, this.latestValues),
        (this.treeScale.x !== b ||
          this.treeScale.y !== A ||
          !ng(this.projectionDelta.x, this.prevProjectionDelta.x) ||
          !ng(this.projectionDelta.y, this.prevProjectionDelta.y)) &&
          ((this.hasProjected = !0),
          this.scheduleRender(),
          this.notifyListeners("projectionUpdate", O));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(f = !0) {
      var m;
      if (((m = this.options.visualElement) == null || m.scheduleRender(), f)) {
        const p = this.getStack();
        p && p.scheduleRender();
      }
      this.resumingFrom &&
        !this.resumingFrom.instance &&
        (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      (this.prevProjectionDelta = ci()),
        (this.projectionDelta = ci()),
        (this.projectionDeltaWithTransform = ci());
    }
    setAnimationOrigin(f, m = !1) {
      const p = this.snapshot,
        g = p ? p.latestValues : {},
        v = { ...this.latestValues },
        b = ci();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) &&
        (this.relativeTarget = this.relativeTargetOrigin = void 0),
        (this.attemptToResolveRelativeTarget = !m);
      const A = qt(),
        O = p ? p.source : void 0,
        B = this.layout ? this.layout.source : void 0,
        L = O !== B,
        Y = this.getStack(),
        Z = !Y || Y.members.length <= 1,
        $ = !!(L && !Z && this.options.crossfade === !0 && !this.path.some($T));
      this.animationProgress = 0;
      let X;
      (this.mixTargetDelta = (lt) => {
        const k = lt / 1e3;
        lg(b.x, f.x, k),
          lg(b.y, f.y, k),
          this.setTargetDelta(b),
          this.relativeTarget &&
            this.relativeTargetOrigin &&
            this.layout &&
            this.relativeParent &&
            this.relativeParent.layout &&
            (Dl(A, this.layout.layoutBox, this.relativeParent.layout.layoutBox),
            WT(this.relativeTarget, this.relativeTargetOrigin, A, k),
            X && _T(this.relativeTarget, X) && (this.isProjectionDirty = !1),
            X || (X = qt()),
            Be(X, this.relativeTarget)),
          L &&
            ((this.animationValues = v), RT(v, g, this.latestValues, k, $, Z)),
          this.root.scheduleUpdateProjection(),
          this.scheduleRender(),
          (this.animationProgress = k);
      }),
        this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(f) {
      var m, p, g;
      this.notifyListeners("animationStart"),
        (m = this.currentAnimation) == null || m.stop(),
        (g = (p = this.resumingFrom) == null ? void 0 : p.currentAnimation) ==
          null || g.stop(),
        this.pendingAnimation &&
          (Kn(this.pendingAnimation), (this.pendingAnimation = void 0)),
        (this.pendingAnimation = _t.update(() => {
          (so.hasAnimatedSinceResize = !0),
            this.motionValue || (this.motionValue = hi(0)),
            (this.currentAnimation = AT(this.motionValue, [0, 1e3], {
              ...f,
              isSync: !0,
              onUpdate: (v) => {
                this.mixTargetDelta(v), f.onUpdate && f.onUpdate(v);
              },
              onStop: () => {},
              onComplete: () => {
                f.onComplete && f.onComplete(), this.completeAnimation();
              },
            })),
            this.resumingFrom &&
              (this.resumingFrom.currentAnimation = this.currentAnimation),
            (this.pendingAnimation = void 0);
        }));
    }
    completeAnimation() {
      this.resumingFrom &&
        ((this.resumingFrom.currentAnimation = void 0),
        (this.resumingFrom.preserveOpacity = void 0));
      const f = this.getStack();
      f && f.exitAnimationComplete(),
        (this.resumingFrom =
          this.currentAnimation =
          this.animationValues =
            void 0),
        this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation &&
        (this.mixTargetDelta && this.mixTargetDelta(LT),
        this.currentAnimation.stop()),
        this.completeAnimation();
    }
    applyTransformsToTarget() {
      const f = this.getLead();
      let {
        targetWithTransforms: m,
        target: p,
        layout: g,
        latestValues: v,
      } = f;
      if (!(!m || !p || !g)) {
        if (
          this !== f &&
          this.layout &&
          g &&
          Ky(this.options.animationType, this.layout.layoutBox, g.layoutBox)
        ) {
          p = this.target || qt();
          const b = ue(this.layout.layoutBox.x);
          (p.x.min = f.target.x.min), (p.x.max = p.x.min + b);
          const A = ue(this.layout.layoutBox.y);
          (p.y.min = f.target.y.min), (p.y.max = p.y.min + A);
        }
        Be(m, p),
          di(m, v),
          Ml(this.projectionDeltaWithTransform, this.layoutCorrected, m, v);
      }
    }
    registerSharedNode(f, m) {
      this.sharedNodes.has(f) || this.sharedNodes.set(f, new UT()),
        this.sharedNodes.get(f).add(m);
      const g = m.options.initialPromotionConfig;
      m.promote({
        transition: g ? g.transition : void 0,
        preserveFollowOpacity:
          g && g.shouldPreserveFollowOpacity
            ? g.shouldPreserveFollowOpacity(m)
            : void 0,
      });
    }
    isLead() {
      const f = this.getStack();
      return f ? f.lead === this : !0;
    }
    getLead() {
      var m;
      const { layoutId: f } = this.options;
      return f
        ? ((m = this.getStack()) == null ? void 0 : m.lead) || this
        : this;
    }
    getPrevLead() {
      var m;
      const { layoutId: f } = this.options;
      return f ? ((m = this.getStack()) == null ? void 0 : m.prevLead) : void 0;
    }
    getStack() {
      const { layoutId: f } = this.options;
      if (f) return this.root.sharedNodes.get(f);
    }
    promote({ needsReset: f, transition: m, preserveFollowOpacity: p } = {}) {
      const g = this.getStack();
      g && g.promote(this, p),
        f && ((this.projectionDelta = void 0), (this.needsReset = !0)),
        m && this.setOptions({ transition: m });
    }
    relegate() {
      const f = this.getStack();
      return f ? f.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: f } = this.options;
      if (!f) return;
      let m = !1;
      const { latestValues: p } = f;
      if (
        ((p.z ||
          p.rotate ||
          p.rotateX ||
          p.rotateY ||
          p.rotateZ ||
          p.skewX ||
          p.skewY) &&
          (m = !0),
        !m)
      )
        return;
      const g = {};
      p.z && Xu("z", f, g, this.animationValues);
      for (let v = 0; v < ku.length; v++)
        Xu(`rotate${ku[v]}`, f, g, this.animationValues),
          Xu(`skew${ku[v]}`, f, g, this.animationValues);
      f.render();
      for (const v in g)
        f.setStaticValue(v, g[v]),
          this.animationValues && (this.animationValues[v] = g[v]);
      f.scheduleRender();
    }
    getProjectionStyles(f) {
      if (!this.instance || this.isSVG) return;
      if (!this.isVisible) return BT;
      const m = { visibility: "" },
        p = this.getTransformTemplate();
      if (this.needsReset)
        return (
          (this.needsReset = !1),
          (m.opacity = ""),
          (m.pointerEvents = lo(f == null ? void 0 : f.pointerEvents) || ""),
          (m.transform = p ? p(this.latestValues, "") : "none"),
          m
        );
      const g = this.getLead();
      if (!this.projectionDelta || !this.layout || !g.target) {
        const O = {};
        return (
          this.options.layoutId &&
            ((O.opacity =
              this.latestValues.opacity !== void 0
                ? this.latestValues.opacity
                : 1),
            (O.pointerEvents = lo(f == null ? void 0 : f.pointerEvents) || "")),
          this.hasProjected &&
            !ga(this.latestValues) &&
            ((O.transform = p ? p({}, "") : "none"), (this.hasProjected = !1)),
          O
        );
      }
      const v = g.animationValues || g.latestValues;
      this.applyTransformsToTarget(),
        (m.transform = jT(
          this.projectionDeltaWithTransform,
          this.treeScale,
          v
        )),
        p && (m.transform = p(v, m.transform));
      const { x: b, y: A } = this.projectionDelta;
      (m.transformOrigin = `${b.origin * 100}% ${A.origin * 100}% 0`),
        g.animationValues
          ? (m.opacity =
              g === this
                ? v.opacity ?? this.latestValues.opacity ?? 1
                : this.preserveOpacity
                ? this.latestValues.opacity
                : v.opacityExit)
          : (m.opacity =
              g === this
                ? v.opacity !== void 0
                  ? v.opacity
                  : ""
                : v.opacityExit !== void 0
                ? v.opacityExit
                : 0);
      for (const O in Vl) {
        if (v[O] === void 0) continue;
        const { correct: B, applyTo: L, isCSSVariable: Y } = Vl[O],
          Z = m.transform === "none" ? v[O] : B(v[O], g);
        if (L) {
          const $ = L.length;
          for (let X = 0; X < $; X++) m[L[X]] = Z;
        } else
          Y ? (this.options.visualElement.renderState.vars[O] = Z) : (m[O] = Z);
      }
      return (
        this.options.layoutId &&
          (m.pointerEvents =
            g === this
              ? lo(f == null ? void 0 : f.pointerEvents) || ""
              : "none"),
        m
      );
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    resetTree() {
      this.root.nodes.forEach((f) => {
        var m;
        return (m = f.currentAnimation) == null ? void 0 : m.stop();
      }),
        this.root.nodes.forEach(ag),
        this.root.sharedNodes.clear();
    }
  };
}
function GT(a) {
  a.updateLayout();
}
function qT(a) {
  var o;
  const l = ((o = a.resumeFrom) == null ? void 0 : o.snapshot) || a.snapshot;
  if (a.isLead() && a.layout && l && a.hasListeners("didUpdate")) {
    const { layoutBox: r, measuredBox: c } = a.layout,
      { animationType: h } = a.options,
      f = l.source !== a.layout.source;
    h === "size"
      ? Le((b) => {
          const A = f ? l.measuredBox[b] : l.layoutBox[b],
            O = ue(A);
          (A.min = r[b].min), (A.max = A.min + O);
        })
      : Ky(h, l.layoutBox, r) &&
        Le((b) => {
          const A = f ? l.measuredBox[b] : l.layoutBox[b],
            O = ue(r[b]);
          (A.max = A.min + O),
            a.relativeTarget &&
              !a.currentAnimation &&
              ((a.isProjectionDirty = !0),
              (a.relativeTarget[b].max = a.relativeTarget[b].min + O));
        });
    const m = ci();
    Ml(m, r, l.layoutBox);
    const p = ci();
    f ? Ml(p, a.applyTransform(c, !0), l.measuredBox) : Ml(p, r, l.layoutBox);
    const g = !ky(m);
    let v = !1;
    if (!a.resumeFrom) {
      const b = a.getClosestProjectingParent();
      if (b && !b.resumeFrom) {
        const { snapshot: A, layout: O } = b;
        if (A && O) {
          const B = qt();
          Dl(B, l.layoutBox, A.layoutBox);
          const L = qt();
          Dl(L, r, O.layoutBox),
            Xy(B, L) || (v = !0),
            b.options.layoutRoot &&
              ((a.relativeTarget = L),
              (a.relativeTargetOrigin = B),
              (a.relativeParent = b));
        }
      }
    }
    a.notifyListeners("didUpdate", {
      layout: r,
      snapshot: l,
      delta: p,
      layoutDelta: m,
      hasLayoutChanged: g,
      hasRelativeLayoutChanged: v,
    });
  } else if (a.isLead()) {
    const { onExitComplete: r } = a.options;
    r && r();
  }
  a.options.transition = void 0;
}
function YT(a) {
  a.parent &&
    (a.isProjecting() || (a.isProjectionDirty = a.parent.isProjectionDirty),
    a.isSharedProjectionDirty ||
      (a.isSharedProjectionDirty = !!(
        a.isProjectionDirty ||
        a.parent.isProjectionDirty ||
        a.parent.isSharedProjectionDirty
      )),
    a.isTransformDirty || (a.isTransformDirty = a.parent.isTransformDirty));
}
function kT(a) {
  a.isProjectionDirty = a.isSharedProjectionDirty = a.isTransformDirty = !1;
}
function XT(a) {
  a.clearSnapshot();
}
function ag(a) {
  a.clearMeasurements();
}
function ZT(a) {
  a.isLayoutDirty = !1;
}
function QT(a) {
  const { visualElement: l } = a.options;
  l && l.getProps().onBeforeLayoutMeasure && l.notify("BeforeLayoutMeasure"),
    a.resetTransform();
}
function ig(a) {
  a.finishAnimation(),
    (a.targetDelta = a.relativeTarget = a.target = void 0),
    (a.isProjectionDirty = !0);
}
function KT(a) {
  a.resolveTargetDelta();
}
function JT(a) {
  a.calcProjection();
}
function PT(a) {
  a.resetSkewAndRotation();
}
function FT(a) {
  a.removeLeadSnapshot();
}
function lg(a, l, o) {
  (a.translate = Nt(l.translate, 0, o)),
    (a.scale = Nt(l.scale, 1, o)),
    (a.origin = l.origin),
    (a.originPoint = l.originPoint);
}
function sg(a, l, o, r) {
  (a.min = Nt(l.min, o.min, r)), (a.max = Nt(l.max, o.max, r));
}
function WT(a, l, o, r) {
  sg(a.x, l.x, o.x, r), sg(a.y, l.y, o.y, r);
}
function $T(a) {
  return a.animationValues && a.animationValues.opacityExit !== void 0;
}
const IT = { duration: 0.45, ease: [0.4, 0, 0.1, 1] },
  og = (a) =>
    typeof navigator < "u" &&
    navigator.userAgent &&
    navigator.userAgent.toLowerCase().includes(a),
  rg = og("applewebkit/") && !og("chrome/") ? Math.round : He;
function ug(a) {
  (a.min = rg(a.min)), (a.max = rg(a.max));
}
function tA(a) {
  ug(a.x), ug(a.y);
}
function Ky(a, l, o) {
  return (
    a === "position" || (a === "preserve-aspect" && !nT(eg(l), eg(o), 0.2))
  );
}
function eA(a) {
  var l;
  return a !== a.root && ((l = a.scroll) == null ? void 0 : l.wasRoot);
}
const nA = Qy({
    attachResizeListener: (a, l) => Nl(a, "resize", l),
    measureScroll: () => ({
      x: document.documentElement.scrollLeft || document.body.scrollLeft,
      y: document.documentElement.scrollTop || document.body.scrollTop,
    }),
    checkIsScrollRoot: () => !0,
  }),
  Zu = { current: void 0 },
  Jy = Qy({
    measureScroll: (a) => ({ x: a.scrollLeft, y: a.scrollTop }),
    defaultParent: () => {
      if (!Zu.current) {
        const a = new nA({});
        a.mount(window), a.setOptions({ layoutScroll: !0 }), (Zu.current = a);
      }
      return Zu.current;
    },
    resetTransform: (a, l) => {
      a.style.transform = l !== void 0 ? l : "none";
    },
    checkIsScrollRoot: (a) => window.getComputedStyle(a).position === "fixed",
  }),
  aA = {
    pan: { Feature: bT },
    drag: { Feature: vT, ProjectionNode: Jy, MeasureLayout: Gy },
  };
function cg(a, l, o) {
  const { props: r } = a;
  a.animationState &&
    r.whileHover &&
    a.animationState.setActive("whileHover", o === "Start");
  const c = "onHover" + o,
    h = r[c];
  h && _t.postRender(() => h(l, Bl(l)));
}
class iA extends Pn {
  mount() {
    const { current: l } = this.node;
    l &&
      (this.unmount = _x(
        l,
        (o, r) => (cg(this.node, r, "Start"), (c) => cg(this.node, c, "End"))
      ));
  }
  unmount() {}
}
class lA extends Pn {
  constructor() {
    super(...arguments), (this.isActive = !1);
  }
  onFocus() {
    let l = !1;
    try {
      l = this.node.current.matches(":focus-visible");
    } catch {
      l = !0;
    }
    !l ||
      !this.node.animationState ||
      (this.node.animationState.setActive("whileFocus", !0),
      (this.isActive = !0));
  }
  onBlur() {
    !this.isActive ||
      !this.node.animationState ||
      (this.node.animationState.setActive("whileFocus", !1),
      (this.isActive = !1));
  }
  mount() {
    this.unmount = _l(
      Nl(this.node.current, "focus", () => this.onFocus()),
      Nl(this.node.current, "blur", () => this.onBlur())
    );
  }
  unmount() {}
}
function fg(a, l, o) {
  const { props: r } = a;
  if (a.current instanceof HTMLButtonElement && a.current.disabled) return;
  a.animationState &&
    r.whileTap &&
    a.animationState.setActive("whileTap", o === "Start");
  const c = "onTap" + (o === "End" ? "" : o),
    h = r[c];
  h && _t.postRender(() => h(l, Bl(l)));
}
class sA extends Pn {
  mount() {
    const { current: l } = this.node;
    l &&
      (this.unmount = Lx(
        l,
        (o, r) => (
          fg(this.node, r, "Start"),
          (c, { success: h }) => fg(this.node, c, h ? "End" : "Cancel")
        ),
        { useGlobalTarget: this.node.props.globalTapTarget }
      ));
  }
  unmount() {}
}
const hc = new WeakMap(),
  Qu = new WeakMap(),
  oA = (a) => {
    const l = hc.get(a.target);
    l && l(a);
  },
  rA = (a) => {
    a.forEach(oA);
  };
function uA({ root: a, ...l }) {
  const o = a || document;
  Qu.has(o) || Qu.set(o, {});
  const r = Qu.get(o),
    c = JSON.stringify(l);
  return r[c] || (r[c] = new IntersectionObserver(rA, { root: a, ...l })), r[c];
}
function cA(a, l, o) {
  const r = uA(l);
  return (
    hc.set(a, o),
    r.observe(a),
    () => {
      hc.delete(a), r.unobserve(a);
    }
  );
}
const fA = { some: 0, all: 1 };
class dA extends Pn {
  constructor() {
    super(...arguments), (this.hasEnteredView = !1), (this.isInView = !1);
  }
  startObserver() {
    this.unmount();
    const { viewport: l = {} } = this.node.getProps(),
      { root: o, margin: r, amount: c = "some", once: h } = l,
      f = {
        root: o ? o.current : void 0,
        rootMargin: r,
        threshold: typeof c == "number" ? c : fA[c],
      },
      m = (p) => {
        const { isIntersecting: g } = p;
        if (
          this.isInView === g ||
          ((this.isInView = g), h && !g && this.hasEnteredView)
        )
          return;
        g && (this.hasEnteredView = !0),
          this.node.animationState &&
            this.node.animationState.setActive("whileInView", g);
        const { onViewportEnter: v, onViewportLeave: b } = this.node.getProps(),
          A = g ? v : b;
        A && A(p);
      };
    return cA(this.node.current, f, m);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u") return;
    const { props: l, prevProps: o } = this.node;
    ["amount", "margin", "root"].some(hA(l, o)) && this.startObserver();
  }
  unmount() {}
}
function hA({ viewport: a = {} }, { viewport: l = {} } = {}) {
  return (o) => a[o] !== l[o];
}
const mA = {
    inView: { Feature: dA },
    tap: { Feature: sA },
    focus: { Feature: lA },
    hover: { Feature: iA },
  },
  pA = { layout: { ProjectionNode: Jy, MeasureLayout: Gy } },
  mc = { current: null },
  Py = { current: !1 };
function gA() {
  if (((Py.current = !0), !!bc))
    if (window.matchMedia) {
      const a = window.matchMedia("(prefers-reduced-motion)"),
        l = () => (mc.current = a.matches);
      a.addListener(l), l();
    } else mc.current = !1;
}
const yA = new WeakMap();
function vA(a, l, o) {
  for (const r in l) {
    const c = l[r],
      h = o[r];
    if (se(c)) a.addValue(r, c);
    else if (se(h)) a.addValue(r, hi(c, { owner: a }));
    else if (h !== c)
      if (a.hasValue(r)) {
        const f = a.getValue(r);
        f.liveStyle === !0 ? f.jump(c) : f.hasAnimated || f.set(c);
      } else {
        const f = a.getStaticValue(r);
        a.addValue(r, hi(f !== void 0 ? f : c, { owner: a }));
      }
  }
  for (const r in o) l[r] === void 0 && a.removeValue(r);
  return l;
}
const dg = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete",
];
class bA {
  scrapeMotionValuesFromProps(l, o, r) {
    return {};
  }
  constructor(
    {
      parent: l,
      props: o,
      presenceContext: r,
      reducedMotionConfig: c,
      blockInitialAnimation: h,
      visualState: f,
    },
    m = {}
  ) {
    (this.current = null),
      (this.children = new Set()),
      (this.isVariantNode = !1),
      (this.isControllingVariants = !1),
      (this.shouldReduceMotion = null),
      (this.values = new Map()),
      (this.KeyframeResolver = Bc),
      (this.features = {}),
      (this.valueSubscriptions = new Map()),
      (this.prevMotionValues = {}),
      (this.events = {}),
      (this.propEventSubscriptions = {}),
      (this.notifyUpdate = () => this.notify("Update", this.latestValues)),
      (this.render = () => {
        this.current &&
          (this.triggerBuild(),
          this.renderInstance(
            this.current,
            this.renderState,
            this.props.style,
            this.projection
          ));
      }),
      (this.renderScheduledAt = 0),
      (this.scheduleRender = () => {
        const A = ge.now();
        this.renderScheduledAt < A &&
          ((this.renderScheduledAt = A), _t.render(this.render, !1, !0));
      });
    const { latestValues: p, renderState: g } = f;
    (this.latestValues = p),
      (this.baseTarget = { ...p }),
      (this.initialValues = o.initial ? { ...p } : {}),
      (this.renderState = g),
      (this.parent = l),
      (this.props = o),
      (this.presenceContext = r),
      (this.depth = l ? l.depth + 1 : 0),
      (this.reducedMotionConfig = c),
      (this.options = m),
      (this.blockInitialAnimation = !!h),
      (this.isControllingVariants = po(o)),
      (this.isVariantNode = gy(o)),
      this.isVariantNode && (this.variantChildren = new Set()),
      (this.manuallyAnimateOnMount = !!(l && l.current));
    const { willChange: v, ...b } = this.scrapeMotionValuesFromProps(
      o,
      {},
      this
    );
    for (const A in b) {
      const O = b[A];
      p[A] !== void 0 && se(O) && O.set(p[A], !1);
    }
  }
  mount(l) {
    (this.current = l),
      yA.set(l, this),
      this.projection && !this.projection.instance && this.projection.mount(l),
      this.parent &&
        this.isVariantNode &&
        !this.isControllingVariants &&
        (this.removeFromVariantTree = this.parent.addVariantChild(this)),
      this.values.forEach((o, r) => this.bindToMotionValue(r, o)),
      Py.current || gA(),
      (this.shouldReduceMotion =
        this.reducedMotionConfig === "never"
          ? !1
          : this.reducedMotionConfig === "always"
          ? !0
          : mc.current),
      this.parent && this.parent.children.add(this),
      this.update(this.props, this.presenceContext);
  }
  unmount() {
    this.projection && this.projection.unmount(),
      Kn(this.notifyUpdate),
      Kn(this.render),
      this.valueSubscriptions.forEach((l) => l()),
      this.valueSubscriptions.clear(),
      this.removeFromVariantTree && this.removeFromVariantTree(),
      this.parent && this.parent.children.delete(this);
    for (const l in this.events) this.events[l].clear();
    for (const l in this.features) {
      const o = this.features[l];
      o && (o.unmount(), (o.isMounted = !1));
    }
    this.current = null;
  }
  bindToMotionValue(l, o) {
    this.valueSubscriptions.has(l) && this.valueSubscriptions.get(l)();
    const r = yi.has(l);
    r && this.onBindTransform && this.onBindTransform();
    const c = o.on("change", (m) => {
        (this.latestValues[l] = m),
          this.props.onUpdate && _t.preRender(this.notifyUpdate),
          r && this.projection && (this.projection.isTransformDirty = !0);
      }),
      h = o.on("renderRequest", this.scheduleRender);
    let f;
    window.MotionCheckAppearSync &&
      (f = window.MotionCheckAppearSync(this, l, o)),
      this.valueSubscriptions.set(l, () => {
        c(), h(), f && f(), o.owner && o.stop();
      });
  }
  sortNodePosition(l) {
    return !this.current ||
      !this.sortInstanceNodePosition ||
      this.type !== l.type
      ? 0
      : this.sortInstanceNodePosition(this.current, l.current);
  }
  updateFeatures() {
    let l = "animation";
    for (l in mi) {
      const o = mi[l];
      if (!o) continue;
      const { isEnabled: r, Feature: c } = o;
      if (
        (!this.features[l] &&
          c &&
          r(this.props) &&
          (this.features[l] = new c(this)),
        this.features[l])
      ) {
        const h = this.features[l];
        h.isMounted ? h.update() : (h.mount(), (h.isMounted = !0));
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  measureViewportBox() {
    return this.current
      ? this.measureInstanceViewportBox(this.current, this.props)
      : qt();
  }
  getStaticValue(l) {
    return this.latestValues[l];
  }
  setStaticValue(l, o) {
    this.latestValues[l] = o;
  }
  update(l, o) {
    (l.transformTemplate || this.props.transformTemplate) &&
      this.scheduleRender(),
      (this.prevProps = this.props),
      (this.props = l),
      (this.prevPresenceContext = this.presenceContext),
      (this.presenceContext = o);
    for (let r = 0; r < dg.length; r++) {
      const c = dg[r];
      this.propEventSubscriptions[c] &&
        (this.propEventSubscriptions[c](),
        delete this.propEventSubscriptions[c]);
      const h = "on" + c,
        f = l[h];
      f && (this.propEventSubscriptions[c] = this.on(c, f));
    }
    (this.prevMotionValues = vA(
      this,
      this.scrapeMotionValuesFromProps(l, this.prevProps, this),
      this.prevMotionValues
    )),
      this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  getVariant(l) {
    return this.props.variants ? this.props.variants[l] : void 0;
  }
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode
      ? this
      : this.parent
      ? this.parent.getClosestVariantNode()
      : void 0;
  }
  addVariantChild(l) {
    const o = this.getClosestVariantNode();
    if (o)
      return (
        o.variantChildren && o.variantChildren.add(l),
        () => o.variantChildren.delete(l)
      );
  }
  addValue(l, o) {
    const r = this.values.get(l);
    o !== r &&
      (r && this.removeValue(l),
      this.bindToMotionValue(l, o),
      this.values.set(l, o),
      (this.latestValues[l] = o.get()));
  }
  removeValue(l) {
    this.values.delete(l);
    const o = this.valueSubscriptions.get(l);
    o && (o(), this.valueSubscriptions.delete(l)),
      delete this.latestValues[l],
      this.removeValueFromRenderState(l, this.renderState);
  }
  hasValue(l) {
    return this.values.has(l);
  }
  getValue(l, o) {
    if (this.props.values && this.props.values[l]) return this.props.values[l];
    let r = this.values.get(l);
    return (
      r === void 0 &&
        o !== void 0 &&
        ((r = hi(o === null ? void 0 : o, { owner: this })),
        this.addValue(l, r)),
      r
    );
  }
  readValue(l, o) {
    let r =
      this.latestValues[l] !== void 0 || !this.current
        ? this.latestValues[l]
        : this.getBaseTargetFromProps(this.props, l) ??
          this.readValueFromInstance(this.current, l, this.options);
    return (
      r != null &&
        (typeof r == "string" && (Ag(r) || Mg(r))
          ? (r = parseFloat(r))
          : !qx(r) && Jn.test(o) && (r = oy(l, o)),
        this.setBaseTarget(l, se(r) ? r.get() : r)),
      se(r) ? r.get() : r
    );
  }
  setBaseTarget(l, o) {
    this.baseTarget[l] = o;
  }
  getBaseTarget(l) {
    var h;
    const { initial: o } = this.props;
    let r;
    if (typeof o == "string" || typeof o == "object") {
      const f = Jc(
        this.props,
        o,
        (h = this.presenceContext) == null ? void 0 : h.custom
      );
      f && (r = f[l]);
    }
    if (o && r !== void 0) return r;
    const c = this.getBaseTargetFromProps(this.props, l);
    return c !== void 0 && !se(c)
      ? c
      : this.initialValues[l] !== void 0 && r === void 0
      ? void 0
      : this.baseTarget[l];
  }
  on(l, o) {
    return this.events[l] || (this.events[l] = new Mc()), this.events[l].add(o);
  }
  notify(l, ...o) {
    this.events[l] && this.events[l].notify(...o);
  }
}
class Fy extends bA {
  constructor() {
    super(...arguments), (this.KeyframeResolver = Ox);
  }
  sortInstanceNodePosition(l, o) {
    return l.compareDocumentPosition(o) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(l, o) {
    return l.style ? l.style[o] : void 0;
  }
  removeValueFromRenderState(l, { vars: o, style: r }) {
    delete o[l], delete r[l];
  }
  handleChildMotionValue() {
    this.childSubscription &&
      (this.childSubscription(), delete this.childSubscription);
    const { children: l } = this.props;
    se(l) &&
      (this.childSubscription = l.on("change", (o) => {
        this.current && (this.current.textContent = `${o}`);
      }));
  }
}
function Wy(a, { style: l, vars: o }, r, c) {
  Object.assign(a.style, l, c && c.getProjectionStyles(r));
  for (const h in o) a.style.setProperty(h, o[h]);
}
function xA(a) {
  return window.getComputedStyle(a);
}
class SA extends Fy {
  constructor() {
    super(...arguments), (this.type = "html"), (this.renderInstance = Wy);
  }
  readValueFromInstance(l, o) {
    var r;
    if (yi.has(o))
      return (r = this.projection) != null && r.isProjecting ? ec(o) : J1(l, o);
    {
      const c = xA(l),
        h = (Rc(o) ? c.getPropertyValue(o) : c[o]) || 0;
      return typeof h == "string" ? h.trim() : h;
    }
  }
  measureInstanceViewportBox(l, { transformPagePoint: o }) {
    return jy(l, o);
  }
  build(l, o, r) {
    Zc(l, o, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(l, o, r) {
    return Pc(l, o, r);
  }
}
const $y = new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust",
]);
function TA(a, l, o, r) {
  Wy(a, l, void 0, r);
  for (const c in l.attrs) a.setAttribute($y.has(c) ? c : Xc(c), l.attrs[c]);
}
class AA extends Fy {
  constructor() {
    super(...arguments),
      (this.type = "svg"),
      (this.isSVGTag = !1),
      (this.measureInstanceViewportBox = qt);
  }
  getBaseTargetFromProps(l, o) {
    return l[o];
  }
  readValueFromInstance(l, o) {
    if (yi.has(o)) {
      const r = sy(o);
      return (r && r.default) || 0;
    }
    return (o = $y.has(o) ? o : Xc(o)), l.getAttribute(o);
  }
  scrapeMotionValuesFromProps(l, o, r) {
    return Dy(l, o, r);
  }
  build(l, o, r) {
    Ty(l, o, this.isSVGTag, r.transformTemplate, r.style);
  }
  renderInstance(l, o, r, c) {
    TA(l, o, r, c);
  }
  mount(l) {
    (this.isSVGTag = Ey(l.tagName)), super.mount(l);
  }
}
const EA = (a, l) =>
    Kc(a) ? new AA(l) : new SA(l, { allowProjection: a !== W.Fragment }),
  MA = TS({ ...JS, ...mA, ...aA, ...pA }, EA),
  re = Kx(MA);
function hg(a, l) {
  if (typeof a == "function") return a(l);
  a != null && (a.current = l);
}
function DA(...a) {
  return (l) => {
    let o = !1;
    const r = a.map((c) => {
      const h = hg(c, l);
      return !o && typeof h == "function" && (o = !0), h;
    });
    if (o)
      return () => {
        for (let c = 0; c < r.length; c++) {
          const h = r[c];
          typeof h == "function" ? h() : hg(a[c], null);
        }
      };
  };
}
function wA(...a) {
  return W.useCallback(DA(...a), a);
}
function RA(a) {
  const l = CA(a),
    o = W.forwardRef((r, c) => {
      const { children: h, ...f } = r,
        m = W.Children.toArray(h),
        p = m.find(zA);
      if (p) {
        const g = p.props.children,
          v = m.map((b) =>
            b === p
              ? W.Children.count(g) > 1
                ? W.Children.only(null)
                : W.isValidElement(g)
                ? g.props.children
                : null
              : b
          );
        return j.jsx(l, {
          ...f,
          ref: c,
          children: W.isValidElement(g) ? W.cloneElement(g, void 0, v) : null,
        });
      }
      return j.jsx(l, { ...f, ref: c, children: h });
    });
  return (o.displayName = `${a}.Slot`), o;
}
var OA = RA("Slot");
function CA(a) {
  const l = W.forwardRef((o, r) => {
    const { children: c, ...h } = o,
      f = W.isValidElement(c) ? _A(c) : void 0,
      m = wA(f, r);
    if (W.isValidElement(c)) {
      const p = NA(h, c.props);
      return c.type !== W.Fragment && (p.ref = m), W.cloneElement(c, p);
    }
    return W.Children.count(c) > 1 ? W.Children.only(null) : null;
  });
  return (l.displayName = `${a}.SlotClone`), l;
}
var VA = Symbol("radix.slottable");
function zA(a) {
  return (
    W.isValidElement(a) &&
    typeof a.type == "function" &&
    "__radixId" in a.type &&
    a.type.__radixId === VA
  );
}
function NA(a, l) {
  const o = { ...l };
  for (const r in l) {
    const c = a[r],
      h = l[r];
    /^on[A-Z]/.test(r)
      ? c && h
        ? (o[r] = (...m) => {
            const p = h(...m);
            return c(...m), p;
          })
        : c && (o[r] = c)
      : r === "style"
      ? (o[r] = { ...c, ...h })
      : r === "className" && (o[r] = [c, h].filter(Boolean).join(" "));
  }
  return { ...a, ...o };
}
function _A(a) {
  var r, c;
  let l =
      (r = Object.getOwnPropertyDescriptor(a.props, "ref")) == null
        ? void 0
        : r.get,
    o = l && "isReactWarning" in l && l.isReactWarning;
  return o
    ? a.ref
    : ((l =
        (c = Object.getOwnPropertyDescriptor(a, "ref")) == null
          ? void 0
          : c.get),
      (o = l && "isReactWarning" in l && l.isReactWarning),
      o ? a.props.ref : a.props.ref || a.ref);
}
function Iy(a) {
  var l,
    o,
    r = "";
  if (typeof a == "string" || typeof a == "number") r += a;
  else if (typeof a == "object")
    if (Array.isArray(a)) {
      var c = a.length;
      for (l = 0; l < c; l++)
        a[l] && (o = Iy(a[l])) && (r && (r += " "), (r += o));
    } else for (o in a) a[o] && (r && (r += " "), (r += o));
  return r;
}
function tv() {
  for (var a, l, o = 0, r = "", c = arguments.length; o < c; o++)
    (a = arguments[o]) && (l = Iy(a)) && (r && (r += " "), (r += l));
  return r;
}
const mg = (a) => (typeof a == "boolean" ? `${a}` : a === 0 ? "0" : a),
  pg = tv,
  UA = (a, l) => (o) => {
    var r;
    if ((l == null ? void 0 : l.variants) == null)
      return pg(
        a,
        o == null ? void 0 : o.class,
        o == null ? void 0 : o.className
      );
    const { variants: c, defaultVariants: h } = l,
      f = Object.keys(c).map((g) => {
        const v = o == null ? void 0 : o[g],
          b = h == null ? void 0 : h[g];
        if (v === null) return null;
        const A = mg(v) || mg(b);
        return c[g][A];
      }),
      m =
        o &&
        Object.entries(o).reduce((g, v) => {
          let [b, A] = v;
          return A === void 0 || (g[b] = A), g;
        }, {}),
      p =
        l == null || (r = l.compoundVariants) === null || r === void 0
          ? void 0
          : r.reduce((g, v) => {
              let { class: b, className: A, ...O } = v;
              return Object.entries(O).every((B) => {
                let [L, Y] = B;
                return Array.isArray(Y)
                  ? Y.includes({ ...h, ...m }[L])
                  : { ...h, ...m }[L] === Y;
              })
                ? [...g, b, A]
                : g;
            }, []);
    return pg(
      a,
      f,
      p,
      o == null ? void 0 : o.class,
      o == null ? void 0 : o.className
    );
  },
  Wc = "-",
  jA = (a) => {
    const l = LA(a),
      { conflictingClassGroups: o, conflictingClassGroupModifiers: r } = a;
    return {
      getClassGroupId: (f) => {
        const m = f.split(Wc);
        return m[0] === "" && m.length !== 1 && m.shift(), ev(m, l) || BA(f);
      },
      getConflictingClassGroupIds: (f, m) => {
        const p = o[f] || [];
        return m && r[f] ? [...p, ...r[f]] : p;
      },
    };
  },
  ev = (a, l) => {
    var f;
    if (a.length === 0) return l.classGroupId;
    const o = a[0],
      r = l.nextPart.get(o),
      c = r ? ev(a.slice(1), r) : void 0;
    if (c) return c;
    if (l.validators.length === 0) return;
    const h = a.join(Wc);
    return (f = l.validators.find(({ validator: m }) => m(h))) == null
      ? void 0
      : f.classGroupId;
  },
  gg = /^\[(.+)\]$/,
  BA = (a) => {
    if (gg.test(a)) {
      const l = gg.exec(a)[1],
        o = l == null ? void 0 : l.substring(0, l.indexOf(":"));
      if (o) return "arbitrary.." + o;
    }
  },
  LA = (a) => {
    const { theme: l, classGroups: o } = a,
      r = { nextPart: new Map(), validators: [] };
    for (const c in o) pc(o[c], r, c, l);
    return r;
  },
  pc = (a, l, o, r) => {
    a.forEach((c) => {
      if (typeof c == "string") {
        const h = c === "" ? l : yg(l, c);
        h.classGroupId = o;
        return;
      }
      if (typeof c == "function") {
        if (HA(c)) {
          pc(c(r), l, o, r);
          return;
        }
        l.validators.push({ validator: c, classGroupId: o });
        return;
      }
      Object.entries(c).forEach(([h, f]) => {
        pc(f, yg(l, h), o, r);
      });
    });
  },
  yg = (a, l) => {
    let o = a;
    return (
      l.split(Wc).forEach((r) => {
        o.nextPart.has(r) ||
          o.nextPart.set(r, { nextPart: new Map(), validators: [] }),
          (o = o.nextPart.get(r));
      }),
      o
    );
  },
  HA = (a) => a.isThemeGetter,
  GA = (a) => {
    if (a < 1) return { get: () => {}, set: () => {} };
    let l = 0,
      o = new Map(),
      r = new Map();
    const c = (h, f) => {
      o.set(h, f), l++, l > a && ((l = 0), (r = o), (o = new Map()));
    };
    return {
      get(h) {
        let f = o.get(h);
        if (f !== void 0) return f;
        if ((f = r.get(h)) !== void 0) return c(h, f), f;
      },
      set(h, f) {
        o.has(h) ? o.set(h, f) : c(h, f);
      },
    };
  },
  gc = "!",
  yc = ":",
  qA = yc.length,
  YA = (a) => {
    const { prefix: l, experimentalParseClassName: o } = a;
    let r = (c) => {
      const h = [];
      let f = 0,
        m = 0,
        p = 0,
        g;
      for (let B = 0; B < c.length; B++) {
        let L = c[B];
        if (f === 0 && m === 0) {
          if (L === yc) {
            h.push(c.slice(p, B)), (p = B + qA);
            continue;
          }
          if (L === "/") {
            g = B;
            continue;
          }
        }
        L === "[" ? f++ : L === "]" ? f-- : L === "(" ? m++ : L === ")" && m--;
      }
      const v = h.length === 0 ? c : c.substring(p),
        b = kA(v),
        A = b !== v,
        O = g && g > p ? g - p : void 0;
      return {
        modifiers: h,
        hasImportantModifier: A,
        baseClassName: b,
        maybePostfixModifierPosition: O,
      };
    };
    if (l) {
      const c = l + yc,
        h = r;
      r = (f) =>
        f.startsWith(c)
          ? h(f.substring(c.length))
          : {
              isExternal: !0,
              modifiers: [],
              hasImportantModifier: !1,
              baseClassName: f,
              maybePostfixModifierPosition: void 0,
            };
    }
    if (o) {
      const c = r;
      r = (h) => o({ className: h, parseClassName: c });
    }
    return r;
  },
  kA = (a) =>
    a.endsWith(gc)
      ? a.substring(0, a.length - 1)
      : a.startsWith(gc)
      ? a.substring(1)
      : a,
  XA = (a) => {
    const l = Object.fromEntries(a.orderSensitiveModifiers.map((r) => [r, !0]));
    return (r) => {
      if (r.length <= 1) return r;
      const c = [];
      let h = [];
      return (
        r.forEach((f) => {
          f[0] === "[" || l[f] ? (c.push(...h.sort(), f), (h = [])) : h.push(f);
        }),
        c.push(...h.sort()),
        c
      );
    };
  },
  ZA = (a) => ({
    cache: GA(a.cacheSize),
    parseClassName: YA(a),
    sortModifiers: XA(a),
    ...jA(a),
  }),
  QA = /\s+/,
  KA = (a, l) => {
    const {
        parseClassName: o,
        getClassGroupId: r,
        getConflictingClassGroupIds: c,
        sortModifiers: h,
      } = l,
      f = [],
      m = a.trim().split(QA);
    let p = "";
    for (let g = m.length - 1; g >= 0; g -= 1) {
      const v = m[g],
        {
          isExternal: b,
          modifiers: A,
          hasImportantModifier: O,
          baseClassName: B,
          maybePostfixModifierPosition: L,
        } = o(v);
      if (b) {
        p = v + (p.length > 0 ? " " + p : p);
        continue;
      }
      let Y = !!L,
        Z = r(Y ? B.substring(0, L) : B);
      if (!Z) {
        if (!Y) {
          p = v + (p.length > 0 ? " " + p : p);
          continue;
        }
        if (((Z = r(B)), !Z)) {
          p = v + (p.length > 0 ? " " + p : p);
          continue;
        }
        Y = !1;
      }
      const $ = h(A).join(":"),
        X = O ? $ + gc : $,
        lt = X + Z;
      if (f.includes(lt)) continue;
      f.push(lt);
      const k = c(Z, Y);
      for (let nt = 0; nt < k.length; ++nt) {
        const rt = k[nt];
        f.push(X + rt);
      }
      p = v + (p.length > 0 ? " " + p : p);
    }
    return p;
  };
function JA() {
  let a = 0,
    l,
    o,
    r = "";
  for (; a < arguments.length; )
    (l = arguments[a++]) && (o = nv(l)) && (r && (r += " "), (r += o));
  return r;
}
const nv = (a) => {
  if (typeof a == "string") return a;
  let l,
    o = "";
  for (let r = 0; r < a.length; r++)
    a[r] && (l = nv(a[r])) && (o && (o += " "), (o += l));
  return o;
};
function PA(a, ...l) {
  let o,
    r,
    c,
    h = f;
  function f(p) {
    const g = l.reduce((v, b) => b(v), a());
    return (o = ZA(g)), (r = o.cache.get), (c = o.cache.set), (h = m), m(p);
  }
  function m(p) {
    const g = r(p);
    if (g) return g;
    const v = KA(p, o);
    return c(p, v), v;
  }
  return function () {
    return h(JA.apply(null, arguments));
  };
}
const Kt = (a) => {
    const l = (o) => o[a] || [];
    return (l.isThemeGetter = !0), l;
  },
  av = /^\[(?:(\w[\w-]*):)?(.+)\]$/i,
  iv = /^\((?:(\w[\w-]*):)?(.+)\)$/i,
  FA = /^\d+\/\d+$/,
  WA = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/,
  $A =
    /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/,
  IA = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/,
  t2 = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/,
  e2 =
    /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/,
  si = (a) => FA.test(a),
  ct = (a) => !!a && !Number.isNaN(Number(a)),
  Zn = (a) => !!a && Number.isInteger(Number(a)),
  Ku = (a) => a.endsWith("%") && ct(a.slice(0, -1)),
  pn = (a) => WA.test(a),
  n2 = () => !0,
  a2 = (a) => $A.test(a) && !IA.test(a),
  lv = () => !1,
  i2 = (a) => t2.test(a),
  l2 = (a) => e2.test(a),
  s2 = (a) => !P(a) && !F(a),
  o2 = (a) => vi(a, rv, lv),
  P = (a) => av.test(a),
  pa = (a) => vi(a, uv, a2),
  Ju = (a) => vi(a, d2, ct),
  vg = (a) => vi(a, sv, lv),
  r2 = (a) => vi(a, ov, l2),
  eo = (a) => vi(a, cv, i2),
  F = (a) => iv.test(a),
  xl = (a) => bi(a, uv),
  u2 = (a) => bi(a, h2),
  bg = (a) => bi(a, sv),
  c2 = (a) => bi(a, rv),
  f2 = (a) => bi(a, ov),
  no = (a) => bi(a, cv, !0),
  vi = (a, l, o) => {
    const r = av.exec(a);
    return r ? (r[1] ? l(r[1]) : o(r[2])) : !1;
  },
  bi = (a, l, o = !1) => {
    const r = iv.exec(a);
    return r ? (r[1] ? l(r[1]) : o) : !1;
  },
  sv = (a) => a === "position" || a === "percentage",
  ov = (a) => a === "image" || a === "url",
  rv = (a) => a === "length" || a === "size" || a === "bg-size",
  uv = (a) => a === "length",
  d2 = (a) => a === "number",
  h2 = (a) => a === "family-name",
  cv = (a) => a === "shadow",
  m2 = () => {
    const a = Kt("color"),
      l = Kt("font"),
      o = Kt("text"),
      r = Kt("font-weight"),
      c = Kt("tracking"),
      h = Kt("leading"),
      f = Kt("breakpoint"),
      m = Kt("container"),
      p = Kt("spacing"),
      g = Kt("radius"),
      v = Kt("shadow"),
      b = Kt("inset-shadow"),
      A = Kt("text-shadow"),
      O = Kt("drop-shadow"),
      B = Kt("blur"),
      L = Kt("perspective"),
      Y = Kt("aspect"),
      Z = Kt("ease"),
      $ = Kt("animate"),
      X = () => [
        "auto",
        "avoid",
        "all",
        "avoid-page",
        "page",
        "left",
        "right",
        "column",
      ],
      lt = () => [
        "center",
        "top",
        "bottom",
        "left",
        "right",
        "top-left",
        "left-top",
        "top-right",
        "right-top",
        "bottom-right",
        "right-bottom",
        "bottom-left",
        "left-bottom",
      ],
      k = () => [...lt(), F, P],
      nt = () => ["auto", "hidden", "clip", "visible", "scroll"],
      rt = () => ["auto", "contain", "none"],
      G = () => [F, P, p],
      pt = () => [si, "full", "auto", ...G()],
      Ut = () => [Zn, "none", "subgrid", F, P],
      Xt = () => ["auto", { span: ["full", Zn, F, P] }, Zn, F, P],
      Ot = () => [Zn, "auto", F, P],
      we = () => ["auto", "min", "max", "fr", F, P],
      ce = () => [
        "start",
        "end",
        "center",
        "between",
        "around",
        "evenly",
        "stretch",
        "baseline",
        "center-safe",
        "end-safe",
      ],
      Ct = () => [
        "start",
        "end",
        "center",
        "stretch",
        "center-safe",
        "end-safe",
      ],
      C = () => ["auto", ...G()],
      H = () => [
        si,
        "auto",
        "full",
        "dvw",
        "dvh",
        "lvw",
        "lvh",
        "svw",
        "svh",
        "min",
        "max",
        "fit",
        ...G(),
      ],
      _ = () => [a, F, P],
      gt = () => [...lt(), bg, vg, { position: [F, P] }],
      S = () => ["no-repeat", { repeat: ["", "x", "y", "space", "round"] }],
      U = () => ["auto", "cover", "contain", c2, o2, { size: [F, P] }],
      Q = () => [Ku, xl, pa],
      q = () => ["", "none", "full", g, F, P],
      K = () => ["", ct, xl, pa],
      dt = () => ["solid", "dashed", "dotted", "double"],
      st = () => [
        "normal",
        "multiply",
        "screen",
        "overlay",
        "darken",
        "lighten",
        "color-dodge",
        "color-burn",
        "hard-light",
        "soft-light",
        "difference",
        "exclusion",
        "hue",
        "saturation",
        "color",
        "luminosity",
      ],
      vt = () => [ct, Ku, bg, vg],
      Dt = () => ["", "none", B, F, P],
      ye = () => ["none", ct, F, P],
      vn = () => ["none", ct, F, P],
      bn = () => [ct, F, P],
      xn = () => [si, "full", ...G()];
    return {
      cacheSize: 500,
      theme: {
        animate: ["spin", "ping", "pulse", "bounce"],
        aspect: ["video"],
        blur: [pn],
        breakpoint: [pn],
        color: [n2],
        container: [pn],
        "drop-shadow": [pn],
        ease: ["in", "out", "in-out"],
        font: [s2],
        "font-weight": [
          "thin",
          "extralight",
          "light",
          "normal",
          "medium",
          "semibold",
          "bold",
          "extrabold",
          "black",
        ],
        "inset-shadow": [pn],
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
        perspective: [
          "dramatic",
          "near",
          "normal",
          "midrange",
          "distant",
          "none",
        ],
        radius: [pn],
        shadow: [pn],
        spacing: ["px", ct],
        text: [pn],
        "text-shadow": [pn],
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"],
      },
      classGroups: {
        aspect: [{ aspect: ["auto", "square", si, P, F, Y] }],
        container: ["container"],
        columns: [{ columns: [ct, P, F, m] }],
        "break-after": [{ "break-after": X() }],
        "break-before": [{ "break-before": X() }],
        "break-inside": [
          { "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"] },
        ],
        "box-decoration": [{ "box-decoration": ["slice", "clone"] }],
        box: [{ box: ["border", "content"] }],
        display: [
          "block",
          "inline-block",
          "inline",
          "flex",
          "inline-flex",
          "table",
          "inline-table",
          "table-caption",
          "table-cell",
          "table-column",
          "table-column-group",
          "table-footer-group",
          "table-header-group",
          "table-row-group",
          "table-row",
          "flow-root",
          "grid",
          "inline-grid",
          "contents",
          "list-item",
          "hidden",
        ],
        sr: ["sr-only", "not-sr-only"],
        float: [{ float: ["right", "left", "none", "start", "end"] }],
        clear: [{ clear: ["left", "right", "both", "none", "start", "end"] }],
        isolation: ["isolate", "isolation-auto"],
        "object-fit": [
          { object: ["contain", "cover", "fill", "none", "scale-down"] },
        ],
        "object-position": [{ object: k() }],
        overflow: [{ overflow: nt() }],
        "overflow-x": [{ "overflow-x": nt() }],
        "overflow-y": [{ "overflow-y": nt() }],
        overscroll: [{ overscroll: rt() }],
        "overscroll-x": [{ "overscroll-x": rt() }],
        "overscroll-y": [{ "overscroll-y": rt() }],
        position: ["static", "fixed", "absolute", "relative", "sticky"],
        inset: [{ inset: pt() }],
        "inset-x": [{ "inset-x": pt() }],
        "inset-y": [{ "inset-y": pt() }],
        start: [{ start: pt() }],
        end: [{ end: pt() }],
        top: [{ top: pt() }],
        right: [{ right: pt() }],
        bottom: [{ bottom: pt() }],
        left: [{ left: pt() }],
        visibility: ["visible", "invisible", "collapse"],
        z: [{ z: [Zn, "auto", F, P] }],
        basis: [{ basis: [si, "full", "auto", m, ...G()] }],
        "flex-direction": [
          { flex: ["row", "row-reverse", "col", "col-reverse"] },
        ],
        "flex-wrap": [{ flex: ["nowrap", "wrap", "wrap-reverse"] }],
        flex: [{ flex: [ct, si, "auto", "initial", "none", P] }],
        grow: [{ grow: ["", ct, F, P] }],
        shrink: [{ shrink: ["", ct, F, P] }],
        order: [{ order: [Zn, "first", "last", "none", F, P] }],
        "grid-cols": [{ "grid-cols": Ut() }],
        "col-start-end": [{ col: Xt() }],
        "col-start": [{ "col-start": Ot() }],
        "col-end": [{ "col-end": Ot() }],
        "grid-rows": [{ "grid-rows": Ut() }],
        "row-start-end": [{ row: Xt() }],
        "row-start": [{ "row-start": Ot() }],
        "row-end": [{ "row-end": Ot() }],
        "grid-flow": [
          { "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"] },
        ],
        "auto-cols": [{ "auto-cols": we() }],
        "auto-rows": [{ "auto-rows": we() }],
        gap: [{ gap: G() }],
        "gap-x": [{ "gap-x": G() }],
        "gap-y": [{ "gap-y": G() }],
        "justify-content": [{ justify: [...ce(), "normal"] }],
        "justify-items": [{ "justify-items": [...Ct(), "normal"] }],
        "justify-self": [{ "justify-self": ["auto", ...Ct()] }],
        "align-content": [{ content: ["normal", ...ce()] }],
        "align-items": [{ items: [...Ct(), { baseline: ["", "last"] }] }],
        "align-self": [{ self: ["auto", ...Ct(), { baseline: ["", "last"] }] }],
        "place-content": [{ "place-content": ce() }],
        "place-items": [{ "place-items": [...Ct(), "baseline"] }],
        "place-self": [{ "place-self": ["auto", ...Ct()] }],
        p: [{ p: G() }],
        px: [{ px: G() }],
        py: [{ py: G() }],
        ps: [{ ps: G() }],
        pe: [{ pe: G() }],
        pt: [{ pt: G() }],
        pr: [{ pr: G() }],
        pb: [{ pb: G() }],
        pl: [{ pl: G() }],
        m: [{ m: C() }],
        mx: [{ mx: C() }],
        my: [{ my: C() }],
        ms: [{ ms: C() }],
        me: [{ me: C() }],
        mt: [{ mt: C() }],
        mr: [{ mr: C() }],
        mb: [{ mb: C() }],
        ml: [{ ml: C() }],
        "space-x": [{ "space-x": G() }],
        "space-x-reverse": ["space-x-reverse"],
        "space-y": [{ "space-y": G() }],
        "space-y-reverse": ["space-y-reverse"],
        size: [{ size: H() }],
        w: [{ w: [m, "screen", ...H()] }],
        "min-w": [{ "min-w": [m, "screen", "none", ...H()] }],
        "max-w": [
          { "max-w": [m, "screen", "none", "prose", { screen: [f] }, ...H()] },
        ],
        h: [{ h: ["screen", "lh", ...H()] }],
        "min-h": [{ "min-h": ["screen", "lh", "none", ...H()] }],
        "max-h": [{ "max-h": ["screen", "lh", ...H()] }],
        "font-size": [{ text: ["base", o, xl, pa] }],
        "font-smoothing": ["antialiased", "subpixel-antialiased"],
        "font-style": ["italic", "not-italic"],
        "font-weight": [{ font: [r, F, Ju] }],
        "font-stretch": [
          {
            "font-stretch": [
              "ultra-condensed",
              "extra-condensed",
              "condensed",
              "semi-condensed",
              "normal",
              "semi-expanded",
              "expanded",
              "extra-expanded",
              "ultra-expanded",
              Ku,
              P,
            ],
          },
        ],
        "font-family": [{ font: [u2, P, l] }],
        "fvn-normal": ["normal-nums"],
        "fvn-ordinal": ["ordinal"],
        "fvn-slashed-zero": ["slashed-zero"],
        "fvn-figure": ["lining-nums", "oldstyle-nums"],
        "fvn-spacing": ["proportional-nums", "tabular-nums"],
        "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
        tracking: [{ tracking: [c, F, P] }],
        "line-clamp": [{ "line-clamp": [ct, "none", F, Ju] }],
        leading: [{ leading: [h, ...G()] }],
        "list-image": [{ "list-image": ["none", F, P] }],
        "list-style-position": [{ list: ["inside", "outside"] }],
        "list-style-type": [{ list: ["disc", "decimal", "none", F, P] }],
        "text-alignment": [
          { text: ["left", "center", "right", "justify", "start", "end"] },
        ],
        "placeholder-color": [{ placeholder: _() }],
        "text-color": [{ text: _() }],
        "text-decoration": [
          "underline",
          "overline",
          "line-through",
          "no-underline",
        ],
        "text-decoration-style": [{ decoration: [...dt(), "wavy"] }],
        "text-decoration-thickness": [
          { decoration: [ct, "from-font", "auto", F, pa] },
        ],
        "text-decoration-color": [{ decoration: _() }],
        "underline-offset": [{ "underline-offset": [ct, "auto", F, P] }],
        "text-transform": [
          "uppercase",
          "lowercase",
          "capitalize",
          "normal-case",
        ],
        "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
        "text-wrap": [{ text: ["wrap", "nowrap", "balance", "pretty"] }],
        indent: [{ indent: G() }],
        "vertical-align": [
          {
            align: [
              "baseline",
              "top",
              "middle",
              "bottom",
              "text-top",
              "text-bottom",
              "sub",
              "super",
              F,
              P,
            ],
          },
        ],
        whitespace: [
          {
            whitespace: [
              "normal",
              "nowrap",
              "pre",
              "pre-line",
              "pre-wrap",
              "break-spaces",
            ],
          },
        ],
        break: [{ break: ["normal", "words", "all", "keep"] }],
        wrap: [{ wrap: ["break-word", "anywhere", "normal"] }],
        hyphens: [{ hyphens: ["none", "manual", "auto"] }],
        content: [{ content: ["none", F, P] }],
        "bg-attachment": [{ bg: ["fixed", "local", "scroll"] }],
        "bg-clip": [{ "bg-clip": ["border", "padding", "content", "text"] }],
        "bg-origin": [{ "bg-origin": ["border", "padding", "content"] }],
        "bg-position": [{ bg: gt() }],
        "bg-repeat": [{ bg: S() }],
        "bg-size": [{ bg: U() }],
        "bg-image": [
          {
            bg: [
              "none",
              {
                linear: [
                  { to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"] },
                  Zn,
                  F,
                  P,
                ],
                radial: ["", F, P],
                conic: [Zn, F, P],
              },
              f2,
              r2,
            ],
          },
        ],
        "bg-color": [{ bg: _() }],
        "gradient-from-pos": [{ from: Q() }],
        "gradient-via-pos": [{ via: Q() }],
        "gradient-to-pos": [{ to: Q() }],
        "gradient-from": [{ from: _() }],
        "gradient-via": [{ via: _() }],
        "gradient-to": [{ to: _() }],
        rounded: [{ rounded: q() }],
        "rounded-s": [{ "rounded-s": q() }],
        "rounded-e": [{ "rounded-e": q() }],
        "rounded-t": [{ "rounded-t": q() }],
        "rounded-r": [{ "rounded-r": q() }],
        "rounded-b": [{ "rounded-b": q() }],
        "rounded-l": [{ "rounded-l": q() }],
        "rounded-ss": [{ "rounded-ss": q() }],
        "rounded-se": [{ "rounded-se": q() }],
        "rounded-ee": [{ "rounded-ee": q() }],
        "rounded-es": [{ "rounded-es": q() }],
        "rounded-tl": [{ "rounded-tl": q() }],
        "rounded-tr": [{ "rounded-tr": q() }],
        "rounded-br": [{ "rounded-br": q() }],
        "rounded-bl": [{ "rounded-bl": q() }],
        "border-w": [{ border: K() }],
        "border-w-x": [{ "border-x": K() }],
        "border-w-y": [{ "border-y": K() }],
        "border-w-s": [{ "border-s": K() }],
        "border-w-e": [{ "border-e": K() }],
        "border-w-t": [{ "border-t": K() }],
        "border-w-r": [{ "border-r": K() }],
        "border-w-b": [{ "border-b": K() }],
        "border-w-l": [{ "border-l": K() }],
        "divide-x": [{ "divide-x": K() }],
        "divide-x-reverse": ["divide-x-reverse"],
        "divide-y": [{ "divide-y": K() }],
        "divide-y-reverse": ["divide-y-reverse"],
        "border-style": [{ border: [...dt(), "hidden", "none"] }],
        "divide-style": [{ divide: [...dt(), "hidden", "none"] }],
        "border-color": [{ border: _() }],
        "border-color-x": [{ "border-x": _() }],
        "border-color-y": [{ "border-y": _() }],
        "border-color-s": [{ "border-s": _() }],
        "border-color-e": [{ "border-e": _() }],
        "border-color-t": [{ "border-t": _() }],
        "border-color-r": [{ "border-r": _() }],
        "border-color-b": [{ "border-b": _() }],
        "border-color-l": [{ "border-l": _() }],
        "divide-color": [{ divide: _() }],
        "outline-style": [{ outline: [...dt(), "none", "hidden"] }],
        "outline-offset": [{ "outline-offset": [ct, F, P] }],
        "outline-w": [{ outline: ["", ct, xl, pa] }],
        "outline-color": [{ outline: _() }],
        shadow: [{ shadow: ["", "none", v, no, eo] }],
        "shadow-color": [{ shadow: _() }],
        "inset-shadow": [{ "inset-shadow": ["none", b, no, eo] }],
        "inset-shadow-color": [{ "inset-shadow": _() }],
        "ring-w": [{ ring: K() }],
        "ring-w-inset": ["ring-inset"],
        "ring-color": [{ ring: _() }],
        "ring-offset-w": [{ "ring-offset": [ct, pa] }],
        "ring-offset-color": [{ "ring-offset": _() }],
        "inset-ring-w": [{ "inset-ring": K() }],
        "inset-ring-color": [{ "inset-ring": _() }],
        "text-shadow": [{ "text-shadow": ["none", A, no, eo] }],
        "text-shadow-color": [{ "text-shadow": _() }],
        opacity: [{ opacity: [ct, F, P] }],
        "mix-blend": [
          { "mix-blend": [...st(), "plus-darker", "plus-lighter"] },
        ],
        "bg-blend": [{ "bg-blend": st() }],
        "mask-clip": [
          {
            "mask-clip": [
              "border",
              "padding",
              "content",
              "fill",
              "stroke",
              "view",
            ],
          },
          "mask-no-clip",
        ],
        "mask-composite": [
          { mask: ["add", "subtract", "intersect", "exclude"] },
        ],
        "mask-image-linear-pos": [{ "mask-linear": [ct] }],
        "mask-image-linear-from-pos": [{ "mask-linear-from": vt() }],
        "mask-image-linear-to-pos": [{ "mask-linear-to": vt() }],
        "mask-image-linear-from-color": [{ "mask-linear-from": _() }],
        "mask-image-linear-to-color": [{ "mask-linear-to": _() }],
        "mask-image-t-from-pos": [{ "mask-t-from": vt() }],
        "mask-image-t-to-pos": [{ "mask-t-to": vt() }],
        "mask-image-t-from-color": [{ "mask-t-from": _() }],
        "mask-image-t-to-color": [{ "mask-t-to": _() }],
        "mask-image-r-from-pos": [{ "mask-r-from": vt() }],
        "mask-image-r-to-pos": [{ "mask-r-to": vt() }],
        "mask-image-r-from-color": [{ "mask-r-from": _() }],
        "mask-image-r-to-color": [{ "mask-r-to": _() }],
        "mask-image-b-from-pos": [{ "mask-b-from": vt() }],
        "mask-image-b-to-pos": [{ "mask-b-to": vt() }],
        "mask-image-b-from-color": [{ "mask-b-from": _() }],
        "mask-image-b-to-color": [{ "mask-b-to": _() }],
        "mask-image-l-from-pos": [{ "mask-l-from": vt() }],
        "mask-image-l-to-pos": [{ "mask-l-to": vt() }],
        "mask-image-l-from-color": [{ "mask-l-from": _() }],
        "mask-image-l-to-color": [{ "mask-l-to": _() }],
        "mask-image-x-from-pos": [{ "mask-x-from": vt() }],
        "mask-image-x-to-pos": [{ "mask-x-to": vt() }],
        "mask-image-x-from-color": [{ "mask-x-from": _() }],
        "mask-image-x-to-color": [{ "mask-x-to": _() }],
        "mask-image-y-from-pos": [{ "mask-y-from": vt() }],
        "mask-image-y-to-pos": [{ "mask-y-to": vt() }],
        "mask-image-y-from-color": [{ "mask-y-from": _() }],
        "mask-image-y-to-color": [{ "mask-y-to": _() }],
        "mask-image-radial": [{ "mask-radial": [F, P] }],
        "mask-image-radial-from-pos": [{ "mask-radial-from": vt() }],
        "mask-image-radial-to-pos": [{ "mask-radial-to": vt() }],
        "mask-image-radial-from-color": [{ "mask-radial-from": _() }],
        "mask-image-radial-to-color": [{ "mask-radial-to": _() }],
        "mask-image-radial-shape": [{ "mask-radial": ["circle", "ellipse"] }],
        "mask-image-radial-size": [
          {
            "mask-radial": [
              { closest: ["side", "corner"], farthest: ["side", "corner"] },
            ],
          },
        ],
        "mask-image-radial-pos": [{ "mask-radial-at": lt() }],
        "mask-image-conic-pos": [{ "mask-conic": [ct] }],
        "mask-image-conic-from-pos": [{ "mask-conic-from": vt() }],
        "mask-image-conic-to-pos": [{ "mask-conic-to": vt() }],
        "mask-image-conic-from-color": [{ "mask-conic-from": _() }],
        "mask-image-conic-to-color": [{ "mask-conic-to": _() }],
        "mask-mode": [{ mask: ["alpha", "luminance", "match"] }],
        "mask-origin": [
          {
            "mask-origin": [
              "border",
              "padding",
              "content",
              "fill",
              "stroke",
              "view",
            ],
          },
        ],
        "mask-position": [{ mask: gt() }],
        "mask-repeat": [{ mask: S() }],
        "mask-size": [{ mask: U() }],
        "mask-type": [{ "mask-type": ["alpha", "luminance"] }],
        "mask-image": [{ mask: ["none", F, P] }],
        filter: [{ filter: ["", "none", F, P] }],
        blur: [{ blur: Dt() }],
        brightness: [{ brightness: [ct, F, P] }],
        contrast: [{ contrast: [ct, F, P] }],
        "drop-shadow": [{ "drop-shadow": ["", "none", O, no, eo] }],
        "drop-shadow-color": [{ "drop-shadow": _() }],
        grayscale: [{ grayscale: ["", ct, F, P] }],
        "hue-rotate": [{ "hue-rotate": [ct, F, P] }],
        invert: [{ invert: ["", ct, F, P] }],
        saturate: [{ saturate: [ct, F, P] }],
        sepia: [{ sepia: ["", ct, F, P] }],
        "backdrop-filter": [{ "backdrop-filter": ["", "none", F, P] }],
        "backdrop-blur": [{ "backdrop-blur": Dt() }],
        "backdrop-brightness": [{ "backdrop-brightness": [ct, F, P] }],
        "backdrop-contrast": [{ "backdrop-contrast": [ct, F, P] }],
        "backdrop-grayscale": [{ "backdrop-grayscale": ["", ct, F, P] }],
        "backdrop-hue-rotate": [{ "backdrop-hue-rotate": [ct, F, P] }],
        "backdrop-invert": [{ "backdrop-invert": ["", ct, F, P] }],
        "backdrop-opacity": [{ "backdrop-opacity": [ct, F, P] }],
        "backdrop-saturate": [{ "backdrop-saturate": [ct, F, P] }],
        "backdrop-sepia": [{ "backdrop-sepia": ["", ct, F, P] }],
        "border-collapse": [{ border: ["collapse", "separate"] }],
        "border-spacing": [{ "border-spacing": G() }],
        "border-spacing-x": [{ "border-spacing-x": G() }],
        "border-spacing-y": [{ "border-spacing-y": G() }],
        "table-layout": [{ table: ["auto", "fixed"] }],
        caption: [{ caption: ["top", "bottom"] }],
        transition: [
          {
            transition: [
              "",
              "all",
              "colors",
              "opacity",
              "shadow",
              "transform",
              "none",
              F,
              P,
            ],
          },
        ],
        "transition-behavior": [{ transition: ["normal", "discrete"] }],
        duration: [{ duration: [ct, "initial", F, P] }],
        ease: [{ ease: ["linear", "initial", Z, F, P] }],
        delay: [{ delay: [ct, F, P] }],
        animate: [{ animate: ["none", $, F, P] }],
        backface: [{ backface: ["hidden", "visible"] }],
        perspective: [{ perspective: [L, F, P] }],
        "perspective-origin": [{ "perspective-origin": k() }],
        rotate: [{ rotate: ye() }],
        "rotate-x": [{ "rotate-x": ye() }],
        "rotate-y": [{ "rotate-y": ye() }],
        "rotate-z": [{ "rotate-z": ye() }],
        scale: [{ scale: vn() }],
        "scale-x": [{ "scale-x": vn() }],
        "scale-y": [{ "scale-y": vn() }],
        "scale-z": [{ "scale-z": vn() }],
        "scale-3d": ["scale-3d"],
        skew: [{ skew: bn() }],
        "skew-x": [{ "skew-x": bn() }],
        "skew-y": [{ "skew-y": bn() }],
        transform: [{ transform: [F, P, "", "none", "gpu", "cpu"] }],
        "transform-origin": [{ origin: k() }],
        "transform-style": [{ transform: ["3d", "flat"] }],
        translate: [{ translate: xn() }],
        "translate-x": [{ "translate-x": xn() }],
        "translate-y": [{ "translate-y": xn() }],
        "translate-z": [{ "translate-z": xn() }],
        "translate-none": ["translate-none"],
        accent: [{ accent: _() }],
        appearance: [{ appearance: ["none", "auto"] }],
        "caret-color": [{ caret: _() }],
        "color-scheme": [
          {
            scheme: [
              "normal",
              "dark",
              "light",
              "light-dark",
              "only-dark",
              "only-light",
            ],
          },
        ],
        cursor: [
          {
            cursor: [
              "auto",
              "default",
              "pointer",
              "wait",
              "text",
              "move",
              "help",
              "not-allowed",
              "none",
              "context-menu",
              "progress",
              "cell",
              "crosshair",
              "vertical-text",
              "alias",
              "copy",
              "no-drop",
              "grab",
              "grabbing",
              "all-scroll",
              "col-resize",
              "row-resize",
              "n-resize",
              "e-resize",
              "s-resize",
              "w-resize",
              "ne-resize",
              "nw-resize",
              "se-resize",
              "sw-resize",
              "ew-resize",
              "ns-resize",
              "nesw-resize",
              "nwse-resize",
              "zoom-in",
              "zoom-out",
              F,
              P,
            ],
          },
        ],
        "field-sizing": [{ "field-sizing": ["fixed", "content"] }],
        "pointer-events": [{ "pointer-events": ["auto", "none"] }],
        resize: [{ resize: ["none", "", "y", "x"] }],
        "scroll-behavior": [{ scroll: ["auto", "smooth"] }],
        "scroll-m": [{ "scroll-m": G() }],
        "scroll-mx": [{ "scroll-mx": G() }],
        "scroll-my": [{ "scroll-my": G() }],
        "scroll-ms": [{ "scroll-ms": G() }],
        "scroll-me": [{ "scroll-me": G() }],
        "scroll-mt": [{ "scroll-mt": G() }],
        "scroll-mr": [{ "scroll-mr": G() }],
        "scroll-mb": [{ "scroll-mb": G() }],
        "scroll-ml": [{ "scroll-ml": G() }],
        "scroll-p": [{ "scroll-p": G() }],
        "scroll-px": [{ "scroll-px": G() }],
        "scroll-py": [{ "scroll-py": G() }],
        "scroll-ps": [{ "scroll-ps": G() }],
        "scroll-pe": [{ "scroll-pe": G() }],
        "scroll-pt": [{ "scroll-pt": G() }],
        "scroll-pr": [{ "scroll-pr": G() }],
        "scroll-pb": [{ "scroll-pb": G() }],
        "scroll-pl": [{ "scroll-pl": G() }],
        "snap-align": [{ snap: ["start", "end", "center", "align-none"] }],
        "snap-stop": [{ snap: ["normal", "always"] }],
        "snap-type": [{ snap: ["none", "x", "y", "both"] }],
        "snap-strictness": [{ snap: ["mandatory", "proximity"] }],
        touch: [{ touch: ["auto", "none", "manipulation"] }],
        "touch-x": [{ "touch-pan": ["x", "left", "right"] }],
        "touch-y": [{ "touch-pan": ["y", "up", "down"] }],
        "touch-pz": ["touch-pinch-zoom"],
        select: [{ select: ["none", "text", "all", "auto"] }],
        "will-change": [
          { "will-change": ["auto", "scroll", "contents", "transform", F, P] },
        ],
        fill: [{ fill: ["none", ..._()] }],
        "stroke-w": [{ stroke: [ct, xl, pa, Ju] }],
        stroke: [{ stroke: ["none", ..._()] }],
        "forced-color-adjust": [{ "forced-color-adjust": ["auto", "none"] }],
      },
      conflictingClassGroups: {
        overflow: ["overflow-x", "overflow-y"],
        overscroll: ["overscroll-x", "overscroll-y"],
        inset: [
          "inset-x",
          "inset-y",
          "start",
          "end",
          "top",
          "right",
          "bottom",
          "left",
        ],
        "inset-x": ["right", "left"],
        "inset-y": ["top", "bottom"],
        flex: ["basis", "grow", "shrink"],
        gap: ["gap-x", "gap-y"],
        p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
        px: ["pr", "pl"],
        py: ["pt", "pb"],
        m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
        mx: ["mr", "ml"],
        my: ["mt", "mb"],
        size: ["w", "h"],
        "font-size": ["leading"],
        "fvn-normal": [
          "fvn-ordinal",
          "fvn-slashed-zero",
          "fvn-figure",
          "fvn-spacing",
          "fvn-fraction",
        ],
        "fvn-ordinal": ["fvn-normal"],
        "fvn-slashed-zero": ["fvn-normal"],
        "fvn-figure": ["fvn-normal"],
        "fvn-spacing": ["fvn-normal"],
        "fvn-fraction": ["fvn-normal"],
        "line-clamp": ["display", "overflow"],
        rounded: [
          "rounded-s",
          "rounded-e",
          "rounded-t",
          "rounded-r",
          "rounded-b",
          "rounded-l",
          "rounded-ss",
          "rounded-se",
          "rounded-ee",
          "rounded-es",
          "rounded-tl",
          "rounded-tr",
          "rounded-br",
          "rounded-bl",
        ],
        "rounded-s": ["rounded-ss", "rounded-es"],
        "rounded-e": ["rounded-se", "rounded-ee"],
        "rounded-t": ["rounded-tl", "rounded-tr"],
        "rounded-r": ["rounded-tr", "rounded-br"],
        "rounded-b": ["rounded-br", "rounded-bl"],
        "rounded-l": ["rounded-tl", "rounded-bl"],
        "border-spacing": ["border-spacing-x", "border-spacing-y"],
        "border-w": [
          "border-w-x",
          "border-w-y",
          "border-w-s",
          "border-w-e",
          "border-w-t",
          "border-w-r",
          "border-w-b",
          "border-w-l",
        ],
        "border-w-x": ["border-w-r", "border-w-l"],
        "border-w-y": ["border-w-t", "border-w-b"],
        "border-color": [
          "border-color-x",
          "border-color-y",
          "border-color-s",
          "border-color-e",
          "border-color-t",
          "border-color-r",
          "border-color-b",
          "border-color-l",
        ],
        "border-color-x": ["border-color-r", "border-color-l"],
        "border-color-y": ["border-color-t", "border-color-b"],
        translate: ["translate-x", "translate-y", "translate-none"],
        "translate-none": [
          "translate",
          "translate-x",
          "translate-y",
          "translate-z",
        ],
        "scroll-m": [
          "scroll-mx",
          "scroll-my",
          "scroll-ms",
          "scroll-me",
          "scroll-mt",
          "scroll-mr",
          "scroll-mb",
          "scroll-ml",
        ],
        "scroll-mx": ["scroll-mr", "scroll-ml"],
        "scroll-my": ["scroll-mt", "scroll-mb"],
        "scroll-p": [
          "scroll-px",
          "scroll-py",
          "scroll-ps",
          "scroll-pe",
          "scroll-pt",
          "scroll-pr",
          "scroll-pb",
          "scroll-pl",
        ],
        "scroll-px": ["scroll-pr", "scroll-pl"],
        "scroll-py": ["scroll-pt", "scroll-pb"],
        touch: ["touch-x", "touch-y", "touch-pz"],
        "touch-x": ["touch"],
        "touch-y": ["touch"],
        "touch-pz": ["touch"],
      },
      conflictingClassGroupModifiers: { "font-size": ["leading"] },
      orderSensitiveModifiers: [
        "*",
        "**",
        "after",
        "backdrop",
        "before",
        "details-content",
        "file",
        "first-letter",
        "first-line",
        "marker",
        "placeholder",
        "selection",
      ],
    };
  },
  p2 = PA(m2);
function g2(...a) {
  return p2(tv(a));
}
const y2 = UA(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground shadow-xs hover:bg-primary/90",
        destructive:
          "bg-destructive text-white shadow-xs hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60",
        outline:
          "border bg-background shadow-xs hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50",
        secondary:
          "bg-secondary text-secondary-foreground shadow-xs hover:bg-secondary/80",
        ghost:
          "hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-4 py-2 has-[>svg]:px-3",
        sm: "h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5",
        lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
        icon: "size-9",
      },
    },
    defaultVariants: { variant: "default", size: "default" },
  }
);
function oi({ className: a, variant: l, size: o, asChild: r = !1, ...c }) {
  const h = r ? OA : "button";
  return j.jsx(h, {
    "data-slot": "button",
    className: g2(y2({ variant: l, size: o, className: a })),
    ...c,
  });
}
/**
 * @license lucide-react v0.510.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const v2 = (a) => a.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(),
  b2 = (a) =>
    a.replace(/^([A-Z])|[\s-_]+(\w)/g, (l, o, r) =>
      r ? r.toUpperCase() : o.toLowerCase()
    ),
  xg = (a) => {
    const l = b2(a);
    return l.charAt(0).toUpperCase() + l.slice(1);
  },
  fv = (...a) =>
    a
      .filter((l, o, r) => !!l && l.trim() !== "" && r.indexOf(l) === o)
      .join(" ")
      .trim(),
  x2 = (a) => {
    for (const l in a)
      if (l.startsWith("aria-") || l === "role" || l === "title") return !0;
  };
/**
 * @license lucide-react v0.510.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var S2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};
/**
 * @license lucide-react v0.510.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const T2 = W.forwardRef(
  (
    {
      color: a = "currentColor",
      size: l = 24,
      strokeWidth: o = 2,
      absoluteStrokeWidth: r,
      className: c = "",
      children: h,
      iconNode: f,
      ...m
    },
    p
  ) =>
    W.createElement(
      "svg",
      {
        ref: p,
        ...S2,
        width: l,
        height: l,
        stroke: a,
        strokeWidth: r ? (Number(o) * 24) / Number(l) : o,
        className: fv("lucide", c),
        ...(!h && !x2(m) && { "aria-hidden": "true" }),
        ...m,
      },
      [
        ...f.map(([g, v]) => W.createElement(g, v)),
        ...(Array.isArray(h) ? h : [h]),
      ]
    )
);
/**
 * @license lucide-react v0.510.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const A2 = (a, l) => {
  const o = W.forwardRef(({ className: r, ...c }, h) =>
    W.createElement(T2, {
      ref: h,
      iconNode: l,
      className: fv(`lucide-${v2(xg(a))}`, `lucide-${a}`, r),
      ...c,
    })
  );
  return (o.displayName = xg(a)), o;
};
/**
 * @license lucide-react v0.510.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const E2 = [["polygon", { points: "6 3 20 12 6 21 6 3", key: "1oa8hb" }]],
  M2 = A2("play", E2),
  D2 = "/assets/enhanced_chanel_chocolate_purse-CbhPFjhZ.png",
  w2 = "/assets/enhanced_marshmallow_sticks-BcRSNv9d.png",
  R2 = "/assets/enhanced_muchogustomunchprivatelabel-CAjoMIFI.png",
  O2 = "/assets/enhanced_branded_oreos-DOsrFQNF.png",
  C2 = "/assets/enhanced_chocolates_with_logos-BjsqU-xd.png",
  V2 = "/assets/enhanced_chocolate_molds-BLMr9Ksr.png",
  z2 = "/assets/enhanced_chocolate_shoes_makeup-9ATWCQuS.png";
function N2() {
  const [a, l] = W.useState(0);
  return (
    W.useEffect(() => {
      const o = () => l(window.scrollY);
      return (
        window.addEventListener("scroll", o),
        () => window.removeEventListener("scroll", o)
      );
    }, []),
    j.jsxs("div", {
      className: "min-h-screen bg-white",
      children: [
        j.jsx("nav", {
          className:
            "fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-100",
          children: j.jsxs("div", {
            className:
              "max-w-7xl mx-auto px-6 py-4 flex items-center justify-between",
            children: [
              j.jsx("div", {
                className: "heading-hero text-2xl",
                style: { color: "#FF4DA6" },
                children: "The Sweet Tooth",
              }),
              j.jsxs("div", {
                className: "flex gap-8 items-center",
                children: [
                  j.jsx("a", {
                    href: "#custom",
                    className:
                      "body-text text-sm hover:text-[#FF4DA6] transition-smooth",
                    children: "Custom Chocolate",
                  }),
                  j.jsx("a", {
                    href: "#packaging",
                    className:
                      "body-text text-sm hover:text-[#FF4DA6] transition-smooth",
                    children: "Packaging",
                  }),
                  j.jsx("a", {
                    href: "#edible-logos",
                    className:
                      "body-text text-sm hover:text-[#FF4DA6] transition-smooth",
                    children: "Edible Logos",
                  }),
                  j.jsx("a", {
                    href: "#displays",
                    className:
                      "body-text text-sm hover:text-[#FF4DA6] transition-smooth",
                    children: "Displays",
                  }),
                  j.jsx(oi, {
                    className: "bg-[#FF4DA6] hover:bg-[#FF4DA6]/90 text-white",
                    children: "Get Started",
                  }),
                ],
              }),
            ],
          }),
        }),
        j.jsxs("section", {
          className:
            "relative min-h-screen flex items-center justify-center overflow-hidden pt-20",
          children: [
            j.jsx("div", {
              className:
                "absolute inset-0 bg-gradient-to-b from-white via-gray-50 to-white",
            }),
            j.jsxs("div", {
              className:
                "relative z-10 max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center",
              children: [
                j.jsxs(re.div, {
                  initial: { opacity: 0, x: -50 },
                  animate: { opacity: 1, x: 0 },
                  transition: { duration: 0.8 },
                  children: [
                    j.jsx("div", {
                      className: "heading-hero text-sm tracking-wider mb-4",
                      style: { color: "#FF4DA6" },
                      children: "THE SWEET TOOTH CHOCOLATE FACTORY",
                    }),
                    j.jsxs("h1", {
                      className: "heading-hero text-7xl mb-6 leading-tight",
                      children: [
                        "CUSTOM",
                        j.jsx("br", {}),
                        "CHOCOLATE.",
                        j.jsx("br", {}),
                        "BOLD ENERGY.",
                      ],
                    }),
                    j.jsx("p", {
                      className: "subheading text-2xl mb-8 text-gray-600",
                      children: "You dream it. We make it.",
                    }),
                    j.jsx("p", {
                      className:
                        "body-text text-lg mb-10 text-gray-700 leading-relaxed",
                      children:
                        "From luxury packaging to edible logos, we transform your vision into premium chocolate experiences that captivate and delight. Every piece is crafted with precision, passion, and unparalleled attention to detail.",
                    }),
                    j.jsxs("div", {
                      className: "flex gap-4",
                      children: [
                        j.jsx(oi, {
                          className:
                            "bg-[#111111] hover:bg-[#111111]/90 text-white px-8 py-6 text-lg",
                          children: "Explore Our Work",
                        }),
                        j.jsx(oi, {
                          variant: "outline",
                          className:
                            "border-2 border-[#111111] text-[#111111] px-8 py-6 text-lg hover:bg-[#111111] hover:text-white",
                          children: "Contact Us",
                        }),
                      ],
                    }),
                  ],
                }),
                j.jsx(re.div, {
                  initial: { opacity: 0, scale: 0.9 },
                  animate: { opacity: 1, scale: 1 },
                  transition: { duration: 0.8, delay: 0.2 },
                  className: "relative",
                  children: j.jsx("div", {
                    className:
                      "relative transform hover:scale-105 transition-smooth",
                    children: j.jsx("img", {
                      src: D2,
                      alt: "Chanel-style chocolate purse",
                      className: "w-full h-auto rounded-2xl shadow-sweet",
                    }),
                  }),
                }),
              ],
            }),
          ],
        }),
        j.jsx("section", {
          id: "packaging",
          className: "py-32 bg-white",
          children: j.jsxs("div", {
            className: "max-w-7xl mx-auto px-6",
            children: [
              j.jsxs(re.div, {
                initial: { opacity: 0, y: 30 },
                whileInView: { opacity: 1, y: 0 },
                transition: { duration: 0.6 },
                viewport: { once: !0 },
                className: "text-center mb-16",
                children: [
                  j.jsxs("h2", {
                    className: "heading-hero text-6xl mb-6",
                    children: [
                      "Custom Packaging",
                      j.jsx("br", {}),
                      "That Turns Heads",
                    ],
                  }),
                  j.jsx("p", {
                    className:
                      "subheading text-xl text-gray-600 max-w-3xl mx-auto",
                    children:
                      "Elevate your brand with packaging that tells your story. From private label pouches to branded treats, we make every detail count.",
                  }),
                ],
              }),
              j.jsx("div", {
                className: "grid md:grid-cols-3 gap-8",
                children: [
                  {
                    img: R2,
                    title: "Private Label Pouches",
                    desc: "Custom branded packaging with your logo",
                  },
                  {
                    img: O2,
                    title: "Branded Oreos",
                    desc: "Edible logos on premium chocolate-dipped cookies",
                  },
                  {
                    img: w2,
                    title: "Marshmallow Sticks",
                    desc: "Individually wrapped with custom labels",
                  },
                ].map((o, r) =>
                  j.jsxs(
                    re.div,
                    {
                      initial: { opacity: 0, y: 30 },
                      whileInView: { opacity: 1, y: 0 },
                      transition: { duration: 0.6, delay: r * 0.1 },
                      viewport: { once: !0 },
                      className:
                        "group relative overflow-hidden rounded-2xl shadow-sweet hover-scale transition-smooth cursor-pointer",
                      children: [
                        j.jsx("div", {
                          className: "aspect-square overflow-hidden bg-gray-50",
                          children: j.jsx("img", {
                            src: o.img,
                            alt: o.title,
                            className:
                              "w-full h-full object-cover group-hover:scale-110 transition-smooth",
                          }),
                        }),
                        j.jsxs("div", {
                          className: "p-6 bg-white",
                          children: [
                            j.jsx("h3", {
                              className: "heading-hero text-2xl mb-2",
                              children: o.title,
                            }),
                            j.jsx("p", {
                              className: "body-text text-gray-600",
                              children: o.desc,
                            }),
                          ],
                        }),
                      ],
                    },
                    r
                  )
                ),
              }),
            ],
          }),
        }),
        j.jsx("section", {
          id: "edible-logos",
          className: "py-32 bg-gradient-to-b from-gray-50 to-white",
          children: j.jsxs("div", {
            className: "max-w-7xl mx-auto px-6",
            children: [
              j.jsxs(re.div, {
                initial: { opacity: 0, y: 30 },
                whileInView: { opacity: 1, y: 0 },
                transition: { duration: 0.6 },
                viewport: { once: !0 },
                className: "text-center mb-16",
                children: [
                  j.jsxs("h2", {
                    className: "heading-hero text-6xl mb-6",
                    children: ["Your Logo,", j.jsx("br", {}), "Made Edible"],
                  }),
                  j.jsx("p", {
                    className:
                      "subheading text-xl text-gray-600 max-w-3xl mx-auto",
                    children:
                      "Transform any logo, shape, or design into premium chocolate. From corporate gifts to event favors, we bring your brand to life in the most delicious way possible.",
                  }),
                ],
              }),
              j.jsxs("div", {
                className: "grid md:grid-cols-2 gap-12 items-center",
                children: [
                  j.jsx(re.div, {
                    initial: { opacity: 0, x: -30 },
                    whileInView: { opacity: 1, x: 0 },
                    transition: { duration: 0.6 },
                    viewport: { once: !0 },
                    children: j.jsx("img", {
                      src: C2,
                      alt: "Custom chocolate logos",
                      className:
                        "w-full h-auto rounded-2xl shadow-sweet hover-scale transition-smooth",
                    }),
                  }),
                  j.jsx(re.div, {
                    initial: { opacity: 0, x: 30 },
                    whileInView: { opacity: 1, x: 0 },
                    transition: { duration: 0.6 },
                    viewport: { once: !0 },
                    children: j.jsx("img", {
                      src: V2,
                      alt: "Chocolate molds and plaques",
                      className:
                        "w-full h-auto rounded-2xl shadow-sweet hover-scale transition-smooth",
                    }),
                  }),
                ],
              }),
              j.jsxs(re.div, {
                initial: { opacity: 0, y: 30 },
                whileInView: { opacity: 1, y: 0 },
                transition: { duration: 0.6, delay: 0.2 },
                viewport: { once: !0 },
                className: "mt-12 text-center",
                children: [
                  j.jsx("p", {
                    className: "body-text text-lg text-gray-700 mb-6",
                    children:
                      "Whether it's a university crest, corporate logo, or custom design, our artisans create edible masterpieces with precision and artistry.",
                  }),
                  j.jsx(oi, {
                    className:
                      "bg-[#FF4DA6] hover:bg-[#FF4DA6]/90 text-white px-8 py-6 text-lg",
                    children: "Request a Custom Quote",
                  }),
                ],
              }),
            ],
          }),
        }),
        j.jsx("section", {
          id: "displays",
          className: "py-32 bg-white",
          children: j.jsxs("div", {
            className: "max-w-7xl mx-auto px-6",
            children: [
              j.jsxs(re.div, {
                initial: { opacity: 0, y: 30 },
                whileInView: { opacity: 1, y: 0 },
                transition: { duration: 0.6 },
                viewport: { once: !0 },
                className: "text-center mb-16",
                children: [
                  j.jsxs("h2", {
                    className: "heading-hero text-6xl mb-6",
                    children: [
                      "Displays, Centerpieces",
                      j.jsx("br", {}),
                      "& Edible Frames",
                    ],
                  }),
                  j.jsx("p", {
                    className:
                      "subheading text-xl text-gray-600 max-w-3xl mx-auto",
                    children:
                      "Make a statement with large-scale edible art. Perfect for events, galas, and unforgettable moments.",
                  }),
                ],
              }),
              j.jsx(re.div, {
                initial: { opacity: 0, scale: 0.95 },
                whileInView: { opacity: 1, scale: 1 },
                transition: { duration: 0.8 },
                viewport: { once: !0 },
                className: "relative rounded-3xl overflow-hidden shadow-sweet",
                children: j.jsx("img", {
                  src: z2,
                  alt: "Chocolate shoes and luxury displays",
                  className: "w-full h-auto",
                }),
              }),
              j.jsx("div", {
                className: "grid md:grid-cols-3 gap-8 mt-12",
                children: [
                  {
                    title: "Event Centerpieces",
                    desc: "Show-stopping chocolate sculptures for your special occasions",
                  },
                  {
                    title: "Corporate Displays",
                    desc: "Branded installations that leave lasting impressions",
                  },
                  {
                    title: "Edible Art",
                    desc: "Custom creations that blur the line between food and art",
                  },
                ].map((o, r) =>
                  j.jsxs(
                    re.div,
                    {
                      initial: { opacity: 0, y: 20 },
                      whileInView: { opacity: 1, y: 0 },
                      transition: { duration: 0.6, delay: r * 0.1 },
                      viewport: { once: !0 },
                      className: "text-center p-8",
                      children: [
                        j.jsx("h3", {
                          className: "heading-hero text-2xl mb-4",
                          children: o.title,
                        }),
                        j.jsx("p", {
                          className: "body-text text-gray-600",
                          children: o.desc,
                        }),
                      ],
                    },
                    r
                  )
                ),
              }),
            ],
          }),
        }),
        j.jsx("section", {
          className: "py-32 bg-gradient-to-b from-gray-50 to-white",
          children: j.jsxs("div", {
            className: "max-w-7xl mx-auto px-6",
            children: [
              j.jsxs(re.div, {
                initial: { opacity: 0, y: 30 },
                whileInView: { opacity: 1, y: 0 },
                transition: { duration: 0.6 },
                viewport: { once: !0 },
                className: "text-center mb-16",
                children: [
                  j.jsx("h2", {
                    className: "heading-hero text-6xl mb-6",
                    children: "Behind the Scenes",
                  }),
                  j.jsx("p", {
                    className:
                      "subheading text-xl text-gray-600 max-w-3xl mx-auto",
                    children:
                      "Watch the magic happen. From tempering to enrobing, every step is a testament to our craftsmanship.",
                  }),
                ],
              }),
              j.jsx("div", {
                className: "grid md:grid-cols-2 gap-8",
                children: [1, 2].map((o) =>
                  j.jsxs(
                    re.div,
                    {
                      initial: { opacity: 0, y: 30 },
                      whileInView: { opacity: 1, y: 0 },
                      transition: { duration: 0.6, delay: o * 0.1 },
                      viewport: { once: !0 },
                      className:
                        "relative aspect-video rounded-2xl overflow-hidden shadow-sweet video-placeholder group cursor-pointer",
                      children: [
                        j.jsx("div", {
                          className:
                            "absolute inset-0 flex items-center justify-center",
                          children: j.jsx("div", {
                            className:
                              "bg-white/90 backdrop-blur-sm rounded-full p-6 group-hover:scale-110 transition-smooth",
                            children: j.jsx(M2, {
                              className: "w-12 h-12 text-[#FF4DA6]",
                            }),
                          }),
                        }),
                        j.jsx("div", {
                          className:
                            "absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/60 to-transparent",
                          children: j.jsx("p", {
                            className: "text-white font-semibold text-lg",
                            children:
                              o === 1
                                ? "Chocolate Tempering & Pouring"
                                : "Enrobing & Packaging",
                          }),
                        }),
                      ],
                    },
                    o
                  )
                ),
              }),
            ],
          }),
        }),
        j.jsx("section", {
          className: "py-32 bg-[#111111] text-white",
          children: j.jsxs("div", {
            className: "max-w-4xl mx-auto px-6 text-center",
            children: [
              j.jsxs(re.div, {
                initial: { opacity: 0, y: 30 },
                whileInView: { opacity: 1, y: 0 },
                transition: { duration: 0.6 },
                viewport: { once: !0 },
                children: [
                  j.jsxs("h2", {
                    className: "heading-hero text-6xl mb-6",
                    children: [
                      "Ready to Create",
                      j.jsx("br", {}),
                      "Something Sweet?",
                    ],
                  }),
                  j.jsx("p", {
                    className: "subheading text-xl mb-10 text-gray-300",
                    children:
                      "Let's bring your vision to life. From concept to delivery, we're with you every step of the way.",
                  }),
                  j.jsxs("div", {
                    className: "flex gap-4 justify-center",
                    children: [
                      j.jsx(oi, {
                        className:
                          "bg-[#FF4DA6] hover:bg-[#FF4DA6]/90 text-white px-10 py-7 text-lg",
                        children: "Start Your Project",
                      }),
                      j.jsx(oi, {
                        variant: "outline",
                        className:
                          "border-2 border-white text-white px-10 py-7 text-lg hover:bg-white hover:text-[#111111]",
                        children: "View Portfolio",
                      }),
                    ],
                  }),
                ],
              }),
              j.jsxs(re.div, {
                initial: { opacity: 0 },
                whileInView: { opacity: 1 },
                transition: { duration: 0.6, delay: 0.3 },
                viewport: { once: !0 },
                className: "mt-20 pt-12 border-t border-white/20",
                children: [
                  j.jsxs("div", {
                    className:
                      "flex justify-between items-center flex-wrap gap-6",
                    children: [
                      j.jsx("div", {
                        className: "heading-hero text-2xl",
                        style: { color: "#FF4DA6" },
                        children: "The Sweet Tooth",
                      }),
                      j.jsxs("div", {
                        className: "flex gap-8 body-text text-sm text-gray-400",
                        children: [
                          j.jsx("a", {
                            href: "#",
                            className: "hover:text-white transition-smooth",
                            children: "About",
                          }),
                          j.jsx("a", {
                            href: "#",
                            className: "hover:text-white transition-smooth",
                            children: "Services",
                          }),
                          j.jsx("a", {
                            href: "#",
                            className: "hover:text-white transition-smooth",
                            children: "Gallery",
                          }),
                          j.jsx("a", {
                            href: "#",
                            className: "hover:text-white transition-smooth",
                            children: "Contact",
                          }),
                        ],
                      }),
                    ],
                  }),
                  j.jsx("p", {
                    className: "body-text text-sm text-gray-500 mt-8",
                    children:
                      "© 2025 The Sweet Tooth Chocolate Factory. All rights reserved.",
                  }),
                ],
              }),
            ],
          }),
        }),
      ],
    })
  );
}
const Sg = document.getElementById("sweettooth-landing-root");
Sg
  ? kb.createRoot(Sg).render(j.jsx(N2, {}))
  : console.error("Target container 'sweettooth-landing-root' not found.");
